// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/primereact/resources/themes/lara-light-indigo/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/react-time-picker/dist/TimePicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fortawesome/fontawesome-svg-core/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/img/footer-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/img/footer-right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/img/breadcrumbleft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/assets/img/breadcrumbright.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/assets/img/bg/title-head.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/assets/img/bg/count-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../public/assets/img/bg/about-testimonial.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,400;0,500;0,600;0,700;0,900;1,400;1,500;1,600;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Author       : Omar
Name: Omar Mobility Rent
Version      : 1.0
*/
.popular-services .listing-tabs-group, .search-box-banner ul, .css-equal-content, .css-equal-heights {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.css-equal-content {
  color: red;
  float: left;
}

.product-detail-head .search-btn .search-button:hover, .product-detail-head .search-btn .search-button, .listing-item:hover .fav-icon i, .listing-item .listing-img .fav-item, .popular-services .listing-tabs-group ul li a img, .popular-services .listing-tabs-group ul li a span, .popular-services .listing-tabs-group ul li a:hover img, .popular-services .listing-tabs-group ul li a:hover, .popular-services .listing-tabs-group ul li a.active img, .popular-services .listing-tabs-group ul li a, .search-box-banner .search-btn .search-button:hover, .search-box-banner .search-btn .search-button, .header .header-navbar-rht .nav-item .header-reg:hover, .header .header-navbar-rht .nav-item .header-reg, .header .header-navbar-rht .nav-item .header-login:hover, .header .header-navbar-rht .nav-item .header-login, .header.fixed, .header, .contact-btn:hover, .contact-btn {
  transition: all 0.5s;
}

.listview-car .card .card-body .listing-details-group ul li span img, .listview-car .card .card-body .blog-list-head .blog-list-rate h6, .product-detail-head .details-btn a, .serve-form .input-block .button-notific, .pagination, .popular-slider-group .owl-carousel .owl-next i, .popular-slider-group .owl-carousel .owl-prev i, .listing-item .listing-content .listing-button .btn-order, .listing-item .listing-img .fav-item .fav-icon, .listing-item .listing-img .fav-item .featured-text, .popular-services .owl-carousel .owl-next i, .popular-services .owl-carousel .owl-prev i, .popular-services .listing-tabs-group ul li a, .popular-services .listing-tabs-group {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.table tbody td a {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.listview-car .card .card-body .blog-list-head, .product-detail-head .detail-page-head {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.grid-listview ul li a, .car-listing .pagination .previtem a, .car-listing .pagination .nextlink a, .list-btn .btn-filters, .modal .payment-success .check, .payment-method ul li a, .modal .available-for-ride, .car-details-slider.owl-carousel .owl-nav .owl-prev, .car-details-slider.owl-carousel .owl-nav .owl-next, .listing-feature ul li span, .specification-card .feature-img, .pagination .pagination .previtem a, .pagination .pagination .nextlink a, .why-choose .card .card-body .choose-img, .listing-item .listing-content .listing-details-group ul, .table .dropdown-item, .table tbody td a.btn-action-icon, .fi-icon, .hi-icon, .footer-social-links .nav, .footer .footer-contact .footer-contact-info .footer-address span, .align-center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.booking-list li {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.order-confirmation .place-order-btn a, .listing-item .listing-content .listing-features .listing-title a, .listing-item .listing-content .listing-features .author-img img, .services .services-group .services-icon .icon-img, .services .services-group .services-icon {
  display: inline-flex;
}

.table tbody td a, .footer-social-widget .nav-social, .footer .footer-contact .footer-contact-info .update-form .btn .feather-send, .footer .footer-contact .footer-contact-info .footer-address {
  display: flex;
}

.payment-method ul, .serve-form .input-block, .error-page, .content-page-header {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.listview-car .card .card-body .listing-details-group ul, .order-confirmation .order-confirm-box .confirmation-title, .order-confirmation .section-title, .modal .grand-total, .modal .booking-info.service-tax ul li, .listing-item .listing-content .listing-location-details, .listing-item .listing-img .fav-item {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.listview-car .card .card-body .listing-details-group ul li span img, .listview-car .card .card-body .listing-details-group ul li, .listview-car .card .card-body .blog-list-head .blog-list-rate h6, .listview-car .card .card-body .blog-list-head .blog-list-title .title-bottom h6, .sorting-div .product-filter-group .grid-listview ul, .sorting-div .product-filter-group .sortbyset, .sorting-div .product-filter-group, .list-btn .filter-list li ul li, .list-btn .filter-list .short-filter, .list-btn .filter-list, .order-confirmation .order-confirm-box .order-car, .payment-method .payment-checkbox label, .booking-details .booking-form .payment-btn, .modal .modal-footer a, .modal .booking-info.pay-amount label, .modal .booking-info.seat-select label, .review-list-rating li, .review-list-rating, .listing-feature ul li, .product-detail-head .details-btn a, .product-detail-head .details-btn, .product-detail-head .detail-page-head .camaro-location .camaro-locations-inner, .product-detail-head .detail-page-head .camaro-location, .product-detail-head .detail-page-head .list-rating, .product-detail-head .detail-page-head, .serve-form .input-block .button-notific, .privacy-section .terms-policy ul li, .pagination, .user-app-group .userapp-heading .download-btn, .popular-slider-group .owl-carousel .owl-next i, .popular-slider-group .owl-carousel .owl-prev i, .listing-item .listing-content .listing-button .btn-order, .listing-item .listing-content .listing-location-details .listing-price h6, .listing-item .listing-content .listing-details-group ul li, .listing-item .listing-img .fav-item .fav-icon, .listing-item .listing-img .fav-item .featured-text, .popular-services .owl-carousel .owl-next i, .popular-services .owl-carousel .owl-prev i, .popular-services .listing-tabs-group ul li a, .search-box-banner .input-block-wrapp, .footer .footer-contact .footer-contact-info .footer-address .addr-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.sorting-div .product-filter-group {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
}

.table .dropdown-item, .footer-social-widget .nav-social {
  justify-content: flex-start;
  -webkit-justify-content: start;
  -ms-flex-pack: start;
}

.listview-car .card .card-body .blog-list-head, .product-detail-head .detail-page-head {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

/*-----------------
    1. Reset
-----------------------*/
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
}

* {
  box-sizing: border-box;
}

article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after {
  content: "";
  content: none;
}

q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*-----------------
    2. Typography
-----------------------*/
a {
  text-decoration: none;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}

h1 {
  font-weight: 900;
  font-size: 62px;
  color: #201F1D;
}
@media (max-width: 1199.98px) {
  h1 {
    font-size: 36px;
  }
}

h2 {
  font-weight: 900;
  font-size: 36px;
  color: #111111;
}
@media (max-width: 991.98px) {
  h2 {
    font-size: 26px;
  }
}

h3 {
  font-weight: 700;
  font-size: 24px;
  color: #111111;
}
@media (max-width: 991.98px) {
  h3 {
    font-size: 18px;
  }
}

h4 {
  font-size: 28px;
  color: #2F2F2F;
}
@media (max-width: 991.98px) {
  h4 {
    font-size: 20px;
  }
}

h5 {
  font-size: 18px;
}
@media (max-width: 991.98px) {
  h5 {
    font-size: 16px;
  }
}

h6 {
  font-weight: 500;
  font-size: 18px;
  color: #111111;
}
@media (max-width: 991.98px) {
  h6 {
    font-size: 16px;
  }
}

/*-----------------
	3. General
-----------------------*/
body {
  font-family: "Fira Sans", sans-serif;
  font-size: 15px;
  color: #787878;
  background: #FCFBFB;
  overflow-x: hidden;
}
@media (max-width: 991.98px) {
  body {
    font-size: 15px;
  }
}

a {
  cursor: pointer;
  transition: all 0.2s ease;
}
a:hover {
  transition: all 0.2s ease;
}
a:focus {
  outline: 0;
}

p:last-child {
  margin-bottom: 0;
}

strong {
  font-weight: 700;
}

.form-control:focus {
  border-color: #bbb;
  box-shadow: none;
  outline: 0 none;
}

/*-----------------
    4. Grid
-----------------------*/
.popular-services .listing-tabs-group, .search-box-banner ul, .css-equal-heights, .css-equal-content {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.css-equal-content {
  color: red;
  float: left;
}

.product-detail-head .search-btn .search-button:hover, .product-detail-head .search-btn .search-button, .listing-item:hover .fav-icon i, .listing-item .listing-img .fav-item, .popular-services .listing-tabs-group ul li a img, .popular-services .listing-tabs-group ul li a span, .popular-services .listing-tabs-group ul li a:hover img, .popular-services .listing-tabs-group ul li a:hover, .popular-services .listing-tabs-group ul li a.active img, .popular-services .listing-tabs-group ul li a, .search-box-banner .search-btn .search-button:hover, .search-box-banner .search-btn .search-button, .header .header-navbar-rht .nav-item .header-reg:hover, .header .header-navbar-rht .nav-item .header-reg, .header .header-navbar-rht .nav-item .header-login:hover, .header .header-navbar-rht .nav-item .header-login, .header.fixed, .header, .contact-btn:hover, .contact-btn {
  transition: all 0.5s;
}

.listview-car .card .card-body .listing-details-group ul li span img, .listview-car .card .card-body .blog-list-head .blog-list-rate h6, .product-detail-head .details-btn a, .serve-form .input-block .button-notific, .pagination, .popular-slider-group .owl-carousel .owl-next i, .popular-slider-group .owl-carousel .owl-prev i, .listing-item .listing-content .listing-button .btn-order, .listing-item .listing-img .fav-item .fav-icon, .listing-item .listing-img .fav-item .featured-text, .popular-services .owl-carousel .owl-next i, .popular-services .owl-carousel .owl-prev i, .popular-services .listing-tabs-group ul li a, .popular-services .listing-tabs-group {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.table tbody td a {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.listview-car .card .card-body .blog-list-head, .product-detail-head .detail-page-head {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.grid-listview ul li a, .car-listing .pagination .previtem a, .car-listing .pagination .nextlink a, .list-btn .btn-filters, .modal .payment-success .check, .payment-method ul li a, .modal .available-for-ride, .car-details-slider.owl-carousel .owl-nav .owl-prev, .car-details-slider.owl-carousel .owl-nav .owl-next, .listing-feature ul li span, .specification-card .feature-img, .pagination .pagination .previtem a, .pagination .pagination .nextlink a, .why-choose .card .card-body .choose-img, .listing-item .listing-content .listing-details-group ul, .table .dropdown-item, .table tbody td a.btn-action-icon, .fi-icon, .hi-icon, .footer-social-links .nav, .footer .footer-contact .footer-contact-info .footer-address span, .align-center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.booking-list li {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.order-confirmation .place-order-btn a, .listing-item .listing-content .listing-features .listing-title a, .listing-item .listing-content .listing-features .author-img img, .services .services-group .services-icon .icon-img, .services .services-group .services-icon {
  display: inline-flex;
}

.table tbody td a, .footer-social-widget .nav-social, .footer .footer-contact .footer-contact-info .update-form .btn .feather-send, .footer .footer-contact .footer-contact-info .footer-address {
  display: flex;
}

.payment-method ul, .serve-form .input-block, .error-page, .content-page-header {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.listview-car .card .card-body .listing-details-group ul, .order-confirmation .order-confirm-box .confirmation-title, .order-confirmation .section-title, .modal .grand-total, .modal .booking-info.service-tax ul li, .listing-item .listing-content .listing-location-details, .listing-item .listing-img .fav-item {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.listview-car .card .card-body .listing-details-group ul li span img, .listview-car .card .card-body .listing-details-group ul li, .listview-car .card .card-body .blog-list-head .blog-list-rate h6, .listview-car .card .card-body .blog-list-head .blog-list-title .title-bottom h6, .sorting-div .product-filter-group .grid-listview ul, .sorting-div .product-filter-group .sortbyset, .sorting-div .product-filter-group, .list-btn .filter-list li ul li, .list-btn .filter-list .short-filter, .list-btn .filter-list, .order-confirmation .order-confirm-box .order-car, .payment-method .payment-checkbox label, .booking-details .booking-form .payment-btn, .modal .modal-footer a, .modal .booking-info.pay-amount label, .modal .booking-info.seat-select label, .review-list-rating li, .review-list-rating, .listing-feature ul li, .product-detail-head .details-btn a, .product-detail-head .details-btn, .product-detail-head .detail-page-head .camaro-location .camaro-locations-inner, .product-detail-head .detail-page-head .camaro-location, .product-detail-head .detail-page-head .list-rating, .product-detail-head .detail-page-head, .serve-form .input-block .button-notific, .privacy-section .terms-policy ul li, .pagination, .user-app-group .userapp-heading .download-btn, .popular-slider-group .owl-carousel .owl-next i, .popular-slider-group .owl-carousel .owl-prev i, .listing-item .listing-content .listing-button .btn-order, .listing-item .listing-content .listing-location-details .listing-price h6, .listing-item .listing-content .listing-details-group ul li, .listing-item .listing-img .fav-item .fav-icon, .listing-item .listing-img .fav-item .featured-text, .popular-services .owl-carousel .owl-next i, .popular-services .owl-carousel .owl-prev i, .popular-services .listing-tabs-group ul li a, .search-box-banner .input-block-wrapp, .footer .footer-contact .footer-contact-info .footer-address .addr-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.sorting-div .product-filter-group {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
}

.table .dropdown-item, .footer-social-widget .nav-social {
  justify-content: flex-start;
  -webkit-justify-content: start;
  -ms-flex-pack: start;
}

.listview-car .card .card-body .blog-list-head, .product-detail-head .detail-page-head {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.col {
  width: auto;
  padding-left: 15px;
  padding-right: 15px;
  float: left;
  position: relative;
  min-height: 1px;
}
@media (min-width: 320px) {
  .col.col-xs-12 {
    width: 100%;
  }
  .col.col-xs-11 {
    width: 91.66666667%;
  }
  .col.col-xs-10 {
    width: 83.33333333%;
  }
  .col.col-xs-9 {
    width: 75%;
  }
  .col.col-xs-8 {
    width: 66.66666667%;
  }
  .col.col-xs-7 {
    width: 58.33333333%;
  }
  .col.col-xs-6 {
    width: 50%;
  }
  .col.col-xs-5 {
    width: 41.66666667%;
  }
  .col.col-xs-4 {
    width: 33.33333333%;
  }
  .col.col-xs-3 {
    width: 25%;
  }
  .col.col-xs-2 {
    width: 16.66666667%;
  }
  .col.col-xs-1 {
    width: 8.33333333%;
  }
}
@media (min-width: 568px) {
  .col.col-sm-12 {
    width: 100%;
  }
  .col.col-sm-11 {
    width: 91.66666667%;
  }
  .col.col-sm-10 {
    width: 83.33333333%;
  }
  .col.col-sm-9 {
    width: 75%;
  }
  .col.col-sm-8 {
    width: 66.66666667%;
  }
  .col.col-sm-7 {
    width: 58.33333333%;
  }
  .col.col-sm-6 {
    width: 50%;
  }
  .col.col-sm-5 {
    width: 41.66666667%;
  }
  .col.col-sm-4 {
    width: 33.33333333%;
  }
  .col.col-sm-3 {
    width: 25%;
  }
  .col.col-sm-2 {
    width: 16.66666667%;
  }
  .col.col-sm-1 {
    width: 8.33333333%;
  }
}
@media (min-width: 768px) {
  .col.col-md-12 {
    width: 100%;
  }
  .col.col-md-11 {
    width: 91.66666667%;
  }
  .col.col-md-10 {
    width: 83.33333333%;
  }
  .col.col-md-9 {
    width: 75%;
  }
  .col.col-md-8 {
    width: 66.66666667%;
  }
  .col.col-md-7 {
    width: 58.33333333%;
  }
  .col.col-md-6 {
    width: 50%;
  }
  .col.col-md-5 {
    width: 41.66666667%;
  }
  .col.col-md-4 {
    width: 33.33333333%;
  }
  .col.col-md-3 {
    width: 25%;
  }
  .col.col-md-2 {
    width: 16.66666667%;
  }
  .col.col-md-1 {
    width: 8.33333333%;
  }
}
@media (min-width: 1024px) {
  .col.col-lg-12 {
    width: 100%;
  }
  .col.col-lg-11 {
    width: 91.66666667%;
  }
  .col.col-lg-10 {
    width: 83.33333333%;
  }
  .col.col-lg-9 {
    width: 75%;
  }
  .col.col-lg-8 {
    width: 66.66666667%;
  }
  .col.col-lg-7 {
    width: 58.33333333%;
  }
  .col.col-lg-6 {
    width: 50%;
  }
  .col.col-lg-5 {
    width: 41.66666667%;
  }
  .col.col-lg-4 {
    width: 33.33333333%;
  }
  .col.col-lg-3 {
    width: 25%;
  }
  .col.col-lg-2 {
    width: 16.66666667%;
  }
  .col.col-lg-1 {
    width: 8.33333333%;
  }
}

/*-----------------
    5. Buttons
-----------------------*/
.btn {
  position: relative;
  text-transform: initial;
  transition: all 0.5s;
}
.btn:hover {
  transition: all 0.5s;
}

.btn-view {
  font-weight: 500;
  font-size: 16px;
  color: #201F1D;
  border: 2px solid #201F1D;
  background-color: #ffffff;
  box-shadow: inset 0 0 0 0 #ffffff;
  border-radius: 5px;
  line-height: 0;
  margin: 0;
  padding: 11px 22px;
}
.btn-view:hover {
  background-color: #1976d2;
  border: 2px solid #FF9307;
  color: #ffffff;
  box-shadow: inset 0 50px 0 0 #FF9307;
}
@media (max-width: 991.98px) {
  .btn-view {
    margin: 0;
    padding: 8px 12px;
    font-size: 14px;
  }
}

.btn-white {
  background-color: #ffffff;
  border-color: #F1F1F1;
  color: #1976d2;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.btn-white:hover {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #ffffff;
  box-shadow: inset 0 50px 0 0 #1976d2;
}

.btn-white-outline {
  background-color: #ffffff;
  border-color: #F1F1F1;
  color: #3F4254;
}
.btn-white-outline:hover {
  background-color: #ffffff;
  border-color: #F1F1F1;
  color: #3F4254;
}

.btn-primary {
  background-color: #1976d2;
  border: 1px solid #1976d2;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.btn-primary:hover {
  background-color: #ffffff;
  border-color: #1976d2;
  color: #1976d2;
  box-shadow: inset 0 50px 0 0 #ffffff;
}

.btn-subscribe {
  background-color: #1976d2;
  border: 1px solid #1976d2;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.btn-subscribe:hover i {
  color: #1976d2 !important;
  transition: 0.5s;
}
.btn-subscribe:hover {
  background-color: #ffffff;
  border-color: #1976d2;
  color: #1976d2;
  box-shadow: inset 0 50px 0 0 #ffffff;
}

.submit-review {
  padding: 12px 20px;
}

.btn-size {
  font-weight: 600;
  font-size: 16px;
  padding: 12px;
}

.btn-outline-light {
  color: #ffffff;
  background-color: #201F1D;
  border: 1px solid #201F1D;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.btn-outline-light:hover {
  background-color: #ffffff;
  border-color: #F1F1F1;
  color: #3F4254;
  box-shadow: inset 0 50px 0 0 #ffffff;
}

.btn-gray {
  background-color: #EFEFEF;
  border: 1px solid #EFEFEF;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.btn-gray:hover {
  background-color: #ffffff;
  border-color: #EFEFEF;
  color: #878A99;
  box-shadow: inset 0 50px 0 0 #ffffff;
}

.btn-gray-outline {
  background-color: #ffffff;
  border: 1px solid #EFEFEF;
  box-shadow: inset 0 0 0 0 #ffffff;
}
.btn-gray-outline:hover {
  background-color: #EFEFEF;
  border-color: #ffffff;
  color: #878A99;
  box-shadow: inset 0 50px 0 0 #ffffff;
}

.btn-outline-primary {
  color: #1976d2;
  border-color: #1976d2;
}
.btn-outline-primary:hover {
  background-color: #1976d2;
  border-color: #1976d2;
}

.btn-check:focus + .btn-primary,
.btn-primary:focus {
  box-shadow: none !important;
}

.btn:focus {
  box-shadow: none !important;
}
.btn.btn-greys {
  background: #EFEFEF;
  color: #9c27b0;
  font-size: 13px;
  padding: 8px 16px;
  font-weight: 600;
}

.cancel {
  background-color: #ffffff;
  border: 1px solid #377dff;
  box-shadow: inset 0 0 0 0 #377dff;
  color: #377dff;
}
.cancel:hover {
  background-color: #ffffff;
  border-color: #377dff;
  color: #377dff;
  box-shadow: inset 0 50px 0 0 #ffffff;
}

.contact-btn {
  background-color: #201F1D;
  border: 1px solid #201F1D;
  box-shadow: inset 0 0 0 #ffffff;
  color: #ffffff;
  border-radius: 5px;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 15px;
  text-align: center;
}
.contact-btn:hover {
  background-color: #ffffff;
  border: 1px solid #201F1D;
  box-shadow: inset 0 70px 0 0 #ffffff;
  color: #201F1D;
}

.btn-secondary {
  background: #2F2F2F;
  color: #ffffff;
}

.fa-facebook {
  background: #3080F8;
  color: #ffffff;
}

.fa-twitter {
  background: #35B6FF;
  color: #ffffff;
}

.fa-instagram {
  background: #FF2D20;
  color: #ffffff;
}

.fa-behance {
  background: #0066FF;
  color: #ffffff;
}

.fa-linkedin {
  background: #0066FF;
  color: #ffffff;
}

.btn-primary.btn:first-child:active {
  background: #1976d2;
  border-color: #1976d2;
}

/*-----------------
    6. Header
-----------------------*/
.header {
  background: #ffffff;
  position: sticky;
  box-shadow: 0px 10px 40px rgba(202, 202, 202, 0.2);
  left: 0;
  top: 0;
  width: 100%;
  z-index: 999;
}
.header.fixed {
  background-color: #ffffff;
  box-shadow: 0px 3px 53px rgba(197, 197, 197, 0.27);
}
.header .logo a {
  float: left;
}
.header .logo a img {
  float: left;
  max-height: 32px;
}
.header .header-nav {
  align-items: center;
  border: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  position: relative;
  height: 85px;
  padding: 0 15px 0 15px;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .header .header-nav {
    height: 65px;
    padding: 0;
  }
}
.header .header-nav .main-nav > li > a {
  color: #2F2F2F;
  line-height: 85px;
  font-weight: 500;
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li > a {
    font-size: 14px;
  }
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li > a {
    color: #ffffff;
  }
}
.header .header-nav .main-nav > li > a:hover {
  color: #1976d2;
}
.header .header-nav .main-nav > li .submenu li {
  position: relative;
}
.header .header-nav .main-nav > li .submenu li.active {
  color: #1976d2;
}
.header .header-nav .main-nav > li .submenu li.active > a {
  color: #1976d2;
}
.header .header-nav .main-nav > li .submenu li a {
  display: block;
  padding: 10px 15px 10px;
  clear: both;
  white-space: nowrap;
  color: #2F2F2F;
  transition: all 0.35s ease;
  width: 100%;
  position: relative;
  font-weight: 500;
}
@media (max-width: 991.98px) {
  .header .header-nav .main-nav > li .submenu li a {
    padding: 10px;
    color: #ffffff;
    font-size: 12px;
  }
}
.header .header-nav .main-nav > li .submenu li a:hover {
  color: #1976d2;
  padding-left: 20px;
}
.header .header-nav .main-nav > li .login-link {
  display: none;
}
.header .navbar-header .navbar-brand {
  display: inline-block;
  padding: 0;
  line-height: 0;
}
@media (max-width: 991.98px) {
  .header .navbar-header .navbar-brand {
    margin-right: 0;
  }
}
@media (max-width: 575.98px) {
  .header .navbar-header .logo {
    display: none;
  }
}
.header .navbar-header .logo-small {
  display: none;
}
@media (max-width: 575.98px) {
  .header .navbar-header .logo-small {
    display: block;
    width: 100%;
    text-align: center;
  }
}
.header .navbar-header #mobile_btn {
  display: none;
  margin-right: 30px;
}
@media (max-width: 991.98px) {
  .header .navbar-header #mobile_btn {
    display: inline-block;
    line-height: 0;
  }
}
@media (max-width: 575.98px) {
  .header .navbar-header #mobile_btn {
    left: 0;
    margin-right: 0;
    padding: 0 0px;
    position: absolute;
    z-index: 99;
  }
}
.header .navbar-header #mobile_btn .bar-icon {
  display: inline-block;
  width: 31px;
}
.header .navbar-header #mobile_btn .bar-icon span {
  background-color: #1976d2;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  margin-bottom: 5px;
}
.header .navbar-header #mobile_btn .bar-icon span:nth-child(2) {
  width: 20px;
}
.header .navbar-header #mobile_btn .bar-icon span:nth-child(3) {
  width: 16px;
  margin-bottom: 0;
}
@media (max-width: 991.98px) {
  .header .navbar-header {
    display: inline-flex;
    align-items: center;
  }
}
@media (max-width: 575.98px) {
  .header .navbar-header {
    width: 100%;
  }
}
.header .main-menu-wrapper {
  margin: 0 15px 0;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper {
    order: 3;
    width: 260px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 11111;
    transform: translateX(-260px);
    transition: all 0.4s;
    background: #201F1D;
    margin: 0;
  }
}
.header .main-menu-wrapper .menu-header {
  align-items: center;
  height: 60px;
  padding: 0 20px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  display: none;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .menu-header {
    display: flex;
    height: 65px;
    align-items: center;
    background: #ffffff;
  }
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .menu-header .menu-logo img {
    width: 160px;
  }
}
.header .main-menu-wrapper .menu-header .menu-close {
  font-size: 18px;
  color: #1976d2;
}
.header .main-menu-wrapper .main-nav > li .submenu > li .submenu {
  left: 100%;
  top: 0;
  margin-top: 10px;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav > li .submenu > li .submenu {
    left: 0;
  }
}
.header .main-menu-wrapper .main-nav > li .submenu > li.has-submenu > a::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 13px;
}
.header .main-menu-wrapper .main-nav {
  display: flex;
  margin: 0;
  padding: 0;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav {
    padding: 0;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    background: #201F1D;
  }
}
.header .main-menu-wrapper .main-nav:last-child {
  margin-right: 0;
}
@media (max-width: 992px) {
  .header .main-menu-wrapper .main-nav > li {
    margin-right: 0;
  }
  .header .main-menu-wrapper .main-nav > li:last-child {
    margin-right: 0;
    border: 0;
  }
}
.header .main-menu-wrapper .main-nav > li.active > a {
  display: block;
  color: #1976d2;
}
.header .main-menu-wrapper .main-nav > li a i {
  font-size: 12px;
  margin-left: 3px;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav > li a {
    display: block;
    line-height: 20px;
    padding: 12px 15px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }
  .header .main-menu-wrapper .main-nav > li a i {
    font-size: 14px;
  }
}
@media (max-width: 991.98px) and (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav > li a i {
    float: right;
    margin-top: 5px;
    font-size: 14px;
  }
}
.header .main-menu-wrapper .main-nav > li:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav > li {
    border-bottom: 1px solid #828282;
    padding: 0;
  }
}
@media (min-width: 992px) {
  .header .main-menu-wrapper .main-nav > li {
    display: block;
    position: relative;
    margin-right: 30px;
  }
  .header .main-menu-wrapper .main-nav > li:last-child {
    margin-right: 0;
  }
}
@media (min-width: 992px) {
  .header .main-menu-wrapper .main-nav > li ul {
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    display: block;
    font-size: 14px;
    left: 0;
    margin: 0;
    min-width: 200px;
    opacity: 0;
    padding: 0;
    position: absolute;
    transition: all 0.2s ease;
    transform: translateY(20px);
    top: 100%;
    visibility: hidden;
    z-index: 1000;
  }
}
@media (min-width: 992px) {
  .header .main-menu-wrapper .main-nav li.has-submenu:hover > .submenu {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    transform: translateY(0);
    border-radius: 2px;
    border-top: 1px solid #1976d2;
  }
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav .has-submenu ul {
    display: none;
    background: rgba(255, 255, 255, 0.2);
  }
}
.header .main-menu-wrapper .main-nav li.login-link {
  display: none;
}
@media (max-width: 991.98px) {
  .header .main-menu-wrapper .main-nav li.login-link {
    display: block;
  }
}
.header .header-navbar-rht {
  margin: 0;
  padding: 0;
}
@media (max-width: 575.98px) {
  .header .header-navbar-rht {
    display: none;
  }
}
.header .header-navbar-rht > li {
  align-items: center;
  display: inline-flex;
  padding-right: 15px;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .header-navbar-rht > li:last-child {
  padding-right: 0px;
}
.header .header-navbar-rht > li .dropdown-menu {
  border: 0;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}
.header .header-navbar-rht > li .dropdown-menu .dropdown-item {
  border-top: 1px solid #FCFBFB;
  padding: 10px 15px;
  font-size: 0.9375rem;
  font-weight: 600;
}
.header .header-navbar-rht > li .dropdown-menu .dropdown-item:hover {
  color: #1976d2;
}
.header .header-navbar-rht > li .dropdown-menu .dropdown-item:last-child {
  border-top: 0;
  border-radius: 5px 5px 0 0;
}
.header .header-navbar-rht > li .dropdown-menu .dropdown-item:first-child {
  border-radius: 0 0 5px 5px;
}
.header .header-navbar-rht .nav-item span {
  margin: 0 8px 0 0;
}
.header .header-navbar-rht .nav-item .add-listing {
  font-weight: 500;
  font-size: 16px;
  color: #201F1D;
}
.header .header-navbar-rht .nav-item .add-listing span {
  color: #127384;
}
.header .header-navbar-rht .nav-item .header-login {
  background-color: #201F1D;
  border: 1px solid #201F1D;
  box-shadow: inset 0 0 0 #ffffff;
  color: #ffffff;
  border-radius: 5px;
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
  text-align: center;
}
@media (max-width: 991.98px) {
  .header .header-navbar-rht .nav-item .header-login {
    padding: 8px 12px;
    font-size: 14px;
  }
}
.header .header-navbar-rht .nav-item .header-login:hover {
  background-color: #ffffff;
  border: 1px solid #201F1D;
  box-shadow: inset 0 70px 0 0 #ffffff;
  color: #201F1D;
}
.header .header-navbar-rht .nav-item .header-reg {
  background-color: #1976d2;
  border: 1px solid #1976d2;
  box-shadow: inset 0 0 0 #ffffff;
  color: #ffffff;
  border-radius: 5px;
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
}
@media (max-width: 991.98px) {
  .header .header-navbar-rht .nav-item .header-reg {
    padding: 8px 12px;
    font-size: 14px;
  }
}
.header .header-navbar-rht .nav-item .header-reg:hover {
  background-color: #ffffff;
  border: 1px solid #1976d2;
  box-shadow: inset 0 70px 0 0 #ffffff;
  color: #1976d2;
}
.header .dropdown-toggle::after {
  display: none;
}

.menu-opened .main-menu-wrapper {
  transform: translateX(0);
}
.menu-opened .main-menu-wrapper body {
  overflow: hidden;
}

.header-modern {
  background: rgba(10, 10, 10, 0.95) !important;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5) !important;
  border-bottom: 1px solid rgba(255, 193, 7, 0.1);
}
.header-modern .header-nav {
  display: grid !important;
  grid-template-columns: 1fr 2fr 1fr !important;
  align-items: center !important;
}
@media (max-width: 991.98px) {
  .header-modern .header-nav {
    display: flex !important;
    justify-content: space-between !important;
  }
}
.header-modern .navbar-header {
  justify-content: flex-start !important;
}
.header-modern .logo-modern {
  animation: logoEntrance 0.8s ease-out;
}
.header-modern .logo-modern img {
  max-height: 50px !important;
  animation: logoSpin 0.8s ease-out;
}
@media (max-width: 991.98px) {
  .header-modern .logo-modern img {
    max-height: 40px !important;
  }
}
.header-modern .logo-modern .brand-text-modern {
  display: flex;
  flex-direction: column;
  gap: 2px;
  animation: logoTextSlide 0.8s ease-out;
}
.header-modern .logo-modern .brand-text-modern .brand-name {
  font-size: 1.35rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 1px;
  line-height: 1;
}
@media (max-width: 991.98px) {
  .header-modern .logo-modern .brand-text-modern .brand-name {
    font-size: 1.2rem;
  }
}
.header-modern .logo-modern .brand-text-modern .brand-tagline {
  font-size: 0.75rem;
  color: #EDA600;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  animation: taglineGlow 2s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .header-modern .logo-modern .brand-text-modern .brand-tagline {
    font-size: 0.7rem;
  }
}
.header-modern .logo-modern:hover img {
  animation: logoHoverSpin 0.6s ease-in-out;
}
.header-modern .logo-small img {
  max-height: 40px !important;
}
.header-modern .main-menu-wrapper {
  display: flex !important;
  justify-content: center !important;
}
@media (max-width: 991.98px) {
  .header-modern .main-menu-wrapper {
    display: block !important;
    justify-content: flex-start !important;
    height: 100vh !important;
    max-height: 100vh !important;
    overflow-y: auto !important;
  }
}
@media (max-width: 991.98px) {
  .header-modern .main-menu-wrapper.slide-nav {
    transform: translateX(0) !important;
  }
}
.header-modern .main-nav-modern {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 40px !important;
}
@media (max-width: 991.98px) {
  .header-modern .main-nav-modern {
    flex-direction: column;
    gap: 0 !important;
    justify-content: flex-start !important;
    width: 100%;
    align-items: flex-start !important;
  }
}
.header-modern .main-nav-modern > li {
  position: relative;
}
@media (max-width: 991.98px) {
  .header-modern .main-nav-modern > li {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
}
.header-modern .main-nav-modern > li > a {
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  transition: all 0.3s ease !important;
  position: relative;
  display: inline-block !important;
  line-height: 85px !important;
}
@media (max-width: 991.98px) {
  .header-modern .main-nav-modern > li > a {
    line-height: 50px !important;
    display: block !important;
    padding: 0 20px;
    width: 100%;
  }
}
.header-modern .main-nav-modern > li > a::after {
  content: "";
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 30px;
  height: 2px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  transition: transform 0.3s ease;
}
@media (max-width: 991.98px) {
  .header-modern .main-nav-modern > li > a::after {
    display: none;
  }
}
.header-modern .main-nav-modern > li > a:hover {
  color: #EDA600 !important;
}
.header-modern .main-nav-modern > li > a:hover::after {
  transform: translateX(-50%) scaleX(1);
}
.header-modern .main-nav-modern > li.active > a {
  color: #EDA600 !important;
}
.header-modern .main-nav-modern > li.active > a::after {
  transform: translateX(-50%) scaleX(1);
}
.header-modern .header-cta-modern {
  display: flex;
  align-items: center;
  justify-content: flex-end !important;
  gap: 12px;
}
@media (max-width: 991.98px) {
  .header-modern .header-cta-modern {
    display: none;
  }
}
.header-modern .header-cta-modern .btn-header-call {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
}
.header-modern .header-cta-modern .btn-header-call i {
  color: #28a745;
  font-size: 16px;
}
.header-modern .header-cta-modern .btn-header-call:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  transform: translateY(-2px);
}
.header-modern .header-cta-modern .btn-header-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  border-radius: 50px;
  color: #1a1a1a;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
}
.header-modern .header-cta-modern .btn-header-primary i {
  font-size: 16px;
}
.header-modern .header-cta-modern .btn-header-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 193, 7, 0.4);
  color: #000;
}

@keyframes logoEntrance {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes logoSpin {
  0% {
    transform: rotate(-180deg) scale(0.5);
    opacity: 0;
  }
  60% {
    transform: rotate(10deg) scale(1.1);
  }
  100% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }
}
@keyframes logoTextSlide {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes taglineGlow {
  0%, 100% {
    text-shadow: 0 0 5px rgba(255, 193, 7, 0.3);
  }
  50% {
    text-shadow: 0 0 10px rgba(255, 193, 7, 0.6), 0 0 20px rgba(255, 193, 7, 0.3);
  }
}
@keyframes logoHoverSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*-----------------
    7. Footer
-----------------------*/
.footer {
  background: #201F1D;
  position: relative;
}
.footer::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  position: absolute;
  top: 50px;
  left: 0;
  width: 97px;
  height: 102px;
  background-size: cover;
}
@media (max-width: 1199.98px) {
  .footer::before {
    display: none;
  }
}
.footer::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 393px;
  height: 334px;
  background-size: cover;
}
@media (max-width: 991.98px) {
  .footer::after {
    display: none;
  }
}
.footer .footer-top {
  position: relative;
  z-index: 99;
  margin: 0;
  padding: 60px 0;
}
@media (max-width: 991.98px) {
  .footer .footer-top {
    margin: 0;
    padding: 40px 0 10px;
  }
}
@media (max-width: 767.98px) {
  .footer .footer-top {
    margin: 0;
    padding: 40px 0 0;
  }
}
.footer .footer-about {
  border-right: 1px solid #000;
}
@media (max-width: 767.98px) {
  .footer .footer-about {
    border: 0;
  }
}
.footer .footer-widget .footer-logo {
  margin-bottom: 35px;
}
.footer .footer-widget .footer-about-content {
  margin-bottom: 50px;
}
@media (max-width: 991.98px) {
  .footer .footer-widget .footer-about-content {
    margin-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .footer .footer-widget .footer-about-content {
    margin-bottom: 20px;
  }
}
.footer .footer-widget .footer-about-content p {
  font-weight: 700;
  color: #1F2937;
  margin-bottom: 0;
}
.footer .footer-widget.footer-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer .footer-widget .footer-title {
  position: relative;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 40px;
}
.footer .footer-widget .footer-title:before {
  content: "";
  background: #FCB215;
  width: 27px;
  height: 4px;
  left: 0;
  position: absolute;
  bottom: -80%;
}
@media (max-width: 991.98px) {
  .footer .footer-widget {
    margin-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .footer .footer-widget {
    margin-bottom: 25px;
  }
}
.footer .footer-menu ul li {
  margin: 0 0 20px;
}
.footer .footer-menu ul li:last-child {
  margin-bottom: 0;
}
.footer .footer-menu ul li a {
  color: #828282;
  transition: all 0.5s ease-in-out;
}
.footer .footer-menu ul li a:hover {
  color: #1976d2;
  padding-left: 10px;
  transition: all 0.5s ease-in-out;
}
.footer .footer-contact h5 {
  font-weight: 700;
  font-size: 24px;
  color: #FFFFFF;
  max-width: 336px;
  margin-bottom: 20px;
}
.footer .footer-contact h6 {
  font-size: 16px;
  color: #DBDBDB;
  margin-bottom: 15px;
  line-height: 20px;
}
.footer .footer-contact .footer-contact-info .footer-address {
  margin-bottom: 20px;
}
.footer .footer-contact .footer-contact-info .footer-address span {
  margin-right: 20px;
  width: 50px;
  height: 50px;
  background: #FF9307;
  color: #ffffff;
  font-size: 20px;
  border-radius: 4px;
  flex-shrink: 0;
}
.footer .footer-contact .footer-contact-info .footer-address .addr-info a {
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
}
.footer .footer-contact .footer-contact-info .update-form {
  position: relative;
}
.footer .footer-contact .footer-contact-info .update-form span {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #828282;
  font-size: 20px;
  line-height: 1;
}
.footer .footer-contact .footer-contact-info .update-form .form-control {
  min-height: 55px;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #ffffff;
  font-size: 14px;
  margin: 0;
  padding: 10px 100px 12px 40px;
  color: #828282;
}
.footer .footer-contact .footer-contact-info .update-form .btn {
  padding: 20px 20px;
  font-size: 15px;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.footer .footer-contact .footer-contact-info .update-form .btn .feather-send {
  color: #ffffff;
}
.footer .footer-contact .footer-contact-info .update-form .btn:active {
  border-color: #FCB215;
}
.footer .footer-contact .footer-contact-info .update-form .btn:active .feather-send {
  color: #FCB215;
}
.footer .footer-bottom {
  background: #201F1D;
  position: relative;
  z-index: 99;
  margin: 0;
  padding: 20px 0;
}
@media (max-width: 767.98px) {
  .footer .footer-bottom {
    margin: 0;
    padding: 15px 0;
  }
}
@media (max-width: 767.98px) {
  .footer .footer-bottom .copyright {
    text-align: center;
  }
}
@media (max-width: 767.98px) {
  .footer .footer-bottom .copyright .copyright-text {
    margin: 0 0 20px;
  }
}
.footer .footer-bottom .copyright .copyright-text p {
  color: #ffffff;
}
.footer .footer-bottom .copyright .vistors-details ul {
  justify-content: end;
  -webkit-justify-content: end;
}
@media (max-width: 767.98px) {
  .footer .footer-bottom .copyright .vistors-details ul {
    justify-content: center;
  }
}
.footer .footer-bottom .copyright .vistors-details ul li {
  margin: 0;
  padding: 0 8px 0;
}
.footer .footer-bottom .copyright .vistors-details ul li a {
  background: #ffffff;
  width: 46px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.footer .footer-bottom .policy-menu {
  text-align: right;
  margin: 0;
  padding: 0;
}
@media (max-width: 767.98px) {
  .footer .footer-bottom .policy-menu {
    text-align: center;
  }
}
.footer .footer-bottom .policy-menu li {
  display: inline-block;
  margin-right: 30px;
  position: relative;
}
@media (max-width: 767.98px) {
  .footer .footer-bottom .policy-menu li {
    margin-right: 10px;
    margin-top: 10px;
  }
}
.footer .footer-bottom .policy-menu li a {
  color: #000;
}
.footer .footer-bottom .policy-menu li a:hover {
  color: #9c27b0;
}
.footer .footer-bottom .policy-menu li::after {
  content: "";
  position: absolute;
  background: #9c27b0;
  width: 5px;
  height: 5px;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.footer .footer-bottom .policy-menu li:last-child {
  margin-right: 0;
}
@keyframes toTopFromBottom {
  49% {
    transform: translateY(-100%);
  }
  50% {
    opacity: 0;
    transform: translateY(100%);
  }
  51% {
    opacity: 1;
  }
}
.footer-social-links {
  margin: 10px 0 30px;
}
.footer-social-links h6 {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  .footer-social-links h6 {
    margin-bottom: 10px;
  }
}
.footer-social-links .nav li {
  margin-right: 10px;
}
.footer-social-links .nav li:last-child {
  margin-right: 0;
}
.footer-social-links .nav li a:hover {
  color: #000;
}

.footer-social-widget {
  margin: 20px 0 0;
}
.footer-social-widget .nav-social li {
  margin-right: 10px;
}
.footer-social-widget .nav-social li:last-child {
  margin-right: 0;
}
.footer-social-widget .nav-social li a:hover {
  color: #000;
}

.hi-icon {
  font-size: 0px;
  cursor: pointer;
  text-align: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
  color: #201F1D;
  background: #DBDBDB;
  border-radius: 50px;
  min-width: 36px;
  height: 36px;
  transition: background 0.3s, color 0.3s, box-shadow 0.3s;
}
@media (max-width: 767.98px) {
  .hi-icon {
    min-width: 36px;
    height: 36px;
  }
}
.hi-icon:after {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 0;
  content: "";
  box-sizing: content-box;
  display: none;
}
.hi-icon:before {
  speak: none;
  font-size: 18px;
  line-height: 20px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  display: block;
  -webkit-font-smoothing: antialiased;
}
@media (max-width: 767.98px) {
  .hi-icon:before {
    font-size: 15px;
  }
}
.hi-icon:hover {
  color: #201F1D;
}
.hi-icon:hover:before {
  animation: toTopFromBottom 0.5s forwards;
}

.fi-icon {
  font-size: 0px;
  cursor: pointer;
  text-align: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 50px;
  min-width: 36px;
  height: 36px;
  transition: background 0.3s, color 0.3s, box-shadow 0.3s;
}
@media (max-width: 767.98px) {
  .fi-icon {
    min-width: 36px;
    height: 36px;
  }
}
.fi-icon:after {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 0;
  content: "";
  box-sizing: content-box;
  display: none;
}
.fi-icon:before {
  speak: none;
  font-size: 18px;
  line-height: 20px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  display: block;
  -webkit-font-smoothing: antialiased;
  color: #ffffff;
}
@media (max-width: 767.98px) {
  .fi-icon:before {
    font-size: 15px;
  }
}
.fi-icon:hover {
  color: #201F1D;
}
.fi-icon:hover:before {
  animation: toTopFromBottom 0.5s forwards;
}

.footer-modern {
  background: linear-gradient(180deg, #0a0a0a 0%, #000000 100%);
  position: relative;
  overflow: hidden;
}
.footer-modern::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 193, 7, 0.3), transparent);
}
.footer-modern .footer-content-modern {
  padding: 80px 0 40px;
}
@media (max-width: 991px) {
  .footer-modern .footer-content-modern {
    padding: 60px 0 30px;
  }
}
@media (max-width: 767px) {
  .footer-modern .footer-content-modern {
    padding: 40px 0 20px;
  }
}
.footer-modern .footer-widget-modern h4 {
  color: white;
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 15px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.footer-modern .footer-widget-modern .footer-desc-modern {
  color: rgba(255, 255, 255, 0.7);
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 25px;
}
@media (max-width: 991px) {
  .footer-modern .footer-widget-modern .footer-desc-modern {
    font-size: 14px;
  }
}
.footer-modern .footer-widget-modern .footer-social-modern {
  display: flex;
  gap: 12px;
}
.footer-modern .footer-widget-modern .footer-social-modern a {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  transition: all 0.3s ease;
}
.footer-modern .footer-widget-modern .footer-social-modern a:hover {
  background: linear-gradient(135deg, #FFC107, #FF9800);
  border-color: transparent;
  color: #1a1a1a;
  transform: translateY(-3px);
}
.footer-modern .footer-widget-modern .footer-title-modern {
  color: white;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 12px;
}
.footer-modern .footer-widget-modern .footer-title-modern::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
}
@media (max-width: 991px) {
  .footer-modern .footer-widget-modern .footer-title-modern {
    font-size: 16px;
  }
}
.footer-modern .footer-widget-modern .footer-links-modern {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-modern .footer-widget-modern .footer-links-modern li {
  margin-bottom: 12px;
}
.footer-modern .footer-widget-modern .footer-links-modern li a {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
  position: relative;
}
.footer-modern .footer-widget-modern .footer-links-modern li a::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%) scaleX(0);
  width: 8px;
  height: 2px;
  background: #FFC107;
  transition: transform 0.3s ease;
}
.footer-modern .footer-widget-modern .footer-links-modern li a:hover {
  color: #FFC107;
  padding-left: 15px;
}
.footer-modern .footer-widget-modern .footer-links-modern li a:hover::before {
  transform: translateY(-50%) scaleX(1);
}
.footer-modern .footer-widget-modern .footer-contact-modern {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-modern .footer-widget-modern .footer-contact-modern li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}
.footer-modern .footer-widget-modern .footer-contact-modern li i {
  color: #FFC107;
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}
.footer-modern .footer-widget-modern .footer-contact-modern li a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}
.footer-modern .footer-widget-modern .footer-contact-modern li a:hover {
  color: #FFC107;
}
.footer-modern .footer-widget-modern .footer-hours-modern {
  padding: 15px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.footer-modern .footer-widget-modern .footer-hours-modern p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  margin-bottom: 5px;
  line-height: 1.6;
}
.footer-modern .footer-widget-modern .footer-hours-modern p:last-child {
  margin-bottom: 0;
}
.footer-modern .footer-widget-modern .footer-hours-modern p strong {
  color: white;
}
.footer-modern .footer-compliance-modern {
  background: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding: 30px 0;
}
@media (max-width: 991px) {
  .footer-modern .footer-compliance-modern {
    padding: 20px 0;
  }
}
.footer-modern .footer-compliance-modern .compliance-logos {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.footer-modern .footer-compliance-modern .compliance-logos .compliance-logo {
  text-decoration: none;
}
.footer-modern .footer-compliance-modern .compliance-logos .compliance-logo .anpc-placeholder,
.footer-modern .footer-compliance-modern .compliance-logos .compliance-logo .sal-placeholder {
  width: 80px;
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFC107;
  font-weight: bold;
  font-size: 14px;
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .footer-modern .footer-compliance-modern .compliance-logos .compliance-logo .anpc-placeholder,
  .footer-modern .footer-compliance-modern .compliance-logos .compliance-logo .sal-placeholder {
    width: 70px;
    height: 45px;
    font-size: 12px;
  }
}
.footer-modern .footer-compliance-modern .compliance-logos .compliance-logo:hover .anpc-placeholder,
.footer-modern .footer-compliance-modern .compliance-logos .compliance-logo:hover .sal-placeholder {
  background: rgba(255, 193, 7, 0.1);
  border-color: rgba(255, 193, 7, 0.3);
  transform: translateY(-2px);
}
.footer-modern .footer-compliance-modern .compliance-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
  max-width: 700px;
}
@media (max-width: 767px) {
  .footer-modern .footer-compliance-modern .compliance-text {
    font-size: 11px;
  }
}
.footer-modern .footer-compliance-modern .compliance-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 15px;
}
@media (max-width: 991px) {
  .footer-modern .footer-compliance-modern .compliance-links {
    margin-top: 20px;
  }
}
.footer-modern .footer-compliance-modern .compliance-links a {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  text-decoration: none;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-modern .footer-compliance-modern .compliance-links a::before {
  content: "→";
  color: #FFC107;
}
.footer-modern .footer-compliance-modern .compliance-links a:hover {
  color: #FFC107;
}
.footer-modern .footer-bottom-modern {
  padding: 25px 0;
}
@media (max-width: 991px) {
  .footer-modern .footer-bottom-modern {
    padding: 20px 0;
  }
}
.footer-modern .footer-bottom-modern .copyright-modern,
.footer-modern .footer-bottom-modern .legal-info-modern {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  margin: 0;
}
@media (max-width: 767px) {
  .footer-modern .footer-bottom-modern .copyright-modern,
  .footer-modern .footer-bottom-modern .legal-info-modern {
    font-size: 12px;
    text-align: center !important;
    margin-bottom: 10px;
  }
}

/*-----------------
    8. Breadcrumb
-----------------------*/
.breadcrumb-bar {
  background: #201F1D;
  padding: 60px 0 60px;
  position: relative;
  z-index: 1;
  width: 100%;
}
@media (max-width: 991.98px) {
  .breadcrumb-bar {
    padding: 50px 0 50px;
  }
}
.breadcrumb-bar:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 393px;
  height: 334px;
  background-size: cover;
}
@media (max-width: 991.98px) {
  .breadcrumb-bar:before {
    display: none;
  }
}
.breadcrumb-bar:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  position: absolute;
  bottom: 50px;
  right: 130px;
  width: 97px;
  height: 102px;
  background-size: cover;
}
@media (max-width: 991.98px) {
  .breadcrumb-bar:after {
    display: none;
  }
}
.breadcrumb-bar .breadcrumb-title {
  font-weight: 700;
  color: #ffffff;
  font-size: 36px;
  margin: 0 0 15px;
}
@media (max-width: 991.98px) {
  .breadcrumb-bar .breadcrumb-title {
    font-size: 32px;
  }
}
.breadcrumb-bar .breadcrumb {
  justify-content: center;
  margin: 0;
}
.breadcrumb-bar .breadcrumb li a {
  color: #ffffff;
}
.breadcrumb-bar .breadcrumb.active {
  color: #ffffff;
}
.breadcrumb-bar .breadcrumb-item + .breadcrumb-item::before {
  color: #ffffff;
}
.breadcrumb-bar .breadcrumb-item.active {
  color: #1976d2;
}

/*-----------------
    9. Select
-----------------------*/
.select2-container {
  min-width: 100% !important;
  width: auto !important;
  z-index: 99;
  padding: 0 !important;
  color: #141432;
}
.select2-container .select2-selection--single {
  height: 43px;
}

.select2-container--default .select2-selection--single {
  background: #FCFBFB;
  border: 1px solid #F4F4F4;
  border-radius: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #878A99;
  line-height: 40px;
  border-radius: 5px;
  padding-right: 30px;
  padding-left: 15px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 40px;
  right: 6px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  position: absolute;
  top: 50%;
  left: 50%;
  border-color: #878A99;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  margin-left: -10px;
  margin-top: -3px;
  width: 0;
  transform: rotate(45deg) translateY(-50%);
  -webkit-transform: rotate(45deg) translateY(-50%);
  -ms-transform: rotate(45deg) translateY(-50%);
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #878A99;
  border-width: 2px 0 0 2px;
  margin-top: 3px;
  padding: 3px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #127384;
  color: #ffffff;
}

.select2-container--focus .select2-selection--single {
  background: #ffffff !important;
  border: 1px solid #127384;
}

span.select2-container.select2-container--default.select2-container--open {
  z-index: 9999;
}

/*-----------------
    10. Table
-----------------------*/
.table {
  color: #2F2F2F;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}
.table .dataTable {
  border-collapse: collapse !important;
}
.table .table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 500;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  white-space: nowrap;
  min-width: 150px;
  font-size: 14px;
}
.table .thead-light th {
  font-size: 15px;
  color: #201F1D;
  font-weight: 500;
  background-color: #F4F4F4;
  padding: 15px;
}
.table thead {
  background-color: #F4F4F4;
  border-bottom: 0;
  vertical-align: middle;
  white-space: nowrap;
}
.table tbody {
  vertical-align: middle;
  white-space: nowrap;
}
.table tbody tr {
  border-bottom: 1pt solid #F1F1F1;
}
.table tbody tr td {
  border-color: #dee2e6;
  padding: 15px;
}
.table tbody td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}
.table tbody td h2 span {
  color: #888888;
  display: block;
  font-size: 13px;
  margin-top: 2px;
}
.table tbody td a {
  color: #2F2F2F;
}
.table tbody td a.btn-action-icon {
  background: #F3F3F3;
  color: #201F1D;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50px;
}
.table tbody td a.btn-action-icon:active {
  color: #1976d2;
}
.table tbody td a + a {
  display: inline-block;
}
.table tbody td a.add-btn {
  display: inline-block !important;
}
.table tbody td a:hover {
  color: #1976d2;
}
.table tbody td a:active {
  color: #ffffff;
}
.table tbody td a.btn {
  display: inline-block;
  padding: 5px 10px;
}
.table tbody td .items-links {
  color: #28283C;
  display: inline-block;
}
.table tbody td .items-links:hover {
  color: #1976d2;
}
.table .invoice-link {
  color: #201F1D;
  display: inline-block;
}
.table .invoice-link:hover {
  color: #9c27b0;
}
.table .invoice-link .table-center th, .table .invoice-link .table-center td {
  vertical-align: middle;
}
.table .invoice-link .dropdown-menu {
  width: 200px;
  background: #ffffff;
  border: 1px solid #888888;
  box-shadow: 0px 4px 4px #888888;
  margin-top: 10px !important;
  border-radius: 6px;
}
.table .invoice-link .dropdown-item {
  font-weight: 500;
  font-size: 13px;
  color: #28283C;
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.table .invoice-link .dropdown-item:last-child {
  margin-bottom: 0;
}
.table .invoice-link .dropdown-item:focus, .table .invoice-link .dropdown-item:hover {
  color: #1976d2;
  background: transparent;
}
.table .invoice-link .dropdown-item.active {
  color: #ffffff;
  text-decoration: none;
  background-color: #1976d2;
}
.table .invoice-link .dropdown-item i {
  font-size: 16px;
}

.table .dropdown-menu {
  width: 160px;
  background: #ffffff;
  border: 1px solid #EDECF8;
  box-shadow: 0px 16px 32px #888888;
  border-radius: 12px;
  padding: 0;
  margin-top: 10px !important;
}
.table .dropdown-item {
  font-weight: 500;
  font-size: 13px;
  color: #201F1D;
  padding: 10px 20px 10px;
}

.table-inbox {
  font-size: 15px;
  margin-bottom: 0;
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.table-striped > tbody > tr:nth-of-type(2n+1) {
  background-color: #f8f9fa;
}
.table-striped .dropdown-action {
  margin-bottom: 0;
}
.table-striped .table-bordered {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.table.no-border > tbody > tr > td,
.table > tbody > tr > th,
.table.no-border > tfoot > tr > td,
.table.no-border > tfoot > tr > th,
.table.no-border > thead > tr > td,
.table.no-border > thead > tr > th {
  padding: 10px 8px;
}

.table-hover tbody tr:hover {
  background-color: #f6f6f7;
}

.table-bordered th {
  border-color: rgba(0, 0, 0, 0.05);
}
.table-bordered td {
  border-color: rgba(0, 0, 0, 0.05);
}
.table-bordered td:first-child {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.table-bordered td:last-child {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.card-table .card-body {
  padding: 0 !important;
}
.card-table .card-body .table > thead > tr > th {
  border-top: 0;
}
.card-table .card-body .table td {
  color: #201F1D;
  font-weight: 400;
  border-top: 0;
  font-size: 13px;
  padding: 15px 25px;
  white-space: nowrap;
  box-shadow: none;
}
.card-table .card-body .table td:first-child {
  padding-left: 25px;
}
.card-table .card-body .table th {
  white-space: nowrap;
  padding: 12px 25px;
  border-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  color: #9c27b0;
}
.card-table .card-body .table th:first-child {
  padding-left: 25px;
}

.table > :not(:first-child) {
  border: 0;
}

.dataTables_length select {
  appearance: auto;
}

.table-nosearch .dataTables_length,
.table-nosearch .dataTables_filter {
  display: none;
}

.card-table div.table-responsive > div.dataTables_wrapper > div.row:first-child {
  padding: 1.5rem 1.5rem 0 !important;
  align-items: center;
}
.card-table div.table-responsive > div.dataTables_wrapper > div.row:last-child {
  padding: 0 1.5rem 1.5rem !important;
  align-items: center;
}

.dataTables_length select {
  appearance: auto;
}

table .badge {
  border-radius: 4px;
  display: inline-block;
  font-size: 13px;
  min-width: auto;
  padding: 8px 10px;
  font-weight: 400;
  text-align: center;
}

.table tbody td a {
  color: #0052ea;
}
.table tbody td a.action-icon {
  color: #333;
}
.table tbody td h2.table-avatar a {
  color: #3F4254;
}
.table tbody td h2.table-avatar a:hover {
  color: #1976d2;
}

.mini-sidebar .header .header-left.header-left-two .logo.logo-small {
  padding: 10px 0 0;
  margin: 0;
}

.categories-table .table tr:last-child td {
  padding-bottom: 0;
  border: none;
}
.categories-table .table td {
  padding: 8px;
  font-size: 14px;
}

.card-table .table {
  background: #ffffff;
  margin-bottom: 24px !important;
  border-radius: 8px;
}

.dataTables_length label {
  font-weight: 500 !important;
  font-size: 14px;
  color: #3F4254;
}

.dataTables_length label:before {
  content: "Show";
  margin-right: 5px;
  font-size: 12px;
}

.dataTables_length label:after {
  content: "Entries";
  margin-left: 5px;
  font-size: 12px;
}

/*-----------------
    11. Home
-----------------------*/
.section {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .section {
    padding: 50px 0;
  }
}

.hero-section-modern {
  position: relative;
  min-height: 60vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 50%, #0a0a0a 100%);
  overflow: hidden;
  padding: 80px 0 60px;
}
@media (max-width: 991.98px) {
  .hero-section-modern {
    min-height: 55vh;
    padding: 60px 0 50px;
  }
}
@media (max-width: 479px) {
  .hero-section-modern {
    min-height: 50vh;
    padding: 50px 0 40px;
  }
}
.hero-section-modern .hero-background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 50%, rgba(255, 193, 7, 0.08) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(33, 150, 243, 0.06) 0%, transparent 50%);
  pointer-events: none;
  animation: gradientShift 15s ease infinite;
}
.hero-section-modern .hero-animated-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
}
.hero-section-modern .hero-animated-bg .floating-element {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 152, 0, 0.05));
  filter: blur(60px);
  animation: float 20s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-animated-bg .floating-element {
    display: none;
  }
}
.hero-section-modern .hero-animated-bg .floating-element-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}
.hero-section-modern .hero-animated-bg .floating-element-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  right: 15%;
  animation-delay: 7s;
}
.hero-section-modern .hero-animated-bg .floating-element-3 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 50%;
  animation-delay: 14s;
}
.hero-section-modern .hero-content-wrapper {
  position: relative;
  z-index: 10;
}
.hero-section-modern .hero-text-center {
  text-align: center;
  padding: 0 15px;
}
.hero-section-modern .hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  padding: 8px 24px;
  margin-bottom: 30px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  animation: badgePulse 3s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-badge {
    padding: 6px 18px;
    font-size: 13px;
    margin-bottom: 20px;
  }
}
.hero-section-modern .hero-badge i {
  color: #EDA600;
  font-size: 16px;
  animation: iconSpin 4s linear infinite;
}
.hero-section-modern .hero-title {
  font-size: 72px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.1;
  margin-bottom: 25px;
  letter-spacing: -0.02em;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-title {
    font-size: 48px;
    margin-bottom: 20px;
  }
}
@media (max-width: 767.98px) {
  .hero-section-modern .hero-title {
    font-size: 36px;
  }
}
.hero-section-modern .hero-title .hero-title-highlight {
  background: linear-gradient(135deg, #FFC107 0%, #FF9800 50%, #FFC107 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
  animation: gradientText 4s ease infinite;
}
.hero-section-modern .hero-description {
  font-size: 18px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 40px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-description {
    font-size: 16px;
    margin-bottom: 30px;
  }
}
@media (max-width: 767.98px) {
  .hero-section-modern .hero-description {
    font-size: 15px;
  }
  .hero-section-modern .hero-description br {
    display: none;
  }
}
.hero-section-modern .hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 60px;
  flex-wrap: wrap;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-actions {
    margin-bottom: 40px;
  }
}
.hero-section-modern .btn-hero {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 16px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
@media (max-width: 991.98px) {
  .hero-section-modern .btn-hero {
    padding: 14px 28px;
    font-size: 15px;
  }
}
@media (max-width: 767.98px) {
  .hero-section-modern .btn-hero {
    padding: 12px 24px;
    font-size: 14px;
  }
}
.hero-section-modern .btn-hero i {
  font-size: 18px;
  transition: transform 0.3s ease;
}
.hero-section-modern .btn-hero:hover i {
  transform: translateX(4px);
}
.hero-section-modern .btn-hero-primary {
  background: linear-gradient(135deg, #FFC107 0%, #FF9800 50%, #FFC107 100%);
  background-size: 200% auto;
  color: #1a1a1a;
  box-shadow: 0 8px 24px rgba(255, 193, 7, 0.3);
  position: relative;
  overflow: hidden;
}
.hero-section-modern .btn-hero-primary::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}
.hero-section-modern .btn-hero-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(255, 193, 7, 0.5);
  color: #000;
  animation: buttonShine 1.5s ease infinite;
}
.hero-section-modern .btn-hero-primary:hover::before {
  width: 300px;
  height: 300px;
}
.hero-section-modern .btn-hero-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}
.hero-section-modern .btn-hero-secondary::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}
.hero-section-modern .btn-hero-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  color: #ffffff;
  transform: translateY(-2px);
}
.hero-section-modern .btn-hero-secondary:hover::before {
  width: 300px;
  height: 300px;
}
.hero-section-modern .hero-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.05);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-stats {
    gap: 25px;
    padding: 20px;
  }
}
@media (max-width: 767.98px) {
  .hero-section-modern .hero-stats {
    flex-direction: column;
    gap: 20px;
  }
}
.hero-section-modern .hero-stat-item {
  text-align: center;
}
.hero-section-modern .hero-stat-item .stat-value {
  font-size: 36px;
  font-weight: 900;
  color: #ffffff;
  margin-bottom: 5px;
  background: linear-gradient(135deg, #FFC107 0%, #FF9800 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-stat-item .stat-value {
    font-size: 28px;
  }
}
.hero-section-modern .hero-stat-item .stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-stat-item .stat-label {
    font-size: 12px;
  }
}
.hero-section-modern .hero-stat-divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.15);
}
@media (max-width: 767.98px) {
  .hero-section-modern .hero-stat-divider {
    display: none;
  }
}
.hero-section-modern .scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  z-index: 100;
  transition: all 0.3s ease;
}
@media (max-width: 991.98px) {
  .hero-section-modern .scroll-indicator {
    bottom: 20px;
    gap: 4px;
  }
}
@media (max-width: 767.98px) {
  .hero-section-modern .scroll-indicator {
    bottom: 15px;
  }
}
.hero-section-modern .scroll-indicator:hover .scroll-arrow i {
  animation: arrowBounce 0.8s ease infinite;
}
.hero-section-modern .scroll-indicator .scroll-animation {
  display: flex;
  justify-content: center;
  align-items: center;
}
.hero-section-modern .scroll-indicator .scroll-mouse {
  width: 22px;
  height: 36px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
@media (max-width: 991.98px) {
  .hero-section-modern .scroll-indicator .scroll-mouse {
    width: 20px;
    height: 32px;
  }
}
.hero-section-modern .scroll-indicator .scroll-mouse .scroll-wheel {
  width: 3px;
  height: 7px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  border-radius: 3px;
  margin-top: 5px;
  animation: scrollWheel 2s ease infinite;
}
@media (max-width: 991.98px) {
  .hero-section-modern .scroll-indicator .scroll-mouse .scroll-wheel {
    width: 2px;
    height: 6px;
    margin-top: 4px;
  }
}
.hero-section-modern .scroll-indicator .scroll-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
}
.hero-section-modern .scroll-indicator .scroll-arrow i {
  color: #EDA600;
  font-size: 18px;
  animation: arrowBounce 2s ease infinite;
}
@media (max-width: 991.98px) {
  .hero-section-modern .scroll-indicator .scroll-arrow i {
    font-size: 16px;
  }
}
.hero-section-modern .hero-decoration {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.15;
  pointer-events: none;
  animation: decorationFloat 20s ease-in-out infinite;
}
@media (max-width: 991.98px) {
  .hero-section-modern .hero-decoration {
    display: none;
  }
}
.hero-section-modern .hero-decoration-1 {
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  top: -200px;
  left: -200px;
  animation-delay: 0s;
}
.hero-section-modern .hero-decoration-2 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #2196F3, #1976D2);
  bottom: -150px;
  right: -150px;
  animation-delay: 10s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}
@keyframes gradientShift {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
@keyframes badgePulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.3);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
}
@keyframes iconSpin {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  20% {
    transform: rotate(-10deg);
  }
  30% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes gradientText {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
@keyframes buttonShine {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
@keyframes scrollWheel {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(16px);
  }
}
@keyframes arrowBounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(8px);
  }
}
@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
@keyframes decorationFloat {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(20px, -20px) rotate(90deg);
  }
  50% {
    transform: translate(0, -40px) rotate(180deg);
  }
  75% {
    transform: translate(-20px, -20px) rotate(270deg);
  }
}
.section-modern {
  position: relative;
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%);
  padding: 100px 0;
  overflow: hidden;
}
@media (max-width: 991.98px) {
  .section-modern {
    padding: 60px 0;
  }
}
@media (max-width: 479px) {
  .section-modern {
    padding: 40px 0;
  }
}

.section-heading-modern {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 10;
}
@media (max-width: 991.98px) {
  .section-heading-modern {
    margin-bottom: 40px;
  }
}
.section-heading-modern .section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 50px;
  padding: 8px 20px;
  margin-bottom: 20px;
  color: #EDA600;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
@media (max-width: 991.98px) {
  .section-heading-modern .section-badge {
    padding: 6px 16px;
    font-size: 12px;
  }
}
.section-heading-modern .section-badge i {
  font-size: 14px;
}
.section-heading-modern h2 {
  font-size: 48px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 15px;
  letter-spacing: -0.02em;
  position: relative;
}
@media (max-width: 991.98px) {
  .section-heading-modern h2 {
    font-size: 36px;
  }
}
@media (max-width: 767.98px) {
  .section-heading-modern h2 {
    font-size: 28px;
  }
}
.section-heading-modern h2::after {
  display: none;
}
.section-heading-modern p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  max-width: 600px;
  margin: 0 auto;
}
@media (max-width: 991.98px) {
  .section-heading-modern p {
    font-size: 16px;
  }
}
@media (max-width: 767.98px) {
  .section-heading-modern p {
    font-size: 15px;
  }
}

.recommended-cars-modern {
  background: #0a0a0a;
  position: relative;
}
.recommended-cars-modern::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(180deg, rgba(255, 193, 7, 0.03) 0%, transparent 100%);
  pointer-events: none;
}
.recommended-cars-modern .cars-showcase-modern {
  margin-bottom: 50px;
  position: relative;
  z-index: 10;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .cars-showcase-modern {
    margin-bottom: 40px;
  }
}
.recommended-cars-modern .cars-showcase-modern .row {
  margin: 0 -15px;
}
.recommended-cars-modern .cars-showcase-modern .row > div {
  padding: 0 15px;
}
.recommended-cars-modern .cars-showcase-modern .row > div > div[class*=col-] {
  width: 100% !important;
  max-width: 100% !important;
  flex: none !important;
  padding: 0 !important;
}
.recommended-cars-modern .empty-state-modern {
  text-align: center;
  padding: 80px 20px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.recommended-cars-modern .empty-state-modern i {
  font-size: 64px;
  color: #EDA600;
  margin-bottom: 20px;
  opacity: 0.5;
}
.recommended-cars-modern .empty-state-modern h3 {
  font-size: 28px;
  color: #ffffff;
  margin-bottom: 10px;
}
.recommended-cars-modern .empty-state-modern p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}
.recommended-cars-modern .section-cta-modern {
  text-align: center;
  position: relative;
  z-index: 10;
}
.recommended-cars-modern .listing-item {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 16px !important;
  padding: 20px !important;
  transition: all 0.4s ease !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item {
    padding: 15px !important;
  }
}
.recommended-cars-modern .listing-item:hover {
  transform: translateY(-8px) !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 193, 7, 0.3) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 193, 7, 0.2) !important;
}
.recommended-cars-modern .listing-item .listing-img {
  margin-bottom: 20px !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  position: relative;
}
.recommended-cars-modern .listing-item .listing-img img {
  border-radius: 12px !important;
  transition: transform 0.4s ease !important;
}
.recommended-cars-modern .listing-item .listing-img:hover img {
  transform: scale(1.05) !important;
}
.recommended-cars-modern .listing-item .listing-img .fav-item {
  padding: 12px 15px !important;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.95), rgba(255, 152, 0, 0.95)) !important;
  -webkit-backdrop-filter: blur(10px) !important;
          backdrop-filter: blur(10px) !important;
}
.recommended-cars-modern .listing-item .listing-img .fav-item .featured-text {
  color: #1a1a1a !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  text-shadow: none !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-img .fav-item .featured-text {
    font-size: 13px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.recommended-cars-modern .listing-item .listing-content .listing-features {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding-bottom: 15px !important;
  margin-bottom: 15px !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-features .listing-title {
  margin-bottom: 0 !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-features .listing-title a {
  color: #ffffff !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  transition: color 0.3s ease !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-content .listing-features .listing-title a {
    font-size: 18px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content .listing-features .listing-title a:hover {
  color: #EDA600 !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-details-group {
  margin-bottom: 15px !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-details-group i {
  color: #EDA600 !important;
  font-size: 16px !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-content .listing-details-group i {
    font-size: 14px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content .listing-details-group p {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 14px !important;
  margin: 0 !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-content .listing-details-group p {
    font-size: 13px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details {
  margin-top: auto !important;
  background: rgba(255, 255, 255, 0.03) !important;
  border-radius: 10px !important;
  padding: 15px !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-content .listing-location-details {
    padding: 12px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price h6 {
  color: #ffffff !important;
  font-size: 26px !important;
  font-weight: 900 !important;
  margin: 0 !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price h6 {
    font-size: 22px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price .btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  padding: 8px 16px !important;
  transition: all 0.3s ease !important;
}
@media (max-width: 991.98px) {
  .recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price .btn {
    font-size: 12px !important;
    padding: 6px 12px !important;
  }
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price .btn.btn-success {
  background: rgba(40, 167, 69, 0.2) !important;
  border: 1px solid rgba(40, 167, 69, 0.5) !important;
  color: #28a745 !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price .btn.btn-success:hover {
  background: #28a745 !important;
  color: #ffffff !important;
  transform: translateY(-2px) !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price .btn.btn-primary {
  background: linear-gradient(135deg, #FFC107, #FF9800) !important;
  border: none !important;
  color: #1a1a1a !important;
}
.recommended-cars-modern .listing-item .listing-content .listing-location-details .listing-price .btn.btn-primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(255, 193, 7, 0.4) !important;
}
.recommended-cars-modern .listing-item.sold-out {
  opacity: 0.7;
  filter: grayscale(0.5);
}
.recommended-cars-modern .listing-item.sold-out:hover {
  transform: translateY(-4px) !important;
}

.btn-modern {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 16px 40px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.4s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}
@media (max-width: 991.98px) {
  .btn-modern {
    padding: 14px 32px;
    font-size: 15px;
  }
}
.btn-modern i {
  font-size: 18px;
  transition: transform 0.3s ease;
}
.btn-modern:hover i {
  transform: translateX(5px);
}

.btn-modern-primary {
  background: linear-gradient(135deg, #FFC107 0%, #FF9800 50%, #FFC107 100%);
  background-size: 200% auto;
  color: #1a1a1a;
  box-shadow: 0 10px 30px rgba(255, 193, 7, 0.3);
}
.btn-modern-primary::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}
.btn-modern-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(255, 193, 7, 0.4);
  color: #000;
}
.btn-modern-primary:hover::before {
  left: 100%;
}

.services-modern {
  position: relative;
  background: linear-gradient(180deg, #1a1a1a 0%, #0f0f0f 100%);
}
.services-modern .services-grid-modern {
  position: relative;
  z-index: 10;
}
.services-modern .services-bg-decoration {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(255, 193, 7, 0.05) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}
@media (max-width: 991.98px) {
  .services-modern .services-bg-decoration {
    width: 400px;
    height: 400px;
  }
}

.service-card-modern {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px 30px;
  margin-bottom: 30px;
  transition: all 0.4s ease;
  overflow: hidden;
}
@media (max-width: 991.98px) {
  .service-card-modern {
    padding: 30px 25px;
  }
}
.service-card-modern .service-number {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 72px;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.03);
  line-height: 1;
  transition: all 0.4s ease;
}
@media (max-width: 991.98px) {
  .service-card-modern .service-number {
    font-size: 60px;
  }
}
.service-card-modern .service-icon-modern {
  width: 70px;
  height: 70px;
  border-radius: 15px;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  transition: all 0.4s ease;
}
@media (max-width: 991.98px) {
  .service-card-modern .service-icon-modern {
    width: 60px;
    height: 60px;
    margin-bottom: 20px;
  }
}
.service-card-modern .service-icon-modern i {
  font-size: 28px;
  color: #EDA600;
  transition: all 0.4s ease;
}
@media (max-width: 991.98px) {
  .service-card-modern .service-icon-modern i {
    font-size: 24px;
  }
}
.service-card-modern h3 {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 15px;
  transition: all 0.4s ease;
}
@media (max-width: 991.98px) {
  .service-card-modern h3 {
    font-size: 20px;
    margin-bottom: 12px;
  }
}
.service-card-modern p {
  font-size: 15px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}
@media (max-width: 991.98px) {
  .service-card-modern p {
    font-size: 14px;
  }
}
.service-card-modern .service-decoration {
  position: absolute;
  bottom: -50px;
  right: -50px;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  transition: all 0.4s ease;
  pointer-events: none;
}
.service-card-modern:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 193, 7, 0.3);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}
.service-card-modern:hover .service-number {
  color: rgba(255, 193, 7, 0.1);
  transform: scale(1.1);
}
.service-card-modern:hover .service-icon-modern {
  background: linear-gradient(135deg, #FFC107, #FF9800);
  border-color: transparent;
  transform: scale(1.1) rotate(5deg);
}
.service-card-modern:hover .service-icon-modern i {
  color: #1a1a1a;
  transform: scale(1.1);
}
.service-card-modern:hover h3 {
  color: #EDA600;
}
.service-card-modern:hover .service-decoration {
  bottom: -30px;
  right: -30px;
  width: 200px;
  height: 200px;
}

.service-card-highlighted {
  background: rgba(255, 193, 7, 0.05);
  border-color: rgba(255, 193, 7, 0.2);
}
.service-card-highlighted:hover {
  background: rgba(255, 193, 7, 0.08);
}

.banner-slider {
  display: none;
}

.popular-services.popular-explore {
  display: none;
}

.services {
  display: none;
}

.search-box-banner {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);
  border-radius: 10px;
  padding: 25px;
  z-index: 1;
  position: relative;
  margin: -35px auto auto;
}
@media (max-width: 991.98px) {
  .search-box-banner {
    padding: 15px 15px 0;
    max-width: 100%;
  }
}
@media (max-width: 767.98px) {
  .search-box-banner {
    padding: 20px;
    max-width: 100%;
  }
}
.search-box-banner ul {
  list-style: none;
  margin: 0 -10px;
  padding: 0;
  outline: none;
}
.search-box-banner .group-img {
  position: relative;
}
.search-box-banner .group-img i {
  position: absolute;
  top: 15px;
  left: 15px;
}
@media (max-width: 991.98px) {
  .search-box-banner .group-img i {
    top: 13px;
  }
}
.search-box-banner .group-img input {
  padding: 13px 13px 13px 36px;
}
@media (max-width: 991.98px) {
  .search-box-banner .group-img input {
    padding: 10px 10px 10px 35px;
  }
}
.search-box-banner .input-block {
  margin: 0;
  padding: 0 10px;
}
.search-box-banner .input-block label {
  margin: 0 0 10px;
  font-weight: 700;
  font-size: 15px;
  color: #2F2F2F;
}
@media (max-width: 991.98px) {
  .search-box-banner .input-block label {
    font-size: 14px;
  }
}
.search-box-banner .search-btn .search-button {
  background-color: #1976d2;
  border: 1px solid #1976d2;
  box-shadow: inset 0 0 0 #ffffff;
  color: #ffffff;
  width: 100%;
  padding: 10px 12px;
}
.search-box-banner .search-btn .search-button i {
  margin-right: 8px;
}
@media (max-width: 767.98px) {
  .search-box-banner .search-btn .search-button {
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .search-box-banner .search-btn .search-button {
    padding: 8px 12px;
  }
}
.search-box-banner .search-btn .search-button:hover {
  background-color: #ffffff;
  border: 1px solid #201F1D;
  box-shadow: inset 0 70px 0 0 #ffffff;
  color: #201F1D;
}
.search-box-banner .column-group-last {
  flex: 13% 1;
  max-width: 13%;
}
@media (max-width: 991.98px) {
  .search-box-banner .column-group-last {
    flex: 50% 1;
    max-width: 50%;
  }
}
@media (max-width: 767.98px) {
  .search-box-banner .column-group-last {
    flex: 100% 1;
    max-width: 100%;
  }
}
.search-box-banner .column-group-last:last-child {
  padding-right: 0;
}
.search-box-banner .column-group-last .search-btn {
  margin-top: 30px;
}
@media (max-width: 991.98px) {
  .search-box-banner .column-group-last .search-btn {
    margin: 15px 0 0;
  }
}
@media (max-width: 767.98px) {
  .search-box-banner .column-group-last .search-btn {
    margin: 0;
  }
}
.search-box-banner .column-group-main {
  flex: 29% 1;
  max-width: 29%;
}
@media (max-width: 991.98px) {
  .search-box-banner .column-group-main {
    flex: 50% 1;
    max-width: 50%;
    margin-bottom: 15px;
  }
}
@media (max-width: 767.98px) {
  .search-box-banner .column-group-main {
    flex: 100% 1;
    max-width: 100%;
    margin-bottom: 0;
  }
}
.search-box-banner .column-group-main:last-child {
  padding-right: 0;
}
@media (max-width: 767.98px) {
  .search-box-banner .input-block-wrapp {
    display: block;
  }
}

.section-heading {
  text-align: center;
  margin: 0 0 50px;
}
@media (max-width: 991.98px) {
  .section-heading {
    margin: 0 0 30px;
  }
}
.section-heading h2 {
  position: relative;
  margin: 0 0 30px;
}
@media (max-width: 991.98px) {
  .section-heading h2 {
    margin: 0 0 20px;
  }
}
.section-heading h2:after {
  content: "";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-repeat: no-repeat;
  left: 0;
  height: 11px;
  right: 0;
  bottom: -22px;
  z-index: 99;
}
@media (max-width: 991.98px) {
  .section-heading h2:after {
    bottom: -17px;
  }
}
.section-heading p {
  max-width: 439px;
  margin: auto;
  font-size: 16px;
}
@media (max-width: 991.98px) {
  .section-heading p {
    font-size: 16px;
  }
}

.services {
  padding: 80px 0 56px;
}
@media (max-width: 991.98px) {
  .services {
    padding: 50px 0 36px;
  }
}
.services .service-right {
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .services .service-right {
    display: none;
  }
}
.services .services-group {
  margin: 0 0 24px;
  text-align: center;
  position: relative;
}
.services .services-group .services-icon {
  border-radius: 50px;
  margin: 0 0 35px;
  padding: 10px;
  background: #ffffff;
  position: relative;
  z-index: 99;
}
@media (max-width: 991.98px) {
  .services .services-group .services-icon {
    padding: 8px;
  }
}
.services .services-group .services-icon .icon-img {
  border-radius: 50px;
  width: 72px;
  height: 72px;
  padding: 10px;
}
@media (max-width: 991.98px) {
  .services .services-group .services-icon .icon-img {
    padding: 8px;
  }
}
.services .services-group .services-content h3 {
  margin: 0 0 10px;
}
.services .services-one {
  border-bottom: 2px solid #127384;
}
@media (max-width: 767.98px) {
  .services .services-one {
    border-bottom: 0;
  }
}
.services .services-two {
  border-bottom: 2px solid #FF9307;
}
@media (max-width: 767.98px) {
  .services .services-two {
    border-bottom: 0;
  }
}
.services .services-three {
  border-bottom: 2px solid #201F1D;
}
@media (max-width: 767.98px) {
  .services .services-three {
    border-bottom: 0;
  }
}
.services .services-three:before {
  border: 0;
  width: 0;
}

.popular-services {
  background: #F2F7F6;
}
.popular-services .listing-tabs-group {
  margin: 0 0 50px;
}
@media (max-width: 991.98px) {
  .popular-services .listing-tabs-group {
    margin: 0 0 30px;
  }
}
.popular-services .listing-tabs-group ul {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767.98px) {
  .popular-services .listing-tabs-group ul {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .popular-services .listing-tabs-group ul li a {
    min-width: 120px;
  }
}
.popular-services .listing-tabs-group ul li a {
  background: #ffffff;
  border: 1px solid #F4F4F4;
  padding: 10px 23px;
  text-transform: capitalize;
  font-weight: 400;
  font-size: 16px;
  color: #2F2F2F;
  border-radius: 6px;
}
@media (max-width: 991.98px) {
  .popular-services .listing-tabs-group ul li a {
    padding: 8px 18px;
    font-size: 14px;
    min-width: 120px;
  }
}
.popular-services .listing-tabs-group ul li a.active {
  background: #127384;
  color: #ffffff;
}
.popular-services .listing-tabs-group ul li a:hover {
  background: #127384;
  color: #ffffff;
}
.popular-services .listing-tabs-group ul li a span {
  margin: 0 10px 0 0;
  padding: 10px;
  line-height: 0;
  background: #FCFCFC;
  border: 1px solid #F2F7F6;
  border-radius: 6px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991.98px) {
  .popular-services .listing-tabs-group ul li a span {
    padding: 8px;
    width: 30px;
    height: 30px;
  }
}
.popular-services .owl-carousel .owl-dots.disabled {
  display: block;
}
.popular-services .owl-carousel .owl-nav.disabled {
  display: block;
}
.popular-services .owl-carousel .owl-prev {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-services .owl-carousel .owl-prev:hover i {
  background: #1976d2 !important;
  color: #ffffff;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-services .owl-carousel .owl-prev i {
  height: 55px;
  width: 55px;
  background: #ffffff !important;
  color: #2F2F2F;
  margin: auto 0;
  border-radius: 50%;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-services .owl-carousel .owl-next {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-services .owl-carousel .owl-next:hover i {
  background: #1976d2 !important;
  color: #ffffff;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-services .owl-carousel .owl-next i {
  height: 55px;
  width: 55px;
  background: #ffffff !important;
  color: #2F2F2F;
  margin: auto 0;
  border-radius: 50%;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}

.popular-explore {
  padding: 80px 0 56px 0;
}
@media (max-width: 991.98px) {
  .popular-explore {
    padding: 50px 0 26px 0;
  }
}

.listing-item {
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 0 24px 0;
  padding: 15px;
}
@media (max-width: 991.98px) {
  .listing-item {
    padding: 15px;
  }
}
.listing-item .listing-img {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  margin: 0 0 10px;
}
.listing-item .listing-img img {
  border-radius: 10px;
  width: 100%;
  transform: translateZ(0);
  transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;
}
.listing-item .listing-img .fav-item {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 15px;
  z-index: 1;
  font-size: 14px;
}
@media (max-width: 991.98px) {
  .listing-item .listing-img .fav-item {
    font-size: 13px;
  }
}
.listing-item .listing-img .fav-item .featured-text {
  background: #ffffff;
  border-radius: 5px;
  min-width: 75px;
  padding: 5px 15px;
  font-size: 14px;
  color: #737373;
}
@media (max-width: 991.98px) {
  .listing-item .listing-img .fav-item .featured-text {
    font-size: 12px;
  }
}
.listing-item .listing-img .fav-item .fav-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: #ffffff;
  border: 1px solid #ffffff;
}
.listing-item .listing-img .fav-icon.selected {
  background-color: #1976d2;
  border: 1px solid #1976d2 !important;
  color: #fff;
}
.listing-item:hover .listing-img img {
  transform: scale(1.15);
}
.listing-item:hover .listing-title a {
  color: #127384 !important;
}
.listing-item .listing-content {
  margin-top: 15px;
}
.listing-item .listing-content .listing-features {
  position: relative;
  border-bottom: 1px solid #F4F4F4;
  margin: 0 0 15px;
  padding: 0 0 15px;
}
.listing-item .listing-content .listing-features .author-img {
  position: absolute;
  top: -35px;
  z-index: 2;
  right: 15px;
  border-radius: 50px;
}
.listing-item .listing-content .listing-features .author-img img {
  width: 35px;
  height: 35px;
  border-radius: 50px;
  border: 2px solid #ffffff;
}
.listing-item .listing-content .listing-features .listing-title {
  margin-bottom: 5px;
  font-size: 20px;
}
.listing-item .listing-content .listing-features .listing-title a {
  font-weight: 600;
  color: #201F1D;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-features .listing-title a {
    font-size: 18px;
  }
}
.listing-item .listing-content .listing-features h6 {
  font-size: 15px;
  color: #787878;
  font-weight: 400;
}
.listing-item .listing-content .listing-features .list-rating i {
  color: #FF9307;
  font-size: 14px;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-features .list-rating i {
    font-size: 12px;
  }
}
.listing-item .listing-content .listing-features .list-rating span {
  font-weight: 500;
  color: #737373;
  margin: 0 0 0 8px;
}
.listing-item .listing-content .listing-details-group {
  margin: 0 0 15px;
}
.listing-item .listing-content .listing-details-group ul {
  margin: 0 0 10px;
}
.listing-item .listing-content .listing-details-group ul:last-child {
  margin: 0;
}
.listing-item .listing-content .listing-details-group ul li {
  flex: 33.33% 1;
  max-width: 33.33%;
}
.listing-item .listing-content .listing-details-group ul li span img {
  line-height: 0;
  width: 16px;
  display: flex;
  justify-content: center;
}
.listing-item .listing-content .listing-details-group ul li p {
  color: #787878;
  margin: 0 0 0 8px;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-details-group ul li p {
    font-size: 13px;
  }
}
.listing-item .listing-content .listing-location-details {
  background: #F2F7F6;
  padding: 8px;
  margin: 0 0 15px;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-location-details .listing-price {
    font-size: 13px;
  }
}
.listing-item .listing-content .listing-location-details .listing-price span {
  margin-right: 7px;
  line-height: 0;
}
.listing-item .listing-content .listing-location-details .listing-price h6 {
  font-weight: 700;
  font-size: 24px;
  color: #FF0000;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-location-details .listing-price h6 {
    font-size: 20px;
  }
}
.listing-item .listing-content .listing-location-details .listing-price h6 span {
  color: rgb(130, 130, 130);
  font-size: 14px;
  font-weight: 400;
  margin-left: 7px;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-location-details .listing-price h6 span {
    font-size: 12px;
  }
}
.listing-item .listing-content .listing-button .btn-order {
  background: #201F1D;
  position: relative;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  padding: 10px;
  width: 100%;
}
@media (max-width: 991.98px) {
  .listing-item .listing-content .listing-button .btn-order {
    font-size: 14px;
  }
}
.listing-item .listing-content .listing-button .btn-order span {
  line-height: 0;
}
.listing-item .listing-content .listing-button .btn-order span i {
  line-height: 0;
}
.listing-item:hover {
  transition: all 0.5s;
}
.listing-item:hover .btn-order {
  background-color: #127384 !important;
  color: #ffffff;
  border-radius: 5px;
}
.listing-item:hover .fav-icon {
  background: #127384;
  border: 1px solid #127384 !important;
  transition: all 0.5s;
}
.listing-item:hover .fav-icon i {
  color: #ffffff;
}

.popular-slider-group {
  margin: 0 0 50px;
}
.popular-slider-group .listing-owl-item .listing-owl-group {
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);
  text-align: center;
}
.popular-slider-group .listing-owl-item .listing-owl-group .listing-owl-img {
  margin: 0 0 20px;
}
.popular-slider-group .listing-owl-item .listing-owl-group .listing-owl-img img {
  width: 103px;
  height: 48px;
  text-align: center;
  margin: auto;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-slider-group .listing-owl-item .listing-owl-group h6 {
  margin: 0 0 5px;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-slider-group .listing-owl-item .listing-owl-group p {
  font-size: 14px;
  color: #737373;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-slider-group .listing-owl-item .listing-owl-group:hover {
  background-color: #127384;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-slider-group .listing-owl-item .listing-owl-group:hover .listing-owl-img img {
  filter: invert(1);
}
.popular-slider-group .listing-owl-item .listing-owl-group:hover h6 {
  color: #ffffff;
}
.popular-slider-group .listing-owl-item .listing-owl-group:hover p {
  color: #ffffff;
}
.popular-slider-group .owl-carousel .owl-dots.disabled {
  display: block;
}
.popular-slider-group .owl-carousel .owl-nav.disabled {
  display: block;
}
.popular-slider-group .owl-carousel .owl-prev {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
  transition: all 0.7s;
}
@media (max-width: 1199.98px) {
  .popular-slider-group .owl-carousel .owl-prev {
    left: 7px;
  }
}
.popular-slider-group .owl-carousel .owl-prev:hover i {
  background: #1976d2 !important;
  color: #ffffff;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-slider-group .owl-carousel .owl-prev i {
  height: 55px;
  width: 55px;
  background: #ffffff !important;
  margin: auto 0;
  border-radius: 50%;
  transition: all 0.7s;
}
@media (max-width: 1199.98px) {
  .popular-slider-group .owl-carousel .owl-prev i {
    height: 35px;
    width: 35px;
    font-size: 12px;
  }
}
.popular-slider-group .owl-carousel .owl-next {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  transition: all 0.7s;
}
@media (max-width: 1199.98px) {
  .popular-slider-group .owl-carousel .owl-next {
    right: 7px;
  }
}
.popular-slider-group .owl-carousel .owl-next:hover i {
  background: #1976d2 !important;
  color: #ffffff;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.popular-slider-group .owl-carousel .owl-next i {
  height: 55px;
  width: 55px;
  background: #ffffff !important;
  margin: auto 0;
  border-radius: 50%;
  transition: all 0.7s;
}
@media (max-width: 1199.98px) {
  .popular-slider-group .owl-carousel .owl-next i {
    height: 35px;
    width: 35px;
    font-size: 12px;
  }
}

.facts-number {
  background: #201F1D;
}
@media (max-width: 991.98px) {
  .facts-number {
    padding-bottom: 35px;
  }
}
.facts-number .facts-left img {
  position: absolute;
  left: -80px;
  top: 10px;
}
@media (max-width: 991.98px) {
  .facts-number .facts-left img {
    display: none;
  }
}
.facts-number .facts-right img {
  position: absolute;
  right: 60px;
  top: 30px;
}
@media (max-width: 991.98px) {
  .facts-number .facts-right img {
    display: none;
  }
}
.facts-number .count-group {
  position: relative;
  width: 100%;
  display: flex;
  top: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  border-radius: 10px;
  padding: 20px;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
@media (max-width: 991.98px) {
  .facts-number .count-group {
    margin: 0 0 15px;
    padding: 15px;
  }
}
.facts-number .count-group:hover {
  top: -10px;
}
.facts-number .count-group:hover .count-img {
  background: #127384;
}
.facts-number .count-group .count-img {
  padding: 24px;
  background: #201F1D;
  border-radius: 10px;
  display: flex;
  align-items: center;
  margin: 0 20px 0 0;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
@media (max-width: 991.98px) {
  .facts-number .count-group .count-img {
    padding: 15px;
  }
}
.facts-number .count-group .count-content h4 {
  font-weight: 900;
  margin: 0 0 7px;
}

.rental-car-item .fav-item-rental {
  position: absolute;
  top: -25px;
  z-index: 2;
  right: 15px;
  border-radius: 50px;
}
.rental-car-item .fav-item-rental .featured-text {
  background: #1976d2;
  border-radius: 3px;
  padding: 6px 10px;
  color: #ffffff;
  font-weight: 500;
  font-size: 15px;
}
@media (max-width: 991.98px) {
  .rental-car-item .fav-item-rental .featured-text {
    font-size: 14px;
  }
}
.rental-car-item .listing-title {
  margin: 5px 0 0;
}
.rental-car-item .listing-title a {
  font-weight: 700;
  color: #201F1D;
}
.rental-car-item .listing-title h6 {
  font-size: 16px;
  color: #2F2F2F;
  margin: 5px 0 0;
}
@media (max-width: 991.98px) {
  .rental-car-item .listing-title h6 {
    font-size: 15px;
  }
}
.rental-car-item .listing-title h6 span {
  color: #2F2F2F;
  font-weight: 400;
}

.why-choose .choose-left {
  position: absolute;
  left: 0;
  top: 10px;
}
@media (max-width: 991.98px) {
  .why-choose .choose-left {
    display: none;
  }
}
.why-choose .card {
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.why-choose .card .card-body .choose-img {
  margin: 0 0 20px;
  padding: 20px;
  border-radius: 10px;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
@media (max-width: 991.98px) {
  .why-choose .card .card-body .choose-img {
    padding: 15px;
  }
}
.why-choose .card .card-body .choose-img img {
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.why-choose .card .card-body .choose-black {
  background: #201F1D;
}
.why-choose .card .card-body .choose-secondary {
  background: #127384;
}
.why-choose .card .card-body .choose-primary {
  background: #1976d2;
}
.why-choose .card .card-body .choose-content {
  text-align: center;
}
.why-choose .card .card-body .choose-content h4 {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 20px 0;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
@media (max-width: 991.98px) {
  .why-choose .card .card-body .choose-content h4 {
    font-size: 22px;
    margin: 0 0 15px 0;
  }
}
.why-choose .card .card-body .choose-content p {
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
  max-width: 265px;
  margin: auto;
}
.why-choose .card:hover {
  background: #000;
}
.why-choose .card:hover .choose-black {
  background: #ffffff;
}
.why-choose .card:hover .choose-secondary {
  background: #ffffff;
}
.why-choose .card:hover .choose-primary {
  background: #ffffff;
}
.why-choose .card:hover .choose-content h4 {
  color: #ffffff;
}
.why-choose .card:hover .choose-content p {
  color: #ffffff;
}
.why-choose .card:hover .choose-img {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
}
.why-choose .card:hover .choose-img img {
  filter: invert(1);
}

.about-testimonial {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
@media (max-width: 991.98px) {
  .about-testimonial {
    background: #201F1D;
  }
}
.about-testimonial .owl-dots {
  text-align: center;
}
.about-testimonial .owl-dots .owl-dot {
  margin: 0 8px 0 0;
}
.about-testimonial .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
  margin: 0;
  background: #DBDBDB;
  border-radius: 50%;
  display: block;
  transition: all 0.4s ease;
}
.about-testimonial .owl-dots .owl-dot.active span {
  background: #1976d2;
  width: 46px;
  height: 8px;
  border-radius: 40px;
}

.user-app-group {
  background: #201F1D;
  position: relative;
  border-radius: 10px;
  margin: 56px 0 0;
  padding: 80px;
}
@media (max-width: 991.98px) {
  .user-app-group {
    margin: 26px 0 0;
    padding: 40px 40px 25px 40px;
  }
}
.user-app-group .userapp-heading h2 {
  font-weight: 900;
  font-size: 52px;
  color: #ffffff;
  margin: 0 0 15px;
}
@media (max-width: 991.98px) {
  .user-app-group .userapp-heading h2 {
    font-size: 32px;
  }
}
.user-app-group .userapp-heading p {
  font-size: 18px;
  color: #ffffff;
  margin: 0 0 37px;
}
@media (max-width: 991.98px) {
  .user-app-group .userapp-heading p {
    font-size: 16px;
    margin: 0 0 27px;
  }
}
@media (max-width: 767.98px) {
  .user-app-group .userapp-heading .download-btn {
    display: block;
  }
}
.user-app-group .userapp-heading .download-btn .app-avilable {
  margin: 0 7px 0 0;
}
@media (max-width: 991.98px) {
  .user-app-group .userapp-heading .download-btn .app-avilable {
    margin: 0 7px 15px 0;
  }
}
.user-app-group .app-left {
  position: absolute;
  left: 5%;
  bottom: 5%;
}
@media (max-width: 991.98px) {
  .user-app-group .app-left {
    display: none;
  }
}
.user-app-group .app-right {
  position: absolute;
  right: 30%;
  top: 10%;
}
@media (max-width: 991.98px) {
  .user-app-group .app-right {
    display: none;
  }
}

.bg-secondary {
  background: #127384 !important;
}

.border-secondary {
  border: 2px dashed #127384;
}

.bg-warning {
  background: #FF9307 !important;
}

.border-warning {
  border: 2px dashed #FF9307;
}

.bg-dark {
  background: #201F1D;
}

.border-dark {
  border: 2px dashed #201F1D;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
}
.bootstrap-datetimepicker-widget table .date-widge td {
  padding: 20px;
  width: 100%;
}
.bootstrap-datetimepicker-widget table td.active {
  background-color: #1976d2;
  text-shadow: unset;
}
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #1976d2;
  text-shadow: unset;
}
.bootstrap-datetimepicker-widget table th {
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
  width: 100%;
}
.bootstrap-datetimepicker-widget table td.day {
  font-size: 14px;
  font-weight: 400;
  padding: 10px;
}

.bootstrap-datetimepicker-widget .timepicker-hour table td {
  padding: 20px;
  width: 100%;
}
.bootstrap-datetimepicker-widget .timepicker-hour table th {
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
  width: 100%;
}
.bootstrap-datetimepicker-widget .timepicker-minute table td {
  padding: 20px;
  width: 100%;
}
.bootstrap-datetimepicker-widget .timepicker-minute table th {
  font-size: 14px;
  font-weight: 400;
  padding: 15px;
  width: 100%;
}

/* VAT Regime Badge Styles */
.vat-regime-badge-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.vat-regime-badge-small::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}
.vat-regime-badge-small:hover::before {
  left: 100%;
}
.vat-regime-badge-small.full {
  background: linear-gradient(135deg, #4CAF50 0%, #66BB6A 50%, #81C784 100%);
  color: white;
  border: 1px solid rgba(76, 175, 80, 0.3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.vat-regime-badge-small.full:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}
.vat-regime-badge-small.margin {
  background: linear-gradient(135deg, #2196F3 0%, #42A5F5 50%, #64B5F6 100%);
  color: white;
  border: 1px solid rgba(33, 150, 243, 0.3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.vat-regime-badge-small.margin:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

/*-----------------
    13. Common
-----------------------*/
@media (max-width: 1199.98px) {
  .container, .container-sm {
    max-width: 100%;
  }
}

.page-wrapper {
  margin-left: 247px;
  padding-top: 77px;
  position: relative;
  transition: all 0.4s ease;
}
@media (max-width: 1199.98px) {
  .page-wrapper {
    margin-left: 200px;
  }
}
.page-wrapper .content {
  padding: 25px;
}
@media (max-width: 1199.98px) {
  .page-wrapper .content {
    padding: 20px;
  }
}
@media (max-width: 991.98px) {
  .page-wrapper .content {
    padding: 15px;
  }
}
@media (max-width: 991.98px) {
  .page-wrapper {
    margin: 0;
    padding-top: 60px;
  }
}

.content-page-header {
  align-items: center;
  -webkit-align-items: center;
  margin: 0 0 30px 0;
}
@media (max-width: 575.98px) {
  .content-page-header {
    display: block;
  }
}
@media (max-width: 768px) {
  .content-page-header {
    margin: 0 0 30px 0;
  }
}
.content-page-header h5 {
  font-size: 24px;
  color: #9c27b0;
  font-weight: 600;
  margin: 0;
}
@media (max-width: 768px) {
  .content-page-header h5 {
    font-size: 18px;
  }
}
.content-page-header h6 {
  font-size: 20px;
  color: #9c27b0;
  font-weight: 600;
  margin: 0;
}

.card {
  background: #ffffff;
  box-shadow: 0 0 13px 0 rgba(82, 63, 105, 0.05);
  margin: 0 0 24px 0;
  display: inline-block;
  width: 100%;
  border: 0;
  border-radius: 8px;
}
.card .card-header {
  border-color: #f0f1f5;
  background-color: #ffffff;
  padding: 1.5rem;
}
.card .card-header:first-child {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
@media (max-width: 1199.98px) {
  .card .card-header {
    padding: 15px;
  }
}
.card .card-body {
  position: relative;
  padding: 1.5rem;
}
@media (max-width: 1199.98px) {
  .card .card-body {
    padding: 15px;
  }
}
.card .card {
  position: relative;
  padding: 1.5rem;
}
@media (max-width: 1199.98px) {
  .card .card {
    padding: 15px;
  }
}

.text-success-light {
  color: #1FBC2F !important;
}

.text-warning-light {
  color: #FFA633;
}

.warning-border {
  border: 1px solid #FFA633;
  padding: 0 3px;
  border-radius: 50px;
}

.danger-border {
  border: 1px solid #FF0000;
  padding: 0 3px;
  border-radius: 50px;
}

.info-border {
  border: 1px solid #377dff;
  padding: 0 3px;
  border-radius: 50px;
}

.text-primary {
  color: #1976d2 !important;
}

.text-danger {
  color: #FF0000 !important;
}

.text-gray-light {
  color: #201F1D;
}

.text-gray-dark {
  color: #3F4254;
}

.text-muted {
  color: #F2F7F6 !important;
}

.bg-light-gray {
  background: #F3F3F3;
}

.bg-primary-light {
  background: #EADDFF;
}

.bg-green-light {
  background: #E1FFED;
}

.bg-danger-light {
  background: #FFECEC;
}

.bg-white-smoke {
  background: #EFEFEF;
}

.bg-light-primary {
  background: #F2F7F6 !important;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}

.dropdown-item {
  font-size: 12px;
  padding: 8px 10px;
}

.add-cate-status {
  margin: 50px 0 0 0 !important;
}
@media (max-width: 575.98px) {
  .add-cate-status {
    margin: 0 !important;
  }
}

.input-block {
  margin: 0 0 15px 0;
}
.input-block .forgot-link {
  color: #FF0000;
  font-size: 14px;
}
.input-block label {
  margin: 0 0 10px 0;
  font-weight: 600;
  color: #2F2F2F;
}
@media (max-width: 1199.98px) {
  .input-block label {
    font-size: 14px;
  }
}
.input-block .optional {
  font-weight: 400;
  font-size: 12px;
  color: #201F1D;
}
.input-block .form-control {
  background: #FCFBFB;
  border: 1px solid #F4F4F4;
  box-shadow: none;
  border-radius: 5px;
  margin: 0;
  padding: 13px;
  font-size: 14px;
  font-weight: 400;
  color: #201F1D;
}
@media (max-width: 767.98px) {
  .input-block .form-control {
    margin: 0 0 15px;
    padding: 10px;
  }
}
.input-block .form-control ::placeholder, .input-block .form-control ::-webkit-input-placeholder, .input-block .form-control :-ms-input-placeholder {
  color: #201F1D;
  font-size: 14px;
  font-weight: 500;
}
.input-block .form-control:focus {
  background: #ffffff;
}
.input-block .form-control .form-title {
  font-weight: 600;
  font-size: 16px;
  color: #9c27b0;
  margin: 0 0 25px 0;
}
.input-block .search-btn .check-available {
  padding: 12px 20px;
}
.input-block textarea.form-control {
  height: auto;
}
.input-block .intl-tel-input, .input-block .iti {
  width: 100%;
}
.input-block .note-toolbar {
  background: #ffffff;
}
.input-block .note-editable {
  background: #ffffff;
}
.input-block .note-resizebar {
  height: 0 !important;
}
.input-block .toggle-password {
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, 50%);
}
.input-block .feather-eye-off {
  color: #201F1D;
}
.input-block .feather-eye {
  margin-right: 1px;
  color: #201F1D;
}

.custom_check {
  position: relative;
  padding-left: 30px;
}
.custom_check .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  border: 1px solid #828282;
  background-color: #ffffff;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
}
.custom_check .checkmark::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  position: absolute;
  display: none;
  left: 2px;
  top: 2px;
  color: #828282;
  font-size: 12px;
}
.custom_check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.custom_check input:checked ~ .checkmark {
  background-color: #ffffff;
}
.custom_check input:checked ~ .checkmark:after {
  display: block;
}
.custom_check span {
  color: #828282;
  font-weight: 400;
}

.pass-group {
  position: relative;
}

.close {
  background: transparent;
  border: 0;
  color: #28283C;
  font-size: 28px;
  line-height: normal;
  top: 20px;
  width: auto;
  height: auto;
  right: 20px;
}
.close span {
  background: #888888;
  border-radius: 50px;
  font-size: 20px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}
.close span:hover {
  background: #1976d2;
  color: #ffffff;
  transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}

.card-title {
  margin-bottom: 0;
  border-radius: 10px;
}

.cal-icon {
  position: relative;
  width: 100%;
}
.cal-icon:after {
  color: #979797;
  content: "\\f073";
  display: block;
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  font-size: 15px;
  margin: auto;
  position: absolute;
  right: 15px;
  top: 10px;
}

.cal-icon-info:after {
  font-family: "Feather";
  content: "\\e926";
  color: #201F1D;
  font-weight: 400;
  font-size: 18px;
  top: 8px;
}

.progress-wrap.active-progress {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.progress-wrap {
  position: fixed;
  right: 12px;
  bottom: 25px;
  height: 35px;
  width: 35px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-shadow: inset 0 0 0 2px rgba(75, 64, 237, 0.2);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  transition: all 200ms linear;
  transform: translateY(15px);
  -webkit-transform: translateY(15px);
  -moz-transform: translateY(15px);
  -ms-transform: translateY(15px);
  -o-transform: translateY(15px);
}
.progress-wrap::after {
  position: absolute;
  content: "\\f062";
  font-family: "FontAwesome";
  text-align: center;
  line-height: 35px;
  font-size: 17px;
  color: #ffffff;
  left: 0;
  top: 0;
  height: 35px;
  width: 35px;
  cursor: pointer;
  display: block;
  z-index: 1;
  transition: all 200ms linear;
}

.pagination .pagination {
  flex-wrap: wrap;
}
@media (max-width: 479px) {
  .pagination .pagination .previtem, .pagination .pagination .nextlink {
    margin-bottom: 10px;
  }
}
.pagination .pagination .previtem a, .pagination .pagination .nextlink a {
  height: 38px;
  border-radius: 10px;
  padding: 0 20px;
  color: #2F2F2F;
}
.pagination .pagination .previtem a:focus, .pagination .pagination .nextlink a:focus {
  outline: 0;
  box-shadow: none;
}
@media (max-width: 479px) {
  .pagination .pagination li .page-group ul {
    flex-wrap: wrap;
  }
}
@media (max-width: 479px) {
  .pagination .pagination li .page-group ul li {
    margin-bottom: 10px;
  }
}
.pagination .pagination-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination .pagination-center .page-group .page-item a {
  border: 1px solid #DEE2E7;
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 19px;
  margin: 0 12px 0 0;
  color: #2F2F2F;
  width: 47px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination .pagination-center .page-group .page-item a:focus {
  outline: 0;
  box-shadow: none;
}
.pagination .pagination-center .page-group .page-item a:hover {
  background-color: #127384;
  color: #ffffff;
  border: 1px solid #127384;
}
.pagination .pagination-center .page-group .page-item .active {
  background-color: #127384;
  color: #ffffff;
  border: 1px solid #127384;
}
.pagination .pagination-center .page-group ul {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 10px;
}

.privacy-section {
  position: relative;
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .privacy-section {
    padding: 40px 0;
  }
}
.privacy-section .terms-policy p {
  margin: 0 0 38px;
}
@media (max-width: 991.98px) {
  .privacy-section .terms-policy p {
    margin: 0 0 28px;
  }
}
.privacy-section .terms-policy ul {
  margin: 0 0 38px;
}
.privacy-section .terms-policy ul li {
  margin: 0 0 11px;
}
.privacy-section .terms-policy ul li span {
  margin-right: 10px;
  color: #FFA633;
}

.error-page {
  padding: 50px;
  align-items: center;
  color: #28283C;
  font-weight: 900;
}
@media (max-width: 575.98px) {
  .error-page {
    padding: 50px;
  }
}
.error-page .main-wrapper {
  display: flex;
  flex-wrap: wrap;
  height: auto;
  justify-content: center;
  width: 100%;
  min-height: unset;
}

.error-box {
  margin: 40px auto;
  max-width: 600px;
  text-align: center;
  width: 100%;
}
.error-box img {
  margin: 0 0 50px;
}
.error-box h3 {
  font-size: 28px;
  margin-bottom: 10px;
}
.error-box p {
  margin: auto auto 30px;
  color: #787878;
  font-weight: 500;
  max-width: 560px;
}
.error-box .btn-maintance {
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  padding: 12px 20px;
}
@media (max-width: 768px) {
  .error-box .btn-maintance {
    padding: 8px 12px;
    font-size: 14px;
  }
}
.error-box .error-500 {
  margin: 0 0 60px;
}
.error-box .coming-soon {
  padding: 50px 0 8px;
  color: #28283C;
}
@media (max-width: 767.98px) {
  .error-box .coming-soon {
    font-size: 20px;
  }
}
.error-box .back-button .btn {
  padding: 15px 20px;
  font-size: 16px;
}
@media (max-width: 575.98px) {
  .error-box .back-button .btn {
    padding: 10px;
    font-size: 14px;
  }
}

.serve-form {
  margin: 0 0 39px;
}
@media (max-width: 767.98px) {
  .serve-form {
    padding-bottom: 30px;
  }
}
.serve-form .input-block {
  margin-bottom: 0;
}
.serve-form .input-block .form-control {
  margin-right: 10px;
  font-size: 14px;
  background: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.serve-form .input-block .form-control::placeholder {
  color: #2F2F2F;
  font-weight: 500;
}
@media (max-width: 767.98px) {
  .serve-form .input-block .form-control {
    min-height: 46px;
    font-size: 14px;
  }
}
.serve-form .input-block .button-notific {
  min-width: 115px;
  height: 47px;
  color: #ffffff;
  border-radius: 5px;
  background: #201F1D;
  font-weight: 600;
  font-size: 16px;
}
@media (max-width: 767.98px) {
  .serve-form .input-block .button-notific {
    min-width: 100px;
    font-size: 14px;
  }
}
.serve-form .input-block .button-notific:hover {
  color: #ffffff;
  background: #3F4254;
  border: 1px solid #3F4254;
}

.progress-wrap.active-progress {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.progress-wrap {
  position: fixed;
  right: 12px;
  bottom: 25px;
  height: 35px;
  width: 35px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-shadow: inset 0 0 0 2px rgba(75, 64, 237, 0.2);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  transition: all 200ms linear;
  transform: translateY(15px);
  -webkit-transform: translateY(15px);
  -moz-transform: translateY(15px);
  -ms-transform: translateY(15px);
  -o-transform: translateY(15px);
}
.progress-wrap svg.progress-circle path {
  stroke: #1976d2;
  stroke-width: 4;
  box-sizing: border-box;
  transition: all 200ms linear;
}
.progress-wrap svg path {
  fill: none;
}
.progress-wrap::after {
  position: absolute;
  content: "\\f062";
  font-family: "FontAwesome";
  text-align: center;
  line-height: 35px;
  font-size: 17px;
  color: #1976d2;
  left: 0;
  top: 0;
  height: 35px;
  width: 35px;
  cursor: pointer;
  display: block;
  z-index: 1;
  transition: all 200ms linear;
}

iframe {
  width: 100%;
}

/*-----------------
    22. About Us
-----------------------*/
.about-img {
  position: relative;
  margin: 0 0 24px 0;
}
.about-img img {
  border-radius: 10px;
  padding: 0 0 0 10px;
}
.about-img .about-exp {
  position: absolute;
  background: #1976d2;
  border-radius: 10px;
  width: 370px;
  height: 100%;
}
@media (max-width: 767.98px) {
  .about-img .about-exp {
    width: 230px;
  }
}
.about-img .about-exp span {
  font-weight: 500;
  font-size: 28px;
  color: #ffffff;
  display: inline-block;
  margin: 250px -122px;
  transform: rotate(-90deg);
}
@media (max-width: 767.98px) {
  .about-img .about-exp span {
    font-size: 18px;
    margin: 275px -90px;
  }
}
@media (max-width: 575.98px) {
  .about-img .about-exp span {
    font-size: 16px;
    margin: 115px -75px;
  }
}

.abt-img {
  padding: 30px 0 30px 60px;
  position: relative;
  z-index: 1;
}

.about-content {
  margin: 0 0 0 50px;
}
@media (max-width: 991.98px) {
  .about-content {
    margin: 0;
  }
}
.about-content h6 {
  font-size: 18px;
  color: #127384;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0 0 12px;
}
.about-content h2 {
  font-size: 38px;
  font-weight: 500;
  margin: 0 0 30px;
}
@media (max-width: 991.98px) {
  .about-content h2 {
    font-size: 28px;
  }
}
@media (max-width: 767.98px) {
  .about-content h2 {
    font-size: 24px;
  }
}
.about-content p {
  margin: 0 0 14px;
}
.about-content ul li {
  position: relative;
  margin: 0 0 15px;
  padding: 0 0 0 25px;
  color: #828282;
}
.about-content ul li::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "\\f058";
  font-family: "FontAwesome";
  color: #127384;
}
.about-content ul li:last-child {
  margin: 0;
}

/*-----------------
    23. Product Details
-----------------------*/
.product-details {
  position: relative;
  z-index: 9;
  padding: 80px 0 56px 0;
}
@media (max-width: 991.98px) {
  .product-details {
    padding: 50px 0 26px 0;
  }
}

.product-detail-head {
  padding: 24px 0;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);
}
@media (max-width: 991.98px) {
  .product-detail-head {
    padding: 24px 24px 9px;
  }
}
@media (max-width: 767.98px) {
  .product-detail-head .detail-page-head {
    display: block;
  }
}
.product-detail-head .detail-page-head .list-rating {
  margin-bottom: 15px;
}
.product-detail-head .detail-page-head .list-rating i {
  color: #FFA633;
}
@media (max-width: 767.98px) {
  .product-detail-head .detail-page-head .camaro-info {
    margin-bottom: 15px;
  }
}
@media (max-width: 575.98px) {
  .product-detail-head .detail-page-head .camaro-location {
    align-items: start;
    flex-direction: column;
  }
}
@media (max-width: 575.98px) {
  .product-detail-head .detail-page-head .camaro-location .camaro-location-inner {
    display: flex;
    align-items: baseline;
  }
}
.product-detail-head .detail-page-head .year {
  display: inline-block;
  margin: 0 13px 0 0;
  padding: 10px 15px;
  background: #127384;
  color: #ffffff;
}
.product-detail-head .detail-page-head .average-list-rating {
  color: #737373;
  font-size: 15px;
  font-weight: 500;
  margin-left: 7px;
}
.product-detail-head .detail-page-head h3 {
  font-weight: 500;
  margin-bottom: 10px;
}
.product-detail-head .search-btn .search-button {
  background-color: #1976d2;
  border: 1px solid #1976d2;
  box-shadow: inset 0 0 0 #ffffff;
  color: #ffffff;
  padding: 12px 20px;
}
@media (max-width: 991.98px) {
  .product-detail-head .search-btn .search-button {
    width: 250px;
  }
}
@media (max-width: 991.98px) {
  .product-detail-head .search-btn .search-button {
    padding: 12px 8px;
  }
}
@media (max-width: 1199.98px) {
  .product-detail-head .search-btn .search-button {
    padding: 12px 12px;
  }
}
.product-detail-head .search-btn .search-button:hover {
  background-color: #ffffff;
  border: 1px solid #201F1D;
  box-shadow: inset 0 70px 0 0 #ffffff;
  color: #201F1D;
}
.product-detail-head .column-group-last {
  flex: 10% 1;
  max-width: 10%;
}
@media (max-width: 575.98px) {
  .product-detail-head .column-group-last {
    flex: 100% 1;
    max-width: 100%;
  }
}
@media (max-width: 991.98px) {
  .product-detail-head .column-group-last {
    flex: 50% 1;
    max-width: 50%;
  }
}
.product-detail-head .column-group-last:last-child {
  padding-right: 0;
}
.product-detail-head .column-group-last .search-btn {
  margin-top: 38px;
}
@media (max-width: 575.98px) {
  .product-detail-head .column-group-last .search-btn {
    margin: 0;
  }
}
.product-detail-head .column-group-main {
  flex: 30% 1;
  max-width: 30%;
}
@media (max-width: 991.98px) {
  .product-detail-head .column-group-main {
    flex: 50% 1;
    max-width: 50%;
    margin-bottom: 15px;
  }
}
@media (max-width: 575.98px) {
  .product-detail-head .column-group-main {
    flex: 100% 1;
    max-width: 100%;
    margin-bottom: 0;
  }
}
.product-detail-head .column-group-main:last-child {
  padding-right: 0;
}
@media (max-width: 991.98px) {
  .product-detail-head .details-btn {
    margin: 0;
    display: block;
  }
}
.product-detail-head .details-btn {
  gap: 15px;
}
.product-detail-head .details-btn a {
  background: #F2F7F6;
  color: #737373;
  border-radius: 40px;
  padding: 15px 45px;
}
@media (max-width: 991.98px) {
  .product-detail-head .details-btn a {
    margin: 0 0 15px;
  }
}
.product-detail-head .details-btn a:hover {
  background: #127384;
  color: #ffffff;
}
.product-detail-head .details-btn a:hover img {
  filter: contrast(50);
}
.product-detail-head .details-btn a i {
  margin-right: 8px;
}
.product-detail-head .details-btn a img {
  margin-right: 5px;
}

.slick-track {
  display: flex;
}

.slick-slide {
  width: 25% !important;
  margin: 0 10px;
  overflow: hidden;
}
.slick-slide.slick-cloned {
  width: 25% !important;
  margin: 0 10px;
  overflow: hidden;
}
.slick-slide.slick-active {
  width: 25% !important;
  margin: 0 10px;
  overflow: hidden;
}
.slick-slide img {
  width: 100%;
  border-radius: 10px;
}

.detail-bigimg {
  position: relative;
  margin-bottom: 15px;
  z-index: 999;
}
.detail-bigimg button {
  width: 50px;
  height: 50px;
  font-size: 0;
  background: #ffffff;
  border-radius: 50%;
  border: none;
  z-index: 9999;
}
@media (max-width: 991.98px) {
  .detail-bigimg button {
    width: 35px;
    height: 35px;
  }
}
.detail-bigimg button.slick-prev {
  position: absolute;
  top: 50%;
  left: 30px;
  transform: translateY(-50%);
}
.detail-bigimg button.slick-prev:hover {
  background: #1976d2 !important;
  color: #ffffff;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.detail-bigimg button.slick-prev:before {
  content: "\\f060";
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  font-size: 15px;
  font-weight: 900;
}
@media (max-width: 991.98px) {
  .detail-bigimg button.slick-prev:before {
    font-size: 13px;
  }
}
.detail-bigimg button.slick-next {
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
.detail-bigimg button.slick-next:hover {
  background: #1976d2 !important;
  color: #ffffff;
  transition: 500ms all ease;
  -moz-transition: 500ms all ease;
  -ms-transition: 500ms all ease;
}
.detail-bigimg button.slick-next:before {
  content: "\\f061";
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  font-size: 15px;
  font-weight: 900;
}
@media (max-width: 991.98px) {
  .detail-bigimg button.slick-next:before {
    font-size: 13px;
  }
}

.detail-product {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);
  border-radius: 5px;
  overflow: hidden;
  padding: 20px 10px;
}

.extra-service span {
  color: #2F2F2F;
  font-weight: 500;
}

.specification-card {
  background: #fff;
  padding: 24px 24px 0;
  box-shadow: 3px 5px 13px rgba(222, 226, 231, 0.44);
  margin: 24px 0 24px;
  border: 0;
}
.specification-card .card-body {
  padding: 0;
}
.specification-card .feature-img {
  width: 60px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #DBDBDB;
  border-radius: 5px;
  margin: 0 12px 0 0;
  flex-shrink: 0;
}
.specification-card .feature-img.access-feature {
  margin-bottom: 0px;
}
.specification-card .featues-info h6 {
  color: #737373;
  margin-bottom: 0;
  font-weight: 400;
  font-size: 14px;
}
.specification-card .featues-info span {
  color: #201F1D;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 5px;
}
.specification-card .featureslist {
  margin: 0 0px 24px 0;
}
.specification-card .access-feature.featureslist:last-child {
  margin: 0;
}

.listing-feature {
  padding: 24px 24px 9px;
}
.listing-feature ul li {
  margin: 0 0 15px 0;
  color: #737373;
}
.listing-feature ul li span {
  padding: 8px;
  background: #127384;
  border-radius: 50%;
  margin-right: 8px;
}
.listing-feature ul li span i {
  font-size: 10px;
  color: #ffffff;
}

.description-list p {
  margin-bottom: 24px;
}
.description-list p:last-child {
  margin-bottom: 0;
}

@media (max-width: 575.98px) {
  .review-header-group {
    flex-direction: column;
    align-items: start;
  }
}

.review-list-rating {
  color: #2F2F2F;
  margin-top: 15px;
}
@media (max-width: 767.98px) {
  .review-list-rating {
    flex-direction: column;
    align-items: start;
  }
}
.review-list-rating li {
  margin-right: 20px;
  text-transform: capitalize;
}
@media (max-width: 767.98px) {
  .review-list-rating li {
    margin-bottom: 10px;
  }
  .review-list-rating li:last-child {
    margin-bottom: 0;
  }
}
@media (max-width: 1199.98px) {
  .review-list-rating li {
    margin-right: 10px;
  }
}
.review-list-rating li p {
  margin-left: 8px;
}
.review-list-rating li p i {
  font-size: 12px;
  color: #FF9307;
}

.review-sec .leave-reply-form .review-list-rating {
  margin-top: 0;
  margin-bottom: 25px;
}
.review-sec .leave-reply-form .review-list-rating li p i {
  color: #828282;
}

.short-video img {
  border-radius: 10px;
}

.details-slider-heading {
  margin-bottom: 25px;
}
@media (max-width: 767.98px) {
  .details-slider-heading h3 {
    margin-top: 30px;
  }
}

.details-car-grid {
  padding: 50px 0 0;
}

.car-details-slider.owl-carousel .owl-nav {
  display: flex;
  -webkit-display: flex;
  position: absolute;
  top: -80px;
  right: 0;
}
@media (max-width: 767.98px) {
  .car-details-slider.owl-carousel .owl-nav {
    left: 0;
    top: -100px;
  }
}
.car-details-slider.owl-carousel .owl-nav .owl-prev, .car-details-slider.owl-carousel .owl-nav .owl-next {
  width: 55px;
  height: 55px;
  border: 1px solid #F4F4F4;
  box-shadow: 0px 4px 24px rgba(255, 255, 255, 0.2);
  background: #ffffff;
  border-radius: 50%;
  transition: all 0.2s ease;
}
@media (max-width: 991.98px) {
  .car-details-slider.owl-carousel .owl-nav .owl-prev, .car-details-slider.owl-carousel .owl-nav .owl-next {
    width: 35px;
    height: 35px;
    font-size: 12px;
  }
}
.car-details-slider.owl-carousel .owl-nav .owl-prev:hover, .car-details-slider.owl-carousel .owl-nav .owl-next:hover {
  background: #1976d2;
  color: #ffffff;
  transition: all 0.2s ease;
}
.car-details-slider.owl-carousel .owl-nav .owl-next {
  margin-left: 15px;
}

.owner-detail {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.owner-detail .owner-img img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 15px;
}
@media (max-width: 991.98px) {
  .owner-detail .owner-img img {
    width: 40px;
    height: 40px;
  }
}
.owner-detail .reviewbox-list-rating h5 {
  color: #2F2F2F;
  font-size: 18px;
}
@media (max-width: 991.98px) {
  .owner-detail .reviewbox-list-rating h5 {
    font-size: 16px;
    margin-bottom: 5px;
  }
}

.booking-list {
  margin-bottom: 20px;
}
.booking-list li {
  display: flex;
  color: #737373;
  margin: 0 0 13px;
  padding: 0 0 13px;
  border-bottom: 1px solid #DBDBDB;
}
.booking-list li span {
  color: #2F2F2F;
  font-size: 16px;
}
.booking-list li:last-child {
  border: none;
  margin: 0;
  padding: 0;
}
.booking-list li h6 {
  color: #1FBC2F;
}

.message-btn {
  display: flex;
  justify-content: center;
}
.message-btn a {
  width: 100%;
  background: #201F1D;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  padding: 12px 20px;
}
@media (max-width: 991.98px) {
  .message-btn a {
    font-size: 15px;
    padding: 10px 18px;
  }
}
.message-btn a:hover {
  background-color: #ffffff;
  border: 1px solid #201F1D;
  box-shadow: inset 0 70px 0 0 #ffffff;
  color: #201F1D;
}

.share-car ul {
  display: flex;
}
.share-car ul li {
  margin-right: 8px;
}
.share-car ul li:last-child {
  margin-right: 0;
}
.share-car ul li .fa-pinterest-p {
  background: #ff2d20;
}

.modal.custom-modal.check-availability-modal {
  z-index: 99999;
}
.modal.custom-modal.check-availability-modal .modal-dialog {
  max-width: 660px;
}
.modal.custom-modal.check-availability-modal .modal-content {
  padding: 30px;
}
@media (max-width: 767.98px) {
  .modal.custom-modal.check-availability-modal .modal-content {
    padding: 15px;
  }
}
.modal.custom-modal.check-availability-modal .modal-content .modal-header {
  margin: 0 0 20px;
  padding: 0 0 20px;
}
.modal.custom-modal.check-availability-modal .modal-content .modal-header .close span {
  background: #ffffff;
  border: 3px solid #FF0000;
  border-radius: 10px 10px 10px 0;
  color: #FF0000;
}
.modal.custom-modal.check-availability-modal .modal-content .modal-body {
  margin: 0 0 20px 0;
  padding: 0;
}
.modal .available-for-ride {
  border: 1px solid #1FBC2F;
  color: #1FBC2F;
  border-radius: 5px;
  padding: 15px;
  background: rgba(31, 188, 47, 0.09);
  margin-bottom: 20px;
}
.modal .available-for-ride p {
  color: #1FBC2F;
  font-size: 18px;
}
.modal .available-for-ride p i {
  margin-right: 8px;
  font-size: 14px;
}
.modal .booking-info {
  border: 1px solid #DBDBDB;
  background: #FCFCFC;
  border-radius: 10px;
  margin: 0 0 20px 0;
  padding: 20px;
}
@media (max-width: 767.98px) {
  .modal .booking-info {
    padding: 15px;
  }
}
.modal .booking-info h5 {
  margin-bottom: 15px;
}
.modal .booking-info p {
  margin-bottom: 15px;
}
.modal .booking-info span {
  color: #828282;
}
.modal .booking-info h6 {
  color: #828282;
}
.modal .booking-info h6 span {
  color: #FF0000;
  font-size: 24px;
}
.modal .booking-info.seat-select {
  background: #ffffff;
}
.modal .booking-info.seat-select h6 {
  color: #2F2F2F;
  font-size: 15px;
  margin-bottom: 15px;
}
.modal .booking-info.seat-select label {
  color: #828282;
  font-size: 14px;
  font-weight: 600;
  padding-left: 25px;
}
.modal .booking-info.seat-select label span {
  color: #FF0000;
}
.modal .booking-info.seat-select label input:checked ~ .checkmark {
  background: #201F1D;
}
.modal .booking-info.seat-select label input:checked ~ .checkmark::after {
  color: #ffffff;
}
.modal .booking-info.pay-amount {
  background: #ffffff;
}
.modal .booking-info.pay-amount h6 {
  margin-bottom: 15px;
}
.modal .booking-info.pay-amount .radio-btn {
  margin-bottom: 10px;
}
.modal .booking-info.pay-amount label {
  padding-left: 0;
}
.modal .booking-info.pay-amount label input {
  width: 15px;
  height: 15px;
  background: #ffffff;
  margin-right: 10px;
}
.modal .booking-info.pay-amount label input:checked {
  background: #2F2F2F;
}
.modal .booking-info.service-tax {
  background: #ffffff;
}
.modal .booking-info.service-tax ul li {
  color: #888888;
  margin: 0 0 20px 0;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #DBDBDB;
}
.modal .booking-info.service-tax ul li span {
  color: #888888;
}
.modal .booking-info.service-tax ul li:last-child {
  margin: 0;
  padding: 0;
  border-bottom: none;
}
.modal .grand-total {
  background: #F2F7F6;
  padding: 20px;
  border-radius: 10px;
}
.modal .grand-total h5 {
  font-size: 20px;
  color: #2F2F2F;
}
.modal .grand-total span {
  font-size: 20px;
  color: #2F2F2F;
}
.modal .modal-footer {
  margin: 0;
  padding: 0;
  border: 0;
}
.modal .modal-footer a {
  margin: 0;
  padding: 12px 20px;
  background: #201F1D;
  color: #ffffff;
}
.modal .modal-footer a i {
  margin-left: 8px;
}

.booking-section {
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .booking-section {
    padding: 50px 0;
  }
}
.booking-section .booking-tab {
  justify-content: center;
  margin-bottom: 30px;
}
@media (max-width: 575.98px) {
  .booking-section .booking-tab {
    flex-direction: column;
  }
}
.booking-section .booking-tab li {
  margin-right: 15px;
}
@media (max-width: 575.98px) {
  .booking-section .booking-tab li {
    margin: 0 0 20px 0;
    padding: 0;
  }
}
.booking-section .booking-tab li a {
  padding: 20px;
  background: #F2F7F6;
  min-width: 260px;
  border: 1px solid #ffffff;
}
.booking-section .booking-tab li a span {
  color: #DBDBDB;
  margin-bottom: 8px;
  display: inline-block;
}
.booking-section .booking-tab li a h5 {
  color: #DBDBDB;
  font-size: 20px;
}
.booking-section .booking-tab li a.active {
  background: #ffffff;
  border: 1px solid #F4F4F4;
}
.booking-section .booking-tab li a.active h5 {
  color: #2F2F2F;
}
.booking-section .booking-tab li a.active span {
  color: #127384;
  font-weight: 600;
}
.booking-section .booking-tab li:last-child {
  margin: 0;
}
@media (max-width: 575.98px) {
  .booking-section .booking-tab li:last-child {
    margin: 0;
  }
}

.booking-details {
  max-width: 900px;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 40px;
  padding: 30px;
}
.booking-details .booking-title h3 {
  color: #000;
  font-weight: 600;
  margin-bottom: 20px;
}
.booking-details .booking-info {
  border: 1px solid #DBDBDB;
  background: #F2F7F6;
  border-radius: 10px;
  margin: 0 0 20px 0;
  padding: 20px;
}
.booking-details .booking-info .pickup-address {
  padding-left: 0;
}
@media (max-width: 767.98px) {
  .booking-details .booking-info .pickup-address {
    margin-bottom: 20px;
  }
}
@media (max-width: 767.98px) {
  .booking-details .booking-info .drop-address {
    margin-bottom: 20px;
    padding-left: 0;
  }
}
@media (max-width: 767.98px) {
  .booking-details .booking-info .booking-amount {
    padding-left: 0;
  }
}
.booking-details .booking-info h5 {
  color: #2F2F2F;
  font-size: 18px;
  margin-bottom: 10px;
}
.booking-details .booking-info p {
  color: #828282;
  margin-bottom: 5px;
}
.booking-details .booking-info span {
  color: #828282;
}
.booking-details .booking-info h6 {
  color: #828282;
}
.booking-details .booking-info h6 span {
  color: #FF0000;
  font-size: 24px;
}
.booking-details .booking-info h6 span i {
  color: #201F1D;
  font-size: 18px;
}
.booking-details .booking-form .booking-title h5 {
  color: #201F1D;
  font-size: 20px;
  margin: 0 0 20px;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #DBDBDB;
}
.booking-details .booking-form .payment-btn {
  justify-content: end;
}
.booking-details .booking-form .payment-btn button {
  background: #201F1D;
  color: #ffffff;
  border: 1px solid #201F1D;
}
.booking-details .booking-form .payment-btn button:hover {
  background: #ffffff;
  color: #201F1D;
  border: 1px solid #201F1D;
}
.booking-details.payment-details {
  max-width: 800px;
}

.back-detail-page {
  text-align: center;
}
.back-detail-page a {
  color: #FF0000;
}

.payment-method {
  border: 1px solid #DBDBDB;
  padding: 20px;
  border-radius: 10px;
}
.payment-method h4 {
  color: #201F1D;
  font-size: 20px;
  margin-bottom: 20px;
}
@media (max-width: 575.98px) {
  .payment-method h4 {
    font-size: 16px;
  }
}
.payment-method ul {
  margin-bottom: 20px;
}
@media (max-width: 767.98px) {
  .payment-method ul {
    flex-wrap: wrap;
  }
}
@media (max-width: 767.98px) {
  .payment-method ul li {
    flex-basis: 48%;
    margin-bottom: 20px;
  }
  .payment-method ul li:last-child {
    margin-bottom: 0;
  }
  .payment-method ul li:nth-child(3) {
    margin-bottom: 0;
  }
}
@media (max-width: 767.98px) and (max-width: 575.98px) {
  .payment-method ul li {
    flex-basis: 100%;
  }
  .payment-method ul li:nth-child(3) {
    margin-bottom: 20px;
  }
}
.payment-method ul li a {
  background: #F2F7F6;
  width: 150px;
  height: 100px;
  border-radius: 10px;
}
@media (max-width: 767.98px) {
  .payment-method ul li a {
    width: 100%;
  }
}
.payment-method .payment-checkbox label {
  color: #787878;
  font-weight: 400;
}
.payment-method .payment-checkbox label span {
  color: #FF0000;
}
.payment-method .payment-checkbox label input:checked ~ .checkmark {
  background: #201F1D;
}
.payment-method .payment-checkbox label input:checked ~ .checkmark::after {
  color: #ffffff;
}

.modal.custom-modal.check-availability-modal.payment-success-modal .modal-dialog {
  max-width: 400px;
}
.modal.custom-modal.check-availability-modal.payment-success-modal .modal-dialog .modal-body {
  text-align: center;
  margin: 0;
}
.modal .payment-success .check {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #1FBC2F;
  margin: auto;
  margin-bottom: 25px;
}
.modal .payment-success .check i {
  color: #ffffff;
}
.modal .payment-success h5 {
  color: #1FBC2F;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
}
.modal .payment-success p {
  color: #737373;
  margin-bottom: 25px;
}
.modal .payment-success p span {
  color: #201F1D;
  font-weight: 600;
}
.modal .payment-success .order-confirm a {
  border: 2px solid #201F1D;
  color: #201F1D;
  font-weight: 700;
  padding: 10px 20px;
  display: inline-block;
  border-radius: 5px;
}

.order-confirmation {
  padding: 80px 0;
}
@media (max-width: 991.98px) {
  .order-confirmation {
    padding: 50px 0;
  }
}
@media (max-width: 767.98px) {
  .order-confirmation {
    padding: 40px 0;
  }
}
.order-confirmation .section-title {
  max-width: 900px;
  margin: 0 auto 20px;
  padding: 0;
}
@media (max-width: 767.98px) {
  .order-confirmation .section-title {
    display: block;
  }
}
.order-confirmation .section-title h5 {
  color: #2F2F2F;
}
@media (max-width: 767.98px) {
  .order-confirmation .section-title h5 {
    margin: 15px 0 0;
  }
}
.order-confirmation .section-title h5 span {
  font-weight: 700;
  font-size: 20px;
}
.order-confirmation .order-confirm-box .confirmation-title {
  margin: 0 0 20px;
  padding: 0 0 20px;
  border-bottom: 1px solid #DBDBDB;
}
.order-confirmation .order-confirm-box .confirmation-title h4 {
  color: #201F1D;
  font-size: 18px;
}
.order-confirmation .order-confirm-box .confirmation-title a {
  color: #2F2F2F;
  font-weight: 600;
}
.order-confirmation .order-confirm-box .confirmation-title a:hover {
  color: #1976d2;
}
.order-confirmation .order-confirm-box .order-car {
  margin-bottom: 20px;
}
.order-confirmation .order-confirm-box .order-car img {
  width: 90px;
  border-radius: 10px;
  margin-right: 10px;
}
.order-confirmation .order-confirm-box .order-car h5 {
  color: #1FBC2F;
  font-size: 18px;
}
.order-confirmation .order-confirm-box .order-car h5 span {
  color: #FF0000;
  font-size: 16px;
  display: block;
  margin-top: 8px;
  font-weight: 600;
}
.order-confirmation .order-confirm-box .visa-card {
  margin-bottom: 30px;
}
.order-confirmation .order-confirm-box .visa-card a {
  display: block;
  margin-bottom: 10px;
}
.order-confirmation .order-confirm-box .visa-card h6 {
  color: #737373;
}
@media (max-width: 991.98px) {
  .order-confirmation .order-confirm-box .address-info {
    margin-bottom: 30px;
  }
}
.order-confirmation .order-confirm-box .address-info li {
  color: #737373;
  margin-bottom: 10px;
}
.order-confirmation .order-confirm-box .address-info li:last-child {
  margin-bottom: 0;
}
.order-confirmation .place-order-btn {
  text-align: right;
  max-width: 900px;
  margin: auto;
}
.order-confirmation .place-order-btn a {
  align-items: center;
  padding: 12px 20px;
}

.listing-details-modern {
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%);
  min-height: 100vh;
}
.listing-details-modern .loading-modern {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 20px;
}
.listing-details-modern .loading-modern .loading-spinner-modern {
  position: relative;
  width: 80px;
  height: 80px;
}
.listing-details-modern .loading-modern .loading-spinner-modern .spinner-ring {
  position: absolute;
  border: 4px solid transparent;
  border-top-color: #FFC107;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}
.listing-details-modern .loading-modern .loading-spinner-modern .spinner-ring:nth-child(1) {
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}
.listing-details-modern .loading-modern .loading-spinner-modern .spinner-ring:nth-child(2) {
  width: 60px;
  height: 60px;
  top: 10px;
  left: 10px;
  border-top-color: #FF9800;
  animation-delay: 0.3s;
}
.listing-details-modern .loading-modern .loading-spinner-modern .spinner-ring:nth-child(3) {
  width: 40px;
  height: 40px;
  top: 20px;
  left: 20px;
  border-top-color: #FFC107;
  animation-delay: 0.6s;
}
.listing-details-modern .loading-modern p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 600;
}
.listing-details-modern .not-found-modern {
  text-align: center;
  padding: 100px 20px;
}
.listing-details-modern .not-found-modern i {
  font-size: 80px;
  color: #FFC107;
  margin-bottom: 20px;
}
.listing-details-modern .not-found-modern h2 {
  color: white;
  margin-bottom: 30px;
}
.listing-details-modern .listing-hero-modern {
  position: relative;
  padding: 120px 0 60px;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  overflow: hidden;
}
@media (max-width: 991px) {
  .listing-details-modern .listing-hero-modern {
    padding: 100px 0 40px;
  }
}
.listing-details-modern .listing-hero-modern .hero-overlay-modern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(255, 193, 7, 0.1) 0%, transparent 50%);
  pointer-events: none;
}
.listing-details-modern .listing-hero-modern .listing-hero-content {
  position: relative;
  z-index: 10;
}
.listing-details-modern .listing-hero-modern .listing-hero-content .hero-badge-modern {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}
.listing-details-modern .listing-hero-modern .listing-hero-content .hero-badge-modern .year-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 50px;
  color: #FFC107;
  font-weight: 700;
  font-size: 14px;
}
.listing-details-modern .listing-hero-modern .listing-hero-content .hero-badge-modern .discount-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: linear-gradient(135deg, #e63946, #d62828);
  border-radius: 50px;
  color: white;
  font-weight: 700;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(230, 57, 70, 0.3);
}
.listing-details-modern .listing-hero-modern .listing-hero-content h1 {
  font-size: 56px;
  font-weight: 800;
  color: white;
  margin-bottom: 25px;
  letter-spacing: -0.02em;
  background: linear-gradient(135deg, #ffffff 0%, #FFC107 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@media (max-width: 991px) {
  .listing-details-modern .listing-hero-modern .listing-hero-content h1 {
    font-size: 40px;
  }
}
@media (max-width: 767px) {
  .listing-details-modern .listing-hero-modern .listing-hero-content h1 {
    font-size: 32px;
  }
}
.listing-details-modern .listing-hero-modern .listing-hero-content .hero-quick-specs {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}
@media (max-width: 767px) {
  .listing-details-modern .listing-hero-modern .listing-hero-content .hero-quick-specs {
    gap: 20px;
  }
}
.listing-details-modern .listing-hero-modern .listing-hero-content .hero-quick-specs span {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  font-weight: 600;
}
.listing-details-modern .listing-hero-modern .listing-hero-content .hero-quick-specs span i {
  color: #FFC107;
  font-size: 18px;
}
.listing-details-modern .listing-content-modern {
  background: #0a0a0a;
  padding: 60px 0 80px;
}
@media (max-width: 991px) {
  .listing-details-modern .listing-content-modern {
    padding: 40px 0 60px;
  }
}
.listing-details-modern .product-img-modern {
  margin-bottom: 30px;
  border-radius: 16px;
  overflow: hidden;
}
.listing-details-modern .product-img-modern .image-gallery {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  padding: 15px;
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-slide {
  border-radius: 12px;
  overflow: hidden;
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-slide img {
  border-radius: 12px;
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-thumbnail {
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-thumbnail.active {
  border-color: #FFC107;
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-thumbnail:hover {
  border-color: rgba(255, 193, 7, 0.5);
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-icon {
  color: white;
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.5));
}
.listing-details-modern .product-img-modern .image-gallery .image-gallery-icon:hover {
  color: #FFC107;
}
.listing-details-modern .specs-card-modern {
  background: rgba(255, 255, 255, 0.03);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 30px;
}
@media (max-width: 991px) {
  .listing-details-modern .specs-card-modern {
    padding: 20px;
  }
}
.listing-details-modern .specs-card-modern .card-header-modern {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.listing-details-modern .specs-card-modern .card-header-modern i {
  color: #FFC107;
  font-size: 24px;
}
.listing-details-modern .specs-card-modern .card-header-modern h4 {
  color: white;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 10px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
}
@media (max-width: 767px) {
  .listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern {
    padding: 12px;
  }
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern:hover {
  background: rgba(255, 193, 7, 0.05);
  border: 1px solid rgba(255, 193, 7, 0.2);
  transform: translateX(5px);
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern .spec-icon-modern {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 193, 7, 0.1);
  border-radius: 10px;
  flex-shrink: 0;
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern .spec-icon-modern i {
  color: #FFC107;
  font-size: 20px;
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern .spec-info-modern {
  flex: 1 1;
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern .spec-info-modern span {
  display: block;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 3px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.listing-details-modern .specs-card-modern .card-body-modern .specs-grid-modern .spec-item-modern .spec-info-modern h6 {
  color: white;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.listing-details-modern .description-card-modern {
  background: rgba(255, 255, 255, 0.03);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 30px;
}
@media (max-width: 991px) {
  .listing-details-modern .description-card-modern {
    padding: 20px;
  }
}
.listing-details-modern .description-card-modern .card-header-modern {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.listing-details-modern .description-card-modern .card-header-modern i {
  color: #FFC107;
  font-size: 24px;
}
.listing-details-modern .description-card-modern .card-header-modern h4 {
  color: white;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}
.listing-details-modern .description-card-modern .card-body-modern p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  line-height: 1.8;
  margin: 0;
}
.listing-details-modern .sticky-sidebar-modern {
  position: sticky;
  top: 100px;
}
@media (max-width: 991px) {
  .listing-details-modern .sticky-sidebar-modern {
    position: static;
    margin-top: 30px;
  }
}
.listing-details-modern .inquiry-card-modern {
  background: rgba(255, 255, 255, 0.03);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 30px;
}
@media (max-width: 991px) {
  .listing-details-modern .inquiry-card-modern {
    padding: 25px;
  }
}
.listing-details-modern .inquiry-card-modern .price-section-modern {
  text-align: center;
  padding: 25px;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 152, 0, 0.1));
  border-radius: 12px;
  margin-bottom: 25px;
}
.listing-details-modern .inquiry-card-modern .price-section-modern .price-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.listing-details-modern .inquiry-card-modern .price-section-modern .price-old {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: line-through;
  margin-bottom: 5px;
}
.listing-details-modern .inquiry-card-modern .price-section-modern .price-current {
  font-size: 42px;
  font-weight: 800;
  color: white;
  line-height: 1;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@media (max-width: 767px) {
  .listing-details-modern .inquiry-card-modern .price-section-modern .price-current {
    font-size: 36px;
  }
}
.listing-details-modern .inquiry-card-modern .price-section-modern .savings-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #e63946, #d62828);
  border-radius: 50px;
  color: white;
  font-size: 13px;
  font-weight: 700;
}
.listing-details-modern .inquiry-card-modern .price-section-modern .savings-badge i {
  font-size: 14px;
}
.listing-details-modern .inquiry-card-modern .divider-modern {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin: 25px 0;
}
.listing-details-modern .inquiry-card-modern .form-header-modern {
  text-align: center;
  margin-bottom: 25px;
}
.listing-details-modern .inquiry-card-modern .form-header-modern i {
  font-size: 32px;
  color: #FFC107;
  margin-bottom: 10px;
}
.listing-details-modern .inquiry-card-modern .form-header-modern h4 {
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
}
.listing-details-modern .inquiry-card-modern .form-header-modern p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  margin: 0;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern {
  margin-bottom: 20px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern label i {
  color: #FFC107;
  font-size: 16px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern .input-modern {
  width: 100%;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: white;
  font-size: 14px;
  transition: all 0.3s ease;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern .input-modern:focus {
  outline: none;
  border-color: rgba(255, 193, 7, 0.5);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern .input-modern::placeholder {
  color: rgba(255, 255, 255, 0.4);
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .form-group-modern .input-modern.textarea-modern {
  resize: vertical;
  min-height: 100px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .btn-submit-modern {
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  border: none;
  border-radius: 10px;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .btn-submit-modern i {
  font-size: 18px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .btn-submit-modern:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 193, 7, 0.4);
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .btn-submit-modern:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .contact-alternatives-modern {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .contact-alternatives-modern .alternative-label {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 12px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .contact-alternatives-modern .btn-call-modern {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.3);
  border-radius: 10px;
  color: #28a745;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .contact-alternatives-modern .btn-call-modern i {
  font-size: 18px;
}
.listing-details-modern .inquiry-card-modern .inquiry-form-modern .contact-alternatives-modern .btn-call-modern:hover {
  background: #28a745;
  color: white;
  border-color: #28a745;
  transform: translateY(-2px);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes fadeInPage {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.main-wrapper {
  animation: fadeInPage 0.5s ease-out;
}

.cta-section-modern h4 {
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
}
.cta-section-modern p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  text-align: center;
  margin-bottom: 25px;
}
.cta-section-modern .btn-call-primary-modern {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  padding: 20px 24px;
  background: linear-gradient(135deg, #28a745, #20c997);
  border: none;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}
.cta-section-modern .btn-call-primary-modern::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}
.cta-section-modern .btn-call-primary-modern:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 12px 35px rgba(40, 167, 69, 0.5);
}
.cta-section-modern .btn-call-primary-modern:hover::before {
  width: 400px;
  height: 400px;
}
.cta-section-modern .btn-call-primary-modern:hover .btn-call-number {
  transform: scale(1.05);
}
.cta-section-modern .btn-call-primary-modern i {
  font-size: 28px;
  color: white;
  animation: phonePulse 2s ease-in-out infinite;
}
.cta-section-modern .btn-call-primary-modern .btn-call-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.cta-section-modern .btn-call-primary-modern .btn-call-content .btn-call-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}
.cta-section-modern .btn-call-primary-modern .btn-call-content .btn-call-number {
  font-size: 22px;
  color: white;
  font-weight: 800;
  transition: transform 0.3s ease;
}
.cta-section-modern .or-divider-modern {
  position: relative;
  text-align: center;
  margin: 20px 0;
}
.cta-section-modern .or-divider-modern::before, .cta-section-modern .or-divider-modern::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 40%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}
.cta-section-modern .or-divider-modern::before {
  left: 0;
}
.cta-section-modern .or-divider-modern::after {
  right: 0;
}
.cta-section-modern .or-divider-modern span {
  display: inline-block;
  padding: 0 15px;
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 50px;
}
.cta-section-modern .btn-form-toggle-modern {
  width: 100%;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  margin-bottom: 20px;
}
.cta-section-modern .btn-form-toggle-modern i {
  font-size: 18px;
}
.cta-section-modern .btn-form-toggle-modern:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 193, 7, 0.3);
  color: #FFC107;
}
.cta-section-modern .inquiry-form-modern {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.5s ease;
}
.cta-section-modern .inquiry-form-modern.expanded {
  max-height: 1000px;
  opacity: 1;
  margin-top: 10px;
}

@keyframes phonePulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
.price-section-modern {
  padding: 25px;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.08), rgba(255, 152, 0, 0.08));
  border-radius: 12px;
  margin-bottom: 25px;
  border: 1px solid rgba(255, 193, 7, 0.2);
}

.price-breakdown-modern .price-row-discount,
.price-breakdown-modern .price-row-base,
.price-breakdown-modern .price-row-vat,
.price-breakdown-modern .price-row-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.price-breakdown-modern .price-row-discount span:first-child,
.price-breakdown-modern .price-row-base span:first-child,
.price-breakdown-modern .price-row-vat span:first-child,
.price-breakdown-modern .price-row-total span:first-child {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.price-breakdown-modern .price-row-discount .price-old-inline {
  color: rgba(255, 255, 255, 0.5);
  font-size: 16px;
  text-decoration: line-through;
}
.price-breakdown-modern .price-row-base .price-base {
  color: white;
  font-size: 20px;
  font-weight: 700;
}
.price-breakdown-modern .price-row-vat .vat-regime-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  background: rgba(33, 150, 243, 0.2);
  border-radius: 10px;
  font-size: 11px;
  color: #2196F3;
  margin-left: 6px;
  cursor: help;
}
.price-breakdown-modern .price-row-vat .vat-regime-badge i {
  font-size: 12px;
}
.price-breakdown-modern .price-row-vat .vat-amount {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 600;
}
.price-breakdown-modern .price-row-total {
  margin-bottom: 0 !important;
}
.price-breakdown-modern .price-row-total span:first-child {
  color: white;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.price-breakdown-modern .price-row-total .price-total {
  font-size: 32px;
  font-weight: 800;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@media (max-width: 767px) {
  .price-breakdown-modern .price-row-total .price-total {
    font-size: 28px;
  }
}
.price-breakdown-modern .savings-badge-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #e63946, #d62828);
  border-radius: 50px;
  color: white;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px;
  align-self: flex-start;
}
.price-breakdown-modern .savings-badge-inline i {
  font-size: 13px;
}
.price-breakdown-modern .price-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
  margin: 15px 0;
}
.price-breakdown-modern .price-divider-bold {
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 193, 7, 0.3), transparent);
  margin: 15px 0;
}
.price-breakdown-modern .vat-included-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
  padding: 10px 15px;
  background: rgba(33, 150, 243, 0.15);
  border: 1px solid rgba(33, 150, 243, 0.3);
  border-radius: 8px;
  color: #64B5F6;
  font-size: 13px;
  font-weight: 600;
}
.price-breakdown-modern .vat-included-notice i {
  font-size: 16px;
}
.price-breakdown-modern .price-row-base-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.price-breakdown-modern .price-row-base-premium span:first-child {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.price-breakdown-modern .price-row-base-premium .price-base-value {
  color: white;
  font-size: 24px;
  font-weight: 800;
}
.price-breakdown-modern .price-row-vat-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05));
  border-radius: 12px;
  border: 1px solid rgba(76, 175, 80, 0.3);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.1);
}
.price-breakdown-modern .price-row-vat-premium .vat-label-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
.price-breakdown-modern .price-row-vat-premium .vat-label-container span:first-child {
  color: #81C784;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.price-breakdown-modern .price-row-vat-premium .vat-label-container .vat-badge-deductible {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  background: linear-gradient(135deg, #4CAF50, #66BB6A);
  border-radius: 10px;
  color: white;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.price-breakdown-modern .price-row-vat-premium .vat-amount-value {
  color: #4CAF50;
  font-size: 20px;
  font-weight: 700;
}
.price-breakdown-modern .price-row-total-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.15), rgba(255, 152, 0, 0.1));
  border-radius: 12px;
  border: 2px solid rgba(255, 193, 7, 0.4);
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);
  margin-bottom: 0 !important;
}
.price-breakdown-modern .price-row-total-premium span:first-child {
  color: white;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.price-breakdown-modern .price-row-total-premium .price-total {
  font-size: 36px;
  font-weight: 800;
  background: linear-gradient(135deg, #FFC107, #FF9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
}
@media (max-width: 767px) {
  .price-breakdown-modern .price-row-total-premium .price-total {
    font-size: 30px;
  }
}

/*-----------------
    24. Products
-----------------------*/
.accordion {
  border-bottom: 1px solid #F4F4F4;
  margin-bottom: 18px;
}
.accordion .filter-title {
  margin-bottom: 20px;
}
.accordion .filter-title a {
  font-size: 18px;
  color: #9c27b0;
  display: inline-block;
}
@media (max-width: 991.98px) {
  .accordion .filter-title a {
    font-size: 16px;
  }
}
.accordion .view-all {
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 12px;
  color: #1976d2;
}

.accordion-last {
  border: 0;
}

.filter-range .irs--flat .irs-grid {
  display: none;
}
.filter-range .irs--flat .irs-min, .filter-range .irs--flat .irs-max, .filter-range .irs--flat .irs-grid-text {
  visibility: hidden !important;
}
.filter-range .irs--flat .irs-line {
  background: #ffffff;
}
.filter-range .irs--flat .irs-bar {
  background: #FF9307;
  height: 8px;
}
.filter-range .irs--flat .irs-single {
  background: #FF9307;
  width: 50px;
  text-align: center;
  margin-left: 10px;
}
.filter-range .irs--flat .irs-single:before {
  border-top-color: #FF9307;
}
.filter-range .irs--flat .irs-handle.state_hover > i:first-child {
  background: #FF9307;
}
.filter-range .irs--flat .irs-handle:hover i {
  background: #FF9307;
}
.filter-range .irs--flat .irs-handle > i {
  background: #FF9307;
  width: 15px;
  height: 15px;
  border-radius: 50%;
}
.product-search {
  margin: 0 0 20px;
  border-bottom: 1px solid #F4F4F4;
}

.form-custom {
  position: relative;
}
.form-custom .form-control {
  padding: 10px;
  margin: 0 0 20px;
  font-weight: 500;
  font-size: 14px;
  color: #828282;
  background: #FCFBFB;
  border: 1px solid #F4F4F4;
}
.form-custom .form-control:focus {
  background: #ffffff;
  outline: none;
}
.form-custom .form-control::placeholder {
  color: #828282;
}
.form-custom span img {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(-5%, -50%);
}

.open-filter .custom_check {
  color: #201F1D;
}
.open-filter .custom_check i {
  color: red;
}
.open-filter i {
  transition: 0.2s;
}

.accordion .collapsed i {
  color: #201F1D;
  transition: 0.2s;
  transform: rotate(-180deg);
}
.accordion .float-end {
  color: #201F1D;
  font-size: 14px;
  margin-top: 3px;
}

@media (max-width: 768px) {
  .list-btn {
    display: none;
  }
}
@media (max-width: 320px) {
  .list-btn .filter-list {
    display: block !important;
  }
}
.list-btn .filter-list .short-filter {
  border: 1px solid #888888;
  border-radius: 8px;
  color: #201F1D;
  font-size: 14px;
  height: 39px;
  padding: 10px;
  background: #ffffff;
}
.list-btn .filter-list .short-filter .sort {
  background: transparent;
  border: none;
  outline: 0;
  font-size: 12px;
  font-weight: 600;
  color: #3F4254;
}
.list-btn .filter-list li {
  padding: 0 5px 0 0;
}
@media (max-width: 320px) {
  .list-btn .filter-list li {
    margin: 0 0 10px;
  }
}
.list-btn .filter-list li a.active {
  border: 1px solid #1976d2 !important;
  color: #1976d2 !important;
}
.list-btn .filter-list li:last-child {
  padding: 0;
}
.list-btn .filter-list li ul li {
  padding: 0;
  margin: 0 0 10px;
}
.list-btn .filter-list li ul li .download-item {
  color: #201F1D;
  font-size: 14px;
  margin: auto;
}
.list-btn .filter-list li ul li .download-item:hover {
  color: #1976d2;
}
.list-btn .filter-list li ul li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}
.list-btn .btn-filters {
  border: 1px solid #888888;
  border-radius: 8px;
  color: #201F1D;
  min-width: 39px;
  height: 39px;
  background: #ffffff;
  transition: all 0.4s ease;
}
@media (max-width: 320px) {
  .list-btn .btn-filters {
    max-width: 140px;
  }
}
.list-btn .btn-filters span {
  margin-bottom: 0;
  line-height: 0;
  font-size: 18px;
}
.list-btn .btn-filters:hover {
  box-shadow: 0 40px 0 0 #1976d2 inset;
  transition: all 0.4s ease;
  color: #ffffff;
}
.list-btn .btn-filters:hover i {
  color: #ffffff;
}
.list-btn .dropdown-menu {
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-shadow: 0px 16px 32px rgba(190, 190, 190, 0.2);
  border-radius: 12px;
  padding: 10px;
  margin-top: 10px !important;
  min-width: 100px;
}
.list-btn .dropdown-menu .dropdown-item {
  font-weight: 500;
  font-size: 14px;
  color: #878A99;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.custom_check {
  color: #828282;
  display: inline-block;
  position: relative;
  font-size: 14px;
  margin-bottom: 15px;
  padding-left: 30px;
  cursor: pointer;
  font-weight: 400;
  -webkit-user-select: none;
          user-select: none;
}
.custom_check input:checked ~ .checkmark {
  background-color: #9c27b0;
  border-color: #9c27b0;
}
.custom_check input:checked ~ .checkmark:after {
  display: block;
  top: 1px;
  left: 5px;
  font-size: 10px;
}
.custom_check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.custom_check .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border: 1px solid #C4C4C4;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #DBDBDB;
  background: #FCFBFB;
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
}
.custom_check .checkmark::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  display: none;
  left: 4px;
  top: 2px;
  color: #ffffff;
  font-size: 9px;
}

.input-block .custom_check {
  margin-bottom: 15px;
}

.car-listing .sidebar-form {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 24px rgba(255, 255, 255, 0.2);
}
@media (max-width: 1199.98px) {
  .car-listing .sidebar-form {
    margin-bottom: 24px;
  }
}
.car-listing .sidebar-form .sidebar-heading h3 {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .car-listing .sidebar-form .sidebar-heading h3 {
    font-size: 16px;
  }
}
.car-listing .sidebar-form .custom_check i {
  color: #FF9307;
}
.car-listing .sidebar-form .reset-filter {
  display: block;
  text-align: center;
  margin-top: 15px;
  color: #FF0000;
}
.car-listing .sidebar-form .reset-filter:hover {
  color: #1976d2;
}
.car-listing .blog-pagination {
  margin-top: 25px;
}
@media (max-width: 479px) {
  .car-listing .blog-pagination {
    margin-top: 10px;
  }
}
.car-listing .pagination {
  flex-wrap: wrap;
}
@media (max-width: 479px) {
  .car-listing .pagination .previtem, .car-listing .pagination .nextlink {
    margin-bottom: 10px;
  }
}
.car-listing .pagination .previtem a, .car-listing .pagination .nextlink a {
  height: 38px;
  border-radius: 10px;
  padding: 0 20px;
  color: #2F2F2F;
}
.car-listing .pagination .previtem a:focus, .car-listing .pagination .nextlink a:focus {
  outline: 0;
  box-shadow: none;
}
@media (max-width: 479px) {
  .car-listing .pagination li .page-group ul {
    flex-wrap: wrap;
  }
}
@media (max-width: 479px) {
  .car-listing .pagination li .page-group ul li {
    margin-bottom: 10px;
  }
}
.car-listing .filter-btn {
  padding: 10px 15px;
}
.car-listing .filter-btn span {
  line-height: 1;
}
.car-listing .filter-btn:active {
  background: #FFA633;
  border-color: #1976d2;
}

@media (max-width: 991.98px) {
  .sorting-div .count-search {
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .sorting-div .product-filter-group {
    display: block;
  }
}
@media (max-width: 991.98px) {
  .sorting-div .product-filter-group {
    justify-content: flex-start;
  }
}
@media (max-width: 575.98px) {
  .sorting-div .product-filter-group .sortbyset {
    flex-wrap: wrap;
  }
}
.sorting-div .product-filter-group .sortbyset .sortbytitle {
  margin-right: 10px;
}
@media (max-width: 575.98px) {
  .sorting-div .product-filter-group .sortbyset .sortbytitle {
    margin: 0 0 10px;
  }
}
.sorting-div .product-filter-group .sortbyset .sorting-select {
  margin-right: 10px;
}
.sorting-div .product-filter-group .sortbyset .sorting-select.select-one {
  width: 90px;
}
@media (max-width: 575.98px) {
  .sorting-div .product-filter-group .sortbyset .sorting-select.select-one {
    margin-bottom: 15px;
    width: 100%;
  }
}
.sorting-div .product-filter-group .sortbyset .sorting-select.select-two {
  width: 150px;
}
@media (max-width: 575.98px) {
  .sorting-div .product-filter-group .sortbyset .sorting-select.select-two {
    margin-bottom: 15px;
    width: 100%;
  }
}
.sorting-div .product-filter-group .sortbyset .sorting-select.select-three {
  width: 300px;
}
@media (max-width: 767.98px) {
  .sorting-div .product-filter-group .sortbyset .sorting-select.select-three {
    width: 300px;
  }
}
@media (max-width: 575.98px) {
  .sorting-div .product-filter-group .sortbyset .sorting-select.select-three {
    margin-bottom: 15px;
    width: 100%;
  }
}
.sortby-sec {
  background: #ffffff;
  padding: 30px 0;
  box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);
}

.grid-listview ul li {
  margin-right: 10px;
}
.grid-listview ul li a {
  width: 40px;
  height: 40px;
  background: #F4F4F4;
  border-radius: 5px;
  transition: all 0.5s;
}
.grid-listview ul li a.active {
  background: #127384;
}
.grid-listview ul li a.active i {
  color: #ffffff;
}
.grid-listview ul li a:hover {
  background: #127384;
  transition: all 0.5s;
}
.grid-listview ul li a:hover i {
  color: #ffffff;
  transition: all 0.5s;
}
.grid-listview ul li a i {
  color: #737373;
  font-size: 16px;
}
.grid-listview ul li:last-child {
  margin: 0;
}

.listview-car .card {
  margin-bottom: 24px;
  padding: 20px;
}
.listview-car .card .blog-img {
  margin-right: 15px;
  flex-shrink: 0.5;
  overflow: hidden;
  border-radius: 10px;
}
@media (max-width: 767.98px) {
  .listview-car .card .blog-img {
    margin-right: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
.listview-car .card .blog-img img {
  border-radius: 10px;
  transition: all 0.5s ease;
}
@media (max-width: 767.98px) {
  .listview-car .card .blog-img img {
    width: 100%;
  }
}
.listview-car .card .blog-img:hover img {
  transform: scale(1.15);
  transition: all 0.5s ease;
}
@media (max-width: 767.98px) {
  .listview-car .card .blog-widget {
    flex-direction: column;
    align-items: center;
  }
}
.listview-car .card .card-body {
  margin: 0;
  padding: 0;
}
.listview-car .card .card-body .blog-list-head {
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .blog-list-head {
    margin-bottom: 20px;
    flex-direction: column;
    align-items: inherit !important;
  }
}
.listview-car .card .card-body .blog-list-head .blog-list-title h3 {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
}
.listview-car .card .card-body .blog-list-head .blog-list-title h3 a {
  color: #201F1D;
}
.listview-car .card .card-body .blog-list-head .blog-list-title h3 a:hover {
  color: #127384;
}
@media (max-width: 991.98px) {
  .listview-car .card .card-body .blog-list-head .blog-list-title h3 a {
    font-size: 18px;
  }
}
.listview-car .card .card-body .blog-list-head .blog-list-title h6 {
  font-size: 15px;
  color: #737373;
  font-weight: 400;
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .blog-list-head .blog-list-title h6 {
    margin-bottom: 10px;
    font-size: 15px;
  }
}
.listview-car .card .card-body .blog-list-head .blog-list-title h5 {
  margin-bottom: 3px;
}
.listview-car .card .card-body .blog-list-head .blog-list-title h5 a {
  font-size: 16px;
  color: #201F1D;
}
.listview-car .card .card-body .blog-list-head .blog-list-title .title-bottom {
  display: flex;
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .blog-list-head .blog-list-title .title-bottom {
    margin-bottom: 10px;
  }
}
.listview-car .card .card-body .blog-list-head .blog-list-title .title-bottom img {
  margin-right: 10px;
  border-radius: 50%;
  width: 46px;
  height: 46px;
}
.listview-car .card .card-body .blog-list-head .blog-list-title .title-bottom h6 i {
  line-height: 0;
}
.listview-car .card .card-body .blog-list-head .blog-list-rate h6 {
  font-weight: 700;
  font-size: 24px;
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .blog-list-head .blog-list-rate h6 {
    font-size: 22px;
  }
}
.listview-car .card .card-body .blog-list-head .blog-list-rate h6 {
  color: #FF0000;
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .blog-list-head .blog-list-rate h6 {
    justify-content: flex-start;
    -webkit-justify-content: start;
    -ms-flex-pack: start;
  }
}
.listview-car .card .card-body .blog-list-head .blog-list-rate h6 span {
  font-size: 14px;
  font-weight: normal;
  color: rgb(130, 130, 130);
  margin-left: 7px;
}
.listview-car .card .card-body .blog-list-head .blog-list-rate .list-rating {
  margin-bottom: 8px;
}
.listview-car .card .card-body .blog-list-head .blog-list-rate .list-rating i {
  color: #FF9307;
  font-size: 14px;
}
.listview-car .card .card-body .blog-list-head.list-head-bottom {
  margin: 0;
  align-items: center;
}
.listview-car .card .card-body .listing-details-group {
  margin: 0 0 15px;
  padding: 0 0 15px;
  border-bottom: 1px solid #F4F4F4;
}
.listview-car .card .card-body .listing-details-group ul {
  margin: 0;
  padding: 10px;
  background: #F2F7F6;
  border-radius: 5px;
}
@media (max-width: 1199.98px) {
  .listview-car .card .card-body .listing-details-group ul {
    margin: 0;
    padding: 10px 10px 0;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
  }
}
@media (max-width: 1199.98px) {
  .listview-car .card .card-body .listing-details-group ul li {
    flex: 33.33% 1;
    max-width: 33.33%;
    display: flex;
    display: -webkit-flex;
    margin-bottom: 15px;
  }
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .listing-details-group ul li {
    flex: 50% 1;
    max-width: 50%;
    display: flex;
    display: -webkit-flex;
  }
}
.listview-car .card .card-body .listing-details-group ul li span {
  line-height: 0;
}
.listview-car .card .card-body .listing-details-group ul li span img {
  margin-right: 10px;
  line-height: 0;
  width: 16px;
}
.listview-car .card .card-body .listing-button .btn-order {
  background: #201F1D;
  color: #ffffff;
  transition: all 0.5s;
}
@media (max-width: 767.98px) {
  .listview-car .card .card-body .listing-button .btn-order {
    width: 100%;
  }
}
.listview-car .card .card-body .listing-button .btn-order:hover {
  background-color: #127384 !important;
  color: #ffffff;
  border-radius: 5px;
  transition: all 0.5s;
}

#checkBoxes1 {
  height: 180px;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  -moz-overflow-y: scroll;
  -ms-overflow-y: scroll;
  -o-overflow-y: scroll;
  margin: 0 0 15px;
}

#checkBoxes2 {
  height: 180px;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  -moz-overflow-y: scroll;
  -ms-overflow-y: scroll;
  -o-overflow-y: scroll;
  margin: 0 0 15px;
}

#checkBoxes3 {
  height: 180px;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  -moz-overflow-y: scroll;
  -ms-overflow-y: scroll;
  -o-overflow-y: scroll;
  margin: 0 0 15px;
}

#checkBoxes4 {
  height: 180px;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  -moz-overflow-y: scroll;
  -ms-overflow-y: scroll;
  -o-overflow-y: scroll;
  margin: 0 0 15px;
}

#checkBoxes5 {
  height: 180px;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  -moz-overflow-y: scroll;
  -ms-overflow-y: scroll;
  -o-overflow-y: scroll;
  margin: 0 0 15px;
}

#checkBoxes1::-webkit-scrollbar {
  width: 6px;
}

#checkBoxes2::-webkit-scrollbar {
  width: 6px;
}

#checkBoxes3::-webkit-scrollbar {
  width: 6px;
}

#checkBoxes4::-webkit-scrollbar {
  width: 6px;
}

#checkBoxes5::-webkit-scrollbar {
  width: 6px;
}

#checkBoxes1::-webkit-scrollbar-track {
  background-color: #ddd;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes2::-webkit-scrollbar-track {
  background-color: #ddd;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes3::-webkit-scrollbar-track {
  background-color: #ddd;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes4::-webkit-scrollbar-track {
  background-color: #ddd;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes5::-webkit-scrollbar-track {
  background-color: #ddd;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes1::-webkit-scrollbar-thumb {
  background-color: #1976d2;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes2::-webkit-scrollbar-thumb {
  background-color: #1976d2;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes3::-webkit-scrollbar-thumb {
  background-color: #1976d2;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes4::-webkit-scrollbar-thumb {
  background-color: #1976d2;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

#checkBoxes5::-webkit-scrollbar-thumb {
  background-color: #1976d2;
  border-radius: 2px;
  -webkit-background-color: #1976d2;
  -moz-background-color: #1976d2;
  -ms-background-color: #1976d2;
  -o-background-color: #1976d2;
}

.stickybar {
  top: 0;
  position: sticky;
}

.p-calendar.p-component.p-inputwrapper .p-inputtext.p-component {
  background: #fcfbfb;
  border: 1px solid #f4f4f4;
  box-shadow: none;
  border-radius: 5px;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #201f1d;
  padding-right: 0;
  max-width: 150px;
}
.p-calendar.p-component.p-inputwrapper input:focus {
  box-shadow: none;
}
.p-calendar.p-component.p-inputwrapper input::placeholder {
  font-size: 14px;
}

.search-box-banner .group-img i {
  top: 17px;
}

.p-datepicker-calendar-container table.p-datepicker-calendar {
  font-size: 14px;
}

div.p-datepicker table td.p-datepicker-today > span {
  background: #ffa633;
  color: #fff;
}

.p-calendar.p-component input {
  font-size: 14px;
}

.group-img div.ant-picker {
  height: 45px;
  padding: 0 10px 0 0;
}
.group-img .ant-picker .ant-picker-input input {
  text-overflow: unset;
  padding: 2px 13px 13px 36px;
}
.group-img .ant-picker .ant-picker-input input::placeholder {
  color: #787878;
}
.group-img .ant-picker .ant-picker-input {
  top: 10px;
}

.ant-picker-input span.ant-picker-suffix {
  display: none;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

#range-slider .range-slider__thumb[data-lower] {
  width: 0;
}

#range-slider .range-slider__range {
  border-radius: 6px;
}

.rc-slider {
  margin-bottom: 15px;
}

.rc-slider-track,
.rc-slider-tracks {
  position: absolute;
  height: 4px;
  background-color: #ff9307;
  border-radius: 6px;
}

.rc-slider-handle {
  position: absolute;
  z-index: 1;
  width: 14px;
  height: 14px;
  margin-top: -5px;
  background-color: #fff;
  border: solid 2px #ff9307;
  border-radius: 50%;
  cursor: pointer;
  cursor: grab;
  opacity: 0.8;
  touch-action: pan-x;
}

.rc-slider-handle {
  border-color: #ff9307 !important;
  box-shadow: 0 0 0 5px #ff9307 !important;
}

.filled {
  color: #ff9307 !important;
}

.collapsed .chev-up {
  color: #201f1d;
  transition: 0.2s;
  transform: rotate(-180deg);
}

.stickysidebar {
  position: sticky;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/style/scss/main.scss","webpack://./src/style/scss/utils/mixins.scss","webpack://./src/style/scss/base/reset.scss","webpack://./src/style/scss/base/typography.scss","webpack://./src/style/scss/base/base.scss","webpack://./src/style/scss/base/colors.scss","webpack://./src/style/scss/base/grid.scss","webpack://./src/style/scss/utils/variables.scss","webpack://./src/style/scss/components/button.scss","webpack://./src/style/scss/layout/header.scss","webpack://./src/style/scss/layout/footer.scss","webpack://./src/style/scss/layout/breadcrumb.scss","webpack://./src/style/scss/layout/select.scss","webpack://./src/style/scss/layout/table.scss","webpack://./src/style/scss/pages/home.scss","webpack://./src/style/scss/pages/common.scss","webpack://./src/style/scss/pages/about-us.scss","webpack://./src/style/scss/pages/detail-page.scss","webpack://./src/style/scss/pages/products.scss","webpack://./src/style/scss/pages/react.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;CAAA;AC+IA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;ADpIF;;ACgJA;EAEI,UAAA;EACA,WAAA;AD9IJ;;ACmJA;EAIE,oBAAA;ADhJF;;ACkJA;EACE,uBAAA;EACA,+BAAA;EACA,qBAAA;AD/IF;;ACiJA;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;AD9IF;;ACgJA;EACE,8BAAA;EACA,sCAAA;EACA,4BAAA;AD7IF;;AC+IA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AD5IF;;AC8IA;EACI,8BAAA;EACA,sCAAA;EACA,4BAAA;AD3IJ;;AC6JA;EAGE,oBAAA;AD1JF;;AC4JA;EAGE,aAAA;ADzJF;;AC2JA;EAGE,aAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;ADxJF;;AC0JA;EAGE,aAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ADvJF;;ACyJA;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ADtJF;;ACwJA;EACE,yBAAA;EACA,iCAAA;EACA,uBAAA;ADrJF;;ACuJA;EACE,2BAAA;EACA,8BAAA;EACA,oBAAA;ADpJF;;ACsJA;EACE,8BAAA;EACA,sCAAA;EACA,4BAAA;ADnJF;;AExHA;;wBAAA;AAIA;EACE,SAAA;EACA,UAAA;EACA,SAAA;AF0HF;;AEvHA;EACE,sBAAA;AF0HF;;AExHA;EACE,cAAA;AF2HF;;AE1HA;EACE,gBAAA;AF6HF;;AE3HA;EACE,YAAA;AF8HF;;AE3HE;EACE,WAAA;EACA,aAAA;AF8HJ;;AE3HE;EACE,WAAA;EACA,aAAA;AF8HJ;;AE5HA;EACE,yBAAA;EACA,iBAAA;AF+HF;;AGhKA;;wBAAA;AA8CA;EACI,qBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AHwHJ;;AGtHA;EACC,gBAAA;EACA,eAXiB;EAYjB,cAAA;AHyHD;AC1HI;EEFJ;IAKE,eArBgB;EHgJhB;AACF;;AGzHA;EACC,gBAAA;EACA,eA1BiB;EA2BjB,cAAA;AH4HD;ACrII;EEMJ;IAKE,eAhCgB;EH8JhB;AACF;;AG5HA;EACC,gBAAA;EACA,eAtCiB;EAuCjB,cAAA;AH+HD;AChJI;EEcJ;IAKE,eA5CgB;EH6KhB;AACF;;AG/HA;EACC,eA3CiB;EA4CjB,cAAA;AHkID;AC1JI;EEsBJ;IAIE,eAlDgB;EHsLhB;AACF;;AGlIA;EACC,eAvDiB;AH4LlB;ACnKI;EE6BJ;IAGE,eA5DgB;EHmMhB;AACF;;AGrIA;EACC,gBA9ES;EA+ET,eA9DiB;EA+DjB,cAAA;AHwID;AC9KI;EEmCJ;IAKE,eApEgB;EH8MhB;AACF;;AIzOA;;wBAAA;AAIA;EACC,oCDEsB;ECDtB,eDUmB;ECTnB,cCHyB;EDIzB,mBCFe;EDGf,kBAAA;AJ2OD;AC9LI;EGlDJ;IAOE,eDcgB;EH+NhB;AACF;;AI3OA;EACC,eAAA;EHuFC,yBGtFmB;AJgPrB;AI/OC;EHqFC,yBGpFoB;AJmPtB;AIjPC;EACC,UAAA;AJmPF;;AI/OC;EACC,gBAAA;AJkPF;;AI/OA;EACC,gBDpBO;AHsQR;;AI/OC;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;AJkPF;;AMtRA;;wBAAA;AL+IA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AD6IF;;ACjIA;EAEI,UAAA;EACA,WAAA;ADmIJ;;AC9HA;EAIE,oBAAA;ADiIF;;AC/HA;EACE,uBAAA;EACA,+BAAA;EACA,qBAAA;ADkIF;;AChIA;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;ADmIF;;ACjIA;EACE,8BAAA;EACA,sCAAA;EACA,4BAAA;ADoIF;;AClIA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;ADqIF;;ACnIA;EACI,8BAAA;EACA,sCAAA;EACA,4BAAA;ADsIJ;;ACpHA;EAGE,oBAAA;ADuHF;;ACrHA;EAGE,aAAA;ADwHF;;ACtHA;EAGE,aAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;ADyHF;;ACvHA;EAGE,aAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AD0HF;;ACxHA;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AD2HF;;ACzHA;EACE,yBAAA;EACA,iCAAA;EACA,uBAAA;AD4HF;;AC1HA;EACE,2BAAA;EACA,8BAAA;EACA,oBAAA;AD6HF;;AC3HA;EACE,8BAAA;EACA,sCAAA;EACA,4BAAA;AD8HF;;AMlYA;EACC,WCiBO;EDhBP,kBCuCsB;EDtCtB,mBCuCuB;EDtCvB,WCNO;EDOP,kBCIW;EDHT,eAAA;ANqYH;AClXI;EKhBF;IACC,WCiDQ;EPoVT;EMnYA;IACC,mBC6CQ;EPwVT;EMnYA;IACC,mBCyCQ;EP4VT;EMnYA;IACC,UCqCO;EPgWR;EMnYA;IACC,mBCiCO;EPoWR;EMnYA;IACC,mBC6BO;EPwWR;EMnYA;IACC,UCyBO;EP4WR;EMnYA;IACC,mBCqBO;EPgXR;EMnYA;IACC,mBCiBO;EPoXR;EMnYA;IACC,UCaO;EPwXR;EMnYA;IACC,mBCSO;EP4XR;EMnYA;IACC,kBCKO;EPgYR;AACF;ACxZI;EKsBF;IACC,WCWQ;EP0XT;EMnYA;IACC,mBCOQ;EP8XT;EMnYA;IACC,mBCGQ;EPkYT;EMnYA;IACC,UCDO;EPsYR;EMnYA;IACC,mBCLO;EP0YR;EMnYA;IACC,mBCTO;EP8YR;EMnYA;IACC,UCbO;EPkZR;EMnYA;IACC,mBCjBO;EPsZR;EMnYA;IACC,mBCrBO;EP0ZR;EMnYA;IACC,UCzBO;EP8ZR;EMnYA;IACC,mBC7BO;EPkaR;EMnYA;IACC,kBCjCO;EPsaR;AACF;AC9bI;EK6DF;IACC,WC5BQ;EPgaT;EMlYA;IACC,mBChCQ;EPoaT;EMlYA;IACC,mBCpCQ;EPwaT;EMlYA;IACC,UCxCO;EP4aR;EMlYA;IACC,mBC5CO;EPgbR;EMlYA;IACC,mBChDO;EPobR;EMlYA;IACC,UCpDO;EPwbR;EMlYA;IACC,mBCxDO;EP4bR;EMlYA;IACC,mBC5DO;EPgcR;EMlYA;IACC,UChEO;EPocR;EMlYA;IACC,mBCpEO;EPwcR;EMlYA;IACC,kBCxEO;EP4cR;AACF;ACpeI;EKoGF;IACC,WCnEQ;EPscT;EMjYA;IACC,mBCvEQ;EP0cT;EMjYA;IACC,mBC3EQ;EP8cT;EMjYA;IACC,UC/EO;EPkdR;EMjYA;IACC,mBCnFO;EPsdR;EMjYA;IACC,mBCvFO;EP0dR;EMjYA;IACC,UC3FO;EP8dR;EMjYA;IACC,mBC/FO;EPkeR;EMjYA;IACC,mBCnGO;EPseR;EMjYA;IACC,UCvGO;EP0eR;EMjYA;IACC,mBC3GO;EP8eR;EMjYA;IACC,kBC/GO;EPkfR;AACF;;AQ1iBA;;wBAAA;AAIA;EACI,kBDWQ;ECVR,uBAAA;EAIA,oBAAA;AR4iBJ;AQ3iBI;EAII,oBAAA;AR6iBR;;AQ1iBA;EACI,gBLPM;EKQN,eLMc;EKLd,cHJW;EGKX,yBAAA;EACA,yBHlBM;EGmBN,iCAAA;EACA,kBAAA;EACA,cAAA;EP8FD,SO7FyB;EP8FzB,kBO9F4B;AR8iB/B;AQ7iBI;EACI,yBH7BS;EG8BT,yBAAA;EACA,cH1BE;EG2BF,oCAAA;AR+iBR;ACzhBI;EOpCJ;IPsGG,SOrF6B;IPsF7B,iBOtFgC;IACjC,eLZgB;EH6jBhB;AACF;;AQ9iBA;EACI,yBHpCM;EGqCN,qBHXe;EGYf,cH3Ca;EG4Cb,iCAAA;ARijBJ;AQhjBI;EACI,yBHzCE;EG0CF,qBH1CE;EG2CF,cH3CE;EG4CF,oCAAA;ARkjBR;;AQ/iBA;EACI,yBHhDM;EGiDN,qBHvBe;EGwBf,cHhDc;ALkmBlB;AQjjBI;EACI,yBHpDE;EGqDF,qBH3BW;EG4BX,cHpDU;ALumBlB;;AQhjBA;EACI,yBH/Da;EGgEb,yBAAA;EACA,iCAAA;ARmjBJ;AQljBI;EACI,yBH9DE;EG+DF,qBHpES;EGqET,cHrES;EGsET,oCAAA;ARojBR;;AQjjBA;EACI,yBH1Ea;EG2Eb,yBAAA;EACA,iCAAA;ARojBJ;AQljBQ;EACI,yBAAA;EAGA,gBAAA;ARojBZ;AQzjBI;EAOI,yBH/EE;EGgFF,qBHrFS;EGsFT,cHtFS;EGuFT,oCAAA;ARqjBR;;AQljBA;EP+BG,kBO9B+B;ARqjBlC;;AQnjBA;EACI,gBLnFQ;EKoFR,eLrEc;EF+Ff,aOzB+B;ARsjBlC;;AQpjBA;EACI,cH9FM;EG+FN,yBHnFW;EGoFX,yBAAA;EACA,iCAAA;ARujBJ;AQtjBI;EACI,yBHnGE;EGoGF,qBH1EW;EG2EX,cHnGU;EGoGV,oCAAA;ARwjBR;;AQrjBA;EACI,yBH1Ea;EG2Eb,yBAAA;EACA,iCAAA;ARwjBJ;AQvjBI;EACI,yBH9GE;EG+GF,qBH/ES;EGgFT,cHvFG;EGwFH,oCAAA;ARyjBR;;AQtjBA;EACI,yBHrHM;EGsHN,yBAAA;EACA,iCAAA;ARyjBJ;AQxjBI;EACI,yBHzFS;EG0FT,qBH1HE;EG2HF,cHlGG;EGmGH,oCAAA;AR0jBR;;AQvjBA;EACI,cHrIa;EGsIb,qBHtIa;ALgsBjB;AQzjBI;EACI,yBHxIS;EGyIT,qBHzIS;ALosBjB;;AQxjBA;;EAEI,2BAAA;AR2jBJ;;AQxjBI;EACI,2BAAA;AR2jBR;AQzjBI;EACI,mBHhHS;EGiHT,cHnJW;EGoJX,eLhIU;EFkGf,iBO+BmC;EAC9B,gBL9II;AHysBZ;;AQxjBA;EACI,yBHxJM;EGyJN,yBAAA;EACA,iCAAA;EACA,cH1HY;ALqrBhB;AQ1jBI;EACI,yBH7JE;EG8JF,qBH7HQ;EG8HR,cH9HQ;EG+HR,oCAAA;AR4jBR;;AQzjBA;EACI,yBHxJW;EGyJX,yBAAA;EACA,+BAAA;EACA,cHvKM;EGwKN,kBAAA;EACA,gBLpKI;EKqKJ,eLrJc;EF+Ff,kBOuD+B;EAC9B,kBAAA;AR4jBJ;AQ1jBI;EACI,yBH/KE;EGgLF,yBAAA;EACA,oCAAA;EACA,cHtKO;ALkuBf;;AQxjBA;EACI,mBHpLK;EGqLL,cHxLM;ALmvBV;;AQzjBA;EACI,mBAAA;EACA,cH5LM;ALwvBV;;AQ1jBA;EACI,mBAAA;EACA,cHhMM;AL6vBV;;AQ3jBA;EACI,mBAAA;EACA,cHpMM;ALkwBV;;AQ5jBA;EACI,mBAAA;EACA,cHxMM;ALuwBV;;AQ7jBA;EACI,mBAAA;EACA,cH5MM;AL4wBV;;AQ3jBY;EACI,mBHvNC;EGwND,qBHxNC;ALsxBjB;;AStxBA;;wBAAA;AAIA;EACI,mBAAA;EACA,gBAAA;EACH,kDAAA;EACG,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;ATwxBJ;AStxBI;EACI,yBJTE;EIUF,kDAAA;ATwxBR;ASpxBQ;EACI,WFfJ;APqyBR;ASrxBY;EACI,WFjBR;EEkBQ,gBAAA;ATuxBhB;ASnxBI;EAGI,mBAAA;EACA,SAAA;EAGA,aAAA;EAEA,eAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBFxBI;EEyBJ,YAAA;ERgFL,sBQ/EmC;EAC9B,gBAAA;ATqxBR;AC1wBI;EQ3BA;IAkBQ,YAAA;IR4ET,UQ3EuC;ETuxBxC;AACF;ASpxBgB;EACI,cJ3CX;EI4CW,iBAAA;EACA,gBNzCV;AH+zBV;ACrxBI;EQJY;IAKQ,eN/BN;EHuzBhB;AACF;AC1xBI;EQJY;IAQQ,cJrDd;EL+0BR;AACF;ASzxBoB;EACI,cJ7DP;ALw1BjB;ASvxBoB;EACI,kBFlDZ;AP20BZ;ASxxBwB;EACI,cJpEX;AL81BjB;ASzxB4B;EACI,cJtEf;ALi2BjB;ASxxBwB;EACI,cFlEnB;EEmEmB,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,cJtEnB;EIwEmB,0BAAA;EACA,WAAA;EACA,kBFlEhB;EEmEgB,gBNvElB;AHi2BV;ACvzBI;EQmBoB;IAYQ,aAAA;IACA,cJjFtB;IIkFsB,eNjEd;EH61BhB;AACF;AS3xB4B;EACI,cJ1Ff;EI2Fe,kBAAA;AT6xBhC;ASxxBgB;EACI,aFnFZ;AP62BR;ASpxBQ;EACI,qBAAA;ERiBT,UQhBuC;EAC9B,cAAA;ATsxBZ;AC10BI;EQiDI;IAKQ,eAAA;ETwxBd;AACF;AC/0BI;EQyDI;IAEO,aAAA;ETwxBb;AACF;AStxBQ;EACI,aAAA;ATwxBZ;ACv1BI;EQ8DI;IAGQ,cAAA;IACA,WAAA;IACA,kBAAA;ET0xBd;AACF;ASxxBQ;EACI,aAAA;EACA,kBAAA;AT0xBZ;ACl2BI;EQsEI;IAIQ,qBAAA;IACA,cAAA;ET4xBd;AACF;ACx2BI;EQsEI;IAQQ,OAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;ET8xBd;AACF;AS7xBY;EACI,qBAAA;EACA,WAAA;AT+xBhB;AS9xBgB;EACI,yBJ9IH;EI+IG,cFvIX;EEwIW,WF3IZ;EE4IY,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;ATgyBpB;AS/xBoB;EACI,WAAA;ATiyBxB;AS/xBoB;EACI,WAAA;EACA,gBAAA;ATiyBxB;ACt4BI;EQgDA;IA8DQ,oBAAA;IACA,mBAAA;ET8xBV;AACF;AC94BI;EQgDA;IAkEQ,WAAA;ETgyBV;AACF;AS9xBI;EACI,gBAAA;ATgyBR;ACt5BI;EQqHA;IAGQ,QAAA;IACA,YAAA;IACA,eF9JH;IE+JG,MAAA;IACA,SAAA;IACA,OAAA;IACA,kBF/IF;IEgJE,gBF5JJ;IE6JI,cAAA;IACA,6BAAA;IACA,oBAAA;IACA,mBJhLG;IIiLH,SAAA;ETkyBV;AACF;ASjyBQ;EAGI,mBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;ATmyBZ;ACl7BI;EQsII;IAaQ,aAAA;IACA,YAAA;IACA,mBAAA;IACA,mBJvMN;EL4+BR;AACF;AC57BI;EQyJY;IAEQ,YAAA;ETqyBtB;AACF;ASjyBY;EACI,eAAA;EACA,cJxNC;AL2/BjB;AS5xBwB;EACI,UAAA;EACA,MAAA;EACA,gBAAA;AT8xB5B;AC18BI;EQyKoB;IAKQ,OAAA;ETgyB9B;AACF;ASpxB4B;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;ATsxBhC;AS9wBQ;EAGI,aAAA;EACA,SAAA;EACA,UAAA;ATgxBZ;AC/9BI;EQ0MI;IAOQ,UAAA;IAEA,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBJpQD;ELshCb;AACF;ASjxBY;EACI,eAAA;ATmxBhB;AC7+BI;EQ4NQ;IAEQ,eAAA;ETmxBlB;ESlxBkB;IACI,eAAA;IACA,SAAA;EToxBtB;AACF;ASjxBoB;EACI,cFpRf;EEqRe,cJ7RP;ALgjCjB;AS/wBoB;EACI,eN5QN;EM6QM,gBAAA;ATixBxB;AC9/BI;EQ0OY;IAMY,cAAA;IACA,iBAAA;IACA,kBAAA;IACA,eNjRV;IMkRU,gBN9RlB;IM+RkB,cJtSlB;ELwjCR;ESjxB0B;IACI,eNrRd;EHwiChB;AACF;AC3gCI;EQsPwB;IAGQ,YAAA;IACA,eAAA;IACA,eNzRlB;EH+iChB;AACF;ASjxBgB;EACI,eAAA;ATmxBpB;ACrhCI;EQ4NQ;IAyCY,gCAAA;IRlMrB,UQmMmD;EToxBpD;AACF;ACjjCI;EQkPQ;IA6CY,cFvTf;IEwTe,kBFhTZ;IEiTY,kBAAA;ETsxBtB;ESrxBsB;IACI,eAAA;ETuxB1B;AACF;AC3jCI;EQuSY;IAEQ,yBJpUd;IIqUc,kBAAA;IACA,sCAAA;IACA,cFpUf;IEqUe,eNrTN;IMsTM,OAAA;IACA,SAAA;IACA,gBAAA;IACA,UAAA;IACA,UAAA;IACA,kBAAA;IAEA,yBAAA;IAGA,2BAAA;IACA,SAAA;IACA,kBAAA;IACA,aAAA;ETsxBtB;AACF;ACllCI;EQkUoB;IACI,mBAAA;IACA,UAAA;IACA,aAAA;IAGA,wBAAA;IACA,kBAAA;IACA,6BAAA;ETmxB1B;AACF;ACxkCI;EQ2TgB;IACI,aAAA;IACA,oCJlXP;ELkoCf;AACF;AS7wBY;EACI,aF1WR;APynCR;ACjlCI;EQiUQ;IAGQ,cAAA;ETixBlB;AACF;AS7wBI;EACI,SAAA;EACA,UAAA;AT+wBR;AC1lCI;EQyUA;IAIQ,aAAA;ETixBV;AACF;AShxBQ;EAGI,mBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ATkxBZ;ASjxBY;EACI,kBAAA;ATmxBhB;ASjxBY;EACI,SAAA;EACA,sCAAA;ATmxBhB;ASlxBgB;EACI,6BAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBN/YR;AHmqCZ;ASnxBoB;EACI,cJ5ZP;ALirCjB;ASnxBoB;EACI,aAAA;EACH,0BAAA;ATqxBrB;ASnxBoB;EACI,0BAAA;ATqxBxB;AS/wBY;ERjTT,iBQkTqC;ATixBxC;AS/wBY;EACI,gBNjaN;EMkaM,eNpZE;EMqZF,cJ9ZD;AL+qCf;AShxBgB;EACI,cJnaJ;ALqrChB;AS/wBY;EACI,yBJpaD;EIqaC,yBAAA;EACA,+BAAA;EACA,cJnbN;EIobM,kBAAA;EACA,gBN9aN;EM+aM,eNjaE;EF+Ff,kBQmU2C;EAC9B,kBFtbN;APusCV;ACxpCI;EQ8XQ;IR3TT,iBQuUmD;IAC9B,eNzaN;EH2rChB;AACF;ASjxBgB;EACI,yBJ/bV;EIgcU,yBAAA;EACA,oCAAA;EACA,cJtbL;ALysCf;AS/wBY;EACI,yBJ5cC;EI6cD,yBAAA;EACA,+BAAA;EACA,cJ1cN;EI2cM,kBAAA;EACA,gBNrcN;EMscM,eNxbE;EF+Ff,kBQ0V2C;ATixB9C;AC9qCI;EQqZQ;IRlVT,iBQ6VmD;IAC9B,eN/bN;EHitChB;AACF;ASjxBgB;EACI,yBJrdV;EIsdU,yBAAA;EACA,oCAAA;EACA,cJ7dH;ALgvCjB;AS5wBE;EACC,aAAA;AT8wBH;;ASzwBI;EACI,wBAAA;AT4wBR;AS3wBQ;EACI,gBAAA;AT6wBZ;;ASvwBA;EACI,6CAAA;EACA,mCAAA;UAAA,2BAAA;EACA,oDAAA;EACA,+CAAA;AT0wBJ;ASxwBI;EACI,wBAAA;EACA,6CAAA;EACA,8BAAA;AT0wBR;AChtCI;EQmcA;IAMQ,wBAAA;IACA,yCAAA;ET2wBV;AACF;ASxwBI;EACI,sCAAA;AT0wBR;ASvwBI;EACI,qCAAA;ATywBR;ASvwBQ;EACI,2BAAA;EACA,iCAAA;ATywBZ;AChuCI;EQqdI;IAKQ,2BAAA;ET0wBd;AACF;ASvwBQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sCAAA;ATywBZ;ASvwBY;EACI,kBAAA;EACA,gBAAA;EACA,cJxhBN;EIyhBM,mBAAA;EACA,cAAA;ATywBhB;AClvCI;EQoeQ;IAQQ,iBAAA;ET0wBlB;AACF;ASvwBY;EACI,kBAAA;EACA,cJ7hBG;EI8hBH,gBN9hBJ;EM+hBI,mBAAA;EACA,yBAAA;EACA,8CAAA;ATywBhB;AC/vCI;EQgfQ;IASQ,iBAAA;ET0wBlB;AACF;ASrwBY;EACI,yCAAA;ATuwBhB;ASjwBQ;EACI,2BAAA;ATmwBZ;AS/vBI;EACI,wBAAA;EACA,kCAAA;ATiwBR;AC9wCI;EQ2gBA;IAKQ,yBAAA;IACA,sCAAA;IACA,wBAAA;IACA,4BAAA;IACA,2BAAA;ETkwBV;AACF;ACvxCI;EQuhBI;IAEQ,mCAAA;ETkwBd;AACF;AS9vBI;EACI,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;ATgwBR;AClyCI;EQ8hBA;IAOQ,sBAAA;IACA,iBAAA;IACA,sCAAA;IACA,WAAA;IACA,kCAAA;ETiwBV;AACF;AS/vBQ;EACI,kBFnlBA;APo1CZ;AC9yCI;EQ4iBI;IAIQ,WAAA;IACA,iDAAA;ETkwBd;AACF;AShwBY;EACI,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kBF/lBJ;EEgmBI,gCAAA;EACA,4BAAA;ATkwBhB;AC7zCI;EQojBQ;IAUQ,4BAAA;IACA,yBAAA;IACA,eAAA;IACA,WAAA;ETmwBlB;AACF;ASjwBgB;EACI,WAAA;EACA,kBF7mBR;EE8mBQ,YAAA;EACA,SAAA;EACA,qCAAA;EACA,WAAA;EACA,WAAA;EACA,qDAAA;EACA,+BAAA;ATmwBpB;ACh1CI;EQokBY;IAYQ,aAAA;ETowBtB;AACF;ASjwBgB;EACI,yBAAA;ATmwBpB;ASjwBoB;EACI,qCAAA;ATmwBxB;AS7vBgB;EACI,yBAAA;AT+vBpB;AS7vBoB;EACI,qCAAA;AT+vBxB;ASxvBI;EACI,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,SAAA;AT0vBR;ACv2CI;EQymBA;IAOQ,aAAA;ET2vBV;AACF;ASzvBQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;EACA,mBAAA;EACA,cJ5qBF;EI6qBE,gBNvqBA;EMwqBA,eAAA;EACA,qBAAA;EACA,yBAAA;AT2vBZ;ASzvBY;EACI,cAAA;EACA,eAAA;AT2vBhB;ASxvBY;EACI,oCAAA;EACA,sCAAA;EACA,cJ1rBN;EI2rBM,2BAAA;AT0vBhB;AStvBQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,qDAAA;EACA,mBAAA;EACA,cAAA;EACA,gBNlsBJ;EMmsBI,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,6CAAA;ATwvBZ;AStvBY;EACI,eAAA;ATwvBhB;ASrvBY;EACI,2BAAA;EACA,6CAAA;EACA,WAAA;ATuvBhB;;AShvBA;EACI;IACI,UAAA;IACA,4BAAA;ETmvBN;ESjvBE;IACI,UAAA;IACA,wBAAA;ETmvBN;AACF;AShvBA;EACI;IACI,qCAAA;IACA,UAAA;ETkvBN;EShvBE;IACI,mCAAA;ETkvBN;EShvBE;IACI,gCAAA;IACA,UAAA;ETkvBN;AACF;AS/uBA;EACI;IACI,UAAA;IACA,4BAAA;ETivBN;ES/uBE;IACI,UAAA;IACA,wBAAA;ETivBN;AACF;AS9uBA;EACI;IACI,2CAAA;ETgvBN;ES9uBE;IACI,6EAAA;ETgvBN;AACF;AS7uBA;EACI;IACI,uBAAA;ET+uBN;ES7uBE;IACI,yBAAA;ET+uBN;AACF;AUlgDA;;wBAAA;AAIA;EACC,mBLIc;EKHd,kBHUW;APy/CZ;AUlgDC;EACC,WAAA;EACA,6DAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AVogDF;AC79CI;ES/CH;IAUG,aAAA;EVsgDF;AACF;AUpgDC;EACC,WAAA;EACA,6DAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AVsgDF;AC5+CI;ESlCH;IAUG,aAAA;EVwgDF;AACF;AUtgDC;EACC,kBAAA;EACA,WAAA;ETqFC,SSpFuB;ETqFvB,eSrF0B;AVygD7B;ACv/CI;ESrBH;ITuFE,SSlFwB;ITmFxB,oBSnF2B;EV4gD5B;AACF;AC7/CI;ESrBH;ITuFE,SS/EwB;ITgFxB,iBShF2B;EV+gD5B;AACF;AU7gDC;EACC,4BAAA;AV+gDF;ACtgDI;ESVH;IAGE,SAAA;EVihDD;AACF;AU9gDE;EACC,mBAAA;AVghDH;AU9gDE;EACC,mBAAA;AVghDH;ACjhDI;ESAF;IAGE,mBAAA;EVkhDF;AACF;ACthDI;ESAF;IAME,mBAAA;EVohDF;AACF;AUnhDG;EACC,gBPrDI;EOsDJ,cLzBW;EK0BX,gBAAA;AVqhDJ;AUjhDG;EACC,gBHxDI;EN0GL,SSjDyB;ETkDzB,USlD4B;AVohD/B;AUjhDE;EACC,kBH3DS;EG4DT,eP9Ce;EO+Cf,gBPnEK;EOoEL,cLzEO;EJmHP,gBSzCwB;AVmhD3B;AUlhDG;EACC,WAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;AVohDJ;ACrjDI;ESJH;IAyCE,mBAAA;EVohDD;AACF;AC1jDI;ESJH;IA4CE,mBAAA;EVshDD;AACF;AUlhDG;ETqBA,gBSpByB;AVohD5B;AUnhDI;EACC,gBAAA;AVqhDL;AUnhDI;EACC,cL7Fe;EJ0FlB,gCSIuB;AVuhDzB;AUthDK;EACC,cL5GW;EK6GX,kBAAA;ETPJ,gCSQwB;AV0hD1B;AUnhDE;EACC,gBAAA;EACA,ePvFe;EOwFf,cAAA;EACA,gBAAA;EACA,mBAAA;AVqhDH;AUnhDE;EACC,ePnGe;EOoGf,cL/Ga;EKgHb,mBAAA;EACA,iBAAA;AVqhDH;AUlhDG;EAEC,mBAAA;AVmhDJ;AUlhDI;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBL1HY;EK2HZ,cLtIK;EKuIL,eP9Ga;EO+Gb,kBAAA;EAEA,cAAA;AVmhDL;AU/gDK;EACC,gBAAA;EACA,ePxHY;EOyHZ,cAAA;AVihDN;AU7gDG;EACC,kBAAA;AV+gDJ;AU9gDI;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cLrJe;EKsJf,ePpIa;EOqIb,cAAA;AVghDL;AU9gDI;EACC,gBAAA;EACA,mBLlKK;EKmKL,kBAAA;EACA,yBAAA;EACA,ePlJa;EOmJb,SAAA;EACA,6BAAA;EACA,cLjKe;ALirDpB;AU9gDI;ETtDD,kBSuDgC;EAC9B,ePxJa;EOyJb,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AVghDL;AU/gDK;EACC,cAAA;AVihDN;AU9gDK;EACC,qBAAA;AVghDN;AU/gDM;EACC,cAAA;AVihDP;AUzgDC;EACC,mBLtLa;EKuLb,kBHxLU;EGyLP,WAAA;ETjFF,SSkFuB;ETjFvB,eSiF0B;AV4gD7B;AChqDI;ESgJH;IT9EE,SSoFwB;ITnFxB,eSmF2B;EV+gD5B;AACF;ACtqDI;ESwJF;IAEE,kBHzMM;EPytDR;AACF;AC3qDI;ES4JD;IT1FA,gBS4F0B;EVihD3B;AACF;AU/gDI;EACC,cLnNK;ALouDV;AU7gDI;EACC,oBAAA;EACA,4BAAA;AV+gDL;ACvrDI;ESsKA;IAIE,uBAAA;EVihDJ;AACF;AUhhDK;ET1GF,SS2G2B;ET1G3B,gBS0G8B;AVmhDjC;AUlhDM;EACC,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AVohDP;AU9gDE;EACI,iBH5OG;EG6OH,SAAA;EACA,UAAA;AVghDN;AC9sDI;ES2LF;IAKE,kBH/OM;EPiwDR;AACF;AUjhDM;EACC,qBHhPU;EGiPV,kBAAA;EACA,kBH3OK;AP8vDZ;ACxtDI;ESkME;IAKD,kBAAA;IACA,gBAAA;EVqhDH;AACF;AUphDO;EACC,WL7NC;ALmvDT;AUrhDQ;EACC,cLhQU;ALuxDnB;AUphDO;EACC,WAAA;EACA,kBHzPI;EG0PJ,mBLtQW;EKuQX,UAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AVshDR;AUphDI;EACC,eAAA;AVshDL;AUx/CA;EACC;IACC,4BAAA;EVmhDA;EUjhDD;IACC,UAAA;IACA,2BAAA;EVmhDA;EUjhDD;IACC,UAAA;EVmhDA;AACF;AUjhDA;ETnMG,mBSoMyB;AVmhD5B;AUlhDI;EACI,ePjSU;EOkSV,cL1TE;EK2TF,mBAAA;AVohDR;AC9xDI;ESuQA;IAKQ,mBAAA;EVshDV;AACF;AUlhDQ;EACI,kBAAA;AVohDZ;AUnhDY;EACI,eAAA;AVqhDhB;AUlhDgB;EACI,WL1SX;AL8zDT;;AU7gDA;ET7NG,gBS8NsB;AVghDzB;AU5gDE;EACC,kBAAA;AV8gDH;AU7gDG;EACC,eAAA;AV+gDJ;AU5gDI;EACC,WL7TI;AL20DT;;AUxgDA;EAEI,cAAA;EACA,eHvUO;EGwUP,kBHpWM;EGqWN,kBH5VQ;EG6VR,UAAA;EACA,gBHzUM;EG0UN,cL9VW;EK+VX,mBLjWY;EKkWZ,mBAAA;EACA,eAAA;EACA,YAAA;EAGA,wDAAA;AV0gDJ;AC10DI;ESiTJ;IAiBQ,eAAA;IACA,YAAA;EV4gDN;AACF;AU3gDI;EACI,oBH9WA;EG+WA,kBH9WI;EG+WJ,WH9XO;EG+XP,YH5XQ;EG6XR,gBAAA;EACA,WAAA;EAGA,uBAAA;EACA,aHvXA;APo4DR;AU3gDI;EACI,WH1XA;EG2XA,eP5WU;EO6WV,iBAAA;EACA,kBHjXE;EGkXF,mBHlXE;EGmXF,oBHnXE;EGoXF,oBHhYA;EGiYA,cHvYC;EGwYD,mCAAA;AV6gDR;ACv2DI;ESiVA;IAWQ,ePzXM;EHw4DhB;AACF;AU7gDI;EACI,cLrYO;ALo5Df;AU9gDQ;EAGI,wCAAA;AVghDZ;;AU5gDA;EAEI,cAAA;EACA,eH9XO;EG+XP,kBH3ZM;EG4ZN,kBHnZQ;EGoZR,UAAA;EACA,gBHhYM;EGiYN,mBAAA;EACA,eAAA;EACA,YAAA;EAGA,wDAAA;AV8gDJ;ACn4DI;ESwWJ;IAeQ,eAAA;IACA,YAAA;EVghDN;AACF;AU/gDI;EACI,oBHnaA;EGoaA,kBHnaI;EGoaJ,WHnbO;EGobP,YHjbQ;EGkbR,gBAAA;EACA,WAAA;EAGA,uBAAA;EACA,aH5aA;AP67DR;AU/gDI;EACI,WH/aA;EGgbA,ePjaU;EOkaV,iBAAA;EACA,kBHtaE;EGuaF,mBHvaE;EGwaF,oBHxaE;EGyaF,oBHrbA;EGsbA,cH5bC;EG6bD,mCAAA;EACN,cLjcQ;ALk9DV;ACj6DI;ESsYA;IAYQ,eP/aM;EHk8DhB;AACF;AUjhDI;EACI,cL3bO;AL88Df;AUlhDQ;EAGI,wCAAA;AVohDZ;;AU9gDA;EACI,6DAAA;EACA,kBAAA;EACA,gBAAA;AVihDJ;AU/gDI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oFAAA;AVihDR;AU9gDI;EACI,oBAAA;AVghDR;AU9gDQ;EAHJ;IAIQ,oBAAA;EVihDV;AACF;AU/gDQ;EAPJ;IAQQ,oBAAA;EVkhDV;AACF;AU9gDQ;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AVghDZ;AU7gDQ;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AV+gDZ;AU7gDY;EANJ;IAOQ,eAAA;EVghDd;AACF;AU7gDQ;EACI,aAAA;EACA,SAAA;AV+gDZ;AU7gDY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AV+gDhB;AU7gDgB;EACI,qDAAA;EACA,yBAAA;EACA,cAAA;EACA,2BAAA;AV+gDpB;AU1gDQ;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AV4gDZ;AU1gDY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,qDAAA;AV4gDhB;AUzgDY;EAlBJ;IAmBQ,eAAA;EV4gDd;AACF;AUzgDQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AV2gDZ;AUzgDY;EACI,mBAAA;AV2gDhB;AUzgDgB;EACI,+BAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AV2gDpB;AUzgDoB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,qCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;AV2gDxB;AUxgDoB;EACI,cAAA;EACA,kBAAA;AV0gDxB;AUxgDwB;EACI,qCAAA;AV0gD5B;AUngDQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AVqgDZ;AUngDY;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AVqgDhB;AUngDgB;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AVqgDpB;AUlgDgB;EACI,+BAAA;EACA,qBAAA;EACA,2BAAA;AVogDpB;AUlgDoB;EACI,cAAA;AVogDxB;AU9/CQ;EACI,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,2CAAA;AVggDZ;AU9/CY;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AVggDhB;AU9/CgB;EACI,gBAAA;AVggDpB;AU7/CgB;EACI,YAAA;AV+/CpB;AUz/CI;EACI,qCAAA;EACA,+CAAA;EACA,kDAAA;EACA,eAAA;AV2/CR;AUz/CQ;EANJ;IAOQ,eAAA;EV4/CV;AACF;AU1/CQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AV4/CZ;AU1/CY;EACI,qBAAA;AV4/ChB;AU1/CgB;;EAEI,WAAA;EACA,YAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AV4/CpB;AU1/CoB;EAfJ;;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;EV8/CtB;AACF;AU1/CoB;;EAEI,kCAAA;EACA,oCAAA;EACA,2BAAA;AV4/CxB;AUt/CQ;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AVw/CZ;AUt/CY;EAPJ;IAQQ,eAAA;EVy/Cd;AACF;AUt/CQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AVw/CZ;AUt/CY;EANJ;IAOQ,gBAAA;EVy/Cd;AACF;AUv/CY;EACI,+BAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AVy/ChB;AUv/CgB;EACI,YAAA;EACA,cAAA;AVy/CpB;AUt/CgB;EACI,cAAA;AVw/CpB;AUl/CI;EACI,eAAA;AVo/CR;AUl/CQ;EAHJ;IAIQ,eAAA;EVq/CV;AACF;AUn/CQ;;EAEI,+BAAA;EACA,eAAA;EACA,SAAA;AVq/CZ;AUn/CY;EANJ;;IAOQ,eAAA;IACA,6BAAA;IACA,mBAAA;EVu/Cd;AACF;;AW/vEA;;wBAAA;AAIA;EACI,mBNIW;EMHX,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AXiwEJ;ACptEI;EUlDJ;IAOQ,oBAAA;EXmwEN;AACF;AWlwEI;EACF,WAAA;EACM,6DAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AXowER;ACnuEI;EUzCA;IAUQ,aAAA;EXswEV;AACF;AWpwEI;EACF,WAAA;EACM,6DAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AXswER;AClvEI;EU5BA;IAUO,aAAA;EXwwET;AACF;AWtwEI;EACI,gBAAA;EACA,cNpCE;EMqCF,eRNU;EFoFf,gBU7E6B;AXwwEhC;AC7vEI;EUfA;IAMQ,eRVM;EHoxEhB;AACF;AWxwEI;EACI,uBAAA;EACA,SAAA;AX0wER;AWxwEY;EACI,cNhDN;AL0zEV;AWvwEQ;EACI,cNpDF;AL6zEV;AWrwEQ;EACI,cNzDF;ALg0EV;AWpwEI;EACI,cNlES;ALw0EjB;;AYx0EA;;wBAAA;AAIA;EACI,0BAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,cP0BW;ALgzEf;AYz0EI;EACI,YAAA;AZ20ER;;AYv0EI;EACI,mBPVQ;EOWR,yBAAA;EXuRN,kBWtRuB;AZ00EzB;AYz0EQ;EACI,cPUD;EOTC,iBAAA;EXmRV,kBWlR2B;EACjB,mBAAA;EACA,kBAAA;AZ20EZ;AYz0EQ;EACI,YAAA;EACA,UAAA;AZ20EZ;;AYv0EA;EXgFE,kBMjGU;ENkGV,QWhFgC;EXmFhC,SWnF8C;EAC5C,qBPJO;EOKP,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EX4BF,yCW3BqB;EX4BrB,iDW5BqB;EX6BrB,6CW7BqB;AZ80EvB;;AY50EA;EACI,qBPfO;EOgBP,yBAAA;EACA,eAAA;EX0ED,YWzE+B;AZ+0ElC;;AY70EA;EACI,mBPrCY;EOsCZ,cP/CM;AL+3EV;;AY70EI;EACI,8BAAA;EACA,yBAAA;AZg1ER;;AY70EA;EACI,aAAA;AZg1EJ;;Aa74EA;;wBAAA;AAIA;EACC,cRGQ;EQFR,eNNc;EMOd,gBAAA;EACA,WNRc;APu5Ef;Aa94EI;EACI,oCAAA;Abg5ER;Aa94EI;EACI,mBNNE;EMOF,oBN6BQ;EM5BR,kBNQG;EMPH,gBVJE;EUKF,SAAA;EACA,UAAA;EACA,sBNWE;EMVF,mBNsBE;EMrBF,gBAAA;EACA,eVEU;AH84ElB;Aa74EQ;EACI,eVDM;EUEN,cRVG;EQWH,gBVhBF;EUiBE,yBRhBM;EJ4Gf,aY3FuC;Ab+4E1C;Aa54EI;EACI,yBRrBU;EQsBV,gBAAA;EACA,sBNNE;EMOF,mBNKE;APy4EV;Aa54EK;EACG,sBNVE;EMWF,mBNCE;AP64EV;Aa74EQ;EACI,gCAAA;Ab+4EZ;Aa94EY;EACI,qBRLT;EJiFJ,aY3E4C;Abg5E/C;Aa54EY;EACI,qBN1CC;EM2CD,kBN7BL;EM8BK,gBVxCL;EUyCK,SAAA;EACA,UAAA;EACA,sBN1BN;APw6EV;Aa74EgB;EACI,cRjBL;EQkBK,cNnDX;EMoDW,eVrCF;EUsCE,eAAA;Ab+4EpB;Aa54EY;EACI,cRzDP;ALu8ET;Aa34EgB;EACI,mBR3BH;EQ4BG,cR7DL;EQ8DK,WAAA;EACA,YAAA;EACA,UAAA;EAEA,mBAAA;Ab44EpB;Aa34EoB;EACI,cR7EP;AL09EjB;Aa14EgB;EACI,qBNxEH;APo9EjB;Aa14EgB;EACI,gCAAA;Ab44EpB;Aa14EgB;EACI,cRvFH;ALm+EjB;Aa14EgB;EACI,cRrFV;ALi+EV;Aa14EgB;EACI,qBNpFH;ENgHd,iBY3B+C;Ab44ElD;Aaz4EY;EACI,cRvEC;EQwED,qBN1FC;APq+EjB;Aa14EgB;EACI,cRrGH;ALi/EjB;Aat4EI;EACI,cRnGO;EQoGP,qBAAA;Abw4ER;Aav4EQ;EACI,cR5GO;ALq/EnB;Aat4EQ;EACI,sBNrFF;AP69EV;Aar4EI;EACI,YAAA;EACA,mBRnHE;EQoHF,yBAAA;EACA,+BAAA;EACA,2BAAA;EZ6KN,kBY5KuB;Abu4EzB;Aar4EK;EACG,gBVnHE;EUoHF,eVzGU;EU0GV,cRtGS;EQuGT,aNtHA;EMuHA,mBN5HE;EM6HF,mBAAA;Abu4ER;Aat4EQ;EACI,gBAAA;Abw4EZ;Aat4EQ;EACI,cRzIK;EQ0IL,uBN1GG;APk/Ef;Aat4EQ;EACI,cRxIF;EQyIE,qBNhIJ;EMiII,yBR/IK;ALuhFjB;Aat4EQ;EACI,eAAA;Abw4EZ;;Aal4EI;EACI,YAAA;EACA,mBRrJE;EQsJF,yBAAA;EACA,iCAAA;EZ4IN,mBY3IuB;EACjB,UAAA;EACA,2BAAA;Abq4ER;Aan4EI;EACI,gBVtJE;EUuJF,eV5IU;EU6IV,cR3JO;EQ8JP,uBAAA;Abm4ER;;Aa/3EA;EACI,eVnJc;EUoJd,gBAAA;Abk4EJ;;Aa/3EI;EACI,mBNvIE;APygFV;;Aa73EQ;EACI,yBAAA;Abg4EZ;Aa73EI;EACI,gBAAA;Ab+3ER;Aa73EI;EACI,gDAAA;Ab+3ER;;Aa53EA;;;;;;EZxEG,iBY8E+B;Ab+3ElC;;Aaz3EY;EACI,yBAAA;Ab43EhB;;Aat3EI;EACI,iCAAA;Aby3ER;Aav3EI;EACI,iCAAA;Aby3ER;Aax3EQ;EACI,oCAAA;EACA,uCAAA;Ab03EZ;Aax3EQ;EACI,qCAAA;EACA,wCAAA;Ab03EZ;;Aal3EI;EZ9GD,qBY+GmC;Abq3EtC;Aaj3EoB;EACI,aAAA;Abm3ExB;Aa/2EY;EACI,cRzOD;EQ0OC,gBVtOL;EUuOK,aAAA;EACA,eV9NE;EFkGf,kBY6H0C;EAC7B,mBN7MN;EM8MM,gBAAA;Abi3EhB;Aah3EgB;EACI,kBAAA;Abk3EpB;Aa/2EY;EACI,mBNpNN;EN+EP,kBYsI2C;EAC9B,gBAAA;EACA,gBVrPN;EUsPM,eV1OE;EU2OF,cRhQG;ALinFnB;Aah3EgB;EACI,kBAAA;Abk3EpB;;Aa32EA;EACC,SAAA;Ab82ED;;Aa32EA;EACI,gBNxPI;APsmFR;;Aa32EI;;EAEI,aNxQA;APsnFR;;Aap2EO;EACC,mCAAA;EACwB,mBAAA;Abu2EhC;Aar2E4B;EACpB,mCAAA;EACwB,mBAAA;Abu2EhC;;Aa71EA;EACI,gBAAA;Abg2EJ;;Aa71EI;EZZF,kBYauB;EACjB,qBAAA;EACA,eVhSU;EUiSV,eAAA;EZ/LL,iBYgMmC;EAC9B,gBV7SG;EU8SH,kBAAA;Abg2ER;;Aa11EY;EACI,cAAA;Ab61EhB;Aa51EgB;EACI,WAAA;Ab81EpB;Aa11EgB;EACI,cRlUF;AL8pFlB;Aa31EoB;EACI,cR3UP;ALwqFjB;;Aan1EY;EACI,iBAAA;EACA,SAAA;Abs1EhB;;Aa/0EQ;EACI,iBAAA;EACA,YAAA;Abk1EZ;Aah1EQ;EACI,YAAA;EACA,eV5UM;AH8pFlB;;Aa70EI;EACI,mBRrWE;EQsWF,8BAAA;EACA,kBAAA;Abg1ER;;Aa70EA;EACI,2BAAA;EACA,eVzVc;EU0Vd,cR3Wc;AL2rFlB;;Aa90EA;EACI,eAAA;EACA,iBAAA;EACA,eVjWc;AHkrFlB;;Aa/0EA;EACI,kBAAA;EACA,gBAAA;EACA,eVtWc;AHwrFlB;;Ac9sFA;;wBAAA;AAIA;EACI,kBPWQ;ENyGT,eanH+B;AdgtFlC;AChqFI;EalDJ;IbqHG,eajHmC;EdktFpC;AACF;;Ac/sFA;EACI,kBPGQ;EOFR,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0EAAA;EACA,gBAAA;EbuGD,oBatG+B;AdktFlC;AC/qFI;Ea1CJ;IAUQ,gBAAA;IbmGL,oBalGmC;EdmtFpC;AACF;ACrrFI;Ea1CJ;IAeQ,gBAAA;Ib8FL,oBa7FmC;EdotFpC;AACF;AcjtFI;EACI,kBPlBI;EOmBJ,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6KAAA;EAEA,oBAAA;EACA,0CAAA;AdktFR;Ac9sFI;EACI,kBP/BI;EOgCJ,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AdgtFR;Ac9sFQ;EACI,kBPxCA;EOyCA,kBAAA;EACA,oFAAA;EACA,kBAAA;EACA,yCAAA;AdgtFZ;ACrtFI;EaAI;IAQQ,aAAA;EditFd;AACF;Ac9sFQ;EACI,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AdgtFZ;Ac7sFQ;EACI,YAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;Ad+sFZ;Ac5sFQ;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;Ad8sFZ;AczsFI;EACI,kBP7EI;EO8EJ,WAAA;Ad2sFR;AcvsFI;EACI,kBP5FE;EO6FF,eAAA;AdysFR;AcrsFI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,2CAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cT7GE;ES8GF,eAAA;EACA,gBXxGE;EWyGF,qBAAA;EACA,6CAAA;AdusFR;ACvwFI;EakDA;IAiBQ,iBAAA;IACA,eAAA;IACA,mBAAA;EdwsFV;AACF;ActsFQ;EACI,cTpHO;ESqHP,eAAA;EACA,sCAAA;AdwsFZ;AcnsFI;EACI,eAAA;EACA,gBAAA;EACA,cTpIE;ESqIF,gBAAA;EACA,mBAAA;EACA,uBAAA;AdqsFR;AC3xFI;EagFA;IASQ,eAAA;IACA,mBAAA;EdssFV;AACF;ACjyFI;EagFA;IAcQ,eAAA;EdusFV;AACF;AcrsFQ;EACI,0EAAA;EACA,0BAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;EACA,wCAAA;AdusFZ;AclsFI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AdosFR;ACxzFI;Ea6GA;IAUQ,eAAA;IACA,mBAAA;EdqsFV;AACF;AC9zFI;Ea6GA;IAeQ,eAAA;EdssFV;EcrsFU;IACI,aAAA;EdusFd;AACF;AclsFI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AdosFR;AC90FI;EaoIA;IASQ,mBAAA;EdqsFV;AACF;AclsFI;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBXnMI;EWoMJ,qBAAA;EACA,yBAAA;EACA,6BAAA;AdosFR;AC/1FI;EaiJA;IAaQ,kBAAA;IACA,eAAA;EdqsFV;AACF;ACr2FI;EaiJA;IAkBQ,kBAAA;IACA,eAAA;EdssFV;AACF;AcpsFQ;EACI,eAAA;EACA,+BAAA;AdssFZ;AcnsFQ;EACI,0BAAA;AdqsFZ;AcjsFI;EACI,0EAAA;EACA,0BAAA;EACA,cAAA;EACA,6CAAA;EACA,kBP5NI;EO6NJ,gBAAA;AdmsFR;AcjsFQ;EACI,WAAA;EACA,kBPlOA;EOmOA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mCAAA;AdmsFZ;AchsFQ;EACI,2BAAA;EACA,8CAAA;EACA,WAAA;EACA,yCAAA;AdksFZ;AchsFY;EACI,YAAA;EACA,aAAA;AdksFhB;Ac7rFI;EACI,oCAAA;EACA,cTtQE;ESuQF,0CAAA;EACA,mCAAA;UAAA,2BAAA;EACA,kBP9PI;EO+PJ,gBAAA;Ad+rFR;Ac7rFQ;EACI,WAAA;EACA,kBPpQA;EOqQA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mCAAA;Ad+rFZ;Ac5rFQ;EACI,qCAAA;EACA,sCAAA;EACA,cT5RF;ES6RE,2BAAA;Ad8rFZ;Ac5rFY;EACI,YAAA;EACA,aAAA;Ad8rFhB;AcxrFI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,0CAAA;Ad0rFR;ACz7FI;EasPA;IAYQ,SAAA;IACA,aAAA;Ed2rFV;AACF;AC/7FI;EasPA;IAiBQ,sBAAA;IACA,SAAA;Ed4rFV;AACF;AczrFI;EACI,kBP5TE;APu/FV;AczrFQ;EACI,eAAA;EACA,gBX9TA;EW+TA,cTnUF;ESoUE,kBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;Ad2rFZ;ACl9FI;Ea+QI;IAWQ,eAAA;Ed4rFd;AACF;AczrFQ;EACI,eAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;Ad2rFZ;AC79FI;Ea8RI;IAOQ,eAAA;Ed4rFd;AACF;AcxrFI;EACI,UAAA;EACA,YAAA;EACA,qCAAA;Ad0rFR;ACv+FI;Ea0SA;IAMQ,aAAA;Ed2rFV;AACF;AcvrFI;EACI,kBP7VI;EO8VJ,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AdyrFR;AC1/FI;EaqTA;IAeQ,YAAA;IACA,QAAA;Ed0rFV;AACF;AChgGI;EaqTA;IAoBQ,YAAA;Ed2rFV;AACF;AcxrFY;EACI,yCAAA;Ad0rFhB;ActrFQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AdwrFZ;AcrrFQ;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBPnYA;EOoYA,aAAA;EACA,uBAAA;EACA,uBAAA;AdurFZ;ACvhGI;EawVI;IAWQ,WAAA;IACA,YAAA;EdwrFd;AACF;ActrFY;EACI,UAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;AdwrFhB;ACriGI;EauWQ;IASQ,UAAA;IACA,WAAA;IACA,eAAA;EdyrFlB;AACF;AcrrFQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AdurFZ;AcrrFY;EACI,cTxaG;ESyaH,eAAA;EACA,uCAAA;AdurFhB;ACtjGI;Ea4XQ;IAMQ,eAAA;EdwrFlB;AACF;AclrFI;EACI,kBPjbI;EOkbJ,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,mDAAA;AdorFR;ACnkGI;EayYA;IASQ,aAAA;EdqrFV;AACF;AclrFI;EACI,YAAA;EACA,aAAA;EACA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AdorFR;AcjrFI;EACI,YAAA;EACA,aAAA;EACA,qDAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;AdmrFR;;Ac9qFA;EACI;IACI,mCAAA;EdirFN;Ec/qFE;IACI,4CAAA;EdirFN;Ec/qFE;IACI,4CAAA;EdirFN;AACF;Ac9qFA;EACI;IACI,UAAA;EdgrFN;Ec9qFE;IACI,YAAA;EdgrFN;AACF;Ac7qFA;EACI;IACI,0CAAA;Ed+qFN;Ec7qFE;IACI,2CAAA;Ed+qFN;AACF;Ac5qFA;EACI;IACI,uBAAA;Ed8qFN;Ec5qFE;IACI,wBAAA;Ed8qFN;Ec5qFE;IACI,yBAAA;Ed8qFN;Ec5qFE;IACI,uBAAA;Ed8qFN;Ec5qFE;IACI,uBAAA;Ed8qFN;AACF;Ac3qFA;EACI;IACI,2BAAA;Ed6qFN;Ec3qFE;IACI,6BAAA;Ed6qFN;AACF;Ac1qFA;EACI;IACI,2BAAA;Ed4qFN;Ec1qFE;IACI,6BAAA;Ed4qFN;AACF;AczqFA;EACI;IACI,UAAA;IACA,wBAAA;Ed2qFN;EczqFE;IACI,UAAA;IACA,2BAAA;Ed2qFN;AACF;AcxqFA;EACI;IACI,wBAAA;Ed0qFN;EcxqFE;IACI,0BAAA;Ed0qFN;AACF;AcvqFA;EACI;IACI,YAAA;EdyqFN;EcvqFE;IACI,UAAA;EdyqFN;AACF;ActqFA;EACI;IACI,uCAAA;EdwqFN;EctqFE;IACI,+CAAA;EdwqFN;EctqFE;IACI,6CAAA;EdwqFN;EctqFE;IACI,iDAAA;EdwqFN;AACF;AcpqFA;EACI,kBPhkBQ;EOikBR,6DAAA;EbxdD,gBayd+B;EAC9B,gBAAA;AdsqFJ;ACnsGI;EayhBJ;IbtdG,ea6dmC;EduqFpC;AACF;ACxsGI;EayhBJ;IbtdG,eaiemC;EdwqFpC;AACF;;AcpqFA;EACI,kBPzlBM;EO0lBN,mBAAA;EACA,kBPllBQ;EOmlBR,WAAA;AduqFJ;ACptGI;EayiBJ;IAOQ,mBAAA;EdwqFN;AACF;ActqFI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cTvmBW;ESwmBX,eAAA;EACA,gBXzmBI;EW0mBJ,qBAAA;EACA,yBAAA;AdwqFR;ACxuGI;EamjBA;IAgBQ,iBAAA;IACA,eAAA;EdyqFV;AACF;AcvqFQ;EACI,eAAA;AdyqFZ;AcrqFI;EACI,eAAA;EACA,gBAAA;EACA,cThoBE;ESioBF,mBAAA;EACA,uBAAA;EACA,kBPxnBI;AP+xGZ;ACzvGI;Ea4kBA;IASQ,eAAA;EdwqFV;AACF;AC9vGI;Ea4kBA;IAaQ,eAAA;EdyqFV;AACF;AcvqFQ;EACI,aAAA;AdyqFZ;AcrqFI;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,cAAA;AduqFR;AC5wGI;EaimBA;IAOQ,eAAA;EdwqFV;AACF;ACjxGI;EaimBA;IAWQ,eAAA;EdyqFV;AACF;;AcpqFA;EACI,mBAAA;EACA,kBP1pBQ;APi0GZ;AcrqFI;EACI,WAAA;EACA,kBP/pBI;EOgqBJ,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,iFAAA;EACA,oBAAA;AduqFR;AcpqFI;EACI,mBAAA;EACA,kBPzqBI;EO0qBJ,WAAA;AdsqFR;AC1yGI;EaioBA;IAMQ,mBAAA;EduqFV;AACF;AcrqFQ;EACI,eAAA;AduqFZ;AcpqFY;EACI,eAAA;AdsqFhB;AcnqFgB;EACI,sBAAA;EACA,0BAAA;EACA,qBAAA;EACA,qBAAA;AdqqFpB;Ac/pFI;EACI,kBP5sBE;EO6sBF,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,0CAAA;AdiqFR;Ac/pFQ;EACI,eAAA;EACA,cThtBO;ESitBP,mBAAA;EACA,YAAA;AdiqFZ;Ac9pFQ;EACI,eAAA;EACA,cT7tBF;ES8tBE,mBAAA;AdgqFZ;Ac7pFQ;EACI,eAAA;EACA,+BAAA;EACA,SAAA;Ad+pFZ;Ac3pFI;EACI,kBPvuBE;EOwuBF,kBP/tBI;EOguBJ,WAAA;Ad6pFR;AczpFI;EACI,gDAAA;EACA,qDAAA;EACA,8BAAA;EACA,wBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;Ad2pFR;ACj2GI;Ea8rBA;IAWQ,wBAAA;Ed4pFV;AACF;Ac1pFQ;EACI,sCAAA;EACA,gDAAA;EACA,+CAAA;EACA,uFAAA;Ad4pFZ;AcxpFQ;EACI,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBP9vBA;APw5GZ;AcxpFY;EACI,8BAAA;EACA,0CAAA;Ad0pFhB;AcvpFY;EACI,iCAAA;AdypFhB;ActpFY;EACI,6BAAA;EACA,gGAAA;EACA,8CAAA;UAAA,sCAAA;AdwpFhB;ActpFgB;EACI,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AdwpFpB;ACp4GI;EawuBY;IAOQ,0BAAA;EdypFtB;AACF;AcppFQ;EACI,SAAA;EACA,aAAA;EACA,sBAAA;AdspFZ;AcppFY;EACI,4DAAA;EACA,+BAAA;EACA,8BAAA;AdspFhB;AcppFgB;EACI,2BAAA;AdspFpB;AcppFoB;EACI,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,sCAAA;AdspFxB;AC55GI;EakwBgB;IAOQ,0BAAA;EdupF1B;AACF;AcrpFwB;EACI,yBAAA;AdupF5B;AcjpFY;EACI,8BAAA;AdmpFhB;AcjpFgB;EACI,yBAAA;EACA,0BAAA;AdmpFpB;AC36GI;EasxBY;IAKQ,0BAAA;EdopFtB;AACF;AcjpFgB;EACI,0CAAA;EACA,0BAAA;EACA,oBAAA;AdmpFpB;ACr7GI;Ea+xBY;IAMQ,0BAAA;EdopFtB;AACF;AchpFY;EACI,2BAAA;EACA,gDAAA;EACA,8BAAA;EACA,wBAAA;EACA,sDAAA;AdkpFhB;ACj8GI;Ea0yBQ;IAQQ,wBAAA;EdmpFlB;AACF;AchpFoB;EACI,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;AdkpFxB;AC58GI;EaszBgB;IAOQ,0BAAA;EdmpF1B;AACF;AchpFoB;EACI,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;AdkpFxB;ACx9GI;Eai0BgB;IAQQ,0BAAA;IACA,4BAAA;EdmpF1B;AACF;AcjpFwB;EACI,6CAAA;EACA,mDAAA;EACA,yBAAA;AdmpF5B;AcjpF4B;EACI,8BAAA;EACA,yBAAA;EACA,sCAAA;AdmpFhC;Ac/oFwB;EACI,gEAAA;EACA,uBAAA;EACA,yBAAA;AdipF5B;Ac/oF4B;EACI,sCAAA;EACA,wDAAA;AdipFhC;AcxoFQ;EACI,YAAA;EACA,sBAAA;Ad0oFZ;AcxoFY;EACI,sCAAA;Ad0oFhB;;AcnoFA;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBXv6BQ;EWw6BR,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBPt6BQ;EOu6BR,gBAAA;AdsoFJ;ACvgHI;Eaq3BJ;IAeQ,kBAAA;IACA,eAAA;EduoFN;AACF;AcroFI;EACI,eAAA;EACA,+BAAA;AduoFR;AcpoFI;EACI,0BAAA;AdsoFR;;AcloFA;EACI,0EAAA;EACA,0BAAA;EACA,cAAA;EACA,8CAAA;AdqoFJ;AcnoFI;EACI,WAAA;EACA,kBPj8BI;EOk8BJ,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AdqoFR;AcloFI;EACI,2BAAA;EACA,8CAAA;EACA,WAAA;AdooFR;AcloFQ;EACI,UAAA;AdooFZ;;Ac9nFA;EACI,kBPt9BQ;EOu9BR,6DAAA;AdioFJ;Ac/nFI;EACI,kBP19BI;EO29BJ,WAAA;AdioFR;Ac9nFI;EACI,kBPh+BI;EOi+BJ,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,gFAAA;EACA,kBAAA;EACA,oBAAA;AdgoFR;ACjkHI;Eaw7BA;IAYQ,YAAA;IACA,aAAA;EdioFV;AACF;;Ac7nFA;EACI,kBPj/BQ;EOk/BR,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AdgoFJ;ACnlHI;Ea08BJ;IAYQ,kBAAA;EdioFN;AACF;Ac/nFI;EACI,kBPjgCI;EOkgCJ,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;EACA,yBAAA;AdioFR;AClmHI;Eay9BA;IAWQ,eAAA;EdkoFV;AACF;Ac/nFI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AdioFR;ACnnHI;Eaw+BA;IAaQ,WAAA;IACA,YAAA;IACA,mBAAA;EdkoFV;AACF;AchoFQ;EACI,eAAA;EACA,cTviCO;ESwiCP,yBAAA;AdkoFZ;AC/nHI;Ea0/BI;IAMQ,eAAA;EdmoFd;AACF;Ac/nFI;EACI,eAAA;EACA,gBAAA;EACA,cTzjCE;ES0jCF,mBAAA;EACA,yBAAA;AdioFR;AC3oHI;EaqgCA;IAQQ,eAAA;IACA,mBAAA;EdkoFV;AACF;Ac/nFI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AdioFR;ACvpHI;EakhCA;IAOQ,eAAA;EdkoFV;AACF;Ac/nFI;EACI,kBPrkCI;EOskCJ,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,+EAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AdioFR;Ac9nFI;EACI,4BAAA;EACA,qCAAA;EACA,oCAAA;EACA,0CAAA;AdgoFR;Ac9nFQ;EACI,6BAAA;EACA,qBAAA;AdgoFZ;Ac7nFQ;EACI,qDAAA;EACA,yBAAA;EACA,kCAAA;Ad+nFZ;Ac7nFY;EACI,cAAA;EACA,qBAAA;Ad+nFhB;Ac3nFQ;EACI,cT3mCO;ALwuHnB;Ac1nFQ;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;Ad4nFZ;;AcvnFA;EACI,mCAAA;EACA,oCAAA;Ad0nFJ;AcxnFI;EACI,mCAAA;Ad0nFR;;AcrnFA;EACI,aAAA;AdwnFJ;;AcnnFI;EACI,aAAA;AdsnFR;;AcjnFA;EACI,aAAA;AdonFJ;;AclnFA;EACI,mBTvpCM;ESwpCN,kDAAA;EACA,mBAAA;EbriCD,aasiC+B;EAC9B,UAAA;EACA,kBPjpCQ;EOkpCR,uBAAA;AdqnFJ;ACjuHI;EaqmCJ;IASY,oBAAA;IACA,eAAA;EdunFV;AACF;ACvuHI;EaqmCJ;IAaY,aAAA;IACA,eAAA;EdynFV;AACF;AcxnFI;EACI,gBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;Ad0nFR;AcvnFI;EACI,kBPnqCI;AP4xHZ;AcxnFQ;EACI,kBPtqCA;EOuqCA,SAAA;EACA,UAAA;Ad0nFZ;AC3vHI;Ea8nCI;IAKQ,SAAA;Ed4nFd;AACF;Ac1nFQ;EbnkCL,4BaokCuC;Ad4nF1C;ACnwHI;EasoCI;IbnkCL,4BaskC+C;Ed8nFhD;AACF;Ac3nFI;Eb3kCD,Sa4kC6B;Eb3kC7B,ea2kCgC;Ad8nFnC;Ac1nFQ;EbhlCL,gBailCiC;EACxB,gBXhsCJ;EWisCI,eAAA;EACA,cTpsCH;ALg0HT;AClxHI;EakpCI;IAMQ,eXtrCE;EHozHhB;AACF;Ac1nFQ;EACI,yBTptCK;ESqtCL,yBAAA;EACA,+BAAA;EACA,cTltCF;ESmtCE,WPxtCG;ENyHZ,kBagmCuC;Ad4nF1C;Ac1nFY;EACI,iBAAA;Ad4nFhB;AClyHI;Ea6pCI;IAYY,WAAA;Ed6nFlB;AACF;ACvyHI;Ea6pCI;Ib1lCL,iBaymC+C;Ed+nFhD;AACF;Ac9nFY;EACI,yBThuCN;ESiuCM,yBAAA;EACA,oCAAA;EACA,cAAA;AdgoFhB;Ac3nFI;EAEI,WAAA;EACA,cAAA;Ad6nFR;ACvzHI;EaurCA;IAMY,WAAA;IACA,cAAA;Ed+nFd;AACF;AC9zHI;EaurCA;IAWY,YAAA;IACA,eAAA;EdioFd;AACF;AchoFQ;EACI,gBAAA;AdkoFZ;AchoFQ;EACI,gBAAA;AdkoFZ;AC30HI;EawsCI;IbtoCL,gBayoCqC;EdooFtC;AACF;ACh1HI;EawsCI;IbtoCL,Sa4oCqC;EdsoFtC;AACF;AcnoFI;EAEI,WAAA;EACA,cAAA;AdqoFR;AC11HI;EaktCA;IAMY,WAAA;IACA,cAAA;IACA,mBAAA;EduoFd;AACF;ACl2HI;EaktCA;IAYY,YAAA;IACA,eAAA;IACA,gBAAA;EdyoFd;AACF;AcxoFQ;EACI,gBAAA;Ad0oFZ;AC72HI;EasuCA;IAGQ,cAAA;EdwoFV;AACF;;AcroFA;EACI,kBAAA;Eb5qCD,gBa6qCyB;AdwoF5B;ACv3HI;Ea6uCJ;Ib3qCG,gBa+qCiC;Ed0oFlC;AACF;AczoFI;EACI,kBP1xCI;ENwGT,gBamrC6B;Ad2oFhC;ACh4HI;EamvCA;IbjrCD,gBaqrCqC;Ed6oFtC;AACF;Ac5oFQ;EACI,WAAA;EACA,kBPlyCA;EOmyCA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;Ad8oFZ;ACj5HI;EayvCI;IAYQ,aAAA;EdgpFd;AACF;Ac7oFI;EACI,gBAAA;EACA,YAAA;EACA,eXxyCU;AHu7HlB;AC35HI;EaywCA;IAKQ,eX1yCM;EH27HhB;AACF;;Ac9oFA;EACI,oBAAA;AdipFJ;ACp6HI;EakxCJ;IAGQ,oBAAA;EdmpFN;AACF;AclpFI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AdopFR;AC96HI;EauxCA;IAKY,aAAA;EdspFd;AACF;AcppFI;Eb7tCD,gBa8tC6B;EACxB,kBAAA;EACA,kBPx0CI;AP89HZ;AcrpFQ;EAEI,mBAAA;EbnuCT,gBaouCiC;EbnuCjC,aamuC2C;EAClC,mBTx1CF;ESy1CE,kBP90CA;EO+0CA,WAAA;AdupFZ;ACh8HI;EamyCI;IbhuCL,YawuC2C;EdypF5C;AACF;AcxpFY;EACI,mBAAA;EAEA,WAAA;EACA,YAAA;Eb9uCb,aa+uC2C;AdypF9C;AC38HI;Ea6yCQ;Ib1uCT,YaivCmD;Ed2pFpD;AACF;AcvpFY;EbvvCT,gBawvCqC;AdypFxC;AcrpFI;EACI,gCAAA;AdupFR;ACt9HI;Ea8zCA;IAGY,gBAAA;EdypFd;AACF;AcvpFI;EACI,gCAAA;AdypFR;AC99HI;Eao0CA;IAGY,gBAAA;Ed2pFd;AACF;AczpFI;EACI,gCAAA;Ad2pFR;ACt+HI;Ea00CA;IAGY,gBAAA;Ed6pFd;AACF;Ac5pFQ;EACI,SAAA;EACA,QAAA;Ad8pFZ;;Ac1pFA;EACI,mBTz3Ce;ALshInB;Ac5pFI;EbrxCD,gBawxC6B;Ad4pFhC;ACt/HI;Eau1CA;IbrxCD,gBa0xCqC;Ed8pFtC;AACF;Ac7pFQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;Ad+pFZ;AChgII;Ea81CI;IAKQ,aAAA;IACA,mBAAA;IACA,uBAAA;EdiqFd;Ec/pFkB;IACI,gBAAA;EdiqFtB;AACF;Ac7pFgB;EACI,mBT/5CV;ESg6CU,yBAAA;Eb5yCjB,kBa+yC+C;EAC9B,0BAAA;EACA,gBX75CT;EW85CS,eXj5CF;EWk5CE,cTp6CX;ESq6CW,kBAAA;Ad6pFpB;ACphII;Ea62CY;Ib1yCb,iBauzCuD;IAC9B,eXz5CV;IW05CU,gBAAA;Ed8pF1B;AACF;Ac7pFoB;EACI,mBTv6CR;ESw6CQ,cTj7Cd;ALglIV;Ac1pFoB;EACI,mBT96CR;ES+6CQ,cTx7Cd;ALolIV;ActpFoB;Eb30CjB,kBa40C6C;Eb30C7C,aa20CyD;EACpC,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AdypFxB;AChjII;Ea64CgB;Ib10CjB,Yau1CuD;IAC9B,WAAA;IACA,YAAA;Ed0pF1B;AACF;AchpFQ;EACI,cAAA;AdkpFZ;AchpFQ;EACI,cAAA;AdkpFZ;AchpFQ;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EAEA,gCAAA;EAGA,0BAAA;EACA,+BAAA;EACA,8BAAA;AdkpFZ;AchpFgB;EACI,8BAAA;EACA,cT5+CV;ES++CU,0BAAA;EACA,+BAAA;EACA,8BAAA;AdkpFpB;Ac/oFY;EACI,YAAA;EACA,WAAA;EACA,8BAAA;EACA,cTr/CP;ESs/CO,cAAA;EACA,kBAAA;EAKA,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad+oFhB;Ac5oFQ;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EAEA,+BAAA;EAGA,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad8oFZ;Ac5oFgB;EACI,8BAAA;EACA,cTlhDV;ESqhDU,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad8oFpB;Ac3oFY;EACI,YAAA;EACA,WAAA;EACA,8BAAA;EACA,cT3hDP;ES4hDO,cAAA;EACA,kBAAA;EAKA,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad2oFhB;;AcroFA;Ebz7CG,sBa07C+B;AdwoFlC;ACroII;Ea4/CJ;IAGQ,sBAAA;Ed0oFN;AACF;;AcxoFA;EACI,kBPziDQ;EO0iDR,mBTrjDM;ESsjDN,mBAAA;Ebn8CD,kBao8CyB;Ebn8CzB,aam8CqC;Ad4oFxC;AClpII;EakgDJ;Ib/7CG,aaq8CuC;Ed8oFxC;AACF;Ac7oFI;EACI,kBPjjDI;EOkjDJ,gBAAA;EACA,mBAAA;Eb38CL,gBa48C6B;Ad+oFhC;Ac9oFQ;EACI,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,yDAAA;AdgpFZ;Ac9oFQ;EACI,kBP7jDA;EO8jDA,OAAA;EACA,MAAA;EACA,WAAA;Ebt9CT,aau9CuC;EAC9B,UAAA;EAEA,eX3jDM;AH0sIlB;AC5qII;EaqhDI;IAWY,eX/jDF;EH+sIhB;AACF;Ac/oFY;EACI,mBTplDN;ESqlDM,kBAAA;EACA,eAAA;Ebl+Cb,iBam+C2C;EAC9B,eXrkDE;EWskDF,cT5kDF;AL6tId;ACzrII;EakiDQ;IAUY,eX5kDN;EH6tIhB;AACF;Ac/oFY;EACI,WAAA;EACA,YAAA;EAGA,kBAAA;EACA,cTtmDN;ESumDM,yBAAA;Ad+oFhB;Ac5oFQ;EACI,yBThnDK;ESinDL,oCAAA;EACA,WAAA;Ad8oFZ;AczoFY;EAGI,sBAAA;Ad2oFhB;AcvoFY;EACI,yBAAA;AdyoFhB;AcroFI;EACI,gBAAA;AduoFR;ActoFQ;EACI,kBPtnDA;EOunDA,gCAAA;Eb/gDT,gBaghDiC;Eb/gDjC,iBa+gD2C;AdyoF9C;AcxoFY;EACI,kBP3nDJ;EO4nDI,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;Ad0oFhB;AczoFgB;EACI,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,yBAAA;Ad0oFpB;AcvoFY;EACI,kBAAA;EACA,eX3nDE;AHowIlB;AcxoFgB;EACI,gBXhpDR;EWipDQ,cTnoDI;AL6wIxB;AChvII;EaomDY;IAKQ,eXloDN;EH6wIhB;AACF;AcxoFY;EACI,eX3oDE;EW4oDF,cTjpDP;ESkpDO,gBXzpDL;AHmyIX;AcvoFgB;EACI,cT1pDH;ES2pDG,eXnpDF;AH4xIlB;AC9vII;EamnDY;IAIY,eXvpDV;EHkyIhB;AACF;AczoFgB;EACI,gBXrqDV;EWsqDU,cThqDN;EJsGX,iBa2jDyC;Ad2oF5C;ActoFQ;EbhkDL,gBaikDiC;AdwoFpC;AcvoFY;EblkDT,gBaokDqC;AdwoFxC;AcvoFgB;EbrkDb,SaskDyC;AdyoF5C;AcvoFgB;EAGI,cAAA;EACA,iBAAA;AdwoFpB;ActoFwB;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AdwoF5B;AcroFoB;EACI,cT1rDf;EJoGN,iBaulD6C;AduoFhD;AChyII;EaupDgB;IAIQ,eX1rDV;EHm0IhB;AACF;AcpoFQ;EACI,mBTrsDO;EJsGhB,YaimDuC;EblmDvC,gBammDiC;AdqoFpC;AC1yII;EasqDQ;IAEQ,eXvsDF;EH60IhB;AACF;AcroFgB;EACI,iBAAA;EACA,cAAA;AduoFpB;AcnoFgB;EACI,gBX7tDZ;EW8tDY,eXxsDF;EWysDE,cTptDP;ALy1Ib;ACxzII;EagrDY;IAMQ,eX9sDN;EHo1IhB;AACF;AcroFoB;EACI,yBTztDR;ES0tDQ,eXxtDN;EWytDM,gBXpuDb;EWquDa,gBAAA;AduoFxB;ACn0II;EawrDgB;IAMQ,eX9tDV;EHu2IhB;AACF;AcnoFY;EAGI,mBT7uDD;ES8uDC,kBP/uDJ;EOgvDI,kBAAA;EACA,gBXtvDJ;EWuvDI,eXxuDE;EWyuDF,cT9vDN;ES+vDM,kBP7vDN;EO8vDM,aAAA;EACA,WAAA;AdmoFhB;ACn1II;EaqsDQ;IAaQ,eXhvDF;EHq3IhB;AACF;AcpoFgB;EACI,cAAA;AdsoFpB;AcroFoB;EACI,cAAA;AduoFxB;AcjoFI;EAII,oBAAA;AdmoFR;AcloFQ;EACI,oCAAA;EACA,cTrxDF;ESsxDE,kBAAA;AdooFZ;AcloFQ;EACI,mBThxDI;ESixDJ,oCAAA;EAIA,oBAAA;AdooFZ;AcnoFY;EACI,cThyDN;ALq6IV;;Ac9nFA;EbprDG,gBaqrDyB;AdioF5B;Ac/nFQ;EbtrDL,aaurDuC;EAC9B,mBT5yDF;ES6yDE,kDAAA;EACA,kBP5yDF;AP66IV;AchoFY;Eb5rDT,gBa6rDqC;AdkoFxC;AcjoFgB;EACI,YAAA;EACA,YAAA;EACA,kBPlzDV;EOmzDU,YPjyDZ;EOoyDY,0BAAA;EACA,+BAAA;EACA,8BAAA;AdmoFpB;AchoFY;Eb1sDT,ea2sDqC;EAGxB,0BAAA;EACA,+BAAA;EACA,8BAAA;AdkoFhB;AchoFY;EACI,eXnzDE;EWozDF,cT1zDF;ES6zDE,0BAAA;EACA,+BAAA;EACA,8BAAA;AdkoFhB;Ac/nFY;EACI,yBTv0DA;ES00DA,0BAAA;EACA,+BAAA;EACA,8BAAA;AdioFhB;Ac/nFoB;EACI,iBAAA;AdioFxB;Ac9nFgB;EACI,cT51DV;AL49IV;Ac9nFgB;EACI,cT/1DV;AL+9IV;Ac1nFQ;EACI,cAAA;Ad4nFZ;Ac1nFQ;EACI,cAAA;Ad4nFZ;Ac1nFQ;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EAEA,gCAAA;EAIA,oBAAA;Ad4nFZ;AC/7II;Ea0zDI;IAWQ,SAAA;Ed8nFd;AACF;Ac5nFgB;EACI,8BAAA;EACA,cT33DV;ES83DU,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad8nFpB;Ac3nFY;EACI,YAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EAMA,oBAAA;Ad2nFhB;ACx9II;Eak1DQ;IAaQ,YAAA;IACA,WAAA;IACA,eXj4DF;EH8/IhB;AACF;Ac1nFQ;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EAEA,+BAAA;EAIA,oBAAA;Ad4nFZ;AC1+II;Eaq2DI;IAWY,UAAA;Ed8nFlB;AACF;Ac5nFgB;EACI,8BAAA;EACA,cTt6DV;ESy6DU,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad8nFpB;Ac3nFY;EACI,YAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EAMA,oBAAA;Ad2nFhB;ACngJI;Ea63DQ;IAaY,YAAA;IACA,WAAA;IACA,eX56DN;EHyiJhB;AACF;;AcnnFA;EACI,mBT77DW;ALmjJf;AC9gJI;Eau5DJ;IAGQ,oBAAA;EdwnFN;AACF;ActnFQ;EACI,kBPr8DA;EOs8DA,WAAA;EACA,SAAA;AdwnFZ;ACxhJI;Ea65DI;IAKQ,aAAA;Ed0nFd;AACF;ActnFQ;EACI,kBP/8DA;EOg9DA,WAAA;EACA,SAAA;AdwnFZ;ACliJI;Eau6DI;IAKQ,aAAA;Ed0nFd;AACF;AcvnFI;EACI,kBPv9DI;EOw9DJ,WAAA;EACA,aP79DA;EO89DA,MAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;Ebt3DL,aau3DmC;EAG9B,0BAAA;EACA,+BAAA;EACA,8BAAA;AdynFR;ACxjJI;Eag7DA;Ib92DD,gBa+3DqC;Ib93DrC,aa83D+C;Ed4nFhD;AACF;Ac3nFQ;EACI,UAAA;Ad6nFZ;Ac5nFY;EACI,mBT9+DA;AL4mJhB;Ac3nFQ;Ebt4DL,aau4DuC;EAC9B,mBTh/DG;ESi/DH,mBAAA;EACA,aPv/DJ;EOw/DI,mBP7/DF;ENiHP,kBa64DiC;EAGxB,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad6nFZ;ACjlJI;Eay8DI;Ibt4DL,aam5D+C;Ed+nFhD;AACF;Ac5nFY;EACI,gBXxgEJ;EF+GT,ea05DqC;Ad8nFxC;;AcrnFI;EACI,kBP7gEI;EO8gEJ,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AdwnFR;AcvnFQ;EACI,mBTliEK;ESmiEL,kBAAA;Eb16DT,iBa26DuC;EAC9B,cThiEF;ESiiEE,gBX1hEF;EW2hEE,eX9gEM;AHuoJlB;AC1mJI;Ea2+DI;IAQY,eXjhEF;EH4oJhB;AACF;AcxnFI;Ebr7DD,eas7D6B;Ad0nFhC;AcznFQ;EACI,gBXtiEJ;EWuiEI,cTxhEY;ALmpJxB;AcznFQ;EACI,eX1hEM;EW2hEN,cT7iEH;EJgHN,ea87DiC;Ad2nFpC;AC3nJI;Ea6/DI;IAKQ,eX/hEE;EH4pJhB;AACF;Ac5nFY;EACI,cTnjEP;ESojEO,gBX/iEL;AH6qJX;;AcrnFI;EACI,kBPvjEI;EOwjEJ,OAAA;EACA,SAAA;AdwnFR;AC1oJI;Ea+gEA;IAKQ,aAAA;Ed0nFV;AACF;AcxnFI;EAGI,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad0nFR;AcxnFY;Eb59DT,gBa69DqC;Eb59DrC,aa49D+C;EAClC,mBAAA;EAIA,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad0nFhB;AChqJI;Ea8hEQ;Ib39DT,aaq+DmD;Ed4nFpD;AACF;Ac3nFgB;EAGI,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad6nFpB;Ac1nFY;EACI,mBTxlED;ALotJf;AcznFY;EACI,mBT/lEA;AL0tJhB;AcznFY;EACI,mBThnEC;AL2uJjB;AcznFY;EACI,kBP5mEN;APuuJV;Ac1nFgB;EACI,eXrlEF;EWslEE,gBX5mEZ;EF8GL,kBa+/DyC;EAGxB,0BAAA;EACA,+BAAA;EACA,8BAAA;Ad4nFpB;AClsJI;Ea8jEY;IAUY,eX/lEV;IFyFf,kBaugEiD;Ed8nFlD;AACF;Ac5nFgB;EAGI,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,gBAAA;EACA,YPhnEZ;AP8uJR;Ac1nFQ;EACI,gBAAA;Ad4nFZ;Ac3nFY;EACI,mBT3oEN;ALwwJV;Ac3nFY;EACI,mBT9oEN;AL2wJV;Ac3nFY;EACI,mBTjpEN;AL8wJV;Ac1nFgB;EACI,cTrpEV;ALixJV;Ac1nFgB;EACI,cTxpEV;ALoxJV;AcznFY;EACI,kBPjpEJ;EOkpEI,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,sBAAA;Ad2nFhB;Ac1nFgB;EACI,iBAAA;Ad4nFpB;;AclnFA;EACI,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;AdqnFJ;ACpvJI;Ea2nEJ;IAMQ,mBTtqEO;EL6xJb;AACF;ActnFC;EACO,kBAAA;AdwnFR;AcvnFE;EbnkEC,iBaokEiC;AdynFpC;AcxnFY;EACI,UAAA;EACA,WAAA;EACA,SAAA;EACA,mBTlrEA;ESmrEA,kBAAA;EACA,cAAA;EAGA,yBAAA;Ad0nFhB;AcvnFgB;EACI,mBT1sEH;ES2sEG,WAAA;EACA,WAAA;EACA,mBAAA;AdynFpB;;AchnFA;EACI,mBT9sEW;ES+sEX,kBPxsEQ;EOysER,mBAAA;EbjmED,gBakmEyB;EbjmEzB,aaimEmC;AdonFtC;ACxxJI;EagqEJ;Ib9lEG,gBaomEiC;IbnmEjC,4BammE2C;EdunF5C;AACF;AcrnFQ;EACI,gBXvtEA;EWwtEA,eXvrEM;EWwrEN,cT7tEF;EJmHP,gBa2mEiC;AdunFpC;ACpyJI;EayqEI;IAMY,eXlsEF;EH2zJhB;AACF;AcvnFQ;EACI,eX5sEM;EW6sEN,cTruEF;EJmHP,gBamnEiC;AdynFpC;AC9yJI;EakrEI;IAKY,eXntEF;IF8Ff,gBasnEyC;Ed2nF1C;AACF;ACpzJI;Ea2rEI;IAGQ,cAAA;Ed0nFd;AACF;AcznFY;EACI,iBAAA;Ad2nFhB;AC5zJI;EagsEQ;IAGQ,oBAAA;Ed6nFlB;AACF;AcznFI;EACI,kBPhvEI;EOivEJ,QAAA;EACA,UAAA;Ad2nFR;ACt0JI;EawsEA;IAKQ,aAAA;Ed6nFV;AACF;Ac3nFI;EACI,kBPxvEI;EOyvEJ,UAAA;EACA,QAAA;Ad6nFR;ACh1JI;EagtEA;IAKQ,aAAA;Ed+nFV;AACF;;Ac5nFA;EACI,8BAAA;Ad+nFJ;;Ac7nFA;EACI,0BAAA;AdgoFJ;;Ac9nFA;EACI,8BAAA;AdioFJ;;Ac/nFA;EACI,0BAAA;AdkoFJ;;AchoFA;EACI,mBT3wEW;AL84Jf;;AcjoFA;EACI,0BAAA;AdooFJ;;AchoFC;EACO,WAAA;AdmoFR;AcjoFY;EACI,aAAA;EACA,WAAA;AdmoFhB;AchoFE;EACC,yBT5yEc;ES6yEd,kBAAA;AdkoFH;AcjoFG;EACC,yBT/yEa;ESgzEb,kBAAA;AdmoFJ;AchoFE;EACC,eAAA;EACA,gBAAA;EACS,aAAA;EACA,WAAA;AdkoFZ;AchoFE;EACC,eAAA;EACA,gBAAA;EACS,aAAA;AdkoFZ;;Ac1nFY;EACI,aAAA;EACA,WAAA;Ad6nFhB;Ac3nFY;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;Ad6nFhB;AcvnFY;EACI,aAAA;EACA,WAAA;AdynFhB;AcvnFY;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AdynFhB;;AclnFA,4BAAA;AACA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AdqnFJ;AcnnFI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AdqnFR;AclnFI;EACI,UAAA;AdonFR;AcjnFI;EACI,0EAAA;EACA,YAAA;EACA,wCAAA;EACA,yCAAA;AdmnFR;AcjnFQ;EACI,2BAAA;EACA,6CAAA;AdmnFZ;Ac/mFI;EACI,0EAAA;EACA,YAAA;EACA,yCAAA;EACA,yCAAA;AdinFR;Ac/mFQ;EACI,2BAAA;EACA,8CAAA;AdinFZ;;AergKA;;wBAAA;AdsDI;EclDJ;IAEQ,eAAA;EfugKN;AACF;;AergKA;EACI,kBAAA;EACA,iBAAA;EACA,kBRIQ;ENsFV,yBczFsB;Af0gKxB;ACj+JI;Ec7CJ;IAMQ,kBAAA;Ef4gKN;AACF;Ae3gKI;EdwGD,acvGmC;Af6gKtC;ACz+JI;EcrCA;IdwGD,acrGuC;Ef+gKxC;AACF;AC9+JI;EcrCA;IdwGD,aclGuC;EfihKxC;AACF;ACn/JI;Ec7CJ;IAkBQ,SAAA;IACA,iBAAA;EfkhKN;AACF;;AehhKA;EACI,mBRzBM;EQ0BN,2BR1BM;ENiHP,kBctFyB;AfmhK5B;AC//JI;EcvBJ;IAMQ,cR7BC;EPijKP;AACF;ACpgKI;EcvBJ;IdyFG,kBchF6B;EfshK9B;AACF;AerhKI;EACI,eZXU;EYYV,cVzCW;EU0CX,gBZlCI;EYmCJ,SAAA;AfuhKR;AC/gKI;EcZA;IAMO,eZnBO;EH4iKhB;AACF;AevhKI;EACI,eZtBU;EYuBV,cVlDW;EUmDX,gBZ3CI;EY4CJ,SAAA;AfyhKR;;AethKA;EACI,mBVtDM;EUwDN,8CAAA;Ed2DD,kBc1DyB;EACxB,qBRtDa;EQuDb,WRhEW;EQiEX,SAAA;EduOF,kBctOmB;AfyhKrB;AexhKI;EACI,qBAAA;EACA,yBVhEE;EUiEF,eAAA;Af0hKR;AezhKQ;EACI,4BAAA;EACA,6BAAA;Af2hKZ;AC9iKI;EcaA;IdsDD,ac7CuC;Ef4hKxC;AACF;Ae1hKI;EACI,kBRhEI;EQiEJ,eAAA;Af4hKR;ACvjKI;EcyBA;Id0CD,actCuC;Ef8hKxC;AACF;Ae5hKI;EACI,kBRvEI;EQwEJ,eAAA;Af8hKR;AChkKI;EcgCA;IdmCD,ac/BuC;EfgiKxC;AACF;;Ae7hKA;EACI,yBAAA;AfgiKJ;;Ae9hKA;EACI,cVxFoB;ALynKxB;;Ae/hKA;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;AfkiKJ;;AehiKA;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;AfmiKJ;;AejiKA;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;AfoiKJ;;AeliKA;EACI,yBAAA;AfqiKJ;;AeniKA;EACI,yBAAA;AfsiKJ;;AepiKA;EACI,cVjHW;ALwpKf;;AeriKA;EACI,cVtHc;AL8pKlB;;AetiKA;EACI,yBAAA;AfyiKJ;;AeviKA;EACI,mBVzFa;ALmoKjB;;AexiKA;EACI,mBV3FmB;ALsoKvB;;AeziKA;EACI,mBV7FiB;ALyoKrB;;Ae1iKA;EACI,mBV/FkB;AL4oKtB;;Ae3iKA;EACI,mBV1Ga;ALwpKjB;;Ae5iKA;EACI,8BAAA;Af+iKJ;;Ae7iKA;EACI,qBR5Ia;EQ6Ib,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AfgjKJ;;Ae9iKA;EACI,eZzIc;EFmGf,iBcuC+B;AfijKlC;;Ae/iKA;Ed1CG,6Bc2CyB;AfkjK5B;AC/pKI;Ec4GJ;Id1CG,oBc6C6B;EfojK9B;AACF;;AeljKA;EdhDG,kBciDyB;AfqjK5B;AepjKI;EACI,cVtJK;EUuJL,eZpJU;AH0sKlB;AepjKI;EdtDD,kBcuD6B;EACxB,gBZrKI;EYsKJ,cVzKC;AL+tKT;ACjrKI;EcwHA;IAKQ,eZ3JM;EHmtKhB;AACF;AetjKI;EACI,gBZ1KG;EY2KH,eZlKU;EYmKV,cVhLO;ALwuKf;AetjKI;EACI,mBVtLQ;EUuLR,yBAAA;EACA,gBRhLA;EN0RN,kBczGuB;EdvEtB,ScwE6B;EdvE7B,acuEgC;EAC3B,eZzKU;EY0KV,gBZrLG;EYsLH,cV1LO;ALmvKf;ACtsKI;EcqIA;IdnED,gBc6EiC;Id5EjC,ac4E2C;Ef4jK5C;AACF;Ae3jKQ;EACI,cV/LG;EUgMH,eZjLM;EYkLN,gBZ9LF;AH2vKV;Ae3jKQ;EACI,mBAAA;Af6jKZ;Ae3jKQ;EACI,gBZrMA;EYsMA,eZvLM;EYwLN,cV/MO;EJqHhB,kBc2FiC;Af6jKpC;AezjKQ;Ed9FL,kBc+FuC;Af2jK1C;AexjKI;EACI,YRnMA;AP6vKR;AexjKI;EACI,WAAA;Af0jKR;AexjKI;EACI,mBV7NE;ALuxKV;AexjKI;EACI,mBVhOE;AL0xKV;AexjKI;EACI,oBAAA;Af0jKR;AexjKI;EACI,eAAA;EACA,kBR7NI;EQ8NJ,QAAA;EACA,QAAA;EAEA,+BAAA;Af0jKR;AexjKI;EACI,cV1OO;ALoyKf;AexjKI;EACI,iBAAA;EACA,cV9OO;ALwyKf;;AevjKA;EACC,kBAAA;EACG,kBAAA;Af0jKJ;AezjKI;EACF,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBV/PQ;EUgQR,kBAAA;EAKA,gCAAA;Af2jKF;Ae1jKQ;EACL,gBAAA;EACA,kCAAA;EACA,gBZpQK;EYqQL,kBAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,cVvQiB;EUwQjB,eZ9Pe;AH0zKlB;AezjKI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;Af2jKR;AexjKI;EACC,yBVzRK;ALm1KV;AezjKoB;EACd,cAAA;Af2jKN;AerjKI;EACI,cV3RY;EU4RZ,gBZ3RG;AHk1KX;;AepjKA;EACI,kBAAA;AfujKJ;;AerjKA;EACI,uBR/QW;EQgRX,SAAA;EACA,cVtRa;EUuRb,eAAA;EACA,mBRzRM;EQ0RN,SAAA;EACA,WR5RI;EQ6RJ,YR7RI;EQ8RJ,WAAA;AfwjKJ;AevjKI;EACI,mBVhRO;EJ+Pb,mBckBuB;EACjB,eZ7RU;EY8RV,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AfyjKR;AexjKQ;EACI,mBVrUK;EUsUL,cVjUF;EUkUE,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;Af0jKZ;;AetjKA;EACI,gBAAA;EdxCF,mBcyCmB;AfyjKrB;;AevjKA;EACI,kBAAA;EACA,WAAA;Af0jKJ;AezjKI;EACI,cAAA;EACA,gBAAA;EACA,cRjVC;EQkVD,kCAAA;EACA,gBZjVA;EYkVA,eZnUU;EYoUV,YRpUA;EQqUA,kBR/UI;EQgVJ,WAAA;EACA,SAAA;Af2jKR;;AevjKI;EACI,sBAAA;EACA,gBAAA;EACA,cV9VO;EU+VP,gBZ3VG;EY4VH,eZ5UU;EY6UV,QAAA;Af0jKR;;AevjKA;EACC,UAAA;EACA,mBAAA;EACA,wBAAA;Af0jKD;;AexjKA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kDAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EAEA,4BAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;Af2jKJ;Ae1jKC;EACC,kBAAA;EACA,gBAAA;EACM,0BAAA;EACN,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cV5YQ;EU6YR,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;Af4jKF;;AetjKI;EACG,eAAA;AfyjKP;ACp6KI;Ec4WI;IAEQ,mBAAA;Ef0jKd;AACF;AezjKY;EACI,YAAA;EAEA,mBAAA;EACA,eAAA;EACA,cVnaP;AL69KT;AezjKgB;EACI,UAAA;EACA,gBRhaZ;AP29KR;ACn7KI;Ec8XY;IAEQ,eAAA;EfujKtB;AACF;ACx7KI;EckYgB;IAEQ,mBAAA;EfwjK1B;AACF;AeljKI;EACI,aRtbA;EQubA,uBR5bE;EQ6bF,mBR7bE;APi/KV;AejjKgB;EACI,yBAAA;EACA,mBVpcV;EUqcU,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cVrcX;EUscW,WAAA;EACA,YAAA;EACA,aRpcZ;EQqcY,uBR1cV;EQ2cU,mBR3cV;AP8/KV;AeljKoB;EACI,UAAA;EACA,gBRvchB;AP2/KR;AeljKoB;EACI,yBV1cR;EU2cQ,cVpdd;EUqdc,yBAAA;AfojKxB;AejjKgB;EACI,yBVhdJ;EUidI,cV1dV;EU2dU,yBAAA;AfmjKpB;AehjKY;EACI,aRxdR;EQydQ,mBR9dN;EQ+dM,uBR/dN;EQgeM,kBAAA;AfkjKhB;;Ae1iKA;EACI,kBRheQ;ENyGT,ecwX+B;Af6iKlC;ACx+KI;EcybJ;IdtXG,ec0XuC;Ef+iKxC;AACF;Ae7iKQ;Ed9XL,gBc+XiC;Af+iKpC;ACh/KI;EcgcI;Id9XL,gBciYqC;EfijKtC;AACF;Ae/iKQ;EdpYL,gBcqYiC;AfijKpC;AehjKY;EdtYT,gBcuYqC;AfkjKxC;AehjKgB;EACI,kBAAA;EACA,cVzfI;AL2iLxB;;Ae1iKA;EdlZG,acmZ+B;EACjC,mBAAA;EACG,cVnfa;EUofb,gBZtgBQ;AHmjLZ;ACtgLI;EcqdJ;IdlZG,acyZmC;Ef8iKpC;AACF;Ae7iKC;EACC,aAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;Af+iKF;;Ae5iKA;EdraG,iBcsasB;EACxB,gBAAA;EACA,kBRzhBS;EQ0hBT,WAAA;Af+iKD;Ae9iKI;Ed1aD,gBc2a6B;AfgjKhC;Ae9iKC;EACO,eZpgBU;EYqgBV,mBAAA;AfgjKR;Ae9iKI;EdjbD,sBckb6B;EACxB,cVvhBC;EUwhBD,gBZhiBE;EYiiBF,gBAAA;AfgjKR;Ae9iKC;EdvQC,kBcwQiB;EACjB,gBZtiBU;EYuiBJ,eZxhBU;EF+Ff,kBc0bmC;AfgjKtC;AC7iLI;EcyfH;IdtbE,iBc4b2C;IAC9B,eZ9hBE;EHglLhB;AACF;AehjKI;EdjcD,gBckc6B;AfkjKhC;AehjKI;EdncD,mBcocmC;EAC9B,cVniBS;ALqlLjB;AC1jLI;EcsgBA;IAIQ,eZliBM;EHslLhB;AACF;AejjKO;Ed3cJ,kBc4cuC;EAC9B,eZ5iBM;AH+lLlB;ACnkLI;Ec8gBG;Id3cJ,ac+c+C;IAC9B,eZjjBF;EHsmLhB;AACF;;Ae9iKA;EdzdG,gBc0dyB;AfijK5B;AC7kLI;Ec2hBJ;IAGE,oBAAA;EfmjKA;AACF;AeljKC;EACC,gBAAA;AfojKF;AeljKE;EACC,kBAAA;EACA,eZnkBe;EYokBN,mBVvlBF;EUwlBE,mBAAA;EACA,gBAAA;EACA,uBAAA;AfojKZ;AenjKG;EACC,cVzlBK;EU0lBL,gBZtlBM;AH2oLV;ACjmLI;EcmiBF;IAYE,gBAAA;IACA,eZ9kBc;EHooLhB;AACF;AepjKE;EACC,gBAAA;EACA,YAAA;EACA,cVvmBO;EUwmBP,kBAAA;EACS,mBV7lBG;EU8lBH,gBZpmBA;EYqmBA,eZtlBM;AH4oLlB;AChnLI;EcmjBF;IAWE,gBAAA;IACA,eZ7lBc;EHmpLhB;AACF;AerjKG;EACC,cVnnBM;EUonBM,mBVlnBE;EUmnBF,yBAAA;AfujKhB;;AeljKA;EACC,UAAA;EACA,mBAAA;EACA,wBAAA;AfqjKD;;AenjKA;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kDAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EAEA,4BAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;AfsjKD;AepjKE;EACC,eV9pBc;EU+pBd,eAAA;EACA,sBAAA;EAEA,4BAAA;AfsjKH;AeljKE;EACC,UAAA;AfojKH;AejjKC;EACC,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cVjrBe;EUkrBf,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;AfmjKF;;AehjKA;EACI,WAAA;AfmjKJ;;AgBjvLA;;wBAAA;AAIA;EACC,kBTWW;ENwGT,kBelHsB;AhBmvLzB;AgBlvLC;EACC,mBAAA;EfiHC,mBehH6B;AhBovLhC;AgBlvLC;EACC,kBTGU;ESFV,mBXbe;EWcf,mBAAA;EACA,YAAA;EACA,YAAA;AhBovLF;AC9sLI;Ee3CH;IAOE,YAAA;EhBsvLD;AACF;AgBrvLE;EACC,gBbTO;EaUP,ebYe;EaXf,cXlBO;EWmBP,qBAAA;EACA,oBAAA;EACA,yBAAA;AhBuvLH;AC3tLI;EelCF;IAQG,ebCa;IaAb,mBAAA;EhByvLH;AACF;ACjuLI;EelCF;IAYG,ebNa;IaOb,mBAAA;EhB2vLH;AACF;;AgBvvLA;EACC,yBAAA;EACA,kBTxBW;ESyBX,UAAA;AhB0vLD;;AgBxvLA;Ef6EG,kBe5EsB;AhB2vLzB;ACjvLI;EeXJ;If6EG,Se1EwB;EhB6vLzB;AACF;AgB5vLC;EACC,ebpBgB;EaqBhB,cXpCc;EWqCd,gBbvCQ;EawCR,yBAAA;EfoEC,gBenEuB;AhB8vL1B;AgB5vLC;EACC,ebnBgB;EaoBhB,gBb7CQ;EF4GP,gBe9DuB;AhB8vL1B;AClwLI;EeCH;IAKE,eb1Be;EH0xLhB;AACF;ACvwLI;EeCH;IAQE,eb/Be;EHiyLhB;AACF;AgBhwLC;EfsDE,gBerDuB;AhBkwL1B;AgB/vLE;EACC,kBTvDS;ENwGT,gBehDwB;EfiDxB,mBejDkC;EAClC,cX7DiB;AL+zLpB;AgBjwLG;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,0BAAA;EACA,cXlEY;ALq0LhB;AgBjwLG;EfsCA,SerCyB;AhBmwL5B;;AiBt1LA;;wBAAA;AAIA;EACI,kBVWQ;EUVR,UAAA;EhBmHD,sBgBlH8B;AjBw1LjC;ACzyLI;EgBlDJ;IhBqHG,sBgBhHkC;EjB01LnC;AACF;;AiBx1LA;EhB6GG,egB5G8B;EAC7B,mBZTM;EYUN,kDAAA;AjB21LJ;ACpzLI;EgB1CJ;IhB6GG,sBgBxGkC;EjB61LnC;AACF;ACzzLI;EgBnCA;IAIQ,cAAA;EjB41LV;AACF;AiB31LQ;EACI,mBAAA;AjB61LZ;AiB31LY;EACI,cZnBQ;ALg3LxB;ACp0LI;EgBtBI;IAEQ,mBAAA;EjB41Ld;AACF;ACz0LI;EgBjBI;IAGO,kBAAA;IACA,sBAAA;EjB21Lb;AACF;AC/0LI;EgBXQ;IAEQ,aAAA;IACA,qBAAA;EjB41LlB;AACF;AiBr1LQ;EACI,qBV9CK;EN+Gd,kBgBhEiC;EhBiEjC,kBgBjE4C;EACnC,mBZ3CI;EY4CJ,cZrDF;AL64LV;AiBt1LQ;EACI,cZ3CE;EY4CF,ed9CQ;Ec+CR,gBdnDF;EcoDE,gBAAA;AjBw1LZ;AiBt1LQ;EACI,gBdvDF;EcwDE,mBAAA;AjBw1LZ;AiBp1LQ;EACI,yBZzEK;EY0EL,yBAAA;EACA,+BAAA;EACA,cZvEF;EJoHP,kBgB5CuC;AjBs1L1C;AC72LI;EgBkBI;IAQY,YAAA;EjBu1LlB;AACF;ACl3LI;EgBkBI;IhBiDL,iBgBtC+C;EjBy1LhD;AACF;ACv3LI;EgBkBI;IhBiDL,kBgBnC+C;EjB21LhD;AACF;AiB11LY;EACI,yBZpFN;EYqFM,yBAAA;EACA,oCAAA;EACA,cAAA;AjB41LhB;AiBv1LI;EAEI,WAAA;EACA,cAAA;AjBy1LR;ACv4LI;EgB2CA;IAMY,YAAA;IACA,eAAA;EjB21Ld;AACF;AC94LI;EgB2CA;IAWY,WAAA;IACA,cAAA;EjB61Ld;AACF;AiB51LQ;EACI,gBAAA;AjB81LZ;AiB51LQ;EACI,gBAAA;AjB81LZ;AC35LI;EgB4DI;IhBML,SgBHqC;EjBg2LtC;AACF;AiB71LI;EAEI,WAAA;EACA,cAAA;AjB+1LR;ACr6LI;EgBmEA;IAMY,WAAA;IACA,cAAA;IACA,mBAAA;EjBi2Ld;AACF;AC76LI;EgBmEA;IAYY,YAAA;IACA,eAAA;IACA,gBAAA;EjBm2Ld;AACF;AiBl2LQ;EACI,gBAAA;AjBo2LZ;ACx7LI;EgBuFA;IhBrBD,SgBwBiC;IACxB,cAAA;EjBk2LV;AACF;AiBv2LI;EAMI,SAAA;AjBo2LR;AiBn2LQ;EACI,mBZlIO;EYmIP,cZpIE;EYqIF,mBAAA;EhB9BT,kBgBiCsC;AjBm2LzC;ACv8LI;EgB8FI;IhB5BL,gBgBoCqC;EjBq2LtC;AACF;AiBp2LY;EACI,mBZjJA;EYkJA,cZ3JN;ALigMV;AiBr2LgB;EACI,oBAAA;AjBu2LpB;AiBp2LY;EACI,iBAAA;AjBs2LhB;AiBp2LY;EACI,iBAAA;AjBs2LhB;;AiB/1LA;EACI,aVrKI;APugMR;;AiBh2LA;EACI,qBAAA;EACA,cAAA;EACA,gBVjJM;APo/LV;AiBl2LI;EACI,qBAAA;EACA,cAAA;EACA,gBVrJE;APy/LV;AiBl2LI;EACI,qBAAA;EACA,cAAA;EACA,gBV1JE;AP8/LV;AiBl2LI;EACI,WAAA;EACA,mBAAA;AjBo2LR;;AiBj2LA;EACI,kBVvLQ;EUwLR,mBAAA;EACA,YAAA;AjBo2LJ;AiBn2LI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBZzME;EY0MF,kBAAA;EACA,YVlMA;EUmMA,aAAA;AjBq2LR;AChgMI;EgBoJA;IASQ,WAAA;IACA,YAAA;EjBu2LV;AACF;AiBt2LQ;EhBtGN,kBMjGU;ENkGV,QgBsGwC;EhBnGxC,UgBmGsD;EAC5C,2BAAA;AjB02LZ;AiBz2LY;EACI,8BAAA;EACA,cZtNN;EYyNM,0BAAA;EACA,+BAAA;EACA,8BAAA;AjB22LhB;AiBz2LY;EACI,gBAAA;EACA,qBV3NC;EU4ND,kCAAA;EACA,ed7ME;Ec8MF,gBAAA;AjB22LhB;AC5hMI;EgB4KQ;IAOQ,edlNF;EH+jMhB;AACF;AiB12LQ;EhB7HN,kBMjGU;ENkGV,QgB6HwC;EhB5HxC,WgB4H4C;EAClC,2BAAA;AjB82LZ;AiB72LY;EACI,8BAAA;EACA,cZ7ON;EYgPM,0BAAA;EACA,+BAAA;EACA,8BAAA;AjB+2LhB;AiB72LY;EACI,gBAAA;EACA,qBVlPC;EUmPD,kCAAA;EACA,edpOE;EcqOF,gBAAA;AjB+2LhB;ACvjMI;EgBmMQ;IAOQ,edzOF;EH0lMhB;AACF;;AiBz2LA;EACI,mBZrQM;EYsQN,kDAAA;EACA,kBAAA;EACA,gBVxOM;ENoFP,kBgBqJ+B;AjB42LlC;;AiBz2LI;EACI,cZ1QC;EY2QD,gBdvQE;AHmnMV;;AiBx2LA;EACI,gBAAA;EACA,oBAAA;EACA,kDAAA;EACA,mBAAA;EACA,SAAA;AjB22LJ;AiB12LI;EACI,UAAA;AjB42LR;AiB12LI;EACI,WAAA;EACA,YAAA;EACA,mBZ9RE;EY+RF,yBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,cAAA;AjB22LR;AiB12LQ;EACI,kBAAA;AjB42LZ;AiBv2LQ;EACA,cZ9RM;EY+RN,gBAAA;EACA,gBdrSG;EcsSH,ed3RU;AHooMlB;AiBv2LQ;EACI,cZ7SG;EY8SH,gBd3SF;Ec4SE,qBV/SK;EUgTL,kBAAA;AjBy2LZ;AiBt2LI;EACI,oBAAA;AjBw2LR;AiBr2LQ;EACI,SAAA;AjBu2LZ;;AiBn2LA;EhB5MG,sBgB6M+B;AjBs2LlC;AiBp2LQ;EhBhNL,kBgBkNiC;EACxB,cZzTE;AL8pMd;AiBp2LY;EACI,YAAA;EAEA,mBZjUA;EYkUA,kBAAA;EACA,iBAAA;AjBq2LhB;AiBp2LgB;EACI,ed/TF;EcgUE,cZ/UV;ALqrMV;;AiB/1LI;EACI,mBAAA;AjBk2LR;AiBj2LQ;EACI,gBAAA;AjBm2LZ;;AC3oMI;EgB4SJ;IAEQ,sBAAA;IACA,kBAAA;EjBk2LN;AACF;;AiBh2LA;EAEI,cZlWK;EYmWL,gBAAA;AjBk2LJ;ACvpMI;EgBkTJ;IAKQ,sBAAA;IACA,kBAAA;EjBo2LN;AACF;AiBn2LI;EAEI,kBAAA;EACA,0BAAA;AjBo2LR;ACjqMI;EgB0TA;IAKQ,mBAAA;EjBs2LV;EiBr2LU;IACI,gBAAA;EjBu2Ld;AACF;ACzqMI;EgB0TA;IAWQ,kBAAA;EjBw2LV;AACF;AiBv2LQ;EACI,gBAAA;AjBy2LZ;AiBx2LY;EACI,ed1WE;Ec2WF,cZjXC;AL2tMjB;;AiBl2LQ;EACI,aAAA;EACA,mBAAA;AjBq2LZ;AiBl2LoB;EACI,cZnYJ;ALuuMpB;;AiB11LI;EACI,mBAAA;AjB61LR;;AiB11LA;EACI,mBAAA;AjB61LJ;ACrsMI;EgByWA;IAEQ,gBAAA;EjB81LV;AACF;;AiB31LA;EhB5SG,iBgB6S8B;AjB81LjC;;AiB11LQ;EACI,aV/ZJ;EUgaI,qBVhaJ;ENoGN,kBMjGU;ENkGV,UgB4TwC;EhB3TxC,QgB2T8C;AjB+1LhD;ACttMI;EgBoXI;IAKQ,OAAA;IACA,WAAA;EjBi2Ld;AACF;AiBh2LY;EACI,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,iDAAA;EACA,mBZnbN;EYobM,kBAAA;EAGA,yBAAA;AjBi2LhB;ACvuMI;EgB4XQ;IAYQ,WAAA;IACA,YAAA;IACA,eAAA;EjBm2LlB;AACF;AiBl2LgB;EACI,mBZncH;EYocG,cZ/bV;EYkcU,yBAAA;AjBo2LpB;AiBj2LY;EACI,iBAAA;AjBm2LhB;;AiB71LA;EACI,aVtcI;EUucJ,mBV5cM;EU6cN,mBAAA;AjBg2LJ;AiB91LQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AjBg2LZ;ACpwMI;EgBgaI;IAMQ,WAAA;IACA,YAAA;EjBk2Ld;AACF;AiB91LQ;EACI,cZ3dH;EY4dG,edvcM;AHuyMlB;AC9wMI;EgB4aI;IAIQ,ed5cE;Ic6cF,kBAAA;EjBk2Ld;AACF;;AiB91LA;EACI,mBAAA;AjBi2LJ;AiBh2LI;EACI,aVneA;EUqeA,cZ/dM;EJsGX,gBgB0X6B;EhBzX7B,iBgByXsC;EACjC,gCAAA;AjBk2LR;AiBj2LQ;EACI,cZ7eH;EY8eG,ed5dM;AH+zMlB;AiBj2LQ;EACI,YV3eJ;EN0GL,SgBkYiC;EhBjYjC,UgBiYoC;AjBo2LvC;AiBl2LQ;EACI,cZheO;ALo0MnB;;AiBh2LA;EACI,aVtfI;EUufJ,uBV5fM;AP+1MV;AiBl2LI;EACI,WAAA;EACA,mBZrfO;EYsfP,cZlgBE;EYmgBF,gBd9fA;Ec+fA,ed/eU;EF+Ff,kBgBiZmC;AjBo2LtC;ACxzMI;EgB8cA;IAQQ,ednfM;IFgGf,kBgBoZuC;EjBs2LxC;AACF;AiBr2LQ;EACI,yBZ3gBF;EY4gBE,yBAAA;EACA,oCAAA;EACA,cZlgBG;ALy2Mf;;AiBl2LI;EACI,aV7gBA;APk3MR;AiBp2LQ;EACI,iBAAA;AjBs2LZ;AiBr2LY;EACI,eAAA;AjBu2LhB;AiBr2LY;EACI,mBAAA;AjBu2LhB;;AiB71LQ;EACI,cAAA;AjBg2LZ;AiB/1LY;EACI,gBAAA;AjBi2LhB;AiB/1LY;EhBtbT,agBub0C;AjBi2L7C;AC31MI;EgByfQ;IhBtbT,agByb+C;EjBm2LhD;AACF;AiBl2LgB;EhB5bb,gBgB6byC;EhB5bzC,iBgB4bkD;AjBq2LrD;AiBn2LwB;EACI,mBZnjBlB;EYojBkB,yBAAA;EACA,+BAAA;EACA,cZtiBf;AL24Mb;AiBj2LgB;EhBvcb,kBgBwcyC;EhBvczC,UgBucoD;AjBo2LvD;AiB/1LI;EAEI,yBAAA;EACA,cZ3iBW;EY4iBX,kBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AjBg2LR;AiB/1LQ;EACI,cZjjBO;EYkjBP,edljBM;AHm5MlB;AiBh2LY;EACI,iBAAA;EACA,ed1jBE;AH45MlB;AiB71LI;EACI,yBAAA;EACA,mBZ7jBQ;EY8jBR,mBAAA;EhBleL,kBgBme6B;EhBle7B,agBkeyC;AjBg2L5C;ACr4MI;EgBiiBA;IhB9dD,agBoe2C;EjBk2L5C;AACF;AiBj2LQ;EACI,mBAAA;AjBm2LZ;AiBj2LQ;EACI,mBAAA;AjBm2LZ;AiBj2LQ;EACI,cZ1lBQ;AL67MpB;AiBj2LQ;EACI,cZ7lBQ;ALg8MpB;AiBl2LY;EACI,cZtlBH;EYulBG,ed5kBE;AHg7MlB;AiBj2LQ;EACI,mBZ3mBF;AL88MV;AiBl2LY;EACI,cZ1mBP;EY2mBO,ed1lBE;Ec2lBF,mBAAA;AjBo2LhB;AiBl2LY;EAEI,cZ5mBI;EY6mBJ,edjmBE;EckmBF,gBd/mBJ;EcgnBI,kBAAA;AjBm2LhB;AiBl2LgB;EACI,cZxmBP;AL48Mb;AiBh2LwB;EACI,mBZjnBb;ALm9Mf;AiBj2L4B;EACI,cZ/nBtB;ALk+MV;AiB11LQ;EACI,mBZzoBF;ALq+MV;AiB31LY;EACI,mBAAA;AjB61LhB;AiB11LY;EACI,mBAAA;AjB41LhB;AiB11LY;EACI,eAAA;AjB41LhB;AiB11LgB;EACI,WAAA;EACA,YAAA;EACA,mBZvpBV;EYwpBU,kBAAA;AjB41LpB;AiB31LoB;EACI,mBZvpBf;ALo/MT;AiBx1LQ;EACI,mBZhqBF;AL0/MV;AiBx1LgB;EAEI,cZhoBL;EJ+EZ,kBgBkjByC;EhBjjBzC,mBgBijBqD;EACpC,gCAAA;AjB01LpB;AiBz1LoB;EACI,cZpoBT;AL+9Mf;AiBz1LoB;EhBvjBjB,SgBwjB6C;EhBvjB7C,UgBujB+C;EAC1B,mBVnqBhB;AP+/MR;AiBr1LI;EACI,mBZtqBW;EJsGhB,agBikBkC;EAE7B,mBAAA;AjBs1LR;AiBr1LQ;EACI,edhqBM;EciqBN,cZvrBH;AL8gNT;AiBr1LQ;EACI,edpqBM;EcqqBN,cZ3rBH;ALkhNT;AiBp1LI;EhB9kBD,SgB+kB6B;EhB9kB7B,UgB8kB+B;EAC1B,SAAA;AjBu1LR;AiBt1LQ;EhBjlBL,SgBklBiC;EhBjlBjC,kBgBilBmC;EAC1B,mBZ1rBG;EY2rBH,cZvsBF;ALgiNV;AiBv1LY;EACI,gBAAA;AjBy1LhB;;AiBj1LA;EhB9lBG,egB+lB8B;AjBo1LjC;ACt/MI;EgBiqBJ;IhB9lBG,egBimBkC;EjBs1LnC;AACF;AiBr1LI;EACI,uBVttBE;EUutBF,mBAAA;AjBu1LR;AC//MI;EgBsqBA;IAIQ,sBAAA;EjBy1LV;AACF;AiBx1LQ;EACI,kBAAA;AjB01LZ;ACvgNI;EgB4qBI;IhB1mBL,kBgB6mBqC;IhB5mBrC,UgB4mBgD;EjB61LjD;AACF;AiB51LY;EACI,aAAA;EACA,mBZttBG;EYutBH,gBAAA;EACA,yBAAA;AjB81LhB;AiB71LgB;EACI,cZ9tBJ;EY+tBI,kBAAA;EACA,qBVtuBH;APqkNjB;AiB71LgB;EACI,cZnuBJ;EYouBI,edrtBF;AHojNlB;AiB71LgB;EACI,mBZjvBV;EYkvBU,yBAAA;AjB+1LpB;AiB91LoB;EACI,cZjvBf;ALilNT;AiB91LoB;EACI,cZ9uBR;EY+uBQ,gBdlvBZ;AHklNZ;AiB31LY;EACI,SAAA;AjB61LhB;AC1iNI;EgB4sBQ;IAGQ,SAAA;EjB+1LlB;AACF;;AiB11LA;EACI,gBAAA;EACA,mBZxwBM;EYywBN,mBAAA;EhBtpBD,mBgBupByB;EhBtpBzB,agBspBwC;AjB81L3C;AiB51LQ;EACI,WZ9uBH;EY+uBG,gBdxwBA;EcywBA,mBAAA;AjB81LZ;AiB31LI;EACI,yBAAA;EACA,mBZtwBW;EYuwBX,mBAAA;EhBlqBL,kBgBmqB6B;EhBlqB7B,agBkqByC;AjB81L5C;AiB71LQ;EACI,eAAA;AjB+1LZ;ACtkNI;EgBsuBI;IAGQ,mBAAA;EjBi2Ld;AACF;AC3kNI;EgB4uBI;IAEQ,mBAAA;IACA,eAAA;EjBi2Ld;AACF;ACjlNI;EgBkvBI;IAEQ,eAAA;EjBi2Ld;AACF;AiB/1LQ;EACI,cZtyBH;EYuyBG,edlxBM;EcmxBN,mBAAA;AjBi2LZ;AiB/1LQ;EACI,cZvyBQ;EYwyBR,kBAAA;AjBi2LZ;AiB/1LQ;EACI,cZ3yBQ;AL4oNpB;AiB/1LQ;EACI,cZ9yBQ;AL+oNpB;AiBh2LY;EACI,cZvyBH;EYwyBG,ed7xBE;AH+nNlB;AiBj2LgB;EACI,cZtyBI;EYuyBJ,ednyBF;AHsoNlB;AiB51LY;EACI,cZ/zBD;EYg0BC,ed3yBE;EF0Ff,gBgBktBqC;EhBjtBrC,mBgBitB+C;EAClC,gCAAA;AjB+1LhB;AiB51LQ;EAEI,oBAAA;AjB61LZ;AiB51LY;EACI,mBZj0BD;EYk0BC,cZ90BN;EY+0BM,yBAAA;AjB81LhB;AiB71LgB;EACI,mBZj1BV;EYk1BU,cZt0BL;EYu0BK,yBAAA;AjB+1LpB;AiB11LI;EACI,gBAAA;AjB41LR;;AiBz1LA;EACI,kBV31BM;APurNV;AiB31LI;EACI,cZ/0BK;AL4qNb;;AiBz1LA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;AjB41LJ;AiB31LI;EACI,cZp2BO;EYq2BP,edh1BU;Eci1BV,mBAAA;AjB61LR;ACtpNI;EgBszBA;IAKQ,edv1BM;EHsrNhB;AACF;AiB71LI;EAEI,mBAAA;AjB81LR;AC9pNI;EgB8zBA;IAIQ,eAAA;EjBg2LV;AACF;ACnqNI;EgBo0BI;IAEQ,eAAA;IACA,mBAAA;EjBi2Ld;EiBh2Lc;IACI,gBAAA;EjBk2LlB;EiBh2Lc;IACI,gBAAA;EjBk2LlB;AACF;AC/qNI;EgBo0BI;IAWY,gBAAA;EjBo2LlB;EiBn2LkB;IACI,mBAAA;EjBq2LtB;AACF;AiBl2LY;EACI,mBZz3BG;EY03BH,YAAA;EACA,aAAA;EACA,mBAAA;AjBo2LhB;AC7rNI;EgBq1BQ;IAOQ,WVl5BL;EPuvNb;AACF;AiBh2LQ;EAEI,cZt4BH;EYu4BG,gBd94BD;AH+uNX;AiBh2LY;EACI,cZx4BH;AL0uNb;AiB91LoB;EACI,mBZj5BT;ALivNf;AiB/1LwB;EACI,cZ/5BlB;ALgwNV;;AiBl1LgB;EACI,gBAAA;AjBq1LpB;AiBp1LoB;EACI,kBV/6Bd;EUg7Bc,SAAA;AjBs1LxB;AiB/0LQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,mBZt6BO;EYu6BP,YV36BJ;EU46BI,mBAAA;AjBg1LZ;AiB/0LY;EACI,cZl8BN;ALmxNV;AiB90LQ;EACI,cZ96BO;EY+6BP,ed56BM;Ec66BN,gBdn8BJ;Eco8BI,kBAAA;AjBg1LZ;AiB90LQ;EACI,cZ/7BE;EYg8BF,mBAAA;AjBg1LZ;AiB/0LY;EACI,cZn8BD;EYo8BC,gBd18BJ;AH2xNZ;AiB50LY;EACI,yBAAA;EACA,cZ38BD;EY48BC,gBdn9BR;Eco9BQ,kBAAA;EACA,qBVt9BC;EUu9BD,kBAAA;AjB80LhB;;AiBv0LA;EhB92BG,egB+2B8B;AjB00LjC;AC5vNI;EgBi7BJ;IhB92BG,egBi3BkC;EjB40LnC;AACF;ACjwNI;EgBi7BJ;IhB92BG,egBo3BkC;EjB80LnC;AACF;AiB70LI;EACI,gBAAA;EhBx3BL,mBgBy3B6B;EhBx3B7B,UgBw3B6C;AjBg1LhD;AC3wNI;EgBy7BA;IAIQ,cAAA;EjBk1LV;AACF;AiBh1LQ;EACI,cZ/+BH;ALi0NT;ACnxNI;EgBg8BI;IhB93BL,gBgBi4BqC;EjBo1LtC;AACF;AiBn1LY;EACI,gBdl/BR;Ecm/BQ,ed/9BE;AHozNlB;AiBh1LQ;EhB14BL,gBgB44BiC;EhB34BjC,iBgB24B0C;EACjC,gCAAA;AjBk1LZ;AiBj1LY;EACI,cZ9/BD;EY+/BC,ed3+BE;AH8zNlB;AiBj1LY;EACI,cZngCP;EYogCO,gBdjgCJ;AHo1NZ;AiBl1LgB;EACI,cZ9gCH;ALk2NjB;AiBh1LQ;EAEG,mBAAA;AjBi1LX;AiBh1LY;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;AjBk1LhB;AiBh1LY;EACI,cZ9/BG;EY+/BH,ed//BE;AHi1NlB;AiBj1LgB;EACG,cZzgCN;EY0gCM,edrgCD;EcsgCC,cVxhCV;EUyhCU,eAAA;EACA,gBdvhCP;AH02NZ;AiB/0LQ;EACI,mBAAA;AjBi1LZ;AiBh1LY;EACI,cVjiCP;EUkiCO,mBAAA;AjBk1LhB;AiBh1LY;EACI,cZ3hCF;AL62Nd;ACz0NI;EgB0/BI;IAEQ,mBAAA;EjBi1Ld;AACF;AiBh1LY;EACI,cZniCF;EYoiCE,mBAAA;AjBk1LhB;AiBj1LgB;EACI,gBAAA;AjBm1LpB;AiB90LI;EACI,iBVxjCC;EUyjCD,gBAAA;EACA,YVviCA;APu3NR;AiB/0LQ;EAEI,mBV5jCF;ENkHP,kBgB28BuC;AjBg1L1C;;AiB30LA;EACI,6DAAA;EACA,iBAAA;AjB80LJ;AiB30LI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;AjB60LR;AiB30LQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AjB60LZ;AiB30LY;EACI,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;AjB60LhB;AiB30LgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AjB60LpB;AiB10LgB;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,qBAAA;AjB40LpB;AiBz0LgB;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,qBAAA;AjB20LpB;AiBt0LQ;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;AjBw0LZ;AiBn0LI;EACI,kBAAA;EACA,mBAAA;AjBq0LR;AiBn0LQ;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AjBq0LZ;AiBl0LQ;EACI,YAAA;EACA,mBAAA;AjBo0LZ;AiB/zLI;EACI,kBAAA;EACA,qBAAA;EACA,6DAAA;EACA,gBAAA;AjBi0LR;AiB/zLQ;EANJ;IAOQ,qBAAA;EjBk0LV;AACF;AiBh0LQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0FAAA;EACA,oBAAA;AjBk0LZ;AiB/zLQ;EACI,kBAAA;EACA,WAAA;AjBi0LZ;AiB/zLY;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AjBi0LhB;AiB/zLgB;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AjBi0LpB;AiB9zLgB;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;AjBg0LpB;AiB5zLY;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AjB8zLhB;AiB5zLgB;EAXJ;IAYQ,eAAA;EjB+zLlB;AACF;AiB7zLgB;EAfJ;IAgBQ,eAAA;EjBg0LlB;AACF;AiB7zLY;EACI,aAAA;EACA,SAAA;EACA,eAAA;AjB+zLhB;AiB7zLgB;EALJ;IAMQ,SAAA;EjBg0LlB;AACF;AiB9zLgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AjBg0LpB;AiB9zLoB;EACI,cAAA;EACA,eAAA;AjBg0LxB;AiBxzLI;EACI,mBAAA;EACA,oBAAA;AjB0zLR;AiBxzLQ;EAJJ;IAKQ,oBAAA;EjB2zLV;AACF;AiBvzLI;EACI,mBAAA;EACA,mBAAA;EACA,gBAAA;AjByzLR;AiBvzLQ;EACI,qCAAA;EACA,mBAAA;EACA,aAAA;AjByzLZ;AiBvzLY;EACI,mBAAA;EACA,gBAAA;AjByzLhB;AiBvzLgB;EACI,mBAAA;AjByzLpB;AiBrzLY;EACI,0CAAA;EACA,kBAAA;EACA,yBAAA;AjBuzLhB;AiBrzLgB;EACI,qBAAA;AjBuzLpB;AiBpzLgB;EACI,oCAAA;AjBszLpB;AiBlzLY;EACI,YAAA;EACA,kDAAA;AjBozLhB;AiBlzLgB;EACI,cAAA;AjBozLpB;AiB7yLI;EACI,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AjB+yLR;AiB7yLQ;EARJ;IASQ,aAAA;EjBgzLV;AACF;AiB9yLQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AjBgzLZ;AiB9yLY;EACI,cAAA;EACA,eAAA;AjBgzLhB;AiB7yLY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AjB+yLhB;AiBzyLgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AjB2yLpB;AiBzyLoB;EAVJ;IAWQ,aAAA;EjB4yLtB;AACF;AiB1yLoB;EACI,mCAAA;EACA,wCAAA;EACA,0BAAA;AjB4yLxB;AiBzyLoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;AjB2yLxB;AiBzyLwB;EACI,cAAA;EACA,eAAA;AjB2yL5B;AiBvyLoB;EACI,SAAA;AjByyLxB;AiBvyLwB;EACI,cAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AjByyL5B;AiBtyLwB;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AjBwyL5B;AiB/xLI;EACI,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;AjBiyLR;AiB/xLQ;EAPJ;IAQQ,aAAA;EjBkyLV;AACF;AiBhyLQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AjBkyLZ;AiBhyLY;EACI,cAAA;EACA,eAAA;AjBkyLhB;AiB/xLY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AjBiyLhB;AiB5xLY;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AjB8xLhB;AiBxxLI;EACI,gBAAA;EACA,UAAA;AjB0xLR;AiBxxLQ;EAJJ;IAKQ,gBAAA;IACA,gBAAA;EjB2xLV;AACF;AiBxxLI;EACI,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;AjB0xLR;AiBxxLQ;EAPJ;IAQQ,aAAA;EjB2xLV;AACF;AiBzxLQ;EACI,kBAAA;EACA,aAAA;EACA,mFAAA;EACA,mBAAA;EACA,mBAAA;AjB2xLZ;AiBzxLY;EACI,eAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AjB2xLhB;AiBxxLY;EACI,eAAA;EACA,+BAAA;EACA,6BAAA;EACA,kBAAA;AjB0xLhB;AiBvxLY;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AjByxLhB;AiBvxLgB;EAVJ;IAWQ,eAAA;EjB0xLlB;AACF;AiBvxLY;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AjByxLhB;AiBvxLgB;EACI,eAAA;AjByxLpB;AiBpxLQ;EACI,WAAA;EACA,sFAAA;EACA,cAAA;AjBsxLZ;AiBnxLQ;EACI,kBAAA;EACA,mBAAA;AjBqxLZ;AiBnxLY;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AjBqxLhB;AiBlxLY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AjBoxLhB;AiBjxLY;EACI,+BAAA;EACA,eAAA;EACA,SAAA;AjBmxLhB;AiB9wLY;EACI,mBAAA;AjBgxLhB;AiB9wLgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AjBgxLpB;AiB9wLoB;EACI,cAAA;EACA,eAAA;AjBgxLxB;AiB5wLgB;EACI,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AjB8wLpB;AiB5wLoB;EACI,aAAA;EACA,oCAAA;EACA,qCAAA;EACA,4CAAA;AjB8wLxB;AiB3wLoB;EACI,+BAAA;AjB6wLxB;AiB1wLoB;EACI,gBAAA;EACA,iBAAA;AjB4wLxB;AiBvwLY;EACI,WAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;AjBywLhB;AiBvwLgB;EACI,eAAA;AjBywLpB;AiBtwLgB;EACI,2BAAA;EACA,6CAAA;AjBwwLpB;AiBrwLgB;EACI,YAAA;EACA,mBAAA;AjBuwLpB;AiBnwLY;EACI,gBAAA;EACA,iBAAA;EACA,8CAAA;AjBqwLhB;AiBnwLgB;EACI,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,mBAAA;AjBqwLpB;AiBlwLgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AjBowLpB;AiBlwLoB;EACI,eAAA;AjBowLxB;AiBjwLoB;EACI,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AjBmwLxB;;AiB1vLA;EACI;IACI,yBAAA;EjB6vLN;AACF;AiB1vLA;EACI;IACI,UAAA;IACA,2BAAA;EjB4vLN;EiB1vLE;IACI,UAAA;IACA,wBAAA;EjB4vLN;AACF;AiBzvLA;EACI,mCAAA;AjB2vLJ;;AiBtvLY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AjByvLhB;AiBtvLY;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AjBwvLhB;AiBrvLY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,qDAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AjBuvLhB;AiBrvLgB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mCAAA;AjBuvLpB;AiBpvLgB;EACI,uCAAA;EACA,8CAAA;AjBsvLpB;AiBpvLoB;EACI,YAAA;EACA,aAAA;AjBsvLxB;AiBnvLoB;EACI,sBAAA;AjBqvLxB;AiBjvLgB;EACI,eAAA;EACA,YAAA;EACA,6CAAA;AjBmvLpB;AiBhvLgB;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AjBkvLpB;AiBhvLoB;EACI,eAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AjBkvLxB;AiB/uLoB;EACI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;AjBivLxB;AiB5uLY;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;AjB8uLhB;AiB5uLgB;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,sFAAA;AjB6uLpB;AiB1uLgB;EACI,OAAA;AjB4uLpB;AiBzuLgB;EACI,QAAA;AjB2uLpB;AiBxuLgB;EACI,qBAAA;EACA,eAAA;EACA,qCAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AjB0uLpB;AiBtuLY;EACI,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AjBwuLhB;AiBtuLgB;EACI,eAAA;AjBwuLpB;AiBruLgB;EACI,qCAAA;EACA,oCAAA;EACA,cAAA;AjBuuLpB;AiBnuLY;EACI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AjBquLhB;AiBnuLgB;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AjBquLpB;;AiBhuLA;EACI;IACI,mBAAA;EjBmuLN;EiBjuLE;IACI,qBAAA;EjBmuLN;AACF;AiB/tLQ;EACI,aAAA;EACA,qFAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;AjBiuLZ;;AiB7tLY;;;;EAII,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AjBguLhB;AiB9tLgB;;;;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AjBmuLpB;AiB9tLgB;EACI,+BAAA;EACA,eAAA;EACA,6BAAA;AjBguLpB;AiB3tLgB;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AjB6tLpB;AiBxtLgB;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AjB0tLpB;AiBxtLoB;EACI,eAAA;AjB0tLxB;AiBttLgB;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;AjBwtLpB;AiBptLY;EACI,2BAAA;AjBstLhB;AiBptLgB;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AjBstLpB;AiBntLgB;EACI,eAAA;EACA,gBAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AjBqtLpB;AiBntLoB;EARJ;IASQ,eAAA;EjBstLtB;AACF;AiBltLY;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AjBotLhB;AiBltLgB;EACI,eAAA;AjBotLpB;AiBhtLY;EACI,WAAA;EACA,uFAAA;EACA,cAAA;AjBktLhB;AiB/sLY;EACI,WAAA;EACA,oFAAA;EACA,cAAA;AjBitLhB;AiB9sLY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AjBgtLhB;AiB9sLgB;EACI,eAAA;AjBgtLpB;AiB3sLY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,0CAAA;AjB6sLhB;AiB3sLgB;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AjB6sLpB;AiB1sLgB;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AjB4sLpB;AiBxsLY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,oFAAA;EACA,mBAAA;EACA,wCAAA;EACA,4CAAA;AjB0sLhB;AiBxsLgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AjB0sLpB;AiBxsLoB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AjB0sLxB;AiBvsLoB;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,4CAAA;EACA,yCAAA;AjBysLxB;AiBrsLgB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AjBusLpB;AiBnsLY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,oFAAA;EACA,mBAAA;EACA,wCAAA;EACA,6CAAA;EACA,2BAAA;AjBqsLhB;AiBnsLgB;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AjBqsLpB;AiBlsLgB;EACI,eAAA;EACA,gBAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,6CAAA;AjBosLpB;AiBlsLoB;EATJ;IAUQ,eAAA;EjBqsLtB;AACF;;AkBhyPA;;wBAAA;AAIA;EACI,gCAAA;EACA,mBAAA;AlBkyPJ;AkBjyPS;EACI,mBAAA;AlBmyPb;AkBlyPgB;EACI,efmBF;EelBE,cbRD;EaSC,qBXHH;APuyPjB;AC1vPI;EiB7CY;IAKQ,efYN;EH0xPhB;AACF;AkBnyPQ;EACI,mBAAA;EACA,gBfRF;EeSE,efCM;EeAN,cbtBK;AL2zPjB;;AkBlyPI;EACQ,SAAA;AlBqyPZ;;AkBjyPY;EACI,aXjBR;APqzPR;AkBlyPY;EACI,6BAAA;AlBoyPhB;AkBlyPY;EACI,mBbhCN;ALo0PV;AkBlyPY;EACI,mBbxBC;EayBD,WAAA;AlBoyPhB;AkBlyPY;EACI,mBb5BC;Ea6BD,WAAA;EACA,kBXvCN;EWwCM,iBAAA;AlBoyPhB;AkBnyPgB;EACI,yBbjCH;ALs0PjB;AkBhyPoB;EACI,mBbvCP;ALy0PjB;AkB9xPoB;EACI,mBb5CP;AL40PjB;AkB7xPgB;EACI,mBbhDH;EaiDG,WAAA;EACA,YAAA;EACA,kBAAA;AlB+xPpB;AkBvxPA;EjB6CG,gBiB5CyB;EACxB,gCAAA;AlByxPJ;;AkBvxPA;EACI,kBXhEQ;AP01PZ;AkBzxPK;EjBwCF,aiBvCmC;EjBsCnC,gBiBrC6B;EACxB,gBfxEE;EeyEF,ef7DU;Ee8DV,cb1EY;Ea2EZ,mBbjFQ;EakFR,yBAAA;AlB2xPR;AkB1xPQ;EACI,mBbrFF;EasFE,aAAA;AlB4xPZ;AkB1xPQ;EACI,cblFQ;AL82PpB;AkBxxPY;EjBcV,kBMjGU;EWqFA,WAAA;EACA,QAAA;EACA,+BAAA;AlB0xPZ;;AkBrxPI;EACI,cbnGO;AL23Pf;AkBvxPQ;EACI,UAAA;AlByxPZ;AkBtxPI;EACI,gBAAA;AlBwxPR;;AkBnxPQ;EACI,cb/GG;EagHH,gBAAA;EACA,0BAAA;AlBsxPZ;AkBnxPI;EACI,cbrHO;EasHP,efvGU;EewGV,eAAA;AlBqxPR;;AC/1PI;EiB6EJ;IAEQ,aXvHA;EP44PN;AACF;ACr2PI;EiBiFH;IAGW,yBAAA;ElBqxPV;AACF;AkBpxPQ;EAEI,yBAAA;EjB0JV,kBiBzJ2B;EACjB,cbvIG;EawIH,efzHM;Ee0HN,YAAA;EACA,aAAA;EACA,mBb/IF;ALo6PV;AkBpxPY;EACI,uBAAA;EACA,YAAA;EACA,UAAA;EACA,efnIE;EeoIF,gBf/IJ;EegJI,cbpJE;AL06PlB;AkBnxPE;EjBrCC,kBiBsCuC;AlBqxP1C;AC93PI;EiBwGF;IjBtCC,gBiByCqC;ElBuxPtC;AACF;AkBtxPY;EACI,oCAAA;EACA,yBAAA;AlBwxPhB;AkBtxPG;EjB9CA,UiB+C+B;AlBwxPlC;AkBrxPgB;EjBlDb,UiBmD+C;EjBpD/C,gBiBqDyC;AlBuxP5C;AkBrxPoB;EACI,cbvKT;EawKS,efzJN;Ee0JM,YAAA;AlBuxPxB;AkBtxPwB;EACI,cbpLX;AL48PjB;AkBrxPoB;EACI,gBAAA;EACA,iBAAA;AlBuxPxB;AkBjxPC;EACO,yBAAA;EjBwGN,kBiBvGuB;EACjB,cbzLO;Ea0LP,eAAA;EACA,YAAA;EAEA,mBbjME;EJiGR,yBiBiG0B;AlBoxP5B;ACr6PI;EiByIH;IAUW,gBAAA;ElBsxPV;AACF;AkBrxPY;EACI,gBAAA;EACA,cAAA;EACC,efjLC;AHw8PlB;AkBrxPE;EACC,oCAAA;EjB3GD,yBiB4G8B;EAC7B,cb9MO;ALu+PV;AkBxxPG;EACC,cbhNM;AL0+PV;AkBtxPI;EACI,mBAAA;EACA,yBAAA;EACA,kDAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;AlBwxPR;AkBvxPQ;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AlByxPZ;;AkBrxPA;EACI,cbhOgB;EaiOhB,qBXpOa;EWqOb,kBX9NQ;EW+NR,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eX/MO;EWgNP,gBftOO;EeuOP,yBXtOI;UWsOJ,iBXtOI;AP8/PR;AkBvxPI;EACI,yBbnPW;EaoPX,qBbpPW;AL6gQnB;AkBxxPQ;EACI,cXjPH;EWkPG,QAAA;EACA,SAAA;EACA,eAAA;AlB0xPZ;AkBvxPI;EACI,kBXjPI;EWkPJ,UAAA;EACA,eX/NG;APw/PX;AkBvxPI;EACI,kBXtPI;EWuPJ,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBbtQE;EauQF,kBAAA;EACA,yBAAA;EACA,mBbxQQ;EayQR,kBAAA;EACA,gCAAA;AlByxPR;AkBxxPQ;EACI,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBXtQA;EWuQA,aXxQJ;EWyQI,SAAA;EACA,QAAA;EACA,cbpRF;EaqRE,cAAA;AlB0xPZ;;AkBrxPI;EACI,mBAAA;AlBwxPR;;AkBpxPI;EACI,mBbhSE;EJoHP,aiB6KmC;EAC9B,mBAAA;EACA,iDAAA;AlBuxPR;ACzgQI;EiB8OA;IAMQ,mBAAA;ElByxPV;AACF;AkBvxPY;EACI,gBflSN;EemSM,eflRE;EemRF,mBAAA;AlByxPhB;ACnhQI;EiBuPQ;IAKQ,efxRF;EHmjQhB;AACF;AkBvxPY;EACI,cbxSC;ALikQjB;AkBtxPQ;EACI,cXpTH;EWqTG,kBXtTF;EWuTE,gBAAA;EACA,cb1SC;ALkkQb;AkBvxPY;EACI,cbjUC;AL0lQjB;AkBrxPI;EACI,gBAAA;AlBuxPR;ACviQI;EiB+QA;IAGQ,gBAAA;ElByxPV;AACF;AkBvxPI;EACI,eAAA;AlByxPR;AC/iQI;EiBuRI;IAEQ,mBAAA;ElB0xPd;AACF;AkBzxPY;EACI,YAAA;EAEA,mBAAA;EACA,eAAA;EACA,cb9UP;ALwmQT;AkBzxPgB;EACI,UAAA;EACA,gBX3UZ;APsmQR;AC9jQI;EiBySY;IAEQ,eAAA;ElBuxPtB;AACF;ACnkQI;EiB6SgB;IAEQ,mBAAA;ElBwxP1B;AACF;AkBlxPI;EACI,kBAAA;AlBoxPR;AkBnxPQ;EACI,cAAA;AlBqxPZ;AkBnxPQ;EACI,mBbxWY;EayWZ,qBbnXK;ALwoQjB;;ACllQI;EiBkUA;IAEQ,mBAAA;ElBmxPV;AACF;ACxlQI;EiBwUA;IAIQ,cAAA;ElBgxPV;AACF;AC7lQI;EiBwUA;IAOO,2BAAA;ElBkxPT;AACF;AClmQI;EiBiVI;IAGQ,eAAA;ElBkxPd;AACF;AkBjxPY;EACI,kBAAA;AlBmxPhB;AC1mQI;EiBsVQ;IjBpRT,gBiBuRyC;ElBqxP1C;AACF;AkBnxPY;EACI,kBAAA;AlBqxPhB;AkBpxPgB;EACI,WAAA;AlBsxPpB;ACrnQI;EiB8VY;IAGO,mBAAA;IACA,WAAA;ElBwxPrB;AACF;AkBtxPgB;EACI,YAAA;AlBwxPpB;AC9nQI;EiBqWY;IAGQ,mBAAA;IACA,WAAA;ElB0xPtB;AACF;AkBxxPgB;EACI,YAAA;AlB0xPpB;ACvoQI;EiB4WY;IAGQ,YAAA;ElB4xPtB;AACF;AC5oQI;EiB4WY;IAMQ,mBAAA;IACA,WAAA;ElB8xPtB;AACF;AkBnxPC;EACG,mBbjbM;EJoHP,eiB8T+B;EAC9B,kDAAA;AlBqxPJ;;AkBjxPQ;EACI,kBAAA;AlBoxPZ;AkBnxPY;EACI,WAAA;EACA,YAAA;EAEA,mBbrbE;EasbF,kBAAA;EAIA,oBAAA;AlBoxPhB;AkBnxPgB;EACI,mBb3bJ;ALgtQhB;AkBpxPoB;EACI,cbtcd;AL4tQV;AkBnxPgB;EACI,mBbjcJ;EaqcI,oBAAA;AlBqxPpB;AkBpxPoB;EACI,cbhdd;Eaodc,oBAAA;AlBsxPxB;AkBnxPgB;EACI,cb3cN;Ea4cM,efpcF;AHytQlB;AkBlxPY;EACI,SAAA;AlBoxPhB;;AkB9wPI;EACI,mBAAA;EjBhXL,aiBiXmC;AlBixPtC;AkBhxPQ;EACI,kBAAA;EACA,gBAAA;EACA,gBXzcF;EW0cE,mBAAA;AlBkxPZ;AC3sQI;EiBqbI;IAMQ,eAAA;IACA,mBAAA;IACA,WAAA;ElBoxPd;AACF;AkBnxPY;EACI,mBAAA;EAGA,yBAAA;AlBqxPhB;ACxtQI;EiB+bQ;IAMQ,WAAA;ElBuxPlB;AACF;AkBpxPgB;EAGI,sBAAA;EAGA,yBAAA;AlBsxPpB;ACruQI;EiBmdI;IAEQ,sBAAA;IACA,mBXrgBN;EPyxQR;AACF;AkBlxPQ;EjBvZL,SiBwZiC;EjBvZjC,UiBuZmC;AlBqxPtC;AkBpxPY;EAEI,mBAAA;AlBqxPhB;AClvQI;EiB2dQ;IAIQ,mBAAA;IACA,sBAAA;IACD,+BAAA;ElBuxPjB;AACF;AkBrxPoB;EACI,mBAAA;EACA,ef9fN;Ee+fM,gBflhBZ;AHyyQZ;AkBtxPwB;EACI,cbthBb;AL8yQf;AkBvxP4B;EACI,cAAA;AlByxPhC;ACpwQI;EiBweoB;IAMQ,efvgBd;EHiyQhB;AACF;AkBvxPoB;EACI,efhhBN;EeihBM,cbxhBV;EayhBU,gBf9hBb;AHuzQX;AC9wQI;EiBkfgB;IAKY,mBAAA;IACA,efrhBd;EHgzQhB;AACF;AkBzxPoB;EACI,kBAAA;AlB2xPxB;AkB1xPwB;EACI,ef1hBV;Ee2hBU,cb5hBJ;ALwzQxB;AkBxxPoB;EACG,aX9iBf;APw0QR;AC9xQI;EiBmgBgB;IAGQ,mBAAA;ElB4xP1B;AACF;AkB3xPuB;EACC,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AlB6xPxB;AkBzxP4B;EACI,cAAA;AlB2xPhC;AkBrxPoB;EACI,gBfpkBhB;EeqkBgB,ef/iBN;AHs0QlB;AChzQI;EiBuhBgB;IAIQ,efljBV;EH20QhB;AACF;AkB9xPoB;EAMI,cb9jBX;ALy1Qb;ACxzQI;EiBuhBgB;IAUY,2BAAA;IACA,8BAAA;IACA,oBAAA;ElB2xP9B;AACF;AkB1xPwB;EACI,efpkBV;EeqkBU,mBXnkBlB;EWokBkB,yBbxkBZ;EaykBY,gBAAA;AlB4xP5B;AkBzxPoB;EACI,kBAAA;AlB2xPxB;AkB1xPwB;EACI,cbrlBX;EaslBW,ef9kBV;AH02QlB;AkBvxPgB;EACI,SAAA;EACA,mBXtmBV;AP+3QV;AkBrxPY;EjBzfT,gBiB0fqC;EjBzfrC,iBiByf8C;EACjC,gCAAA;AlBwxPhB;AkBvxPgB;EjB5fb,SiB8fyC;EjB7fzC,aiB6f2C;EAC1B,mBbpmBD;EaqmBC,kBAAA;AlByxPpB;AC31QI;EiB8jBY;IjB5fb,SiBkgB6C;IjBjgB7C,oBiBigBgD;IAC3B,aAAA;IACA,qBAAA;IACA,eAAA;IACA,uBAAA;ElB4xPtB;AACF;ACr2QI;EiB0kBgB;IAIQ,cAAA;IACA,iBAAA;IACA,aAAA;IACA,qBAAA;IACA,mBAAA;ElB4xP1B;AACF;AC/2QI;EiB0kBgB;IAYQ,WAAA;IACA,cAAA;IACA,aAAA;IACA,qBAAA;ElB8xP1B;AACF;AkB7xPwB;EACI,cAAA;AlB+xP5B;AkB9xP4B;EACI,kBAAA;EACA,cAAA;EACA,WAAA;AlBgyPhC;AkBvxPgB;EACI,mBb/oBL;EagpBK,cb5pBV;EagqBU,oBAAA;AlByxPpB;ACx4QI;EiBymBY;IAQQ,WAAA;ElB2xPtB;AACF;AkB1xPoB;EACI,oCAAA;EACA,cbtqBd;EauqBc,kBAAA;EAIA,oBAAA;AlB4xPxB;;AkBpxPA;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;EACE,uBAAA;EACA,sBAAA;EACA,qBAAA;EjBtkBD,gBiBukBuB;AlBuxP1B;;AkBrxPA;EACI,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EjB/kBD,gBiBglByB;AlBwxP5B;;AkBtxPA;EACI,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EjBxlBD,gBiBylByB;AlByxP5B;;AkBvxPA;EACI,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EjBjmBD,gBiBkmByB;AlB0xP5B;;AkBxxPA;EACI,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EjB1mBD,gBiB2mByB;AlB2xP5B;;AkBzxPA;EACE,UAAA;AlB4xPF;;AkB1xPA;EACI,UAAA;AlB6xPJ;;AkB3xPA;EACI,UAAA;AlB8xPJ;;AkB5xPA;EACI,UAAA;AlB+xPJ;;AkB7xPA;EACI,UAAA;AlBgyPJ;;AkB9xPA;EACE,sBAAA;EACA,kBAAA;EACA,iCbvvBe;EawvBb,8BbxvBa;EayvBb,6BbzvBa;Ea0vBb,4Bb1vBa;AL2hRjB;;AkB/xPA;EACI,sBAAA;EACA,kBAAA;EACA,iCb/vBa;EagwBb,8BbhwBa;EaiwBb,6BbjwBa;EakwBb,4BblwBa;ALoiRjB;;AkBhyPA;EACI,sBAAA;EACA,kBAAA;EACA,iCbvwBa;EawwBb,8BbxwBa;EaywBb,6BbzwBa;Ea0wBb,4Bb1wBa;AL6iRjB;;AkBjyPA;EACI,sBAAA;EACA,kBAAA;EACA,iCb/wBa;EagxBb,8BbhxBa;EaixBb,6BbjxBa;EakxBb,4BblxBa;ALsjRjB;;AkBlyPA;EACI,sBAAA;EACA,kBAAA;EACA,iCbvxBa;EawxBb,8BbxxBa;EayxBb,6BbzxBa;Ea0xBb,4Bb1xBa;AL+jRjB;;AkBnyPA;EACI,yBb7xBa;Ea8xBb,kBAAA;EACA,iCb/xBa;EagyBb,8BbhyBa;EaiyBb,6BbjyBa;EakyBb,4BblyBa;ALwkRjB;;AkBpyPA;EACI,yBbryBa;EasyBb,kBAAA;EACA,iCbvyBa;EawyBb,8BbxyBa;EayyBb,6BbzyBa;Ea0yBb,4Bb1yBa;ALilRjB;;AkBryPA;EACI,yBb7yBa;Ea8yBb,kBAAA;EACA,iCb/yBa;EagzBb,8BbhzBa;EaizBb,6BbjzBa;EakzBb,4BblzBa;AL0lRjB;;AkBtyPA;EACI,yBbrzBa;EaszBb,kBAAA;EACA,iCbvzBa;EawzBb,8BbxzBa;EayzBb,6BbzzBa;Ea0zBb,4Bb1zBa;ALmmRjB;;AkBvyPA;EACI,yBb7zBa;Ea8zBb,kBAAA;EACA,iCb/zBa;Eag0Bb,8Bbh0Ba;Eai0Bb,6Bbj0Ba;Eak0Bb,4Bbl0Ba;AL4mRjB;;AmBrmRA;EACE,MAAA;EACA,gBAAA;AnBwmRF;;AmBrmRE;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cApBM;EAqBN,gBAAA;EACA,gBAAA;AnBwmRJ;AmBrmRI;EACE,gBAAA;AnBumRN;AmBrmRI;EACE,eAAA;AnBumRN;;AmBjmRI;EACE,SAAA;AnBomRN;;AmB/lRE;EACE,eAAA;AnBkmRJ;;AmB5lRM;EACE,mBAAA;EACA,WAjDE;AnBgpRV;;AmBzlRE;EACE,eAAA;AnB4lRJ;;AmBxlRE;EACE,YAAA;EACA,mBAAA;AnB2lRJ;AmBvlRM;EACE,oBAAA;EACA,2BAAA;AnBylRR;AmBxlRQ;EACE,cArEA;AnB+pRV;AmB/lRI;EAQE,SAAA;AnB0lRN;;AmBrlRE;EACE,aAAA;AnBwlRJ;;AmBnlRA;EACE,aAAA;AnBslRF;;AmBnlRA;EACE,QAAA;AnBslRF;;AmBnlRA;EACE,kBAAA;AnBslRF;;AmBnlRA;EACE,mBAAA;AnBslRF;;AmBnlRA;;EAEE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AnBslRF;;AmBnlRA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AnBslRF;;AmBnlRA;EACE,gCAAA;EACA,wCAAA;AnBslRF;;AmBplRA;EACE,yBAAA;AnBulRF;;AmBnlRE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AnBslRJ;;AmBllRA;EACE,gBAAA;EACA,MAAA;AnBqlRF","sourcesContent":["/*\nAuthor       : Omar\nName: Omar Mobility Rent\nVersion      : 1.0\n*/\n\n// UTILS\n@import \"utils/variables\";\n@import \"utils/mixins\";\n\n//  BASE\n@import \"base/reset\";\n@import \"base/typography\";\n@import \"base/colors\"; \n@import \"base/base\";\n@import \"base/grid\";\n\n// COMPONENTS\n@import \"components/button\";\n\n\n// LAYOUT \n@import \"layout/content\";\n@import \"layout/header\";\n@import \"layout/footer\";\n@import \"layout/breadcrumb\";\n@import \"layout/select\";\n@import \"layout/table\";\n\n// PAGES\n@import \"pages/home\";\n@import \"pages/common\";\n@import \"pages/about-us\";\n@import \"pages/detail-page\";\n@import \"pages/products\";\n@import \"pages/react\";","$breakpoints: (\n  xs: 320px,\n  sm: 568px,\n  custom767: 767.98px,\n  md: 768px,\n  lg: 1024px,\n  custom320: 320px,\n  custom479: 479px,\n  custom575: 575.98px,\n  custom768: 768px,\n  custom849: 849px,\n  custom991: 991.98px,\n  custom992: 992px,\n  custom1299: 1299.98px,\n  custom1399: 1399.98px,\n  custom1199: 1199.98px,\n  custom1023: 1023px,\n  custom1024: 1024px,\n  custom1400: 1400px,\n  custom1440: 1440px,\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (min-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n// Respond below.\n@mixin respond-below($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (max-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n\n\n@mixin transform($property) {\n  transform: $property;\n  -webkit-transform: $property;\n  -ms-transform: $property;\n}\n\n// Define vertical, horizontal, or both position\n@mixin position-alignment($position) {\n  position: $__absolute;\n  \n  @if $position == 'vertical' {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n  @else if $position == 'horizontal' {\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translate(-50%);\n  }\n  @else if $position == 'both' {\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n  }\n}\n\n@mixin transition($__property) {\n  -webkit-transition: $__property;\n  -ms-transition: $__property;\n  transition: $__property;\n}\n\n@mixin background-properties($__cover:cover,$__no-repeat:no-repeat,$__center:center){\n  background-size:$__cover;\n  background-repeat:$__no-repeat;\n  background-position:$__center;\n}\n\n@mixin position($__position_value,$__top_value,$__right_value,$__bottom_value,$__left_value){\n  position:$__position_value;\n  top:$__top_value;\n  right:$__right_value;\n  bottom:$__bottom_value;\n  left:$__left_value;\n}\n\n@mixin margin-padding($__margin, $__padding) {\n   margin: $__margin;\n   padding:$__padding;\n}\n\n@mixin placeholder-color($color) {\n  &::-webkit-input-placeholder { /* WebKit browsers */\n      color: $color;\n      opacity: 1;\n  }\n  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */\n      color: $color;\n      opacity: 1;\n  }\n  &::-moz-placeholder { /* Mozilla Firefox 19+ */\n      color: $color;\n      opacity: 1;\n  }\n  &:-ms-input-placeholder { /* Internet Explorer 10+ */\n      color: $color;\n      opacity: 1;\n  }\n}\n\n%equal-heights {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n%ul_reset {\n  list-style:none;\n  padding:0;\n  margin:0;\n}\n.css-equal-heights {\n\t@extend %equal-heights;\n}\n\n.css-equal-content {\n    @extend %equal-heights;\n    color: red;\n    float: left;\n}\n.align-center {\n  @extend %flex-align-center;\n}\n%animation-effect {   \n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s;\n}\n%justify-content-center {  \n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n%align-items-center {  \n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n%justify-content-between {  \n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n%flex-align-center {\n  display: flex;\n  display: -webkit-flex;\n  align-items:center;\n  -webkit-align-items:center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n%justify-content-spacebetween {\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n}\n%clear{\n  content:\"\";\n  display:table;\n  clear:both;\n}\n\n%ul_reset {\n  list-style:none;\n  padding:0;\n  margin:0;\n}\n\n%full_width_height_div {\n  width:$__full__width;\n  height:$__full__height;\n}\n%inline-flex {  \n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n%display-flex {  \n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n%display-flex-between {  \n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n%display-flex-center-between {  \n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n%display-flex-center {  \n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n%jusflex-end {\n  justify-content: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n}\n%jusflex-start {\n  justify-content: flex-start;\n  -webkit-justify-content: start;\n  -ms-flex-pack: start;\n}\n%justify-content-between {  \n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n}\n%flex-wrap {  \n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n%flex-end {  \n  -webkit-box-align: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n}\n%flex-column {  \n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n@mixin rounded($unit) {\n  border-radius: $unit;\n}\n@mixin transform-origin($property) {\n  transform-origin: $property;\n  -webkit-transform-origin: $property;\n  -ms-transform-origin: $property;\n}\n@mixin box-shadow($__inset:inset,$__horizontaloffset:10px,$__verticaloffset:10px,$blur:10px,$__spread:10px,$__color: #000000) {\n  -webkit-box-shadow: $__inset $__horizontaloffset $__verticaloffset $blur $__spread $__color;\n  -moz-box-shadow: $__inset $__horizontaloffset $__verticaloffset $blur $__spread $__color;\n  box-shadow: $__inset $__horizontaloffset $__verticaloffset $blur $__spread $__color;\n}\n@mixin rounded($unit) {\n  border-radius: $unit;\n}\n","/*-----------------\n    1. Reset\n-----------------------*/\n\nhtml, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n* {\n  box-sizing:border-box;\n}\narticle, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {\n  display: block; }\nol, ul {\n  list-style: none; }\n\nblockquote, q {\n  quotes: none; }\n\nblockquote {\n  &:before, &:after {\n    content: '';\n    content: none; } }\n\nq {\n  &:before, &:after {\n    content: '';\n    content: none; } }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }","/*-----------------\n    2. Typography\n-----------------------*/\n\n@import url('https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,400;0,500;0,600;0,700;0,900;1,400;1,500;1,600;1,700;1,900&display=swap');\n\n\n$__body__font__family: 'Fira Sans', sans-serif;\n\n$__highbold:900;\n$__bold:700;\n$__semibold:600;\n$__medium:500;\n$__regular:400;\n$__light:300;\n\n$__body__font__size:15px;\n$__menu__font__size:16px;\n$__button__font__size:18px;\n$__font__size__8:8px;\n$__font__size__10:10px;\n$__font__size__11:11px;\n$__font__size__12:12px;\n$__font__size__13:13px;\n$__font__size__14:14px;\n$__font__size__15:15px;\n$__font__size__16:16px;\n$__font__size__17:17px;\n$__font__size__19:19px;\n$__font__size__18:18px;\n$__font__size__20:20px;\n$__font__size__22:22px;\n$__font__size__24:24px;\n$__font__size__26:26px;\n$__font__size__28:28px;\n$__font__size__32:32px;\n$__font__size__36:36px;\n$__font__size__38:38px;\n$__font__size__40:40px;\n$__font__size__48:48px;\n$__font__size__42:42px;\n$__font__size__50:50px;\n$__font__size__52:52px;\n$__font__size__62:62px;\n\n\na {\n    text-decoration: none;\n    transition: ease all 0.5s;\n    -webkit-transition: ease all 0.5s;\n    -ms-transition: ease all 0.5s;\n}\nh1 {\n\tfont-weight: 900;\n\tfont-size: $__font__size__62;\n\tcolor: #201F1D;\n\t@include respond-below(custom1199){\n\t\tfont-size:$__font__size__36;\n\t}\n}\nh2 {\n\tfont-weight: 900;\n\tfont-size:$__font__size__36;\n\tcolor: #111111;;\n\t@include respond-below(custom991){\n\t\tfont-size:$__font__size__26;\n\t}\n}\nh3 {\n\tfont-weight: 700;\n\tfont-size:$__font__size__24;\n\tcolor: #111111;\n\t@include respond-below(custom991){\n\t\tfont-size:$__font__size__18;\n\t}\n}\nh4 {\n\tfont-size:$__font__size__28;\n\tcolor: #2F2F2F;\n\t@include respond-below(custom991){\n\t\tfont-size:$__font__size__20;\n\t}\n}\nh5 {\n\tfont-size:$__font__size__18;\n\t@include respond-below(custom991){\n\t\tfont-size:$__font__size__16;\n\t}\n}\nh6 {\n\tfont-weight:$__medium;\n\tfont-size:$__font__size__18;\n\tcolor: #111111;\n\t@include respond-below(custom991){\n\t\tfont-size:$__font__size__16;\n\t}\n}\n","/*-----------------\n\t3. General\n-----------------------*/\n\nbody{\n\tfont-family: $__body__font__family;\n\tfont-size: $__body__font__size;\n\tcolor: $__secondarycolor__light;\n\tbackground: $__cylindrical;\n\toverflow-x: hidden;\n\t@include respond-below(custom991){\n\t\tfont-size:$__font__size__15;\n\t}\n}\na {\n\tcursor: pointer;\n\t@include transition(all 0.2s ease);\n\t&:hover{\n\t\t@include transition(all 0.2s ease);\n\t}\n\t&:focus {\n\t\toutline: 0;\n\t}\n}\np {\n\t&:last-child{\n\t\tmargin-bottom:0;\n\t}\n}\nstrong{\n\tfont-weight: $__bold;\n}\n.form-control {\n\t&:focus {\n\t\tborder-color: #bbb;\n\t\tbox-shadow: none;\n\t\toutline: 0 none;\n\t}\n    \n}","$__primarycolor: #1976d2;\n$__primarylight: rgba(255, 255, 255, 0.2);\n$__primary__light__blue: #42a5f5;\n$__secondarycolor: #9c27b0;\n$__secondarycolor__light: #787878;\n$__white: #ffffff;\n$__cylindrical: #FCFBFB;\n$__grayish__blue: #3F4254;\n$__gray: #2F2F2F;\n$__gray__dark: #201F1D;\n$__text-warning__light: #FFA633;\n$__golden__yellow: #EDA600;\n$__gray__lightdark: #828282;\n$__light__gooses: #F4F4F4;\n$__dark__blues: #127384;\n$__blue__light: #DBDBDB;\n$__warningcolor: #FF9307;\n$__goose-gray: #201F1D;\n$__sandstone: #737373;\n$__light__vampire: #F2F7F6;\n$__grey: #787878;\n$__dangered: #FF0000;\n$__note__light: rgb(130, 130, 130);\n$__note__lights: rgb(130, 130, 130, 1);\n$__light_grass: rgba(18, 115, 132, 1);\n$__light__smokey-grays: #201F1D;\n$__cloud__grays: #EDECF8;\n$__graybackblue: #28283C;\n$__alice__blue: #FCFCFC;\n$__success__light: #1FBC2F;\n$__gray15: #878A99;\n$__light__grayish: #F1F1F1;\n$__light__gray__has: #E3E3E3;\n$__mine__shaft: #374B5C;\n$__light__gray: #DEE2E7;\n$__black_color:#141432;\n$__black:#000;\n$__white__smoke: #EFEFEF;\n$__violet__dark:#377dff;\n$__dark__black:#1F2937;\n$__ash:#dee2e6;\n$__dark__gray: #888888;\n$__smoke__white: #F3F3F3;\n$__bg__primary__light: #EADDFF;\n$__bg__green__light: #E1FFED;\n$__bg__danger__light: #FFECEC;\n","/*-----------------\n    4. Grid\n-----------------------*/\n\n@import \"../utils/variables\";\n@import \"../utils/mixins\";\n\n.col {\n\twidth:$__auto;\n\tpadding-left:$__grid__padding__left;\n\tpadding-right:$__grid__padding__right;\n\tfloat:$__left;\n\tposition: $__relative;\n  \tmin-height: 1px;\n\n\t@include respond-above(xs) {\n\t\t&.col-xs-12 {\n\t\t\twidth: $__col__12;\n\t\t}\n\t\t&.col-xs-11 {\n\t\t\twidth: $__col__11;\n\t\t}\n\t\t&.col-xs-10 {\n\t\t\twidth: $__col__10;\n\t\t}\n\t\t&.col-xs-9 {\n\t\t\twidth: $__col__9;\n\t\t}\n\t\t&.col-xs-8 {\n\t\t\twidth: $__col__8;\n\t\t}\n\t\t&.col-xs-7 {\n\t\t\twidth: $__col__7;\n\t\t}\n\t\t&.col-xs-6 {\n\t\t\twidth: $__col__6;\n\t\t}\n\t\t&.col-xs-5 {\n\t\t\twidth: $__col__5;\n\t\t}\n\t\t&.col-xs-4 {\n\t\t\twidth: $__col__4;\n\t\t}\n\t\t&.col-xs-3 {\n\t\t\twidth: $__col__3;\n\t\t}\n\t\t&.col-xs-2 {\n\t\t\twidth: $__col__2;\n\t\t}\n\t\t&.col-xs-1 {\n\t\t\twidth: $__col__1;\n\t\t}\n\t}\n\t@include respond-above(sm) {\n\t\t&.col-sm-12 {\n\t\t\twidth: $__col__12;\n\t\t}\n\t\t&.col-sm-11 {\n\t\t\twidth: $__col__11;\n\t\t}\n\t\t&.col-sm-10 {\n\t\t\twidth: $__col__10;\n\t\t}\n\t\t&.col-sm-9 {\n\t\t\twidth: $__col__9;\n\t\t}\n\t\t&.col-sm-8 {\n\t\t\twidth: $__col__8;\n\t\t}\n\t\t&.col-sm-7 {\n\t\t\twidth: $__col__7;\n\t\t}\n\t\t&.col-sm-6 {\n\t\t\twidth: $__col__6;\n\t\t}\n\t\t&.col-sm-5 {\n\t\t\twidth: $__col__5;\n\t\t}\n\t\t&.col-sm-4 {\n\t\t\twidth: $__col__4;\n\t\t}\n\t\t&.col-sm-3 {\n\t\t\twidth: $__col__3;\n\t\t}\n\t\t&.col-sm-2 {\n\t\t\twidth: $__col__2;\n\t\t}\n\t\t&.col-sm-1 {\n\t\t\twidth: $__col__1;\n\t\t}\n\t}\n\n\t@include respond-above(md) {\n\t\t&.col-md-12 {\n\t\t\twidth: $__col__12;\n\t\t}\n\t\t&.col-md-11 {\n\t\t\twidth: $__col__11;\n\t\t}\n\t\t&.col-md-10 {\n\t\t\twidth: $__col__10;\n\t\t}\n\t\t&.col-md-9 {\n\t\t\twidth: $__col__9;\n\t\t}\n\t\t&.col-md-8 {\n\t\t\twidth: $__col__8;\n\t\t}\n\t\t&.col-md-7 {\n\t\t\twidth: $__col__7;\n\t\t}\n\t\t&.col-md-6 {\n\t\t\twidth: $__col__6;\n\t\t}\n\t\t&.col-md-5 {\n\t\t\twidth: $__col__5;\n\t\t}\n\t\t&.col-md-4 {\n\t\t\twidth: $__col__4;\n\t\t}\n\t\t&.col-md-3 {\n\t\t\twidth: $__col__3;\n\t\t}\n\t\t&.col-md-2 {\n\t\t\twidth: $__col__2;\n\t\t}\n\t\t&.col-md-1 {\n\t\t\twidth: $__col__1;\n\t\t}\n\t}\n\n\t@include respond-above(lg) {\n\t\t&.col-lg-12 {\n\t\t\twidth: $__col__12;\n\t\t}\n\t\t&.col-lg-11 {\n\t\t\twidth: $__col__11;\n\t\t}\n\t\t&.col-lg-10 {\n\t\t\twidth: $__col__10;\n\t\t}\n\t\t&.col-lg-9 {\n\t\t\twidth: $__col__9;\n\t\t}\n\t\t&.col-lg-8 {\n\t\t\twidth: $__col__8;\n\t\t}\n\t\t&.col-lg-7 {\n\t\t\twidth: $__col__7;\n\t\t}\n\t\t&.col-lg-6 {\n\t\t\twidth: $__col__6;\n\t\t}\n\t\t&.col-lg-5 {\n\t\t\twidth: $__col__5;\n\t\t}\n\t\t&.col-lg-4 {\n\t\t\twidth: $__col__4;\n\t\t}\n\t\t&.col-lg-3 {\n\t\t\twidth: $__col__3;\n\t\t}\n\t\t&.col-lg-2 {\n\t\t\twidth: $__col__2;\n\t\t}\n\t\t&.col-lg-1 {\n\t\t\twidth: $__col__1;\n\t\t}\n\t}\n}","$__full__width:100%;\n$__half__width:50%;\n$__full_height_window:100vh;\n$__full__height:100%;\n$__half__height:50%;\n$__left:left;\n$__right:right;\n$__center:center;\n$__block:block;\n$__inline__block:inline-block;\n$__inline:inline;\n$__table:table;\n$__flex:flex;\n$__webkit__flex:-webkit-flex;\n$__none:none;\n$__absolute:absolute;\n$__relative:relative;\n$__static:static;\n$__fixed:fixed;\n$__unset:unset;\n$__uppercase:uppercase;\n$__lowercase:lowercase;\n$__capitalize:capitalize;\n$__inherit:inherit;\n$__initial:initial;\n$__auto:auto;\n$__normal:normal;\n$__margin__auto:0 auto;\n$__null:null;\n$__bottom:bottom;\n$__middle:middle;\n$__top:top;\n$__transparent:transparent;\n$__no_repeat:no-repeat;\n$__cover:cover;\n$__pointer:pointer;\n$__not-allowed:not-allowed;\n$__hidden:hidden;\n$__show:show;\n$__visible:visible;\n$__both:both;\n$__ellipsis:ellipsis;\n$__nowrap:nowrap;\n$__inline__flex:inline-flex;\n$__underline:underline;\n\n// Custom Values\n\n$__grid__padding__left:15px;\n$__grid__padding__right:15px;\n$__container__width:1140px;\n\n\n// Grid Values\n\n$__col__1:8.33333333%;\n$__col__2:16.66666667%;\n$__col__3:25%;\n$__col__4:33.33333333%;\n$__col__5:41.66666667%;\n$__col__6:50%;\n$__col__7:58.33333333%;\n$__col__8:66.66666667%;\n$__col__9:75%;\n$__col__10:83.33333333%;\n$__col__11:91.66666667%;\n$__col__12:100%;\n\n\n","/*-----------------\n    5. Buttons\n-----------------------*/\n\n.btn {\n    position: $__relative;\n    text-transform: initial;\n    -webkit-transition: all 0.5s;\n    -moz-transition: all 0.5s;\n    -o-transition: all 0.5s;\n    transition: all 0.5s;\n    &:hover {\n        -webkit-transition: all 0.5s;\n        -moz-transition: all 0.5s;\n        -o-transition: all 0.5s;\n        transition: all 0.5s;\n    }\n}\n.btn-view {\n    font-weight: $__medium;\n    font-size: $__font__size__16;\n    color: $__goose-gray;\n    border: 2px solid $__goose-gray;\n    background-color: $__white;\n    box-shadow: inset 0 0 0 0 $__white;\n    border-radius: 5px;\n    line-height: 0;\n    @include margin-padding(0, 11px 22px);\n    &:hover {\n        background-color: $__primarycolor;\n        border: 2px solid $__warningcolor;\n        color: $__white;\n        box-shadow: inset 0 50px 0 0 $__warningcolor;\n    }\n    @include respond-below(custom991){\n        @include margin-padding(0, 8px 12px);\n\t\tfont-size:$__font__size__14;\n\t}\n}\n\n.btn-white {\n    background-color: $__white;\n    border-color: $__light__grayish;\n    color: $__primarycolor;\n    box-shadow: inset 0 0 0 0 $__white;\n    &:hover {\n        background-color: $__white;\n        border-color: $__white;\n        color: $__white;\n        box-shadow: inset 0 50px 0 0 $__primarycolor;\n    }\n}\n.btn-white-outline {\n    background-color: $__white;\n    border-color: $__light__grayish;\n    color: $__grayish__blue;\n    &:hover {\n        background-color: $__white;\n        border-color: $__light__grayish;\n        color: $__grayish__blue;\n    }\n}\n.btn-primary {\n    background-color: $__primarycolor;\n    border: 1px solid $__primarycolor;\n    box-shadow: inset 0 0 0 0 $__white;\n    &:hover {\n        background-color: $__white;\n        border-color: $__primarycolor;\n        color: $__primarycolor;\n        box-shadow: inset 0 50px 0 0 $__white;\n    }\n}\n.btn-subscribe {\n    background-color: $__primarycolor;\n    border: 1px solid $__primarycolor;\n    box-shadow: inset 0 0 0 0 $__white;\n    &:hover {\n        i {\n            color: $__primarycolor !important;\n            -webkit-transition: 0.5s;\n            -ms-transition: 0.5s;\n            transition: 0.5s;\n        }\n        background-color: $__white;\n        border-color: $__primarycolor;\n        color: $__primarycolor;\n        box-shadow: inset 0 50px 0 0 $__white;\n    }\n}\n.submit-review {\n    @include margin-padding(null, 12px 20px);\n}\n.btn-size {\n    font-weight: $__semibold;\n    font-size: $__font__size__16;\n    @include margin-padding(null, 12px);\n}\n.btn-outline-light {\n    color: $__white;\n    background-color: $__goose-gray;\n    border: 1px solid $__goose-gray;\n    box-shadow: inset 0 0 0 0 $__white;\n    &:hover {\n        background-color: $__white;\n        border-color: $__light__grayish;\n        color: $__grayish__blue;\n        box-shadow: inset 0 50px 0 0 $__white;\n    }\n}\n.btn-gray {\n    background-color: $__white__smoke;\n    border: 1px solid $__white__smoke;\n    box-shadow: inset 0 0 0 0 $__white;\n    &:hover {\n        background-color: $__white;\n        border-color: $__white__smoke;\n        color: $__gray15;\n        box-shadow: inset 0 50px 0 0 $__white;\n    }\n}\n.btn-gray-outline {\n    background-color: $__white;\n    border: 1px solid $__white__smoke;\n    box-shadow: inset 0 0 0 0 $__white;\n    &:hover {\n        background-color: $__white__smoke;\n        border-color: $__white;\n        color: $__gray15;\n        box-shadow: inset 0 50px 0 0 $__white;\n    }\n}\n.btn-outline-primary {\n    color: $__primarycolor;\n    border-color: $__primarycolor;\n    &:hover {\n        background-color: $__primarycolor;\n        border-color: $__primarycolor;\n    }\n}\n.btn-check:focus+.btn-primary, \n.btn-primary:focus {\n    box-shadow: $__none !important;\n}\n.btn{\n    &:focus{\n        box-shadow: $__none !important; \n    }\n    &.btn-greys{\n        background: $__white__smoke;\n        color: $__secondarycolor;\n        font-size: $__font__size__13;\n        @include margin-padding(null, 8px 16px);\n        font-weight: $__semibold;\n    }\n}\n.cancel {\n    background-color: $__white;\n    border: 1px solid $__violet__dark;\n    box-shadow: inset 0 0 0 0 $__violet__dark;\n    color: $__violet__dark;\n    &:hover {\n        background-color: $__white;\n        border-color: $__violet__dark;\n        color: $__violet__dark;\n        box-shadow: inset 0 50px 0 0 $__white;\n    }\n}\n.contact-btn {\n    background-color: $__goose-gray;\n    border: 1px solid $__goose-gray;                \n    box-shadow: inset 0 0 0 $__white;\n    color: $__white;                \n    border-radius: 5px;\n    font-weight: $__bold;\n    font-size: $__font__size__16;\n    @include margin-padding(null, 12px 15px);\n    text-align: center;\n    @extend %animation-effect;\n    &:hover {\n        background-color: $__white;\n        border: 1px solid $__goose-gray;\n        box-shadow: inset 0 70px 0 0 $__white;\n        color: $__goose-gray;\n        @extend %animation-effect;\n    }\n}\n.btn-secondary {\n    background: $__gray;\n    color: $__white;\n}\n.fa-facebook {\n    background: #3080F8;\n    color: $__white;\n}  \n.fa-twitter {\n    background: #35B6FF;\n    color: $__white;\n} \n.fa-instagram {\n    background: #FF2D20;\n    color: $__white;\n}\n.fa-behance {\n    background: #0066FF;\n    color: $__white;\n}\n.fa-linkedin {\n    background: #0066FF;\n    color: $__white;\n}\n.btn-primary {\n    &.btn {\n        &:first-child {\n            &:active {\n                background: $__primarycolor;\n                border-color: $__primarycolor;\n            }\n        }\n    }\n}","/*-----------------\n    6. Header\n-----------------------*/\n\n.header {\n    background: $__white;\n    position: sticky;\n\tbox-shadow: 0px 10px 40px rgba(202, 202, 202, 0.2);\n    left: 0;\n    top: 0;\n    width: 100%;\n    z-index: 999;\n    @extend %animation-effect;\n    &.fixed {\n        background-color: $__white;\n        box-shadow: 0px 3px 53px rgb(197 197 197 / 27%);\n        @extend %animation-effect;\n    }\n    .logo {\n        a {\n            float: $__left;\n            img {\n                float: $__left;\n                max-height: 32px;\n            }\n        }\n    }\n    .header-nav {\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        border: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        position: $__relative;\n        height: 85px;\n        @include margin-padding(null, 0 15px 0 15px);\n        margin-bottom: 0;\n        @include respond-below(custom991) {\n            height: 65px;\n            @include margin-padding(null, 0);\n        }\n        .main-nav {\n            >li {\n                >a {\n                    color: $__gray;\n                    line-height: 85px;\n                    font-weight: $__medium;\n                    @include respond-below(custom991) {\n                        font-size: $__font__size__14;\n                    }\n                    @include respond-below(custom991) {\n                        color: $__white;\n                    }\n                    &:hover {\n                        color: $__primarycolor;\n                    }\n                }\n                .submenu {                    \n                    li {\n                        position: $__relative;\n                        &.active {\n                            color: $__primarycolor;\n                            >a {\n                                color: $__primarycolor;\n                            }\n                        }\n                        a {\n                            display: $__block;\n                            padding: 10px 15px 10px;\n                            clear: both;\n                            white-space: nowrap;\n                            color: $__gray;\n                            -webkit-transition: all .35s ease;\n                            transition: all .35s ease;\n                            width: 100%;\n                            position: $__relative;\n                            font-weight: $__medium;\n                            @include respond-below(custom991) { \n                                padding: 10px;\n                                color: $__white;\n                                font-size: $__font__size__12;\n                            }\n                            &:hover {\n                                color: $__primarycolor;\n                                padding-left: 20px;\n                            }\n                        }\n                    }\n                }\n                .login-link {\n                    display: $__none;\n                }\n            }\n        }\n    }\n    .navbar-header {\n        .navbar-brand {\n            display: inline-block;\n            @include margin-padding(null, 0);\n            line-height: 0;\n            @include respond-below(custom991) {\n                margin-right: 0;\n            }\n        }\n        .logo {\n            @include respond-below(custom575) {\n               display: none;\n            }\n        }\n        .logo-small {\n            display: none;\n            @include respond-below(custom575) {\n                display: block;\n                width: 100%;\n                text-align: center;\n             }\n        }\n        #mobile_btn {\n            display: none;\n            margin-right: 30px;            \n            @include respond-below(custom991) {\n                display: inline-block;\n                line-height: 0;\n            }\n            @include respond-below(custom575) {\n                left: 0;\n                margin-right: 0;\n                padding: 0 0px;\n                position: absolute;\n                z-index: 99;\n            }\n            .bar-icon {\n                display: inline-block;\n                width: 31px;\n                span {\n                    background-color: $__primarycolor;\n                    display: $__block;\n                    float: $__left;\n                    height: 3px;\n                    margin-bottom: 7px;\n                    width: 31px;\n                    border-radius: 2px;\n                    margin-bottom: 5px;\n                    &:nth-child(2) {\n                        width: 20px;\n                    }\n                    &:nth-child(3) {\n                        width: 16px;\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n        \n        @include respond-below(custom991) {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: inline-flex;\n            align-items: center;\n        } \n        @include respond-below(custom575) {\n            width: 100%;\n        }       \n    }\n    .main-menu-wrapper {\n        margin: 0 15px 0;\n        @include respond-below(custom991) {\n            order: 3;\n            width: 260px;\n            position: $__fixed;    \n            top: 0;\n            bottom: 0;\n            left: 0;\n            overflow-x: $__hidden;\n            overflow-y: $__auto;\n            z-index: 11111;\n            transform: translateX(-260px);\n            transition: all 0.4s;\n            background: $__gray__dark;\n            margin: 0;\n        }\n        .menu-header {\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            height: 60px;\n            padding: 0 20px;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            display: none;\n            @include respond-below(custom991) {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                height: 65px;\n                align-items: center;\n                background: $__white;\n            }\n            .menu-logo {\n                img {\n                    @include respond-below(custom991) {\n                        width: 160px;\n                    }\n                }\n            }\n                \n            .menu-close {\n                font-size: 18px;\n                color: $__primarycolor;\n            }\n        }\n        .main-nav {\n            >li {\n                .submenu {\n                    >li {\n                        .submenu {\n                            left: 100%;\n                            top: 0;\n                            margin-top: 10px;\n                            @include respond-below(custom991) {\n                                left: 0;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .main-nav {\n            >li {\n                .submenu {\n                    >li.has-submenu {\n                        >a {\n                            &::after {\n                                content: \"\\f054\";\n                                font-family: 'Font Awesome 5 Free';\n                                font-weight: 900;\n                                position: absolute;\n                                right: 15px;\n                                top: 12px;\n                                font-size: 13px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        \n        .main-nav {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            margin: 0;\n            padding: 0;\n            @include respond-below(custom991) {\n                padding: 0;\n                -ms-flex-direction: column;\n                flex-direction: column;\n                padding-left: 0;\n                margin-bottom: 0;\n                list-style: none;\n                background: $__gray__dark;\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n            > li {\n                @include respond-below(custom992) {\n                    margin-right: 0;\n                    &:last-child {\n                        margin-right: 0;\n                        border: 0;\n                    }\n                }\n                &.active {\n                    >a {\n                        display: $__block;\n                        color: $__primarycolor;\n                    }  \n                }\n                a  {                    \n                    i {\n                        font-size: $__font__size__12;\n                        margin-left: 3px;\n                    }              \n                        @include respond-below(custom991) {\n                            display: block;\n                            line-height: 20px;\n                            padding: 12px 15px;\n                            font-size: $__font__size__14;\n                            font-weight: $__medium;\n                            color: $__white;                        \n                            i {\n                                font-size: $__font__size__14;\n                                @include respond-below(custom991) {\n                                    float: right;\n                                    margin-top: 5px;\n                                    font-size: $__font__size__14;\n                                }\n                            }\n                        }\n                }\n                     \n                &:last-child {\n                    margin-right: 0;\n                }\n                    @include respond-below(custom991) {\n                        border-bottom: 1px solid $__gray__lightdark;\n                        @include margin-padding(null, 0);\n                    }\n                    @include respond-above(custom992) {\n                        display: $__block;\n                        position: $__relative;\n                        margin-right: 30px;\n                        &:last-child {\n                            margin-right: 0;\n                        }\n                    }\n                 \n                ul {\n                    @include respond-above(custom992) {\n                        background-color: $__white   ;\n                        border-radius: 5px;\n                        box-shadow: 0 0 3px rgb(0 0 0 / 10%);\n                        display: $__block;\n                        font-size: $__font__size__14;\n                        left: 0;\n                        margin: 0;\n                        min-width: 200px;\n                        opacity: 0;\n                        padding: 0;\n                        position: absolute;\n                        -webkit-transition: all .2s ease;\n                        transition: all .2s ease;\n                        -webkit-transform: translateY(20px);\n                        -ms-transform: translateY(20px);\n                        transform: translateY(20px);\n                        top: 100%;\n                        visibility: hidden;\n                        z-index: 1000;\n                    }\n                }\n            }            \n            @include respond-above(custom992) {\n                li.has-submenu {\n                    &:hover {\n                        >.submenu {\n                            visibility: visible;\n                            opacity: 1;\n                            margin-top: 0;\n                            -webkit-transform: translateY(0);\n                            -ms-transform: translateY(0);\n                            transform: translateY(0);\n                            border-radius: 2px;\n                            border-top: 1px solid $__primarycolor;\n                        }\n                    }\n                }\n            }\n            @include respond-below(custom991) {\n                .has-submenu {\n                    ul {\n                        display: none;\n                        background: $__primarylight;\n                    }\n                }\n            }\n            li.login-link {\n                display: $__none;\n                @include respond-below(custom991) {\n                    display: block;\n                }\n            }\n        }\n    }\n    .header-navbar-rht {\n        margin: 0;\n        padding: 0;\n        @include respond-below(custom575) {\n            display: none;\n        }\n        >li {\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            padding-right: 15px;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:last-child {\n                padding-right:0px;\n            }\n            .dropdown-menu {\n                border: 0;\n                box-shadow: 0 0 3px rgb(0 0 0 / 10%);\n                .dropdown-item {\n                    border-top: 1px solid $__cylindrical;\n                    padding: 10px 15px;\n                    font-size: 0.9375rem;\n                    font-weight: $__semibold;\n                    &:hover {\n                        color: $__primarycolor;\n                    }\n                    &:last-child {\n                        border-top: 0;\n\t                    border-radius: 5px 5px 0 0;\n                    }\n                    &:first-child {\n                        border-radius: 0 0 5px 5px;\n                    }\n                }\n            }            \n        }\n        .nav-item { \n            span{\n                @include margin-padding(0 8px 0 0, null);\n            }\n            .add-listing {\n                font-weight: $__medium;\n                font-size: $__font__size__16;\n                color: $__goose-gray;\n                span {\n                    color: $__dark__blues;\n                }\n            }               \n            .header-login {\n                background-color: $__goose-gray;\n                border: 1px solid $__goose-gray;                \n                box-shadow: inset 0 0 0 $__white;\n                color: $__white;                \n                border-radius: 5px;\n                font-weight: $__medium;\n                font-size: $__font__size__16;\n                @include margin-padding(null, 10px 20px);\n                text-align: $__center;\n                @extend %animation-effect;\n                    @include respond-below(custom991){\n                        @include margin-padding(null, 8px 12px);\n                        font-size: $__font__size__14;\n                    }\n                &:hover {\n                    background-color: $__white;\n                    border: 1px solid $__goose-gray;\n                    box-shadow: inset 0 70px 0 0 $__white;\n                    color: $__goose-gray;\n                    @extend %animation-effect;\n                }\n            }\n            .header-reg {\n                background-color: $__primarycolor;\n                border: 1px solid $__primarycolor;                \n                box-shadow: inset 0 0 0 $__white;                \n                color: $__white;\n                border-radius: 5px;\n                font-weight: $__medium;\n                font-size: $__font__size__16;\n                @include margin-padding(null, 10px 20px);\n                @extend %animation-effect;\n                    @include respond-below(custom991){\n                        @include margin-padding(null, 8px 12px);\n                        font-size: $__font__size__14;\n                    }\n                &:hover {\n                    background-color: $__white;\n                    border: 1px solid $__primarycolor;\n                    box-shadow: inset 0 70px 0 0 $__white;\n                    color: $__primarycolor;\n                    @extend %animation-effect;\n                }\n            }\n        }\n    }\n    .dropdown-toggle {\n\t\t&::after {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n.menu-opened {\n    .main-menu-wrapper {\n        transform: translateX(0);\n        body {\n            overflow: hidden;\n        }\n    }\n}\n\n// Modern Header Styling\n.header-modern {\n    background: rgba(10, 10, 10, 0.95) !important;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5) !important;\n    border-bottom: 1px solid rgba(255, 193, 7, 0.1);\n\n    .header-nav {\n        display: grid !important;\n        grid-template-columns: 1fr 2fr 1fr !important;\n        align-items: center !important;\n\n        @include respond-below(custom991) {\n            display: flex !important;\n            justify-content: space-between !important;\n        }\n    }\n\n    .navbar-header {\n        justify-content: flex-start !important;\n    }\n\n    .logo-modern {\n        animation: logoEntrance 0.8s ease-out;\n\n        img {\n            max-height: 50px !important;\n            animation: logoSpin 0.8s ease-out;\n\n            @include respond-below(custom991) {\n                max-height: 40px !important;\n            }\n        }\n\n        .brand-text-modern {\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n            animation: logoTextSlide 0.8s ease-out;\n\n            .brand-name {\n                font-size: 1.35rem;\n                font-weight: 800;\n                color: $__white;\n                letter-spacing: 1px;\n                line-height: 1;\n\n                @include respond-below(custom991) {\n                    font-size: 1.2rem;\n                }\n            }\n\n            .brand-tagline {\n                font-size: 0.75rem;\n                color: $__golden__yellow;\n                font-weight: $__semibold;\n                letter-spacing: 2px;\n                text-transform: uppercase;\n                animation: taglineGlow 2s ease-in-out infinite;\n\n                @include respond-below(custom991) {\n                    font-size: 0.7rem;\n                }\n            }\n        }\n\n        &:hover {\n            img {\n                animation: logoHoverSpin 0.6s ease-in-out;\n            }\n        }\n    }\n\n    .logo-small {\n        img {\n            max-height: 40px !important;\n        }\n    }\n\n    .main-menu-wrapper {\n        display: flex !important;\n        justify-content: center !important;\n\n        @include respond-below(custom991) {\n            display: block !important;\n            justify-content: flex-start !important;\n            height: 100vh !important;\n            max-height: 100vh !important;\n            overflow-y: auto !important;\n        }\n\n        &.slide-nav {\n            @include respond-below(custom991) {\n                transform: translateX(0) !important;\n            }\n        }\n    }\n\n    .main-nav-modern {\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        gap: 40px !important;\n\n        @include respond-below(custom991) {\n            flex-direction: column;\n            gap: 0 !important;\n            justify-content: flex-start !important;\n            width: 100%;\n            align-items: flex-start !important;\n        }\n\n        > li {\n            position: $__relative;\n\n            @include respond-below(custom991) {\n                width: 100%;\n                border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n            }\n\n            > a {\n                color: rgba(255, 255, 255, 0.9) !important;\n                font-weight: $__semibold !important;\n                font-size: 15px !important;\n                transition: all 0.3s ease !important;\n                position: $__relative;\n                display: inline-block !important;\n                line-height: 85px !important;\n\n                @include respond-below(custom991) {\n                    line-height: 50px !important;\n                    display: block !important;\n                    padding: 0 20px;\n                    width: 100%;\n                }\n\n                &::after {\n                    content: '';\n                    position: $__absolute;\n                    bottom: 20px;\n                    left: 50%;\n                    transform: translateX(-50%) scaleX(0);\n                    width: 30px;\n                    height: 2px;\n                    background: linear-gradient(135deg, #FFC107, #FF9800);\n                    transition: transform 0.3s ease;\n\n                    @include respond-below(custom991) {\n                        display: none;\n                    }\n                }\n\n                &:hover {\n                    color: $__golden__yellow !important;\n\n                    &::after {\n                        transform: translateX(-50%) scaleX(1);\n                    }\n                }\n            }\n\n            &.active {\n                > a {\n                    color: $__golden__yellow !important;\n\n                    &::after {\n                        transform: translateX(-50%) scaleX(1);\n                    }\n                }\n            }\n        }\n    }\n\n    .header-cta-modern {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end !important;\n        gap: 12px;\n\n        @include respond-below(custom991) {\n            display: none;\n        }\n\n        .btn-header-call {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            padding: 10px 20px;\n            background: rgba(255, 255, 255, 0.05);\n            border: 1px solid rgba(255, 255, 255, 0.1);\n            border-radius: 50px;\n            color: $__white;\n            font-weight: $__semibold;\n            font-size: 14px;\n            text-decoration: none;\n            transition: all 0.3s ease;\n\n            i {\n                color: #28a745;\n                font-size: 16px;\n            }\n\n            &:hover {\n                background: rgba(255, 255, 255, 0.1);\n                border-color: rgba(255, 255, 255, 0.2);\n                color: $__white;\n                transform: translateY(-2px);\n            }\n        }\n\n        .btn-header-primary {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            padding: 10px 24px;\n            background: linear-gradient(135deg, #FFC107, #FF9800);\n            border-radius: 50px;\n            color: #1a1a1a;\n            font-weight: $__bold;\n            font-size: 14px;\n            text-decoration: none;\n            transition: all 0.3s ease;\n            box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);\n\n            i {\n                font-size: 16px;\n            }\n\n            &:hover {\n                transform: translateY(-2px);\n                box-shadow: 0 6px 20px rgba(255, 193, 7, 0.4);\n                color: #000;\n            }\n        }\n    }\n}\n\n// Logo Animations\n@keyframes logoEntrance {\n    0% {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes logoSpin {\n    0% {\n        transform: rotate(-180deg) scale(0.5);\n        opacity: 0;\n    }\n    60% {\n        transform: rotate(10deg) scale(1.1);\n    }\n    100% {\n        transform: rotate(0deg) scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes logoTextSlide {\n    0% {\n        opacity: 0;\n        transform: translateX(-30px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes taglineGlow {\n    0%, 100% {\n        text-shadow: 0 0 5px rgba(255, 193, 7, 0.3);\n    }\n    50% {\n        text-shadow: 0 0 10px rgba(255, 193, 7, 0.6), 0 0 20px rgba(255, 193, 7, 0.3);\n    }\n}\n\n@keyframes logoHoverSpin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n","/*-----------------\n    7. Footer\n-----------------------*/\n\n.footer {\n\tbackground: $__gray__dark;\n\tposition: $__relative;\n\t&::before {\n\t\tcontent: \"\";\n\t\tbackground: url(../../../../public/assets/img/footer-left.png) no-repeat;\n\t\tposition: absolute;\n\t\ttop: 50px;\n\t\tleft: 0;\n\t\twidth: 97px;\n\t\theight: 102px;\n\t\tbackground-size: cover;\n\t\t\t@include respond-below(custom1199) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t}\n\t&::after {\n\t\tcontent: \"\";\n\t\tbackground: url(../../../../public/assets/img/footer-right.png) no-repeat;\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\twidth: 393px;\n\t\theight: 334px;\n\t\tbackground-size: cover;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t}\n\t.footer-top {\n\t\tposition: relative;\n\t\tz-index: 99;\n\t\t@include margin-padding(0, 60px 0);\n\t\t@include respond-below(custom991) {  \n\t\t\t@include margin-padding(0, 40px 0 10px);\n\t\t}\n\t\t@include respond-below(custom767) {  \n\t\t\t@include margin-padding(0, 40px 0 0);\n\t\t}\n\t}\n\t.footer-about {\n\t\tborder-right: 1px solid $__black;\n\t\t@include respond-below(custom767) { \n\t\t\tborder: 0;\n\t\t}\n\t}\n\t.footer-widget {\n\t\t.footer-logo {\n\t\t\tmargin-bottom: 35px;\n\t\t}\n\t\t.footer-about-content {\n\t\t\tmargin-bottom: 50px;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-weight: $__bold;\n\t\t\t\tcolor: $__dark__black;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t\t&.footer-menu {\n\t\t\tul {\n\t\t\t\tlist-style: $__none;\n\t\t\t\t@include margin-padding(0, 0);\n\t\t\t}\n\t\t}\n\t\t.footer-title {\n\t\t\tposition: $__relative;\n\t\t\tfont-size: $__font__size__20;\n\t\t\tfont-weight: $__bold;\n\t\t\tcolor: $__white;\n\t\t\t@include margin-padding(0 0 40px, null);\n\t\t\t&:before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tbackground: #FCB215;\n\t\t\t\twidth: 27px;\n\t\t\t\theight: 4px;\n\t\t\t\tleft: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -80%;\n\t\t\t}\n\t\t}\n\t\t@include respond-below(custom991) {  \n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t\t@include respond-below(custom767) {  \n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t}\n\t.footer-menu {\n\t\tul {\n\t\t\tli {\n\t\t\t\t@include margin-padding(0 0 20px, null);\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\ta {\n\t\t\t\t\tcolor: $__gray__lightdark;\n\t\t\t\t\t@include transition(all 0.5s ease-in-out);\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: $__primarycolor;\n\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\t@include transition(all 0.5s ease-in-out);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.footer-contact {\n\t\th5 {\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: $__font__size__24;\n\t\t\tcolor: #FFFFFF;\n\t\t\tmax-width: 336px;\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\th6 {\n\t\t\tfont-size: $__font__size__16;\n\t\t\tcolor: $__blue__light;\n\t\t\tmargin-bottom: 15px;\n\t\t\tline-height: 20px;\n\t\t}\n\t\t.footer-contact-info {\n\t\t\t.footer-address {\n\t\t\t\t@extend %display-flex;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\tspan {\n\t\t\t\t\tmargin-right: 20px;\n\t\t\t\t\twidth: 50px;\n\t\t\t\t\theight: 50px;\n\t\t\t\t\tbackground: $__warningcolor;\n\t\t\t\t\tcolor: $__white;\n\t\t\t\t\tfont-size: $__font__size__20;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t@extend %flex-align-center;\n\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t}\n\t\t\t\t.addr-info {\n\t\t\t\t\t@extend %display-flex-center;\n\t\t\t\t\ta {\t\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tfont-size: $__font__size__18;\n\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.update-form {\n\t\t\t\tposition: relative;\n\t\t\t\tspan {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 10px;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\tcolor: $__gray__lightdark;\n\t\t\t\t\tfont-size: $__font__size__20;\n\t\t\t\t\tline-height: 1;\n\t\t\t\t}\n\t\t\t\t.form-control {\n\t\t\t\t\tmin-height: 55px;\n\t\t\t\t\tbackground: $__white;\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\tborder: 1px solid $__white;\n\t\t\t\t\tfont-size: $__font__size__14;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tpadding: 10px 100px 12px 40px;\n\t\t\t\t\tcolor: $__gray__lightdark;\n\t\t\t\t}\n\t\t\t\t.btn {\n\t\t\t\t\t@include margin-padding(null, 20px 20px);\n\t\t\t\t\tfont-size: $__font__size__15;\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tright: 10px;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t.feather-send {\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\t@extend %display-flex;\n\t\t\t\t\t}\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tborder-color: #FCB215;\n\t\t\t\t\t\t.feather-send {\n\t\t\t\t\t\t\tcolor: #FCB215;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t\t\n\t}\n\t.footer-bottom {\n\t\tbackground: $__goose-gray;\n\t\tposition: $__relative;\n    \tz-index: 99;\n\t\t@include margin-padding(0, 20px 0);\n\t\t@include respond-below(custom767) {  \n\t\t\t@include margin-padding(0, 15px 0);\n\t\t}\n\t\t.copyright {\n\t\t\t@include respond-below(custom767) {\n\t\t\t\ttext-align: $__center;\n\t\t\t}\n\t\t\t.copyright-text {\n\t\t\t\t@include respond-below(custom767) {\n\t\t\t\t\t@include margin-padding(0 0 20px, null);\n\t\t\t\t}\n\n\t\t\t\tp {\n\t\t\t\t\tcolor: $__white;\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.vistors-details {\n\t\t\t\tul {\n\t\t\t\t\tjustify-content: end;\n\t\t\t\t\t-webkit-justify-content: end;\n\t\t\t\t\t@include respond-below(custom767) { \n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t}\n\t\t\t\t\tli {\n\t\t\t\t\t\t@include margin-padding(0, 0 8px 0);\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tbackground: #ffffff;\n\t\t\t\t\t\t\twidth: 46px;\n\t\t\t\t\t\t\theight: 30px;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.policy-menu {\n\t\t    text-align: $__right;\n\t\t    margin: 0;\n\t\t    padding: 0;\n\t\t    @include respond-below(custom767) {\n\t\t\t\ttext-align: $__center;\n\t\t\t}\n\t\t    li {\n\t\t    \tdisplay: $__inline__block;\n    \t\t\tmargin-right: 30px;\n    \t\t\tposition: $__relative;\n    \t\t\t@include respond-below(custom767) {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t}\n    \t\t\ta {\n    \t\t\t\tcolor: $__black;\n    \t\t\t\t&:hover {\n    \t\t\t\t\tcolor: $__secondarycolor;\n    \t\t\t\t}\n    \t\t\t}\n    \t\t\t&::after {\n\t\t\t\t    content: \"\";\n\t\t\t\t    position: $__absolute;\n\t\t\t\t    background: $__secondarycolor;\n\t\t\t\t    width: 5px;\n\t\t\t\t    height: 5px;\n\t\t\t\t    left: -10px;\n\t\t\t\t    top: 50%;\n\t\t\t\t    transform: translateY(-50%);\n\t\t\t\t}\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t    }\n\t\t}\n\t}\n}\n@-webkit-keyframes toTopFromBottom {\n\t49% {\n\t\t-webkit-transform: translateY(-100%);\n\t}\n\t50% {\n\t\topacity: 0;\n\t\t-webkit-transform: translateY(100%);\n\t}\n\t51% {\n\t\topacity: 1;\n\t}\n}\n@-moz-keyframes toTopFromBottom {\n\t49% {\n\t\t-moz-transform: translateY(-100%);\n\t}\n\t50% {\n\t\topacity: 0;\n\t\t-moz-transform: translateY(100%);\n\t}\n\t51% {\n\t\topacity: 1;\n\t}\n}\n@keyframes toTopFromBottom {\n\t49% {\n\t\ttransform: translateY(-100%);\n\t}\n\t50% {\n\t\topacity: 0;\n\t\ttransform: translateY(100%);\n\t}\n\t51% {\n\t\topacity: 1;\n\t}\n}\n.footer-social-links {\n    @include margin-padding(10px 0 30px, null);\n    h6 {\n        font-size: $__font__size__18;\n        color: $__white;\n        margin-bottom: 15px;\n        @include respond-below(custom767) {\n            margin-bottom: 10px;\n        }\n    }\n    .nav {\n       @extend %flex-align-center;\n        li {\n            margin-right: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n            a {\n                &:hover {\n                    color: $__black;\n                }\n            }\n        }\n    }\n}\n\n.footer-social-widget {\n\t@include margin-padding(20px 0 0, null);\n\t.nav-social {\n\t\t@extend %display-flex;\n\t\t@extend %jusflex-start;\n\t\tli {\n\t\t\tmargin-right: 10px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t\ta {\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: $__black;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.hi-icon {\n    @extend %flex-align-center;\n    font-size: 0px;\n    cursor: $__pointer;\n    text-align: $__center;\n    position: $__relative;\n    z-index: 1;\n    overflow: $__hidden;\n    color: $__goose-gray;\n    background: $__blue__light;\n    border-radius: 50px;\n    min-width: 36px;\n    height: 36px;\n    -webkit-transition: background 0.3s, color 0.3s, box-shadow 0.3s;\n    -moz-transition: background 0.3s, color 0.3s, box-shadow 0.3s;\n    transition: background 0.3s, color 0.3s, box-shadow 0.3s;\n    @include respond-below(custom767) {\n        min-width: 36px;\n        height: 36px;\n    }\n    &:after {\n        pointer-events: $__none;\n        position: $__absolute;\n        width: $__full__width;\n        height: $__full__height;\n        border-radius: 0;\n        content: '';\n        -webkit-box-sizing: content-box;\n        -moz-box-sizing: content-box;\n        box-sizing: content-box;\n        display: $__none;\n    }\n    &:before {\n        speak: $__none;\n        font-size: $__font__size__18;\n        line-height: 20px;\n        font-style: $__normal;\n        font-weight: $__normal;\n        font-variant: $__normal;\n        text-transform: $__none;\n        display: $__block;\n        -webkit-font-smoothing: antialiased;\n        @include respond-below(custom767) {\n            font-size: $__font__size__15;\n        }\n    }\n    &:hover {\n        color: $__goose-gray;\n        &:before {\n            -webkit-animation: toTopFromBottom 0.5s forwards;\n            -moz-animation: toTopFromBottom 0.5s forwards;\n            animation: toTopFromBottom 0.5s forwards;\n        }\n    }\n}\n.fi-icon {\n    @extend %flex-align-center;\n    font-size: 0px;\n    cursor: $__pointer;\n    text-align: $__center;\n    position: $__relative;\n    z-index: 1;\n    overflow: $__hidden;\n    border-radius: 50px;\n    min-width: 36px;\n    height: 36px;\n    -webkit-transition: background 0.3s, color 0.3s, box-shadow 0.3s;\n    -moz-transition: background 0.3s, color 0.3s, box-shadow 0.3s;\n    transition: background 0.3s, color 0.3s, box-shadow 0.3s;\n    @include respond-below(custom767) {\n        min-width: 36px;\n        height: 36px;\n    }\n    &:after {\n        pointer-events: $__none;\n        position: $__absolute;\n        width: $__full__width;\n        height: $__full__height;\n        border-radius: 0;\n        content: '';\n        -webkit-box-sizing: content-box;\n        -moz-box-sizing: content-box;\n        box-sizing: content-box;\n        display: $__none;\n    }\n    &:before {\n        speak: $__none;\n        font-size: $__font__size__18;\n        line-height: 20px;\n        font-style: $__normal;\n        font-weight: $__normal;\n        font-variant: $__normal;\n        text-transform: $__none;\n        display: $__block;\n        -webkit-font-smoothing: antialiased;\t\t\n\t\tcolor: $__white;\n        @include respond-below(custom767) {\n            font-size: $__font__size__15;\n        }\n    }\n    &:hover {\n        color: $__goose-gray;\n        &:before {\n            -webkit-animation: toTopFromBottom 0.5s forwards;\n            -moz-animation: toTopFromBottom 0.5s forwards;\n            animation: toTopFromBottom 0.5s forwards;\n        }\n    }\n}\n\n// Modern Footer Styling\n.footer-modern {\n    background: linear-gradient(180deg, #0a0a0a 0%, #000000 100%);\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background: linear-gradient(90deg, transparent, rgba(255, 193, 7, 0.3), transparent);\n    }\n\n    .footer-content-modern {\n        padding: 80px 0 40px;\n\n        @media (max-width: 991px) {\n            padding: 60px 0 30px;\n        }\n\n        @media (max-width: 767px) {\n            padding: 40px 0 20px;\n        }\n    }\n\n    .footer-widget-modern {\n        h4 {\n            color: white;\n            font-size: 24px;\n            font-weight: 800;\n            margin-bottom: 15px;\n            background: linear-gradient(135deg, #FFC107, #FF9800);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-clip: text;\n        }\n\n        .footer-desc-modern {\n            color: rgba(255, 255, 255, 0.7);\n            font-size: 15px;\n            line-height: 1.7;\n            margin-bottom: 25px;\n\n            @media (max-width: 991px) {\n                font-size: 14px;\n            }\n        }\n\n        .footer-social-modern {\n            display: flex;\n            gap: 12px;\n\n            a {\n                width: 40px;\n                height: 40px;\n                border-radius: 50%;\n                background: rgba(255, 255, 255, 0.05);\n                border: 1px solid rgba(255, 255, 255, 0.1);\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: white;\n                font-size: 16px;\n                transition: all 0.3s ease;\n\n                &:hover {\n                    background: linear-gradient(135deg, #FFC107, #FF9800);\n                    border-color: transparent;\n                    color: #1a1a1a;\n                    transform: translateY(-3px);\n                }\n            }\n        }\n\n        .footer-title-modern {\n            color: white;\n            font-size: 18px;\n            font-weight: bold;\n            margin-bottom: 20px;\n            position: relative;\n            padding-bottom: 12px;\n\n            &::after {\n                content: '';\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                width: 40px;\n                height: 2px;\n                background: linear-gradient(135deg, #FFC107, #FF9800);\n            }\n\n            @media (max-width: 991px) {\n                font-size: 16px;\n            }\n        }\n\n        .footer-links-modern {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n\n            li {\n                margin-bottom: 12px;\n\n                a {\n                    color: rgba(255, 255, 255, 0.7);\n                    font-size: 14px;\n                    text-decoration: none;\n                    transition: all 0.3s ease;\n                    display: inline-block;\n                    position: relative;\n\n                    &::before {\n                        content: '';\n                        position: absolute;\n                        left: -15px;\n                        top: 50%;\n                        transform: translateY(-50%) scaleX(0);\n                        width: 8px;\n                        height: 2px;\n                        background: #FFC107;\n                        transition: transform 0.3s ease;\n                    }\n\n                    &:hover {\n                        color: #FFC107;\n                        padding-left: 15px;\n\n                        &::before {\n                            transform: translateY(-50%) scaleX(1);\n                        }\n                    }\n                }\n            }\n        }\n\n        .footer-contact-modern {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n\n            li {\n                display: flex;\n                align-items: flex-start;\n                gap: 12px;\n                margin-bottom: 15px;\n                color: rgba(255, 255, 255, 0.7);\n                font-size: 14px;\n\n                i {\n                    color: #FFC107;\n                    font-size: 16px;\n                    margin-top: 2px;\n                    flex-shrink: 0;\n                }\n\n                a {\n                    color: rgba(255, 255, 255, 0.7);\n                    text-decoration: none;\n                    transition: color 0.3s ease;\n\n                    &:hover {\n                        color: #FFC107;\n                    }\n                }\n            }\n        }\n\n        .footer-hours-modern {\n            padding: 15px;\n            background: rgba(255, 255, 255, 0.03);\n            border-radius: 10px;\n            border: 1px solid rgba(255, 255, 255, 0.05);\n\n            p {\n                color: rgba(255, 255, 255, 0.7);\n                font-size: 13px;\n                margin-bottom: 5px;\n                line-height: 1.6;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n\n                strong {\n                    color: white;\n                }\n            }\n        }\n    }\n\n    .footer-compliance-modern {\n        background: rgba(255, 255, 255, 0.02);\n        border-top: 1px solid rgba(255, 255, 255, 0.05);\n        border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n        padding: 30px 0;\n\n        @media (max-width: 991px) {\n            padding: 20px 0;\n        }\n\n        .compliance-logos {\n            display: flex;\n            gap: 20px;\n            margin-bottom: 15px;\n            flex-wrap: wrap;\n\n            .compliance-logo {\n                text-decoration: none;\n\n                .anpc-placeholder,\n                .sal-placeholder {\n                    width: 80px;\n                    height: 50px;\n                    background: rgba(255, 255, 255, 0.05);\n                    border: 2px solid rgba(255, 255, 255, 0.1);\n                    border-radius: 8px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    color: #FFC107;\n                    font-weight: bold;\n                    font-size: 14px;\n                    transition: all 0.3s ease;\n\n                    @media (max-width: 767px) {\n                        width: 70px;\n                        height: 45px;\n                        font-size: 12px;\n                    }\n                }\n\n                &:hover {\n                    .anpc-placeholder,\n                    .sal-placeholder {\n                        background: rgba(255, 193, 7, 0.1);\n                        border-color: rgba(255, 193, 7, 0.3);\n                        transform: translateY(-2px);\n                    }\n                }\n            }\n        }\n\n        .compliance-text {\n            color: rgba(255, 255, 255, 0.6);\n            font-size: 12px;\n            line-height: 1.6;\n            margin: 0;\n            max-width: 700px;\n\n            @media (max-width: 767px) {\n                font-size: 11px;\n            }\n        }\n\n        .compliance-links {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            margin-top: 15px;\n\n            @media (max-width: 991px) {\n                margin-top: 20px;\n            }\n\n            a {\n                color: rgba(255, 255, 255, 0.7);\n                font-size: 12px;\n                text-decoration: none;\n                transition: color 0.3s ease;\n                display: flex;\n                align-items: center;\n                gap: 6px;\n\n                &::before {\n                    content: '→';\n                    color: #FFC107;\n                }\n\n                &:hover {\n                    color: #FFC107;\n                }\n            }\n        }\n    }\n\n    .footer-bottom-modern {\n        padding: 25px 0;\n\n        @media (max-width: 991px) {\n            padding: 20px 0;\n        }\n\n        .copyright-modern,\n        .legal-info-modern {\n            color: rgba(255, 255, 255, 0.5);\n            font-size: 13px;\n            margin: 0;\n\n            @media (max-width: 767px) {\n                font-size: 12px;\n                text-align: center !important;\n                margin-bottom: 10px;\n            }\n        }\n    }\n}\n","/*-----------------\n    8. Breadcrumb\n-----------------------*/\n\n.breadcrumb-bar {\n    background: $__gray__dark;\n    padding: 60px 0 60px;\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    @include respond-below(custom991) {\n        padding: 50px 0 50px;\n     } \n    &:before {\n\t\tcontent: \"\";\n        background: url(../../../../public/assets/img/breadcrumbleft.png) no-repeat;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 393px;\n        height: 334px;\n        background-size: cover;\n        @include respond-below(custom991) {\n            display: none;\n        } \n\t}\n    &:after {\n\t\tcontent: \"\";\n        background: url(../../../../public/assets/img/breadcrumbright.png) no-repeat;\n        position: absolute;\n        bottom: 50px;\n        right: 130px;\n        width: 97px;\n        height: 102px;\n        background-size: cover;\n        @include respond-below(custom991) {\n           display: none;\n        } \n\t}\n    .breadcrumb-title {\n        font-weight: 700;\n        color: $__white;\n        font-size: $__font__size__36;\n        @include margin-padding(0 0 15px, null);\n        @include respond-below(custom991) {\n            font-size: $__font__size__32;\n        } \n    }\n    .breadcrumb {\n        justify-content: center;\n        margin: 0;\n        li {\n            a {\n                color: $__white;\n            }\n        }\n        &.active {\n            color: $__white;\n        }\n      }\n    .breadcrumb-item+.breadcrumb-item {\n        &::before {\n            color: $__white;\n        }\n    }\n    .breadcrumb-item.active {\n        color: $__primarycolor;\n    }\n      \n      \n}","/*-----------------\n    9. Select\n-----------------------*/\n\n.select2-container {\n    min-width: 100% !important;\n    width: $__auto !important;\n    z-index: 99;    \n    padding: 0 !important;\n    color: $__black_color;\n    .select2-selection--single {\n        height: 43px;\n    }\n}\n.select2-container--default {\n    .select2-selection--single {        \n        background: $__cylindrical;\n        border: 1px solid $__light__gooses;\n        @include rounded(5px);\n        .select2-selection__rendered {\n            color:$__gray15;\n            line-height: 40px;\n            @include rounded(5px);\n            padding-right: 30px;\n            padding-left: 15px;\n        }\n        .select2-selection__arrow {\n            height: 40px;\n            right: 6px;\n        }\n    }  \n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n    @include position($__absolute,50%,null,null,50%);\n    border-color: $__gray15;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    height: 0;\n    margin-left: -10px;\n    margin-top: -3px;\n    width: 0;\n    @include transform(rotate(45deg) translateY(-50%));\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n    border-color: $__gray15;\n    border-width: 2px 0 0 2px;\n    margin-top: 3px;\n    @include margin-padding(null, 3px);\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background: $__dark__blues;\n    color: $__white;\n}\n.select2-container--focus  {\n    .select2-selection--single{\n        background: $__white !important;\n        border: 1px solid $__dark__blues;\n    }\n}\nspan.select2-container.select2-container--default.select2-container--open {\n    z-index: 9999;\n}\n","/*-----------------\n    10. Table\n-----------------------*/\n\n.table {\n\tcolor: $__gray;\n\tmax-width: $__full__width;\n\tmargin-bottom: 0;\n\twidth: $__full__width;\n    .dataTable {\n        border-collapse: collapse !important;\n    }\n    .table-avatar {\n        align-items: $__center;\n        display: $__inline__flex;\n        font-size: $__inherit;\n        font-weight: $__medium;\n        margin: 0;\n        padding: 0;\n        vertical-align: $__middle;\n        white-space: $__nowrap;\n        min-width: 150px;\n        font-size: $__font__size__14;\n    }\n    .thead-light {\n        th {\n            font-size: $__font__size__15;\n            color: $__goose-gray;\n            font-weight: $__medium;\n            background-color: $__light__gooses;\n            @include margin-padding(null, 15px);\n        }\n    }\n    thead {\n        background-color: $__light__gooses;\n        border-bottom: 0;\n        vertical-align: $__middle;\n        white-space:$__nowrap;\n     }\n     tbody{\n        vertical-align: $__middle;\n        white-space: $__nowrap;\n        tr {\n            border-bottom: 1pt solid #F1F1F1;\n            td{\n                border-color: $__ash;\n                 @include margin-padding(null, 15px);\n            }\n         }\n        td {\n            h2 {\n                display: $__inline__block;\n                font-size: $__inherit;\n                font-weight: $__regular;\n                margin: 0;\n                padding: 0;\n                vertical-align: $__middle;\n                span {\n                    color: $__dark__gray;\n                    display: $__block;\n                    font-size: $__font__size__13;\n                    margin-top: 2px;\n                }\n            }\n            a {\n                color: $__gray;\n                @extend %display-flex;\n                @extend %align-items-center;\n                &.btn-action-icon{\n                    background: $__smoke__white;\n                    color: $__gray__dark;\n                    width: 28px;\n                    height: 28px;\n                    padding: 0;\n                    @extend %flex-align-center;\n                    border-radius: 50px;\n                    &:active {\n                        color: $__primarycolor;\n                    }\n                }\n                + a{\n                    display: $__inline__block;\n                }\n                &.add-btn {\n                    display: $__inline__block !important;\n                }\n                &:hover {\n                    color: $__primarycolor;\n                }\n                &:active {\n                    color: $__white;\n                }\n                &.btn{\n                    display: $__inline__block;\n                    @include margin-padding(null, 5px 10px);\n                }\n            }\n            .items-links {\n                color: $__graybackblue;\n                display: $__inline__block;\n                &:hover {\n                    color: $__primarycolor;\n                } \n            }\n        }\n     }\n     \n    .invoice-link {\n        color: $__gray__dark;\n        display: inline-block;\n        &:hover {\n            color: $__secondarycolor;\n    }\n    .table-center {\n        th,td {\n            vertical-align: $__middle;\n        }\n    }\n    .dropdown-menu {\n        width: 200px;\n        background: $__white;\n        border: 1px solid $__dark__gray;\n        box-shadow: 0px 4px 4px $__dark__gray;\n        margin-top: 10px !important;\n        @include rounded(6px);\n    }\n     .dropdown-item {\n        font-weight: $__medium;\n        font-size: $__font__size__13;\n        color: $__graybackblue;\n        display: $__flex;\n        align-items: $__center;\n        margin-bottom: 14px;\n        &:last-child {\n            margin-bottom: 0;\n        }\n        &:focus,&:hover {\n            color: $__primarycolor;\n            background: $__transparent;\n        }\n        &.active{\n            color: $__white;\n            text-decoration: $__none;\n            background-color: $__primarycolor;\n        }\n        i {\n            font-size: 16px;\n        }\n    }\n    }\n}\n.table {\n    .dropdown-menu {\n        width: 160px;\n        background: $__white;\n        border: 1px solid $__cloud__grays;\n        box-shadow: 0px 16px 32px $__dark__gray;\n        @include rounded(12px);\n        padding: 0;\n        margin-top: 10px !important;\n    }\n    .dropdown-item {\n        font-weight: $__medium;\n        font-size: $__font__size__13;\n        color: $__gray__dark;\n        @extend %flex-align-center;\n        @extend %jusflex-start;\n        padding: 10px 20px 10px;\n    }\n}\n\n.table-inbox {\n    font-size: $__font__size__15;\n    margin-bottom: 0;\n}\n.table-nowrap {\n    th,td {\n        white-space: $__nowrap\n    }\n}\n.table-striped  {\n    > tbody  {\n        > tr:nth-of-type(2n+1) {\n            background-color: #f8f9fa;\n        }\n    }\n    .dropdown-action {\n        margin-bottom: 0;\n    }\n    .table-bordered {\n        border: 1px solid rgba(0, 0, 0, 0.05) !important;\n    }\n}\n.table.no-border > tbody > tr > td,\n.table > tbody > tr > th,\n.table.no-border > tfoot > tr > td,\n.table.no-border > tfoot > tr > th,\n.table.no-border > thead > tr > td,\n.table.no-border > thead > tr > th { \n    @include margin-padding(null, 10px 8px);\n}\n\n.table-hover {\n    tbody {\n        tr{\n            &:hover {\n                background-color: #f6f6f7;\n            }\n        }\n    }\n}\n.table-bordered{\n    th{\n        border-color: rgba(0, 0, 0, 0.05);\n    }\n    td{\n        border-color: rgba(0, 0, 0, 0.05);\n        &:first-child{  \n            border-top-left-radius: 0 !important;\n            border-bottom-left-radius: 0 !important;\n        }\n        &:last-child{\n            border-top-right-radius: 0 !important;\n            border-bottom-right-radius: 0 !important;\n        }\n\n    }\n}\n\n\n.card-table {\n    .card-body {\n        @include margin-padding(null, 0  !important);        \n        .table {\n            > thead {\n                > tr {\n                    > th {\n                        border-top: 0;\n                    }\n                }\n            }\n            td {\n                color: $__gray__dark;\n                font-weight: $__regular;\n                border-top:0;\n                font-size: $__font__size__13;\n               @include margin-padding(null, 15px 25px);\n                white-space: $__nowrap;\n                box-shadow: none;\n                &:first-child{\n                    padding-left: 25px; \n                }\n            }\n            th {\n                white-space: $__nowrap;\n                @include margin-padding(null, 12px 25px);\n                border-bottom: 0;\n                font-weight: $__medium;\n                font-size: $__font__size__14;;\n                color: $__secondarycolor;\n                &:first-child{\n                    padding-left: 25px; \n                }\n            }\n        }\n    }\n}\n\n.table>:not(:first-child) {\n\tborder: 0;\n}\n \n.dataTables_length select {\n    appearance: $__auto;\n}\n.table-nosearch{\n    .dataTables_length,\n    .dataTables_filter{\n        display: $__none;\n    }\n}\n.card-table {\n\tdiv {\n\t\t&.table-responsive {\n\t\t\t& > div {\n\t\t\t\t&.dataTables_wrapper {\n\t\t\t\t\t& > div {\n\t\t\t\t\t\t&.row {\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\tpadding:1.5rem 1.5rem 0 !important;\n                                align-items: center;\n\t\t\t\t\t\t\t}\n                            &:last-child {\n\t\t\t\t\t\t\t\tpadding:0 1.5rem 1.5rem !important ;\n                                align-items: center;\n\t\t\t\t\t\t\t}\n                        }\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n \n.dataTables_length select {\n    appearance: auto;\n}\ntable {\n    .badge {\n        @include rounded(4px);\n        display: inline-block;\n        font-size: $__font__size__13;\n        min-width: auto;\n        @include margin-padding(null, 8px 10px);\n        font-weight: $__regular;\n        text-align: center;\n    }\n}\n.table {\n    tbody {\n        td {\n            a {\n                color: #0052ea;\n                &.action-icon{\n                    color: #333;\n                }\n            }\n            h2.table-avatar{\n                a{\n                    color: $__grayish__blue;\n                    &:hover {\n                        color: $__primarycolor;\n                    }\n                }\n            }\n        }\n    }\n}\n.mini-sidebar {\n    .header {\n        .header-left.header-left-two{\n            .logo.logo-small {\n                padding: 10px 0 0;\n                margin: 0;\n            }\n        }\n    }\n}\n.categories-table{\n   .table{\n        tr:last-child td {\n            padding-bottom: 0;\n            border: none;\n        }\n        td {\n            padding: 8px;\n            font-size: $__font__size__14;\n        }\n   }\n}\n.card-table{\n    .table{\n        background: $__white;\n        margin-bottom: 24px  !important;\n        border-radius: 8px;\n    }\n}\n.dataTables_length label {\n    font-weight: $__medium !important;\n    font-size: $__font__size__14;\n    color: $__grayish__blue;\n}\n.dataTables_length label:before {\n    content: \"Show\";\n    margin-right: 5px;\n    font-size: $__font__size__12;\n}\n.dataTables_length label:after {\n    content: \"Entries\";\n    margin-left: 5px;\n    font-size: $__font__size__12;\n}","/*-----------------\n    11. Home\n-----------------------*/\n\n.section {\n    position: $__relative;\n    @include margin-padding(null, 80px 0);\n    @include respond-below(custom991) {\n        @include margin-padding(null, 50px 0);\n    } \n}\n// Modern Hero Section\n.hero-section-modern {\n    position: $__relative;\n    min-height: 60vh;\n    display: flex;\n    align-items: center;\n    background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 50%, #0a0a0a 100%);\n    overflow: hidden;\n    @include margin-padding(null, 80px 0 60px);\n\n    @include respond-below(custom991) {\n        min-height: 55vh;\n        @include margin-padding(null, 60px 0 50px);\n    }\n\n    @include respond-below(custom479) {\n        min-height: 50vh;\n        @include margin-padding(null, 50px 0 40px);\n    }\n\n    // Background overlay with subtle gradient\n    .hero-background-overlay {\n        position: $__absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: radial-gradient(circle at 30% 50%, rgba(255, 193, 7, 0.08) 0%, transparent 50%),\n                    radial-gradient(circle at 70% 50%, rgba(33, 150, 243, 0.06) 0%, transparent 50%);\n        pointer-events: none;\n        animation: gradientShift 15s ease infinite;\n    }\n\n    // Animated background elements\n    .hero-animated-bg {\n        position: $__absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        overflow: hidden;\n        pointer-events: none;\n\n        .floating-element {\n            position: $__absolute;\n            border-radius: 50%;\n            background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 152, 0, 0.05));\n            filter: blur(60px);\n            animation: float 20s ease-in-out infinite;\n\n            @include respond-below(custom991) {\n                display: none;\n            }\n        }\n\n        .floating-element-1 {\n            width: 300px;\n            height: 300px;\n            top: 10%;\n            left: 10%;\n            animation-delay: 0s;\n        }\n\n        .floating-element-2 {\n            width: 200px;\n            height: 200px;\n            top: 60%;\n            right: 15%;\n            animation-delay: 7s;\n        }\n\n        .floating-element-3 {\n            width: 150px;\n            height: 150px;\n            bottom: 20%;\n            left: 50%;\n            animation-delay: 14s;\n        }\n    }\n\n    // Content wrapper\n    .hero-content-wrapper {\n        position: $__relative;\n        z-index: 10;\n    }\n\n    // Center text content\n    .hero-text-center {\n        text-align: $__center;\n        padding: 0 15px;\n    }\n\n    // Premium badge\n    .hero-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        background: rgba(255, 255, 255, 0.1);\n        backdrop-filter: blur(10px);\n        border: 1px solid rgba(255, 255, 255, 0.15);\n        border-radius: 50px;\n        padding: 8px 24px;\n        margin-bottom: 30px;\n        color: $__white;\n        font-size: 14px;\n        font-weight: $__medium;\n        letter-spacing: 0.5px;\n        animation: badgePulse 3s ease-in-out infinite;\n\n        @include respond-below(custom991) {\n            padding: 6px 18px;\n            font-size: 13px;\n            margin-bottom: 20px;\n        }\n\n        i {\n            color: $__golden__yellow;\n            font-size: 16px;\n            animation: iconSpin 4s linear infinite;\n        }\n    }\n\n    // Main title\n    .hero-title {\n        font-size: 72px;\n        font-weight: 800;\n        color: $__white;\n        line-height: 1.1;\n        margin-bottom: 25px;\n        letter-spacing: -0.02em;\n\n        @include respond-below(custom991) {\n            font-size: 48px;\n            margin-bottom: 20px;\n        }\n\n        @include respond-below(custom767) {\n            font-size: 36px;\n        }\n\n        .hero-title-highlight {\n            background: linear-gradient(135deg, #FFC107 0%, #FF9800 50%, #FFC107 100%);\n            background-size: 200% auto;\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-clip: text;\n            display: inline-block;\n            animation: gradientText 4s ease infinite;\n        }\n    }\n\n    // Description\n    .hero-description {\n        font-size: 18px;\n        line-height: 1.7;\n        color: rgba(255, 255, 255, 0.8);\n        margin-bottom: 40px;\n        max-width: 700px;\n        margin-left: auto;\n        margin-right: auto;\n\n        @include respond-below(custom991) {\n            font-size: 16px;\n            margin-bottom: 30px;\n        }\n\n        @include respond-below(custom767) {\n            font-size: 15px;\n            br {\n                display: none;\n            }\n        }\n    }\n\n    // Action buttons\n    .hero-actions {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 16px;\n        margin-bottom: 60px;\n        flex-wrap: wrap;\n\n        @include respond-below(custom991) {\n            margin-bottom: 40px;\n        }\n    }\n\n    .btn-hero {\n        display: inline-flex;\n        align-items: center;\n        gap: 10px;\n        padding: 16px 32px;\n        border-radius: 50px;\n        font-size: 16px;\n        font-weight: $__semibold;\n        text-decoration: none;\n        transition: all 0.3s ease;\n        border: 2px solid transparent;\n\n        @include respond-below(custom991) {\n            padding: 14px 28px;\n            font-size: 15px;\n        }\n\n        @include respond-below(custom767) {\n            padding: 12px 24px;\n            font-size: 14px;\n        }\n\n        i {\n            font-size: 18px;\n            transition: transform 0.3s ease;\n        }\n\n        &:hover i {\n            transform: translateX(4px);\n        }\n    }\n\n    .btn-hero-primary {\n        background: linear-gradient(135deg, #FFC107 0%, #FF9800 50%, #FFC107 100%);\n        background-size: 200% auto;\n        color: #1a1a1a;\n        box-shadow: 0 8px 24px rgba(255, 193, 7, 0.3);\n        position: $__relative;\n        overflow: hidden;\n\n        &::before {\n            content: '';\n            position: $__absolute;\n            top: 50%;\n            left: 50%;\n            width: 0;\n            height: 0;\n            border-radius: 50%;\n            background: rgba(255, 255, 255, 0.3);\n            transform: translate(-50%, -50%);\n            transition: width 0.6s, height 0.6s;\n        }\n\n        &:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 12px 32px rgba(255, 193, 7, 0.5);\n            color: #000;\n            animation: buttonShine 1.5s ease infinite;\n\n            &::before {\n                width: 300px;\n                height: 300px;\n            }\n        }\n    }\n\n    .btn-hero-secondary {\n        background: rgba(255, 255, 255, 0.1);\n        color: $__white;\n        border: 2px solid rgba(255, 255, 255, 0.2);\n        backdrop-filter: blur(10px);\n        position: $__relative;\n        overflow: hidden;\n\n        &::before {\n            content: '';\n            position: $__absolute;\n            top: 50%;\n            left: 50%;\n            width: 0;\n            height: 0;\n            border-radius: 50%;\n            background: rgba(255, 255, 255, 0.1);\n            transform: translate(-50%, -50%);\n            transition: width 0.6s, height 0.6s;\n        }\n\n        &:hover {\n            background: rgba(255, 255, 255, 0.15);\n            border-color: rgba(255, 255, 255, 0.3);\n            color: $__white;\n            transform: translateY(-2px);\n\n            &::before {\n                width: 300px;\n                height: 300px;\n            }\n        }\n    }\n\n    // Stats section\n    .hero-stats {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 40px;\n        padding: 30px;\n        background: rgba(255, 255, 255, 0.05);\n        backdrop-filter: blur(10px);\n        border-radius: 20px;\n        border: 1px solid rgba(255, 255, 255, 0.1);\n\n        @include respond-below(custom991) {\n            gap: 25px;\n            padding: 20px;\n        }\n\n        @include respond-below(custom767) {\n            flex-direction: column;\n            gap: 20px;\n        }\n    }\n\n    .hero-stat-item {\n        text-align: $__center;\n\n        .stat-value {\n            font-size: 36px;\n            font-weight: $__highbold;\n            color: $__white;\n            margin-bottom: 5px;\n            background: linear-gradient(135deg, #FFC107 0%, #FF9800 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-clip: text;\n\n            @include respond-below(custom991) {\n                font-size: 28px;\n            }\n        }\n\n        .stat-label {\n            font-size: 13px;\n            color: rgba(255, 255, 255, 0.6);\n            text-transform: uppercase;\n            letter-spacing: 1px;\n\n            @include respond-below(custom991) {\n                font-size: 12px;\n            }\n        }\n    }\n\n    .hero-stat-divider {\n        width: 1px;\n        height: 50px;\n        background: rgba(255, 255, 255, 0.15);\n\n        @include respond-below(custom767) {\n            display: none;\n        }\n    }\n\n    // Scroll Indicator\n    .scroll-indicator {\n        position: $__absolute;\n        bottom: 30px;\n        left: 50%;\n        transform: translateX(-50%);\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        cursor: pointer;\n        z-index: 100;\n        transition: all 0.3s ease;\n\n        @include respond-below(custom991) {\n            bottom: 20px;\n            gap: 4px;\n        }\n\n        @include respond-below(custom767) {\n            bottom: 15px;\n        }\n\n        &:hover {\n            .scroll-arrow i {\n                animation: arrowBounce 0.8s ease infinite;\n            }\n        }\n\n        .scroll-animation {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n\n        .scroll-mouse {\n            width: 22px;\n            height: 36px;\n            border: 2px solid rgba(255, 255, 255, 0.5);\n            border-radius: 20px;\n            position: $__relative;\n            display: flex;\n            justify-content: center;\n            align-items: flex-start;\n\n            @include respond-below(custom991) {\n                width: 20px;\n                height: 32px;\n            }\n\n            .scroll-wheel {\n                width: 3px;\n                height: 7px;\n                background: linear-gradient(135deg, #FFC107, #FF9800);\n                border-radius: 3px;\n                margin-top: 5px;\n                animation: scrollWheel 2s ease infinite;\n\n                @include respond-below(custom991) {\n                    width: 2px;\n                    height: 6px;\n                    margin-top: 4px;\n                }\n            }\n        }\n\n        .scroll-arrow {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            i {\n                color: $__golden__yellow;\n                font-size: 18px;\n                animation: arrowBounce 2s ease infinite;\n\n                @include respond-below(custom991) {\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n\n    // Decorative elements\n    .hero-decoration {\n        position: $__absolute;\n        border-radius: 50%;\n        filter: blur(100px);\n        opacity: 0.15;\n        pointer-events: none;\n        animation: decorationFloat 20s ease-in-out infinite;\n\n        @include respond-below(custom991) {\n            display: none;\n        }\n    }\n\n    .hero-decoration-1 {\n        width: 400px;\n        height: 400px;\n        background: linear-gradient(135deg, #FFC107, #FF9800);\n        top: -200px;\n        left: -200px;\n        animation-delay: 0s;\n    }\n\n    .hero-decoration-2 {\n        width: 300px;\n        height: 300px;\n        background: linear-gradient(135deg, #2196F3, #1976D2);\n        bottom: -150px;\n        right: -150px;\n        animation-delay: 10s;\n    }\n}\n\n// Keyframe Animations\n@keyframes float {\n    0%, 100% {\n        transform: translate(0, 0) scale(1);\n    }\n    33% {\n        transform: translate(30px, -30px) scale(1.1);\n    }\n    66% {\n        transform: translate(-20px, 20px) scale(0.9);\n    }\n}\n\n@keyframes gradientShift {\n    0%, 100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.8;\n    }\n}\n\n@keyframes badgePulse {\n    0%, 100% {\n        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.3);\n    }\n    50% {\n        box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);\n    }\n}\n\n@keyframes iconSpin {\n    0% {\n        transform: rotate(0deg);\n    }\n    10% {\n        transform: rotate(10deg);\n    }\n    20% {\n        transform: rotate(-10deg);\n    }\n    30% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(0deg);\n    }\n}\n\n@keyframes gradientText {\n    0%, 100% {\n        background-position: 0% 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n}\n\n@keyframes buttonShine {\n    0%, 100% {\n        background-position: 0% 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n}\n\n@keyframes scrollWheel {\n    0% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(16px);\n    }\n}\n\n@keyframes arrowBounce {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(8px);\n    }\n}\n\n@keyframes fadeInOut {\n    0%, 100% {\n        opacity: 0.7;\n    }\n    50% {\n        opacity: 1;\n    }\n}\n\n@keyframes decorationFloat {\n    0%, 100% {\n        transform: translate(0, 0) rotate(0deg);\n    }\n    25% {\n        transform: translate(20px, -20px) rotate(90deg);\n    }\n    50% {\n        transform: translate(0, -40px) rotate(180deg);\n    }\n    75% {\n        transform: translate(-20px, -20px) rotate(270deg);\n    }\n}\n\n// Modern Section Styling\n.section-modern {\n    position: $__relative;\n    background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%);\n    @include margin-padding(null, 100px 0);\n    overflow: hidden;\n\n    @include respond-below(custom991) {\n        @include margin-padding(null, 60px 0);\n    }\n\n    @include respond-below(custom479) {\n        @include margin-padding(null, 40px 0);\n    }\n}\n\n// Modern Section Heading\n.section-heading-modern {\n    text-align: $__center;\n    margin-bottom: 60px;\n    position: $__relative;\n    z-index: 10;\n\n    @include respond-below(custom991) {\n        margin-bottom: 40px;\n    }\n\n    .section-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        background: rgba(255, 193, 7, 0.1);\n        border: 1px solid rgba(255, 193, 7, 0.3);\n        border-radius: 50px;\n        padding: 8px 20px;\n        margin-bottom: 20px;\n        color: $__golden__yellow;\n        font-size: 13px;\n        font-weight: $__semibold;\n        letter-spacing: 0.5px;\n        text-transform: uppercase;\n\n        @include respond-below(custom991) {\n            padding: 6px 16px;\n            font-size: 12px;\n        }\n\n        i {\n            font-size: 14px;\n        }\n    }\n\n    h2 {\n        font-size: 48px;\n        font-weight: 800;\n        color: $__white;\n        margin-bottom: 15px;\n        letter-spacing: -0.02em;\n        position: $__relative;\n\n        @include respond-below(custom991) {\n            font-size: 36px;\n        }\n\n        @include respond-below(custom767) {\n            font-size: 28px;\n        }\n\n        &::after {\n            display: none; // Remove old decoration\n        }\n    }\n\n    p {\n        font-size: 18px;\n        color: rgba(255, 255, 255, 0.7);\n        max-width: 600px;\n        margin: 0 auto;\n\n        @include respond-below(custom991) {\n            font-size: 16px;\n        }\n\n        @include respond-below(custom767) {\n            font-size: 15px;\n        }\n    }\n}\n\n// Recommended Cars Section\n.recommended-cars-modern {\n    background: #0a0a0a;\n    position: $__relative;\n\n    &::before {\n        content: '';\n        position: $__absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 200px;\n        background: linear-gradient(180deg, rgba(255, 193, 7, 0.03) 0%, transparent 100%);\n        pointer-events: none;\n    }\n\n    .cars-showcase-modern {\n        margin-bottom: 50px;\n        position: $__relative;\n        z-index: 10;\n\n        @include respond-below(custom991) {\n            margin-bottom: 40px;\n        }\n\n        .row {\n            margin: 0 -15px;\n\n            // Override CarCard's hardcoded column classes\n            > div {\n                padding: 0 15px;\n\n                // Force the inner div from CarCard to be full width\n                > div[class*=\"col-\"] {\n                    width: 100% !important;\n                    max-width: 100% !important;\n                    flex: none !important;\n                    padding: 0 !important;\n                }\n            }\n        }\n    }\n\n    .empty-state-modern {\n        text-align: $__center;\n        padding: 80px 20px;\n        background: rgba(255, 255, 255, 0.03);\n        border-radius: 20px;\n        border: 1px solid rgba(255, 255, 255, 0.1);\n\n        i {\n            font-size: 64px;\n            color: $__golden__yellow;\n            margin-bottom: 20px;\n            opacity: 0.5;\n        }\n\n        h3 {\n            font-size: 28px;\n            color: $__white;\n            margin-bottom: 10px;\n        }\n\n        p {\n            font-size: 16px;\n            color: rgba(255, 255, 255, 0.6);\n            margin: 0;\n        }\n    }\n\n    .section-cta-modern {\n        text-align: $__center;\n        position: $__relative;\n        z-index: 10;\n    }\n\n    // Override default listing-item styling for modern theme\n    .listing-item {\n        background: rgba(255, 255, 255, 0.03) !important;\n        border: 1px solid rgba(255, 255, 255, 0.1) !important;\n        border-radius: 16px !important;\n        padding: 20px !important;\n        transition: all 0.4s ease !important;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n\n        @include respond-below(custom991) {\n            padding: 15px !important;\n        }\n\n        &:hover {\n            transform: translateY(-8px) !important;\n            background: rgba(255, 255, 255, 0.05) !important;\n            border-color: rgba(255, 193, 7, 0.3) !important;\n            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6),\n                        0 0 0 1px rgba(255, 193, 7, 0.2) !important;\n        }\n\n        .listing-img {\n            margin-bottom: 20px !important;\n            border-radius: 12px !important;\n            overflow: hidden !important;\n            position: $__relative;\n\n            img {\n                border-radius: 12px !important;\n                transition: transform 0.4s ease !important;\n            }\n\n            &:hover img {\n                transform: scale(1.05) !important;\n            }\n\n            .fav-item {\n                padding: 12px 15px !important;\n                background: linear-gradient(135deg, rgba(255, 193, 7, 0.95), rgba(255, 152, 0, 0.95)) !important;\n                backdrop-filter: blur(10px) !important;\n\n                .featured-text {\n                    color: #1a1a1a !important;\n                    font-weight: $__bold !important;\n                    font-size: 15px !important;\n                    text-shadow: none !important;\n\n                    @include respond-below(custom991) {\n                        font-size: 13px !important;\n                    }\n                }\n            }\n        }\n\n        .listing-content {\n            flex: 1;\n            display: flex;\n            flex-direction: column;\n\n            .listing-features {\n                border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n                padding-bottom: 15px !important;\n                margin-bottom: 15px !important;\n\n                .listing-title {\n                    margin-bottom: 0 !important;\n\n                    a {\n                        color: $__white !important;\n                        font-size: 20px !important;\n                        font-weight: $__bold !important;\n                        transition: color 0.3s ease !important;\n\n                        @include respond-below(custom991) {\n                            font-size: 18px !important;\n                        }\n\n                        &:hover {\n                            color: $__golden__yellow !important;\n                        }\n                    }\n                }\n            }\n\n            .listing-details-group {\n                margin-bottom: 15px !important;\n\n                i {\n                    color: $__golden__yellow !important;\n                    font-size: 16px !important;\n\n                    @include respond-below(custom991) {\n                        font-size: 14px !important;\n                    }\n                }\n\n                p {\n                    color: rgba(255, 255, 255, 0.8) !important;\n                    font-size: 14px !important;\n                    margin: 0 !important;\n\n                    @include respond-below(custom991) {\n                        font-size: 13px !important;\n                    }\n                }\n            }\n\n            .listing-location-details {\n                margin-top: auto !important;\n                background: rgba(255, 255, 255, 0.03) !important;\n                border-radius: 10px !important;\n                padding: 15px !important;\n                border: 1px solid rgba(255, 255, 255, 0.05) !important;\n\n                @include respond-below(custom991) {\n                    padding: 12px !important;\n                }\n\n                .listing-price {\n                    h6 {\n                        color: $__white !important;\n                        font-size: 26px !important;\n                        font-weight: $__highbold !important;\n                        margin: 0 !important;\n\n                        @include respond-below(custom991) {\n                            font-size: 22px !important;\n                        }\n                    }\n\n                    .btn {\n                        border-radius: 8px !important;\n                        font-weight: $__semibold !important;\n                        font-size: 13px !important;\n                        padding: 8px 16px !important;\n                        transition: all 0.3s ease !important;\n\n                        @include respond-below(custom991) {\n                            font-size: 12px !important;\n                            padding: 6px 12px !important;\n                        }\n\n                        &.btn-success {\n                            background: rgba(40, 167, 69, 0.2) !important;\n                            border: 1px solid rgba(40, 167, 69, 0.5) !important;\n                            color: #28a745 !important;\n\n                            &:hover {\n                                background: #28a745 !important;\n                                color: $__white !important;\n                                transform: translateY(-2px) !important;\n                            }\n                        }\n\n                        &.btn-primary {\n                            background: linear-gradient(135deg, #FFC107, #FF9800) !important;\n                            border: none !important;\n                            color: #1a1a1a !important;\n\n                            &:hover {\n                                transform: translateY(-2px) !important;\n                                box-shadow: 0 8px 20px rgba(255, 193, 7, 0.4) !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        // Sold state\n        &.sold-out {\n            opacity: 0.7;\n            filter: grayscale(0.5);\n\n            &:hover {\n                transform: translateY(-4px) !important;\n            }\n        }\n    }\n}\n\n// Modern Button\n.btn-modern {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 16px 40px;\n    border-radius: 50px;\n    font-size: 16px;\n    font-weight: $__semibold;\n    text-decoration: none;\n    transition: all 0.4s ease;\n    border: 2px solid transparent;\n    position: $__relative;\n    overflow: hidden;\n\n    @include respond-below(custom991) {\n        padding: 14px 32px;\n        font-size: 15px;\n    }\n\n    i {\n        font-size: 18px;\n        transition: transform 0.3s ease;\n    }\n\n    &:hover i {\n        transform: translateX(5px);\n    }\n}\n\n.btn-modern-primary {\n    background: linear-gradient(135deg, #FFC107 0%, #FF9800 50%, #FFC107 100%);\n    background-size: 200% auto;\n    color: #1a1a1a;\n    box-shadow: 0 10px 30px rgba(255, 193, 7, 0.3);\n\n    &::before {\n        content: '';\n        position: $__absolute;\n        top: 0;\n        left: -100%;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n        transition: left 0.6s ease;\n    }\n\n    &:hover {\n        transform: translateY(-3px);\n        box-shadow: 0 15px 40px rgba(255, 193, 7, 0.4);\n        color: #000;\n\n        &::before {\n            left: 100%;\n        }\n    }\n}\n\n// Services Section Modern\n.services-modern {\n    position: $__relative;\n    background: linear-gradient(180deg, #1a1a1a 0%, #0f0f0f 100%);\n\n    .services-grid-modern {\n        position: $__relative;\n        z-index: 10;\n    }\n\n    .services-bg-decoration {\n        position: $__absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 600px;\n        height: 600px;\n        background: radial-gradient(circle, rgba(255, 193, 7, 0.05) 0%, transparent 70%);\n        border-radius: 50%;\n        pointer-events: none;\n\n        @include respond-below(custom991) {\n            width: 400px;\n            height: 400px;\n        }\n    }\n}\n\n.service-card-modern {\n    position: $__relative;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 20px;\n    padding: 40px 30px;\n    margin-bottom: 30px;\n    transition: all 0.4s ease;\n    overflow: hidden;\n\n    @include respond-below(custom991) {\n        padding: 30px 25px;\n    }\n\n    .service-number {\n        position: $__absolute;\n        top: 20px;\n        right: 20px;\n        font-size: 72px;\n        font-weight: 900;\n        color: rgba(255, 255, 255, 0.03);\n        line-height: 1;\n        transition: all 0.4s ease;\n\n        @include respond-below(custom991) {\n            font-size: 60px;\n        }\n    }\n\n    .service-icon-modern {\n        width: 70px;\n        height: 70px;\n        border-radius: 15px;\n        background: rgba(255, 193, 7, 0.1);\n        border: 1px solid rgba(255, 193, 7, 0.3);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 25px;\n        transition: all 0.4s ease;\n\n        @include respond-below(custom991) {\n            width: 60px;\n            height: 60px;\n            margin-bottom: 20px;\n        }\n\n        i {\n            font-size: 28px;\n            color: $__golden__yellow;\n            transition: all 0.4s ease;\n\n            @include respond-below(custom991) {\n                font-size: 24px;\n            }\n        }\n    }\n\n    h3 {\n        font-size: 24px;\n        font-weight: 700;\n        color: $__white;\n        margin-bottom: 15px;\n        transition: all 0.4s ease;\n\n        @include respond-below(custom991) {\n            font-size: 20px;\n            margin-bottom: 12px;\n        }\n    }\n\n    p {\n        font-size: 15px;\n        line-height: 1.7;\n        color: rgba(255, 255, 255, 0.7);\n        margin: 0;\n\n        @include respond-below(custom991) {\n            font-size: 14px;\n        }\n    }\n\n    .service-decoration {\n        position: $__absolute;\n        bottom: -50px;\n        right: -50px;\n        width: 150px;\n        height: 150px;\n        background: radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%);\n        border-radius: 50%;\n        transition: all 0.4s ease;\n        pointer-events: none;\n    }\n\n    &:hover {\n        transform: translateY(-10px);\n        background: rgba(255, 255, 255, 0.05);\n        border-color: rgba(255, 193, 7, 0.3);\n        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n\n        .service-number {\n            color: rgba(255, 193, 7, 0.1);\n            transform: scale(1.1);\n        }\n\n        .service-icon-modern {\n            background: linear-gradient(135deg, #FFC107, #FF9800);\n            border-color: transparent;\n            transform: scale(1.1) rotate(5deg);\n\n            i {\n                color: #1a1a1a;\n                transform: scale(1.1);\n            }\n        }\n\n        h3 {\n            color: $__golden__yellow;\n        }\n\n        .service-decoration {\n            bottom: -30px;\n            right: -30px;\n            width: 200px;\n            height: 200px;\n        }\n    }\n}\n\n.service-card-highlighted {\n    background: rgba(255, 193, 7, 0.05);\n    border-color: rgba(255, 193, 7, 0.2);\n\n    &:hover {\n        background: rgba(255, 193, 7, 0.08);\n    }\n}\n\n// Old banner slider - keeping for reference, can be removed\n.banner-slider {\n    display: none; // Hiding old design\n}\n\n// Hide old popular-services styling\n.popular-services {\n    &.popular-explore {\n        display: none;\n    }\n}\n\n// Hide old services section\n.services {\n    display: none;\n}\n.search-box-banner {\n    background: $__white;\n    box-shadow: 0px 4px 24px rgb(225 225 225 / 25%);\n    border-radius: 10px;\n    @include margin-padding(null, 25px);        \n    z-index: 1;\n    position: $__relative;\n    margin: -35px auto auto;\n        @include respond-below(custom991) {\n            padding: 15px 15px 0;\n            max-width: 100%;\n        }\n        @include respond-below(custom767) {\n            padding: 20px;\n            max-width: 100%;\n        }\n    ul {\n        list-style: none;\n        margin: 0 -10px;\n        padding: 0;\n        outline: none;\n        @extend %equal-heights;\n    }\n    .group-img {\n        position: $__relative;\n        i {\n            position: $__absolute;\n            top: 15px;\n            left: 15px;\n            @include respond-below(custom991) { \n                top: 13px;\n            }\n        }\n        input {\n            @include margin-padding(null, 13px 13px 13px 36px);\n                @include respond-below(custom991) {\n                    @include margin-padding(null, 10px 10px 10px 35px);\n                }\n        }\n    }\n    .input-block {\n        @include margin-padding(0, 0 10px);\n            @include respond-below(custom991) {\n               \n            } \n        label {\n            @include margin-padding(0 0 10px, null);\n            font-weight: $__bold;\n            font-size: 15px;\n            color: $__gray;\n            @include respond-below(custom991){\n                font-size:$__font__size__14;\n            }\n        }\n    }\n    .search-btn {\n        .search-button {\n            background-color: $__primarycolor;\n            border: 1px solid $__primarycolor;                \n            box-shadow: inset 0 0 0 $__white;                \n            color: $__white;      \n            width: $__full__width;       \n            @include margin-padding(null, 10px 12px);           \n            @extend %animation-effect;\n            i {\n                margin-right: 8px;\n            }\n                @include respond-below(custom767) {\n                    width: 100%;\n                } \n                @include respond-below(custom991) {\n                    @include margin-padding(null, 8px 12px);\n                }               \n            &:hover {\n                background-color: $__white;\n                border: 1px solid #201F1D;\n                box-shadow: inset 0 70px 0 0 $__white;\n                color: #201F1D;\n                @extend %animation-effect;\n            }\n        }\n    }\n    .column-group-last {\n        -ms-flex: 13%;\n        flex: 13%;\n        max-width: 13%;\n            @include respond-below(custom991) {\n                -ms-flex: 50%;\n                flex: 50%;\n                max-width: 50%;\n            }            \n            @include respond-below(custom767) {\n                -ms-flex: 100%;\n                flex: 100%;\n                max-width: 100%;\n            }         \n        &:last-child {\n            padding-right: 0;\n        }\n        .search-btn {\n            margin-top: 30px;\n            @include respond-below(custom991) {\n                @include margin-padding(15px 0 0, null);\n            }\n            @include respond-below(custom767) {\n                @include margin-padding(0, null);\n            }\n        }\n    }\n    .column-group-main {\n        -ms-flex: 29%;\n        flex: 29%;\n        max-width: 29%;\n            @include respond-below(custom991) {\n                -ms-flex: 50%;\n                flex: 50%;\n                max-width: 50%;\n                margin-bottom: 15px;\n            }            \n            @include respond-below(custom767) {\n                -ms-flex: 100%;\n                flex: 100%;\n                max-width: 100%;\n                margin-bottom: 0;\n            } \n        &:last-child {\n            padding-right: 0;\n        }\n    }\n    .input-block-wrapp {\n        @extend %display-flex-center;\n        @include respond-below(custom767) {\n            display: block;\n        }\n    }\n}  \n.section-heading {\n    text-align: center;\n    @include margin-padding(0 0 50px, null); \n        @include respond-below(custom991) {\n            @include margin-padding(0 0 30px, null);\n        }\n    h2 {\n        position: $__relative;\n        @include margin-padding(0 0 30px, null);\n            @include respond-below(custom991) {\n                @include margin-padding(0 0 20px, null);\n            }\n        &:after {\n            content: \"\";\n            position: $__absolute;\n            background-image: url(../../../../public/assets/img/bg/title-head.png);            \n            background-position: center;\n            background-repeat: no-repeat;\n            left: 0;\n            height: 11px;\n            right: 0;\n            bottom: -22px;\n            z-index: 99;            \n            @include respond-below(custom991) {\n                bottom: -17px;\n            }\n        }\n    }    \n    p {\n        max-width: 439px;\n        margin: auto;\n        font-size: $__font__size__16;\n        @include respond-below(custom991){\n            font-size: $__font__size__16;\n        }\n    }\n}\n.services {  \n    padding: 80px 0 56px;\n    @include respond-below(custom991){\n        padding: 50px 0 36px;\n    }\n    .service-right {\n        position: absolute;\n        top: 0;\n        right: 0;\n            @include respond-below(custom991) {\n                display: none;\n            }\n    }\n    .services-group {        \n        @include margin-padding(0 0 24px, null);\n        text-align: center;\n        position: $__relative;\n        .services-icon {\n            @extend %inline-flex;\n            border-radius: 50px;\n            @include margin-padding(0 0 35px, 10px);\n            background: $__white;\n            position: $__relative;\n            z-index: 99;\n            @include respond-below(custom991) {\n                @include margin-padding(null, 8px);\n            }\n            .icon-img {            \n                border-radius: 50px;\n                @extend %inline-flex;\n                width: 72px;\n                height: 72px;\n                @include margin-padding(null, 10px);\n                    @include respond-below(custom991) {\n                        @include margin-padding(null, 8px);\n                    }\n            }\n        }\n        .services-content {\n            h3 {\n                @include margin-padding(0 0 10px, null);\n            }\n        }\n    }\n    .services-one {\n        border-bottom: 2px solid $__dark__blues;\n            @include respond-below(custom767) {\n                border-bottom: 0;\n            }\n    }\n    .services-two {\n        border-bottom: 2px solid $__warningcolor;\n            @include respond-below(custom767) {\n                border-bottom: 0;\n            }\n    }\n    .services-three {\n        border-bottom: 2px solid $__goose-gray;\n            @include respond-below(custom767) {\n                border-bottom: 0;\n            }\n        &:before {\n            border: 0;\n            width: 0;\n        }\n    }\n}\n.popular-services {\n    background: $__light__vampire;\n    .listing-tabs-group {\n        @extend %equal-heights;\n        @extend %justify-content-center;\n        @include margin-padding(0 0 50px, null);\n            @include respond-below(custom991) {\n                @include margin-padding(0 0 30px, null);\n            }\n        ul {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            @include respond-below(custom767) {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                li {\n                    a {\n                        min-width: 120px\n                    }\n                }\n            }\n            li {\n                a {\n                    background: $__white;\n                    border: 1px solid $__light__gooses;\n                    @extend %display-flex-center;\n                    @extend %justify-content-center;\n                    @include margin-padding(null, 10px 23px);\n                    text-transform: capitalize;\n                    font-weight: $__regular;\n                    font-size: $__font__size__16;\n                    color: $__gray;\n                    border-radius: 6px;\n                    @extend %animation-effect;\n                        @include respond-below(custom991) {   \n                            @include margin-padding(null, 8px 18px);\n                            font-size: $__font__size__14;\n                            min-width: 120px;\n                        }\n                    &.active {\n                        background: $__dark__blues;\n                        color: $__white;\n                        img {\n                            @extend %animation-effect;\n                        }\n                    }\n                    &:hover {\n                        background: $__dark__blues;\n                        color: $__white;\n                        @extend %animation-effect;\n                        img {\n                            @extend %animation-effect;\n                        }\n                    }\n                    span {\n                        @include margin-padding(0 10px 0 0, 10px);\n                        line-height: 0;\n                        background: #FCFCFC;\n                        border: 1px solid #F2F7F6;\n                        border-radius: 6px;\n                        width: 35px;\n                        height: 35px;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        @extend %animation-effect;\n                        @include respond-below(custom991) {   \n                            @include margin-padding(null, 8px);\n                            width: 30px;\n                            height: 30px;\n                        }\n                    }\n                    img {\n                        @extend %animation-effect;\n                    }\n                }\n            }\n        }\n    }\n    .owl-carousel {\n        .owl-dots.disabled {\n            display: block;\n        }\n        .owl-nav.disabled {\n            display: block;\n        }\n        .owl-prev {\n            position: absolute;\n            top: 50%;\n            left: 0;  \n            -ms-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%); \n            -webkit-transition: 500ms all ease;\n            -o-transition: 500ms all ease;\n            transition: 500ms all ease;\n            -moz-transition: 500ms all ease;\n            -ms-transition: 500ms all ease;\n            &:hover {\n                i {\n                    background: $__primarycolor !important;\n                    color: $__white;\n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                                }\n            }      \n            i {\n                height: 55px;\n                width: 55px;\n                background: $__white !important;\n                color: $__gray;\n                margin: auto 0;\n                border-radius: 50%;\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n            }\n        }\n        .owl-next {\n            position: absolute;\n            top: 50%;\n            right: 0;\n            -ms-transform: translate(-50%, -50%);\n            transform: translate(50%, -50%);\n            -webkit-transition: 500ms all ease;\n            -o-transition: 500ms all ease;\n            transition: 500ms all ease;\n            -moz-transition: 500ms all ease;\n            -ms-transition: 500ms all ease;\n            &:hover {\n                i {\n                    background: $__primarycolor !important;\n                    color: $__white;\n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                }\n            }       \n            i {\n                height: 55px;\n                width: 55px;\n                background: $__white !important;\n                color: $__gray;\n                margin: auto 0;\n                border-radius: 50%;\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n            }\n        }\n        \n    }\n}\n.popular-explore {\n    @include margin-padding(null, 80px 0 56px 0);\n    @include respond-below(custom991) {\n        padding: 50px 0 26px 0;\n    }\n}\n.listing-item {\n    position: $__relative;\n    background: $__white;\n    border-radius: 10px;\n    @include margin-padding(0 0 24px 0, 15px);\n        @include respond-below(custom991) {\n            @include margin-padding(null, 15px);\n        }\n    .listing-img {\n        position: $__relative;\n        overflow: hidden;\n        border-radius: 10px;\n        @include margin-padding(0 0 10px, null);\n        img {\n            border-radius: 10px;\n            width: 100%;\n            transform: translateZ(0);\n            transition: all 2000ms cubic-bezier(0.19, 1, 0.22, 1) 0ms;\n        }\n        .fav-item {\n            position: $__absolute;\n            left: 0;\n            top: 0;\n            width: 100%;\n            @include margin-padding(null, 15px);\n            z-index: 1;\n            @extend %display-flex-center-between;\n            font-size: $__font__size__14;\n            @extend %animation-effect;\n                @include respond-below(custom991) {\n                    font-size: $__font__size__13;\n                }\n            .featured-text {\n                background: $__white;\n                border-radius: 5px;\n                min-width: 75px;\n                @include margin-padding(null, 5px 15px);\n                font-size: $__font__size__14;\n                color: $__sandstone;\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                    @include respond-below(custom991) {\n                        font-size: $__font__size__12;\n                    }\n            }\n            .fav-icon {\n                width: 26px;\n                height: 26px;\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                border-radius: 50%;\n                color: $__white;\n                border: 1px solid $__white;\n            }\n        }\n        .fav-icon.selected {\n            background-color: $__primarycolor;\n            border: 1px solid $__primarycolor !important;\n            color: #fff;\n        }\n    }\n    &:hover {\n        .listing-img {\n            img {\n                -webkit-transform: scale(1.15);\n                -moz-transform: scale(1.15);\n                transform: scale(1.15);\n            }\n        }\n        .listing-title {\n            a {                \n                color: $__dark__blues !important;\n            }\n        }\n    }\n    .listing-content {\n        margin-top: 15px;\n        .listing-features {\n            position: $__relative;\n            border-bottom: 1px solid $__light__gooses;\n            @include margin-padding(0 0 15px, 0 0 15px);\n            .author-img {\n                position: $__absolute;\n                top: -35px;\n                z-index: 2;\n                right: 15px;\n                border-radius: 50px;\n                img {\n                    width: 35px;\n                    height: 35px;\n                    @extend %inline-flex;\n                    border-radius: 50px;\n                    border: 2px solid $__white;\n                }\n            }\n            .listing-title {\n                margin-bottom: 5px;\n                font-size: $__font__size__20;\n                a {\n                    font-weight: $__semibold;\n                    color: $__light__smokey-grays;\n                    @extend %inline-flex;\n                    @include respond-below(custom991) {\n                        font-size: $__font__size__18;\n                    }\n                }\n            }\n            h6 {\n                font-size: $__font__size__15;\n                color: $__grey;\n                font-weight: $__regular;\n            }\n            .list-rating {\n                i {\n                    color: $__warningcolor;\n                    font-size: $__font__size__14;\n                        @include respond-below(custom991) {\n                            font-size: $__font__size__12;\n                        }\n                }\n                span {\n                    font-weight: $__medium;\n                    color: $__sandstone;\n                    @include margin-padding(0 0 0 8px, null);\n                }\n            }\n            \n        }\n        .listing-details-group {\n            @include margin-padding(0 0 15px, null);            \n            ul {\n                @extend %flex-align-center;                \n                @include margin-padding(0 0 10px, null);                                \n                &:last-child {\n                    @include margin-padding(0, null);\n                }\n                li {\n                    @extend %display-flex-center;\n                    -ms-flex: 33.33%;\n                    flex: 33.33%;\n                    max-width: 33.33%;\n                    span {\n                        img {\n                            line-height: 0;\n                            width: 16px;\n                            display: flex;\n                            justify-content: center;\n                        }\n                    }\n                    p {\n                        color: $__grey;\n                        @include margin-padding(0 0 0 8px, null);\n                        @include respond-below(custom991) {\n                            font-size: $__font__size__13;\n                        }\n                    }\n                }\n            }\n        }\n        .listing-location-details {\n            background: $__light__vampire;\n            @extend %display-flex-center-between;\n            @include margin-padding(null, 8px);\n            @include margin-padding(0 0 15px, null);\n            .listing-price {\n                @include respond-below(custom991) {\n                    font-size: $__font__size__13;\n                }\n                span {\n                    margin-right: 7px;\n                    line-height: 0;\n                }\n            }\n            .listing-price {\n                h6 {\n                    font-weight: $__bold;\n                    font-size: $__font__size__24;\n                    color: $__dangered;\n                    @extend %display-flex-center;\n                    @include respond-below(custom991) {\n                        font-size: $__font__size__20;\n                    }                    \n                    span {\n                        color: $__note__light;\n                        font-size: $__font__size__14;\n                        font-weight: $__regular;\n                        margin-left: 7px;\n                        @include respond-below(custom991) {\n                            font-size: $__font__size__12;\n                        }\n                    }\n                }\n            }\n        }\n        .listing-button {\n            .btn-order {\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                background: $__goose-gray;\n                position: $__relative;\n                border-radius: 5px;\n                font-weight: $__semibold;\n                font-size: $__font__size__16;\n                color: $__white;\n                text-align: $__center;\n                padding: 10px;\n                width: 100%;\n                @include respond-below(custom991) {\n                    font-size: $__font__size__14;\n                }\n                span {\n                    line-height: 0;\n                    i {\n                        line-height: 0;\n                    }\n                }\n            }\n        }\n    }\n    &:hover {\n        -webkit-transition: all 0.5s;\n        -moz-transition: all 0.5s;\n        -o-transition: all 0.5s;\n        transition: all 0.5s;\n        .btn-order {\n            background-color: $__dark__blues !important;\n            color: $__white;\n            border-radius: 5px;\n        }\n        .fav-icon {\n            background: $__dark__blues;\n            border: 1px solid $__dark__blues !important;\n            -webkit-transition: all 0.5s;\n            -moz-transition: all 0.5s;\n            -o-transition: all 0.5s;\n            transition: all 0.5s;\n            i {                    \n                color: $__white;\n                @extend %animation-effect;\n            }\n        }\n    }\n}\n// Most Popular Cartypes\n.popular-slider-group {\n    @include margin-padding(0 0 50px, null);  \n    .listing-owl-item {\n        .listing-owl-group {\n            @include margin-padding(null, 30px);\n            background: $__white;\n            box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);\n            text-align: $__center;\n            .listing-owl-img {\n                @include margin-padding(0 0 20px, null);\n                img {\n                    width: 103px;\n                    height: 48px;\n                    text-align: $__center;\n                    margin: $__auto;                \n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                }\n            }        \n            h6 {\n                @include margin-padding(0 0 5px, null);            \n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n            }\n            p {\n                font-size: $__font__size__14;\n                color: $__sandstone;            \n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n            }\n            \n            &:hover {\n                background-color: $__dark__blues;\n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n                .listing-owl-img {\n                    img {\n                        filter: invert(1);\n                    }  \n                }\n                h6 {\n                    color: $__white;\n                }\n                p {\n                    color: $__white;\n                }\n            }\n        }\n    }\n    .owl-carousel {\n        .owl-dots.disabled {\n            display: block;\n        }\n        .owl-nav.disabled {\n            display: block;\n        }\n        .owl-prev {\n            position: absolute;\n            top: 50%;\n            left: 0;  \n            -ms-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%); \n            -webkit-transition: all 0.7s;\n            -moz-transition: all 0.7s;\n            -o-transition: all 0.7s;\n            transition: all 0.7s;\n            @include respond-below(custom1199) {\n                left: 7px;\n            }\n            &:hover {\n                i {\n                    background: $__primarycolor !important;\n                    color: $__white;\n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                }\n            }      \n            i {\n                height: 55px;\n                width: 55px;\n                background: $__white !important;\n                margin: auto 0;\n                border-radius: 50%;\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                -webkit-transition: all 0.7s;\n                -moz-transition: all 0.7s;\n                -o-transition: all 0.7s;\n                transition: all 0.7s;\n                @include respond-below(custom1199) {\n                    height: 35px;\n                    width: 35px;\n                    font-size: $__font__size__12;\n                }\n            }\n        }\n        .owl-next {\n            position: absolute;\n            top: 50%;\n            right: 0;\n            -ms-transform: translate(-50%, -50%);\n            transform: translate(50%, -50%);\n            -webkit-transition: all 0.7s;\n            -moz-transition: all 0.7s;\n            -o-transition: all 0.7s;\n            transition: all 0.7s;\n                @include respond-below(custom1199) {\n                    right: 7px;\n                }\n            &:hover {\n                i {\n                    background: $__primarycolor !important;\n                    color: $__white;\n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                }\n            }       \n            i {\n                height: 55px;\n                width: 55px;\n                background: $__white !important;\n                margin: auto 0;\n                border-radius: 50%;\n                @extend %display-flex-center;\n                @extend %justify-content-center;\n                -webkit-transition: all 0.7s;\n                -moz-transition: all 0.7s;\n                -o-transition: all 0.7s;\n                transition: all 0.7s;\n                    @include respond-below(custom1199) {\n                        height: 35px;\n                        width: 35px;\n                        font-size: $__font__size__12;\n                    }\n            }\n        }\n        \n    }\n    \n}\n\n// Facts By The Numbers\n\n.facts-number {\n    background: $__goose-gray;\n    @include respond-below(custom991) {\n        padding-bottom: 35px;\n    }\n    .facts-left {\n        img {\n            position: $__absolute;\n            left: -80px;\n            top: 10px;\n            @include respond-below(custom991) {\n                display: none;\n            } \n        }\n    }\n    .facts-right {\n        img {\n            position: $__absolute;\n            right: 60px;\n            top: 30px;\n            @include respond-below(custom991) {\n                display: none;\n            } \n        }\n    }\n    .count-group {\n        position: $__relative;\n        width: 100%;\n        display: $__flex;\n        top: 0;\n        background-image: url(../../../../public/assets/img/bg/count-bg.jpg);\n        background-repeat: no-repeat;\n        background-position: right;\n        background-size: cover;\n        border-radius: 10px;\n        @include margin-padding(null, 20px);\n        -webkit-transition: 500ms all ease;\n        -o-transition: 500ms all ease;\n        transition: 500ms all ease;\n        -moz-transition: 500ms all ease;\n        -ms-transition: 500ms all ease;\n            @include respond-below(custom991) {\n                @include margin-padding(0 0 15px, 15px);\n            }\n        &:hover {\n            top: -10px;\n            .count-img {\n                background: $__dark__blues;\n            } \n        }\n        .count-img {\n            @include margin-padding(null, 24px);\n            background: $__goose-gray;\n            border-radius: 10px;\n            display: $__flex;\n            align-items: $__center; \n            @include margin-padding(0 20px 0 0, null);\n            -webkit-transition: 500ms all ease;\n            -o-transition: 500ms all ease;\n            transition: 500ms all ease;\n            -moz-transition: 500ms all ease;\n            -ms-transition: 500ms all ease;\n                @include respond-below(custom991) {\n                    @include margin-padding(null, 15px);\n                }\n        }        \n        .count-content {\n            h4 {\n                font-weight: $__highbold;\n                @include margin-padding(0 0 7px, null);\n            }\n        }\n    }\n}\n\n// Recommended Car Rental deals\n\n.rental-car-item {\n    .fav-item-rental {\n        position: $__absolute;\n        top: -25px;\n        z-index: 2;\n        right: 15px;\n        border-radius: 50px;\n        .featured-text {\n            background: $__primarycolor;\n            border-radius: 3px;\n            @include margin-padding(null, 6px 10px);\n            color: $__white;\n            font-weight: $__medium;\n            font-size: $__font__size__15;\n                @include respond-below(custom991) { \n                    font-size: $__font__size__14;\n                }\n        }\n    }    \n    .listing-title {        \n        @include margin-padding(5px 0 0, null);\n        a {\n            font-weight: $__bold;\n            color: $__light__smokey-grays;\n        }\n        h6 {\n            font-size: $__font__size__16;\n            color: $__gray;            \n            @include margin-padding(5px 0 0, null);\n            @include respond-below(custom991) {\n                font-size: $__font__size__15;\n            }\n            span {\n                color: $__gray;\n                font-weight: $__regular;\n            }\n        }\n    }\n}\n\n// Why Choose Us\n\n.why-choose {\n    .choose-left {\n        position: $__absolute;\n        left: 0;\n        top: 10px;\n        @include respond-below(custom991) {\n            display: none;\n        } \n    }\n    .card {          \n        -webkit-transition: 500ms all ease;\n        -o-transition: 500ms all ease;\n        transition: 500ms all ease;\n        -moz-transition: 500ms all ease;\n        -ms-transition: 500ms all ease;      \n        .card-body {\n            .choose-img {\n                @include margin-padding(0 0 20px, 20px);\n                border-radius: 10px;\n                @extend %flex-align-center;                \n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n                    @include respond-below(custom991) { \n                        @include margin-padding(null, 15px);\n                    }\n                img {                    \n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                }\n            }\n            .choose-black {            \n                background: $__goose-gray;\n                \n            }        \n            .choose-secondary {            \n                background: $__dark__blues;\n            }\n            .choose-primary {            \n                background: $__primarycolor;\n            }\n            .choose-content {\n                text-align: $__center;\n                h4 {\n                    font-size: $__font__size__24;\n                    font-weight: $__bold;\n                    @include margin-padding(0 0 20px 0, null);\n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                        @include respond-below(custom991) { \n                            font-size: $__font__size__22;  \n                            @include margin-padding(0 0 15px 0, null); \n                        }\n                }\n                p {\n                    -webkit-transition: 500ms all ease;\n                    -o-transition: 500ms all ease;\n                    transition: 500ms all ease;\n                    -moz-transition: 500ms all ease;\n                    -ms-transition: 500ms all ease;\n                    max-width: 265px;\n                    margin: $__auto;\n                }\n            }\n        }        \n        &:hover {\n            background: #000;\n            .choose-black {            \n                background: $__white;\n            }        \n            .choose-secondary {            \n                background: $__white;\n            }\n            .choose-primary {            \n                background: $__white;\n            }\n            .choose-content {\n                h4 {\n                    color: $__white;\n                }\n                p {\n                    color: $__white;\n                }\n            }\n            .choose-img {\n                position: $__relative;\n                background-image: url(../../../../public/assets/img/bg/count-bg.jpg);\n                background-repeat: no-repeat;\n                background-position: right;\n                background-size: cover;\n                img {\n                    filter: invert(1);\n                }\n            }\n            \n        }\n    }\n}\n\n// What People say about us\n\n.about-testimonial {\n    background-image: url(../../../../public/assets/img/bg/about-testimonial.jpg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover; \n    @include respond-below(custom991) {\n        background: $__goose-gray;\n    }    \n\t.owl-dots {\n        text-align: center;\n\t\t.owl-dot {\n            @include margin-padding(0 8px 0 0, null);\n            span {\n                width: 8px;\n                height: 8px;\n                margin: 0;\n                background: $__blue__light;\n                border-radius: 50%;\n                display: block;\n                -webkit-transition: all 0.4s ease;\n                -moz-transition: all 0.4s ease;\n                transition: all 0.4s ease;\n            }\n            &.active {                \n                span {\n                    background: $__primarycolor;\n                    width: 46px;\n                    height: 8px;\n                    border-radius: 40px;\n                }\n            } \n\t\t}\n\t}       \n}\n\n// User Friendly App Available\n\n.user-app-group {\n    background: $__gray__dark;\n    position: $__relative;\n    border-radius: 10px;\n    @include margin-padding(56px 0 0, 80px);\n        @include respond-below(custom991) {\n            @include margin-padding(26px 0 0, 40px 40px 25px 40px);\n        }\n    .userapp-heading {\n        h2 {\n            font-weight: $__highbold;\n            font-size: $__font__size__52;\n            color: $__white;\n            @include margin-padding(0 0 15px, null);\n                @include respond-below(custom991) {\n                    font-size: $__font__size__32;\n                }\n        }\n        p {\n            font-size: $__font__size__18;\n            color: $__white;\n            @include margin-padding(0 0 37px, null);\n                @include respond-below(custom991) {\n                    font-size: $__font__size__16;\n                    @include margin-padding(0 0 27px, null);\n                }\n        }\n        .download-btn {\n            @extend %display-flex-center;\n            @include respond-below(custom767) {\n                display: block;\n            }\n            .app-avilable {\n                margin: 0 7px 0 0;\n                @include respond-below(custom991) {\n                    margin: 0 7px 15px 0;\n                }\n            }\n        }\n    }\n    .app-left {\n        position: $__absolute;\n        left: 5%;\n        bottom: 5%;\n        @include respond-below(custom991) {\n            display: none;\n        }\n    }\n    .app-right {\n        position: $__absolute;\n        right: 30%;\n        top: 10%;\n        @include respond-below(custom991) {\n            display: none;\n        }\n    }\n}\n.bg-secondary {\n    background: $__dark__blues !important;\n}\n.border-secondary {\n    border: 2px dashed $__dark__blues;\n}\n.bg-warning {\n    background: $__warningcolor !important;\n}\n.border-warning {\n    border: 2px dashed $__warningcolor;\n}\n.bg-dark {\n    background: $__goose-gray;\n}\n.border-dark {\n    border: 2px dashed $__goose-gray;\n}\n\n.bootstrap-datetimepicker-widget {\n\ttable {\n        width: 100%;\n        .date-widge {            \n            td {\n                padding: 20px;\n                width: 100%;\n            }\n        }\n\t\ttd.active {\n\t\t\tbackground-color: $__primarycolor;\n\t\t\ttext-shadow: unset;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: $__primarycolor;\n\t\t\t\ttext-shadow: unset;\n\t\t\t}\n\t\t}\n\t\tth {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 400;\n            padding: 12px;\n            width: 100%;\n\t\t}\n\t\ttd.day {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 400;\n            padding: 10px;\n\t\t}\n\t}\n}\n\n.bootstrap-datetimepicker-widget {\n    .timepicker-hour {\n        table {\n            td {\n                padding: 20px;\n                width: 100%;\n            }\n            th {\n                font-size: 14px;\n                font-weight: 400;\n                padding: 12px;\n                width: 100%;\n            }\n        }\n    }\n    .timepicker-minute {\n        table {\n            td {\n                padding: 20px;\n                width: 100%;\n            }\n            th {\n                font-size: 14px;\n                font-weight: 400;\n                padding: 15px;\n                width: 100%;\n            }\n        }\n    }\n\n}\n\n/* VAT Regime Badge Styles */\n.vat-regime-badge-small {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 12px;\n    border-radius: 12px;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: -100%;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n        transition: left 0.5s ease;\n    }\n\n    &:hover::before {\n        left: 100%;\n    }\n\n    &.full {\n        background: linear-gradient(135deg, #4CAF50 0%, #66BB6A 50%, #81C784 100%);\n        color: white;\n        border: 1px solid rgba(76, 175, 80, 0.3);\n        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n\n        &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);\n        }\n    }\n\n    &.margin {\n        background: linear-gradient(135deg, #2196F3 0%, #42A5F5 50%, #64B5F6 100%);\n        color: white;\n        border: 1px solid rgba(33, 150, 243, 0.3);\n        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n\n        &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);\n        }\n    }\n}\n","/*-----------------\n    13. Common\n-----------------------*/\n\n.container, .container-sm {\n    @include respond-below(custom1199) {\n        max-width: 100%;\n    }   \n}\n.page-wrapper {\n    margin-left: 247px;\n    padding-top: 77px;\n    position: $__relative;\n    @include transition(all 0.4s ease);\n    @include respond-below(custom1199) {\n        margin-left: 200px;\n    }\n    .content {\n        @include margin-padding(null, 25px);\n        @include respond-below(custom1199) {\n            @include margin-padding(null, 20px);\n        }\n        @include respond-below(custom991) {\n            @include margin-padding(null, 15px);\n        }\n    }\n    @include respond-below(custom991) {\n        margin: 0;\n        padding-top: 60px;\n    }\n}\n.content-page-header {\n    align-items: $__center;\n    -webkit-align-items: $__center;\n    @include margin-padding(0 0 30px 0, null);\n    @extend %display-flex-between;\n    @include respond-below(custom575) {\n        display: $__block;\n    }\n    @include respond-below(custom768) {\n        @include margin-padding(0 0 30px 0, null);\n    }\n    h5 {\n        font-size: $__font__size__24;\n        color: $__secondarycolor;\n        font-weight: $__semibold;\n        margin: 0;\n        @include respond-below(custom768) {\n           font-size: $__font__size__18; \n        }\n    }\n    h6 {\n        font-size: $__font__size__20;\n        color: $__secondarycolor;\n        font-weight: $__semibold;\n        margin: 0;\n    }  \n}\n.card {\n    background: $__white;\n    -webkit-box-shadow: 0 0 13px 0 rgb(82 63 105 / 5%);\n    box-shadow: 0 0 13px 0 rgb(82 63 105 / 5%);\n    @include margin-padding(0 0 24px 0 , null);\n    display: $__inline__block;\n    width: $__full__width;\n    border: 0;\n    @include rounded(8px);\n    .card-header {\n        border-color: #f0f1f5;\n        background-color: $__white;\n        padding: 1.5rem;\n        &:first-child {\n            border-top-left-radius: 20px;\n            border-top-right-radius: 20px;\n        }\n        @include respond-below(custom1199) {\n            @include margin-padding(null, 15px);\n        }\n    }\n    .card-body {\n        position: $__relative;\n        padding: 1.5rem;\n        @include respond-below(custom1199) {\n            @include margin-padding(null, 15px);\n        }\n    }\n    .card {\n        position: $__relative;\n        padding: 1.5rem;\n        @include respond-below(custom1199) {\n            @include margin-padding(null, 15px);\n        }\n    }\n}\n.text-success-light {\n    color: $__success__light !important;\n}\n.text-warning-light {    \n    color: $__text-warning__light;\n}\n.warning-border {\n    border: 1px solid $__text-warning__light;\n    padding: 0 3px;\n    border-radius: 50px;\n}\n.danger-border {\n    border: 1px solid $__dangered;\n    padding: 0 3px;\n    border-radius: 50px;\n}\n.info-border {\n    border: 1px solid $__violet__dark;\n    padding: 0 3px;\n    border-radius: 50px;\n}\n.text-primary {    \n    color: $__primarycolor !important;\n}\n.text-danger {\n    color: $__dangered !important;\n}\n.text-gray-light {\n    color: $__gray__dark\n}\n.text-gray-dark {\n    color: $__grayish__blue\n}\n.text-muted {\n    color: $__light__vampire !important\n}\n.bg-light-gray {\n    background: $__smoke__white;\n}\n.bg-primary-light {\n    background: $__bg__primary__light\n}\n.bg-green-light {    \n    background: $__bg__green__light\n}\n.bg-danger-light {\n    background: $__bg__danger__light\n}\n.bg-white-smoke {\n    background: $__white__smoke\n}\n.bg-light-primary {\n    background: $__light__vampire !important\n}\n.dropdown-toggle::after {\n    display: $__inline__block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0;\n    border-bottom: 0;\n    border-left: 0;\n}\n.dropdown-item {\n    font-size: $__font__size__12;\n    @include margin-padding(null, 8px 10px);\n}\n.add-cate-status {\n    @include margin-padding(50px 0 0 0 !important, null);\n    @include respond-below(custom575) {\n        @include margin-padding(0 !important, null); \n    }  \n}\n.input-block {\n    @include margin-padding(0 0 15px 0 , null);\n    .forgot-link {\n        color: $__dangered;\n        font-size: $__font__size__14;\n    }\n    label {\n        @include margin-padding(0 0 10px 0, null);\n        font-weight: $__semibold;\n        color: $__gray;\n        @include respond-below(custom1199){\n            font-size:$__font__size__14;\n        }\n    } \n    .optional {\n        font-weight: $__regular;\n        font-size: $__font__size__12;\n        color: $__gray__dark;\n    }\n    .form-control {\n        background: $__cylindrical;\n        border: 1px solid $__light__gooses;\n        box-shadow: $__none;\n        @include rounded(5px);\n        @include margin-padding(0, 13px);\n        font-size: $__font__size__14;\n        font-weight: $__regular;\n        color: $__gray__dark;\n        @include respond-below(custom767) {\n            @include margin-padding(0 0 15px, 10px);\n        }\n        ::placeholder, ::-webkit-input-placeholder, :-ms-input-placeholder  {\n            color: $__gray__dark;\n            font-size: $__font__size__14;\n            font-weight: $__medium;\n        }\n        &:focus {\n            background: #ffffff;\n        }\n        .form-title {\n            font-weight: $__semibold;\n            font-size: $__font__size__16;\n            color: $__secondarycolor;\n            @include margin-padding(0 0 25px 0, null);\n        }\n    }\n    .search-btn {\n        .check-available {\n            @include margin-padding(null, 12px 20px);\n        }\n    }\n    textarea.form-control {\n        height: $__auto;\n    }\n    .intl-tel-input, .iti {\n        width: 100%;\n    }\n    .note-toolbar {\n        background: $__white;\n    }\n    .note-editable {\n        background: $__white;\n    }\n    .note-resizebar {\n        height: 0 !important;\n    }\n    .toggle-password {\n        cursor: pointer;\n        position: $__absolute;\n        top: 50%;\n        right: 0;\n        -ms-transform: translate(-50%, -50%);\n        transform: translate(-50%, 50%);\n    }\n    .feather-eye-off {\n        color: $__gray__dark;\n    }\n    .feather-eye {\n        margin-right: 1px;\n        color: $__gray__dark;\n    }\n}\n.custom_check {\n\tposition: relative;\n    padding-left: 30px;\n    .checkmark {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\theight: 16px;\n\t\twidth: 16px;\n\t\tborder: 1px solid $__gray__lightdark;\n\t\tbackground-color: $__white;\n\t\tborder-radius: 2px;\n\t\t-moz-transition: all 0.3s ease-in-out;\n\t\t-o-transition: all 0.3s ease-in-out;\n\t\t-webkit-transition: all 0.3s ease-in-out;\n\t\t-ms-transition: all 0.3s ease-in-out;\n\t\ttransition: all 0.3s ease-in-out;\n        &::after {\n\t\t\tcontent: \"\\f00c\";\n\t\t\tfont-family:\"Font Awesome 5 Free\";\n\t\t\tfont-weight: $__bold;\n\t\t\tposition: absolute;\n\t\t\tdisplay: none;\n\t\t\tleft: 2px;\n\t\t\ttop: 2px;\n\t\t\tcolor: $__gray__lightdark;\n\t\t\tfont-size: $__font__size__12;\n\t\t}\n\t}\n    input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        &:checked {\n\t\t\t~ {\n\t\t\t\t.checkmark {\n\t\t\t\t\tbackground-color: $__white;\n                    &:after {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }    \n    span {\n        color: $__gray__lightdark;\n        font-weight: $__regular;\n    }\n}\n.pass-group {\n    position: relative;\n}\n.close {\n    background: $__transparent;\n    border: 0;\n    color: $__graybackblue;\n    font-size: 28px;\n    line-height: $__normal;\n    top: 20px;\n    width: $__auto;\n    height: $__auto;\n    right: 20px;\n    span {\n        background: $__dark__gray;\n        @include rounded(50px);\n        font-size: $__font__size__20;\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        transition: all 0.4s ease;\n        -moz-transition: all 0.4s ease;\n        -o-transition: all 0.4s ease;\n        -ms-transition: all 0.4s ease;\n        -webkit-transition: all 0.4s ease;\n        &:hover {\n            background: $__primarycolor;\n            color: $__white;\n            transition: all 0.4s ease;\n            -moz-transition: all 0.4s ease;\n            -o-transition: all 0.4s ease;\n            -ms-transition: all 0.4s ease;\n            -webkit-transition: all 0.4s ease;\n        }\n    }\n}\n.card-title {\n    margin-bottom: 0;\n    @include rounded(10px);\n}\n.cal-icon {\n    position: relative;\n    width: 100%;\n    &:after {\n        color: #979797;\n        content: \"\\f073\";\n        display: $__block;\n        font-family: \"Font Awesome 5 Free\";\n        font-weight: $__bold;\n        font-size: $__font__size__15;\n        margin: $__auto;\n        position: $__absolute;\n        right: 15px;\n        top: 10px;\n    }\n}\n.cal-icon-info {\n    &:after {\n        font-family: \"Feather\";\n        content: \"\\e926\";\n        color: $__gray__dark;\n        font-weight: $__regular;\n        font-size: $__font__size__18;\n        top: 8px;\n    }\n}\n.progress-wrap.active-progress {\n\topacity: 1;\n\tvisibility: visible;\n\ttransform: translateY(0);\n}\n.progress-wrap {\n    position: fixed;\n    right: 12px;\n    bottom: 25px;\n    height: 35px;\n    width: 35px;\n    cursor: pointer;\n    display: block;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    box-shadow: inset 0 0 0 2px rgb(75 64 237 / 20%);\n    z-index: 99;\n    opacity: 0;\n    visibility: hidden;\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n    transform: translateY(15px);\n    -webkit-transform: translateY(15px);\n    -moz-transform: translateY(15px);\n    -ms-transform: translateY(15px);\n    -o-transform: translateY(15px);\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: '\\f062';\n        font-family: 'FontAwesome';\n\t\ttext-align: center;\n\t\tline-height: 35px;\n\t\tfont-size: 17px;\n\t\tcolor: $__white;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tcursor: pointer;\n\t\tdisplay: block;\n\t\tz-index: 1;\n\t\t-webkit-transition: all 200ms linear;\n\t\ttransition: all 200ms linear;\n\t}\n}\n.pagination {\n    @extend %display-flex-center;\n    @extend %justify-content-center;\n    .pagination {\n       flex-wrap: wrap;                  \n        .previtem,.nextlink {\n            @include respond-below(custom479) {\n                margin-bottom: 10px;\n            }\n            a {\n                height: 38px;\n                @extend %flex-align-center;\n                border-radius: 10px;\n                padding: 0 20px;\n                color: $__gray;\n                &:focus {\n                    outline: 0;\n                    box-shadow: $__none;\n                } \n            }\n        }\n        li {\n            .page-group {\n                ul {\n                    @include respond-below(custom479) {\n                        flex-wrap: wrap;\n                    }\n                    li {\n                        @include respond-below(custom479) {\n                            margin-bottom: 10px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .pagination-center {\n        display: $__flex;\n        justify-content: $__center;\n        align-items: $__center; \n        .page-group {\n            .page-item {\n                a {\n                    border: 1px solid $__light__gray;\n                    background: $__white;\n                    border-radius: 10px;\n                    padding: 10px 19px;\n                    margin: 0 12px 0 0;\n                    color: $__gray;\n                    width: 47px;\n                    height: 38px;\n                    display: $__flex;\n                    justify-content: $__center;\n                    align-items: $__center;      \n                    &:focus {\n                        outline: 0;\n                        box-shadow: $__none;\n                    }    \n                    &:hover {\n                        background-color: $__dark__blues;\n                        color: $__white;\n                        border: 1px solid $__dark__blues;\n                    }                \n                }\n                .active {\n                    background-color: $__dark__blues;\n                    color: $__white;\n                    border: 1px solid $__dark__blues;\n                }                  \n            }\n            ul {\n                display: $__flex;\n                align-items: $__center;\n                justify-content: $__center;\n                margin: 0 0 0 10px;\n            }\n        }            \n    } \n}\n\n// policy and terms\n\n.privacy-section {\n    position: $__relative;\n    @include margin-padding(null, 80px 0);\n        @include respond-below(custom991) {\n            @include margin-padding(null, 40px 0);\n        }\n    .terms-policy {\n        p {\n            @include margin-padding(0 0 38px, null);\n            @include respond-below(custom991) {\n                @include margin-padding(0 0 28px, null);\n            }\n        }\n        ul {\n            @include margin-padding(0 0 38px, null);\n            li {\n                @include margin-padding(0 0 11px, null);\n                @extend %display-flex-center;\n                span {\n                    margin-right: 10px;\n                    color: $__text-warning__light;\n                }\n            }\n        }\n    }\n}\n// 404 and 405\n\n.error-page {\n    @include margin-padding(null, 50px);\n\talign-items: center;\n    color: $__graybackblue;\n    font-weight: $__highbold;\n    @extend %display-flex-between;\n    @include respond-below(custom575) {\n        @include margin-padding(null, 50px);\n    }\n\t.main-wrapper {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\theight: auto;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tmin-height: unset;\n\t}\n}\n.error-box {\n\t@include margin-padding(40px auto, null);\n\tmax-width: 600px;\n\ttext-align: $__center;\n\twidth: 100%;\n    img {\n        @include margin-padding(0 0 50px, null);\n    }\n\th3 {\n        font-size: $__font__size__28;\n        margin-bottom: 10px\n\t}\n    p {\n        @include margin-padding(auto auto 30px, null);\n        color: $__grey;\n        font-weight: $__medium;\n        max-width: 560px;\n    }\n\t.btn-maintance {\n\t\t@include rounded(5px);\n\t\tfont-weight: $__semibold;\n        font-size: $__font__size__16;\n        @include margin-padding(null, 12px 20px);\n            @include respond-below(custom768) {\n                @include margin-padding(null, 8px 12px);\n                font-size: $__font__size__14;\n            }\n\t}\n    .error-500 {\n        @include margin-padding(0 0 60px, null);\n    }\n    .coming-soon {\n        @include margin-padding(null, 50px 0 8px);\n        color: $__graybackblue;\n        @include respond-below(custom767) {\n            font-size: $__font__size__20;\n        }\n    }\n    .back-button {\n       .btn  {\n            @include margin-padding(null, 15px 20px);\n            font-size: $__font__size__16;\n                @include respond-below(custom575) {\n                    @include margin-padding(null, 10px);\n                    font-size: $__font__size__14;\n                }\n            }\n    }\n    \n}\n// Comming soon\n\n.serve-form {\n    @include margin-padding(0 0 39px, null);\n\t@include respond-below(custom767) {\n\t\tpadding-bottom: 30px;\n\t}\n\t.input-block {\n\t\tmargin-bottom: 0;\n\t\t@extend %display-flex-between;\n\t\t.form-control {\n\t\t\tmargin-right: 10px;\n\t\t\tfont-size: $__font__size__14;\n            background: $__white;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n\t\t\t&::placeholder {\n\t\t\t\tcolor: $__gray;\n\t\t\t\tfont-weight: $__medium;\n\t\t\t}\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tmin-height: 46px;\n\t\t\t\tfont-size: $__font__size__14;\n\t\t\t}\n\t\t}\n\t\t.button-notific {\n\t\t\tmin-width: 115px;\n\t\t\theight: 47px;\n\t\t\tcolor: $__white;\n\t\t\tborder-radius: 5px;\n            background: $__goose-gray;\n            font-weight: $__semibold;\n            font-size: $__font__size__16;\n            @extend %display-flex-center;\n            @extend %justify-content-center;\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tfont-size: $__font__size__14;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: $__white;\n                background: $__grayish__blue;\n                border: 1px solid $__grayish__blue;\n\t\t\t}\n\t\t}\n\t}\n}\n.progress-wrap.active-progress {\n\topacity: 1;\n\tvisibility: visible;\n\ttransform: translateY(0);\n}\n.progress-wrap {\n\tposition: fixed;\n\tright: 12px;\n\tbottom: 25px;\n\theight: 35px;\n\twidth: 35px;\n\tcursor: pointer;\n\tdisplay: block;\n\tborder-radius: 50%;\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n\tbox-shadow: inset 0 0 0 2px rgb(75 64 237 / 20%);\n\tz-index: 99;\n\topacity: 0;\n\tvisibility: hidden;\n\t-webkit-transition: all 200ms linear;\n\ttransition: all 200ms linear;\n\ttransform: translateY(15px);\n\t-webkit-transform: translateY(15px);\n\t-moz-transform: translateY(15px);\n\t-ms-transform: translateY(15px);\n\t-o-transform: translateY(15px);\n\tsvg.progress-circle {\n\t\tpath {\n\t\t\tstroke: $__primarycolor;\n\t\t\tstroke-width: 4;\n\t\t\tbox-sizing: border-box;\n\t\t\t-webkit-transition: all 200ms linear;\n\t\t\ttransition: all 200ms linear;\n\t\t}\n\t}\n\tsvg {\n\t\tpath {\n\t\t\tfill: none;\n\t\t}\n\t}\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: '\\f062';\n\t\tfont-family: 'FontAwesome';\n\t\ttext-align: center;\n\t\tline-height: 35px;\n\t\tfont-size: 17px;\n\t\tcolor: $__primarycolor;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\tcursor: pointer;\n\t\tdisplay: block;\n\t\tz-index: 1;\n\t\t-webkit-transition: all 200ms linear;\n\t\ttransition: all 200ms linear;\n\t}\n}\niframe {\n    width: 100%;\n}","/*-----------------\n    22. About Us\n-----------------------*/\n\n.about-img {\n\tposition: $__relative;\n\t@include margin-padding(0 0 24px 0, null);\n\timg {\n\t\tborder-radius: 10px;\n\t\t@include margin-padding(null, 0 0 0 10px);\n\t}\n\t.about-exp {\n\t\tposition: $__absolute;\n\t\tbackground: $__primarycolor;\n\t\tborder-radius: 10px;\n\t\twidth: 370px;\n\t\theight: 100%;\n\t\t@include respond-below(custom767) {\n\t\t\twidth: 230px;\n\t\t}\t\t\t\n\t\tspan {\n\t\t\tfont-weight: $__medium;\n\t\t\tfont-size: $__font__size__28;\n\t\t\tcolor: $__white;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin: 250px -122px;\n\t\t\ttransform: rotate(-90deg);\n\t\t\t\t@include respond-below(custom767) {\n\t\t\t\t\tfont-size: $__font__size__18;\n\t\t\t\t\tmargin: 275px -90px;\n\t\t\t\t}\t\t\t\t\t\t\t\n\t\t\t\t@include respond-below(custom575) {\n\t\t\t\t\tfont-size: $__font__size__16;\n\t\t\t\t\tmargin: 115px -75px;\n\t\t\t\t}\n\t\t}\n\t}\n}\n.abt-img {\n\tpadding: 30px 0 30px 60px;\n\tposition: $__relative;\n\tz-index: 1;\n}\n.about-content {\n\t@include margin-padding(0 0 0 50px, null);\n\t\t@include respond-below(custom991) {\n\t\t\t@include margin-padding(0, null);\n\t\t}\n\th6 {\n\t\tfont-size: $__font__size__18;\n\t\tcolor: $__dark__blues;\n\t\tfont-weight: $__medium;\n\t\ttext-transform: uppercase;\n\t\t@include margin-padding(0 0 12px, null);\n\t}\n\th2 {\n\t\tfont-size: $__font__size__38;\n\t\tfont-weight: $__medium;\n\t\t@include margin-padding(0 0 30px, null);\n\t\t@include respond-below(custom991) {\n\t\t\tfont-size: $__font__size__28;\n\t\t}\n\t\t@include respond-below(custom767) {\n\t\t\tfont-size: $__font__size__24;\n\t\t}\n\t}\n\tp {\n\t\t@include margin-padding(0 0 14px, null);\n\t}\n\tul {\n\t\tli {\n\t\t\tposition: $__relative;\n\t\t\t@include margin-padding(0 0 15px, 0 0 0 25px);\n\t\t\tcolor: $__gray__lightdark;\n\t\t\t&::before {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tcontent: '\\f058';\n\t\t\t\tfont-family: 'FontAwesome';\n\t\t\t\tcolor: $__dark__blues;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t@include margin-padding(0, null);\n\t\t\t}\n\t\t}\n\t}\n}\n","/*-----------------\n    23. Product Details\n-----------------------*/\n\n.product-details {\n    position: $__relative;\n    z-index: 9;\n    @include margin-padding(null,80px 0 56px 0);\n    @include respond-below(custom991) {           \n        @include margin-padding(null,50px 0 26px 0);\n     }\n}\n.product-detail-head {\n    @include margin-padding(null,24px 0);\n    background: $__white;\n    box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);\n    @include respond-below(custom991) {            \n        @include margin-padding(null,24px 24px 9px);\n    }\n    .detail-page-head {\n        @extend %display-flex-center;\n        @extend %justify-content-between;\n        @include respond-below(custom767) {\n            display: block;\n        }\n        .list-rating {\n            margin-bottom: 15px;\n            @extend %display-flex-center;\n            i {\n                color: $__text-warning__light;\n            }\n        }        \n        .camaro-info {                \n            @include respond-below(custom767) {\n                margin-bottom: 15px;\n            }                \n        }\n        .camaro-location {\n            @extend %display-flex-center;\n            @include respond-below(custom575) {   \n               align-items: start;\n               flex-direction: column;    \n            }  \n            .camaro-location-inner {\n                @include respond-below(custom575) {   \n                    display: flex;\n                    align-items: baseline;\n                } \n            }\n            .camaro-locations-inner {\n                @extend %display-flex-center;\n            }    \n        }\n\n        .year {\n            display: $__inline__block;\n            @include margin-padding(0 13px 0 0,10px 15px);\n            background: $__dark__blues;\n            color: $__white;\n        }\n        .average-list-rating {\n            color: $__sandstone;\n            font-size: $__body__font__size;\n            font-weight: $__medium;\n            margin-left: 7px;\n        }\n        h3 {\n            font-weight: $__medium;\n            margin-bottom: 10px;\n        }\n    }\n    .search-btn {\n        .search-button {\n            background-color: $__primarycolor;\n            border: 1px solid $__primarycolor;                \n            box-shadow: inset 0 0 0 $__white;                \n            color: $__white;             \n            @include margin-padding(null, 12px 20px);           \n            @extend %animation-effect;\n                @include respond-below(custom991) {\n                    width: 250px;\n                } \n                @include respond-below(custom991) {\n                    @include margin-padding(null, 12px 8px);\n                }\n                @include respond-below(custom1199) {\n                    @include margin-padding(null, 12px 12px);\n                }                \n            &:hover {\n                background-color: $__white;\n                border: 1px solid #201F1D;\n                box-shadow: inset 0 70px 0 0 $__white;\n                color: #201F1D;\n                @extend %animation-effect;\n            }\n        }\n    }\n    .column-group-last {\n        -ms-flex: 10%;\n        flex: 10%;\n        max-width: 10%;\n            @include respond-below(custom575) {\n                -ms-flex: 100%;\n                flex: 100%;\n                max-width: 100%;\n            }\n            @include respond-below(custom991) {\n                -ms-flex: 50%;\n                flex: 50%;\n                max-width: 50%;\n            }         \n        &:last-child {\n            padding-right: 0;\n        }\n        .search-btn {\n            margin-top: 38px;\n            @include respond-below(custom575) {\n                @include margin-padding(0, null);\n            }\n        }\n    }\n    .column-group-main {\n        -ms-flex: 30%;\n        flex: 30%;\n        max-width: 30%;\n            @include respond-below(custom991) {\n                -ms-flex: 50%;\n                flex: 50%;\n                max-width: 50%;\n                margin-bottom: 15px;\n            }            \n            @include respond-below(custom575) {\n                -ms-flex: 100%;\n                flex: 100%;\n                max-width: 100%;\n                margin-bottom: 0;\n            } \n        &:last-child {\n            padding-right: 0;\n        }\n    }\n    .details-btn {\n        @extend %display-flex-center;        \n        @include respond-below(custom991) {            \n            @include margin-padding(0, null);\n            display: block;\n        }\n        gap: 15px;\n        a {\n            background: $__light__vampire;\n            color: $__sandstone;\n            border-radius: 40px;\n            @extend %display-flex-center;\n            @extend %justify-content-center; \n            @include margin-padding(null,15px 45px); \n            @include respond-below(custom991) {  \n                @include margin-padding(0 0 15px, null);\n            }\n            &:hover {\n                background: $__dark__blues;\n                color: $__white;\n                img {\n                    filter: contrast(50);\n                }\n            }\n            i {\n                margin-right: 8px;\n            }\n            img {\n                margin-right: 5px;\n            }\n    \n        }\n    }\n}\n\n.slick-track {\n    display: $__flex;\n}\n.slick-slide {\n    width: 25% !important;\n    margin: 0 10px;\n    overflow: $__hidden;\n    &.slick-cloned {\n        width: 25% !important;\n        margin: 0 10px;\n        overflow: $__hidden;\n    }\n    &.slick-active {\n        width: 25% !important;\n        margin: 0 10px;\n        overflow: $__hidden;\n    }\n    img {\n        width: 100%;\n        border-radius: 10px;\n    }\n}\n.detail-bigimg {\n    position: $__relative;\n    margin-bottom: 15px;\n    z-index: 999;\n    button {\n        width: 50px;\n        height: 50px;\n        font-size: 0;\n        background: $__white;\n        border-radius: 50%;\n        border: $__none;\n        z-index: 9999;\n        @include respond-below(custom991) {\n            width: 35px;\n            height: 35px;\n        }\n        &.slick-prev {\n            @include position($__absolute,50%,null,null,30px);\n            transform: translateY(-50%);\n            &:hover {\n                background: $__primarycolor !important;\n                color: $__white;\n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n            }\n            &:before {\n                content: \"\\f060\";\n                display:$__inline__block;\n                font-family: \"Font Awesome 5 Free\";\n                font-size: $__font__size__15;\n                font-weight: 900;  \n                @include respond-below(custom991) {\n                    font-size: $__font__size__13;\n                }\n            }\n        }\n        &.slick-next {\n            @include position($__absolute,50%,30px,null,null);\n            transform: translateY(-50%);\n            &:hover {\n                background: $__primarycolor !important;\n                color: $__white;\n                -webkit-transition: 500ms all ease;\n                -o-transition: 500ms all ease;\n                transition: 500ms all ease;\n                -moz-transition: 500ms all ease;\n                -ms-transition: 500ms all ease;\n            }\n            &:before {\n                content: \"\\f061\";\n                display:$__inline__block;\n                font-family: \"Font Awesome 5 Free\";\n                font-size: $__font__size__15;\n                font-weight: 900;  \n                @include respond-below(custom991) {\n                    font-size: $__font__size__13;\n                }\n            }\n        }\n\n     \n\n    }\n}\n.detail-product {\n    background: $__white;\n    box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);\n    border-radius: 5px;\n    overflow: $__hidden;\n    @include margin-padding(null, 20px 10px);\n}\n.extra-service {\n    span {\n        color: $__gray;\n        font-weight: $__medium;\n    }\n}\n\n.specification-card {\n    background: #fff;\n    padding: 24px 24px 0;\n    box-shadow: 3px 5px 13px rgba(222, 226, 231, 0.44);\n    margin: 24px 0 24px;\n    border: 0;\n    .card-body {\n        padding: 0;\n    }\n    .feature-img {\n        width: 60px;\n        height: 60px;\n        background: $__white;\n        border: 1px solid $__blue__light;\n        border-radius: 5px;\n        margin: 0 12px 0 0;\n        @extend %flex-align-center;\n        flex-shrink: 0;\n        &.access-feature {\n            margin-bottom: 0px;\n        }\n    \n    }\n    .featues-info {\n        h6 {\n        color: $__sandstone;\n        margin-bottom: 0;\n        font-weight: $__regular;\n        font-size: $__font__size__14;\n        }\n        span {\n            color: $__gray__dark;\n            font-weight: $__medium;\n            display: $__inline__block;\n            margin-bottom: 5px;\n        }\n    }\n    .featureslist {\n        margin: 0 0px 24px 0;\n    }\n    .access-feature.featureslist {\n        &:last-child {\n            margin: 0;\n        }\n    }\n}\n.listing-feature {\n    @include margin-padding(null, 24px 24px 9px);\n    ul {\n        li {\n            @extend %display-flex-center;\n            @include margin-padding(0 0 15px 0,null);\n            color: $__sandstone;\n            span {\n                padding: 8px;\n                @extend %flex-align-center;\n                background: $__dark__blues;\n                border-radius: 50%;\n                margin-right: 8px;\n                i {\n                    font-size: $__font__size__10;\n                    color: $__white;\n                }\n            }\n        }\n    }\n}\n.description-list {\n    p {\n        margin-bottom: 24px;\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n.review-header-group {\n    @include respond-below(custom575) {\n        flex-direction: column;\n        align-items: start;\n    }\n}\n.review-list-rating {\n    @extend %display-flex-center;\n    color: $__gray;\n    margin-top: 15px;\n    @include respond-below(custom767) {\n        flex-direction: column;\n        align-items: start;\n    }\n    li {\n        @extend %display-flex-center;\n        margin-right: 20px;\n        text-transform: capitalize;\n        @include respond-below(custom767) {\n            margin-bottom: 10px;\n            &:last-child {\n                margin-bottom: 0;\n            }\n        } \n        @include respond-below(custom1199) {\n            margin-right: 10px;\n        }\n        p {\n            margin-left: 8px;\n            i {\n                font-size: $__font__size__12;\n                color: $__warningcolor;\n            }\n        }\n     \n    }\n}\n.review-sec {\n    .leave-reply-form {\n        .review-list-rating {\n            margin-top: 0;\n            margin-bottom: 25px;\n            li {\n                p {\n                    i {\n                        color: $__gray__lightdark;\n                    }\n                }\n             \n            }\n        }\n    }\n}\n\n.short-video {\n    img {\n        border-radius: 10px;\n    }\n}\n.details-slider-heading {\n    margin-bottom: 25px;\n    h3 {\n        @include respond-below(custom767) { \n            margin-top: 30px\n        }\n    }\n}\n.details-car-grid {\n    @include margin-padding(null,50px 0 0);\n}\n.car-details-slider {\n    &.owl-carousel {\n        .owl-nav {\n            display: $__flex;\n            -webkit-display: $__flex;             \n            @include position($__absolute,-80px,0,null,null);           \n            @include respond-below(custom767) { \n                left: 0; \n                top: -100px\n            }\n            .owl-prev, .owl-next {\n                width: 55px;\n                height: 55px;\n                @extend %flex-align-center;\n                border: 1px solid $__light__gooses;\n                box-shadow: 0px 4px 24px $__primarylight;\n                background: $__white;\n                border-radius: 50%;\n                -webkit-transition: all 0.2s ease;\n                -ms-transition: all 0.2s ease;\n                transition: all 0.2s ease;\n                @include respond-below(custom991) {  \n                    width: 35px;\n                    height: 35px;\n                    font-size: 12px;\n                }\n                &:hover {\n                    background: $__primarycolor;\n                    color: $__white;\n                    -webkit-transition: all 0.2s ease;\n                    -ms-transition: all 0.2s ease;\n                    transition: all 0.2s ease;\n                }\n            }\n            .owl-next {\n                margin-left: 15px;\n            }\n        }\n    }\n    \n}\n.owner-detail {\n    display: $__flex;\n    align-items: $__center;\n    margin-bottom: 20px;\n    .owner-img {\n        img {\n            width: 80px;\n            height: 80px;\n            border-radius: 50%;\n            margin-right: 15px;\n            @include respond-below(custom991) { \n                width: 40px;\n                height: 40px;\n            }\n        }\n    }\n    .reviewbox-list-rating {\n        h5 {\n            color: $__gray;\n            font-size: $__font__size__18;\n            @include respond-below(custom991) { \n                font-size: $__font__size__16;\n                margin-bottom: 5px;\n            }\n        }\n    }\n}\n.booking-list {\n    margin-bottom: 20px;\n    li {\n        display: $__flex;\n        @extend %justify-content-spacebetween;\n        color: $__sandstone;\n        @include margin-padding(0 0 13px,0 0 13px);\n        border-bottom: 1px solid $__blue__light;\n        span {\n            color: $__gray;\n            font-size: $__font__size__16;\n        }\n        &:last-child {\n            border: $__none;\n            @include margin-padding(0 ,0);\n        }\n        h6 {\n            color: $__success__light    ;\n        }\n    }\n}\n.message-btn {\n    display: $__flex;\n    justify-content: $__center;\n    a {\n        width: 100%;\n        background: $__goose-gray;\n        color: $__white;\n        font-weight: $__bold;\n        font-size: $__font__size__16;\n        @include margin-padding(null, 12px 20px);\n        @include respond-below(custom991) {\n            font-size: $__font__size__15;\n            @include margin-padding(null, 10px 18px);\n        }\n        &:hover {\n            background-color: $__white;\n            border: 1px solid $__goose-gray;\n            box-shadow: inset 0 70px 0 0 $__white;\n            color: $__goose-gray;\n        }\n    }\n}\n.share-car {\n    ul {\n        display: $__flex;\n        li {\n            margin-right: 8px;\n            &:last-child {\n                margin-right: 0;\n            }\n            .fa-pinterest-p {\n                background: #ff2d20;\n            }\n        }\n    }\n}\n\n// Check Availability Modal\n\n.modal{\n    &.custom-modal{\n        &.check-availability-modal {\n            z-index: 99999;\n            .modal-dialog {\n                max-width: 660px\n            }\n            .modal-content {\n                @include margin-padding(null,30px);\n                @include respond-below(custom767) {\n                    @include margin-padding(null, 15px);  \n                }\n                .modal-header {\n                    @include margin-padding(0 0 20px,0 0 20px);\n                    .close {\n                        span {\n                            background: $__white;\n                            border: 3px solid $__dangered;\n                            border-radius: 10px 10px 10px 0;\n                            color: $__dangered;\n                        }\n                    }\n                }\n                .modal-body {\n                    @include margin-padding(0 0 20px 0,0);\n                }\n            }\n        }\n    }\n    .available-for-ride {\n        @extend %flex-align-center;\n        border: 1px solid $__success__light;\n        color: $__success__light;\n        border-radius: 5px;\n        padding: 15px;\n        background: rgba(31, 188, 47, 0.09);\n        margin-bottom: 20px;\n        p {\n            color: $__success__light;\n            font-size: $__font__size__18;\n            i {\n                margin-right: 8px;\n                font-size: $__font__size__14;\n            }\n        }\n\n    }\n    .booking-info {\n        border: 1px solid $__blue__light;\n        background: $__alice__blue;\n        border-radius: 10px;\n        @include margin-padding(0 0 20px 0, 20px);\n            @include respond-below(custom767) {\n                @include margin-padding(null, 15px);  \n            }\n        h5 {\n            margin-bottom: 15px;\n        }\n        p {\n            margin-bottom: 15px;\n        }\n        span {\n            color: $__gray__lightdark;\n        }\n        h6 {\n            color: $__gray__lightdark;\n            span {\n                color: $__dangered;\n                font-size: $__font__size__24;\n            }\n        }\n        &.seat-select {\n            background: $__white;\n            h6 {\n                color: $__gray;\n                font-size: $__font__size__15;\n                margin-bottom: 15px\n            }\n            label {\n                @extend %display-flex-center;\n                color: $__gray__lightdark;\n                font-size: $__font__size__14;\n                font-weight: $__semibold;\n                padding-left: 25px;\n                span {\n                    color: $__dangered;\n                }\n                input {\n                    &:checked {\n                        ~.checkmark{\n                            background: $__goose-gray;\n                            &::after {\n                                color: $__white;\n                            }\n                        }\n                    }\n    \n                }\n            }\n           \n        }\n        &.pay-amount {\n            background: $__white;\n            h6 {\n                margin-bottom: 15px;\n               \n            }\n            .radio-btn {\n                margin-bottom: 10px;\n            }\n            label {\n                padding-left: 0;\n                @extend %display-flex-center;\n                input {\n                    width: 15px;\n                    height: 15px;\n                    background: $__white;\n                    margin-right: 10px;\n                    &:checked {\n                        background: $__gray;\n                    }\n                }\n            }\n        }\n        &.service-tax {\n            background: $__white;\n            ul {\n                li{\n                    @extend %display-flex-center-between;\n                    color: $__dark__gray;\n                    @include margin-padding(0 0 20px 0, 0 0 20px 0);\n                    border-bottom: 1px solid $__blue__light;\n                    span {\n                        color: $__dark__gray;\n                    }\n                    &:last-child {\n                        @include margin-padding(0,0);\n                        border-bottom: $__none;\n                    }\n                }\n            }\n        }\n\n    }\n    .grand-total {\n        background: $__light__vampire;\n        @include margin-padding(null,20px);\n        @extend %display-flex-center-between;\n        border-radius: 10px;\n        h5 {\n            font-size: $__font__size__20;\n            color: $__gray;\n        }\n        span {\n            font-size: $__font__size__20;\n            color: $__gray;\n        }\n    }\n    .modal-footer {\n        @include margin-padding(0,0);\n        border: 0;\n        a {\n            @include margin-padding(0,12px 20px);  \n            background: $__goose-gray;\n            color: $__white;\n            @extend %display-flex-center;\n            i {\n                margin-left: 8px;\n            }\n        }\n    }\n    \n}\n\n// Booking \n.booking-section {\n    @include margin-padding(null,80px 0);  \n    @include respond-below(custom991) {\n        @include margin-padding(null,50px 0);  \n    }\n    .booking-tab {\n        justify-content: $__center;\n        margin-bottom: 30px;\n        @include respond-below(custom575) {\n            flex-direction: column;\n        }\n        li {\n            margin-right: 15px;\n            @include respond-below(custom575) {\n                @include margin-padding(0 0 20px 0,0); \n            }\n            a {\n                padding: 20px;\n                background: $__light__vampire;\n                min-width: 260px;\n                border: 1px solid $__white;\n                span {\n                    color: $__blue__light;\n                    margin-bottom: 8px;\n                    display: $__inline__block;\n                }\n                h5 {\n                    color: $__blue__light;\n                    font-size: $__font__size__20;\n                }\n                &.active {\n                    background: $__white;\n                    border: 1px solid $__light__gooses;\n                    h5 {\n                        color: $__gray;\n                    }\n                    span {\n                        color: $__dark__blues;  \n                        font-weight: $__semibold;\n                    }\n                }\n\n            }\n            &:last-child {\n                margin: 0;\n                @include respond-below(custom575) {\n                    margin: 0;\n                }\n            }\n        }\n    }\n}\n.booking-details {\n    max-width: 900px;\n    background: $__white;\n    border-radius: 10px;\n    @include margin-padding(0 $__auto 40px,30px);\n    .booking-title {\n        h3 {\n            color: $__black;\n            font-weight: $__semibold;\n            margin-bottom: 20px;\n        }\n    }\n    .booking-info {\n        border: 1px solid $__blue__light;\n        background: $__light__vampire;\n        border-radius: 10px;\n        @include margin-padding(0 0 20px 0, 20px);\n        .pickup-address {\n            padding-left: 0;\n            @include respond-below(custom767) {\n                margin-bottom: 20px;\n            }\n        }\n        .drop-address {\n            @include respond-below(custom767) {\n                margin-bottom: 20px;\n                padding-left: 0;\n            }\n        }\n        .booking-amount {\n            @include respond-below(custom767) {\n                padding-left: 0;\n            }\n        }\n        h5 {\n            color: $__gray;\n            font-size: $__font__size__18;\n            margin-bottom: 10px;\n        }\n        p {\n            color: $__gray__lightdark;\n            margin-bottom: 5px;\n        }\n        span {\n            color: $__gray__lightdark;\n        }\n        h6 {\n            color: $__gray__lightdark;\n            span {\n                color: $__dangered;\n                font-size: $__font__size__24;\n                i {\n                    color: $__light__smokey-grays;\n                    font-size: $__font__size__18;\n                }\n            }\n        }\n    }\n    .booking-form {\n        .booking-title {\n            h5 {\n                color: $__gray__dark;\n                font-size: $__font__size__20;\n                @include margin-padding(0 0 20px, 0 0 20px 0);\n                border-bottom: 1px solid $__blue__light;\n            }\n        }\n        .payment-btn {\n            @extend %display-flex-center;\n            justify-content: end;\n            button {\n                background: $__goose-gray;\n                color: $__white;\n                border: 1px solid $__goose-gray;\n                &:hover {\n                    background: $__white;\n                    color: $__goose-gray;\n                    border: 1px solid $__goose-gray;\n                }\n            }\n        }\n    }\n    &.payment-details {\n        max-width: 800px;\n    }\n}\n.back-detail-page {\n    text-align: $__center;\n    a {\n        color: $__dangered;\n    }\n  \n}\n.payment-method {\n    border: 1px solid $__blue__light;\n    padding: 20px;\n    border-radius: 10px;\n    h4 {\n        color: $__gray__dark;\n        font-size: $__font__size__20;\n        margin-bottom: 20px;\n        @include respond-below(custom575) {\n            font-size: $__font__size__16;\n        }\n    }\n    ul {\n        @extend %display-flex-between;\n        margin-bottom: 20px;\n        @include respond-below(custom767) {\n            flex-wrap: wrap;\n        }\n        li {\n            @include respond-below(custom767) {\n                flex-basis: 48%;\n                margin-bottom: 20px;\n                &:last-child {\n                    margin-bottom: 0;\n                }\n                &:nth-child(3) {\n                    margin-bottom: 0;\n                }\n                @include respond-below(custom575) {\n                    flex-basis: 100%;\n                    &:nth-child(3) {\n                        margin-bottom: 20px;\n                    }\n                }\n            }\n            a {\n                background: $__light__vampire;\n                width: 150px;\n                height: 100px;\n                border-radius: 10px;\n                @extend %flex-align-center;\n                @include respond-below(custom767) {\n                    width: $__full__width;\n                }\n            }\n        }\n    }\n    .payment-checkbox {\n        label {\n            @extend %display-flex-center;\n            color: $__grey;\n            font-weight: $__regular;\n            span {\n                color: $__dangered;\n            }\n            input {\n                &:checked {\n                    ~.checkmark{\n                        background: $__goose-gray;\n                        &::after {\n                            color: $__white;\n                        }\n                    }\n                }\n\n            }\n        }\n    }\n}\n\n// Payment Success Modal\n.modal{\n    &.custom-modal {\n        &.check-availability-modal {\n            &.payment-success-modal {\n                .modal-dialog {\n                    max-width: 400px;\n                    .modal-body {\n                        text-align: $__center;\n                        margin: 0;\n                    }\n                }\n            }\n        }\n    } \n    .payment-success {\n        .check {\n            width: 56px;\n            height: 56px;\n            border-radius: 50%;\n            @extend %flex-align-center;\n            background: $__success__light;\n            margin: $__auto;\n            margin-bottom: 25px;\n            i {\n                color: $__white;\n            }\n        }\n        h5 {\n            color: $__success__light;\n            font-size: $__font__size__24;\n            font-weight: $__bold;\n            margin-bottom: 8px;\n        }\n        p {\n            color: $__sandstone;\n            margin-bottom: 25px;\n            span {\n                color: $__goose-gray;\n                font-weight: $__semibold;\n               \n            }\n        }\n        .order-confirm {\n            a {\n                border:2px solid $__goose-gray;\n                color: $__goose-gray;\n                font-weight: $__bold;\n                padding: 10px 20px;\n                display: $__inline__block;\n                border-radius: 5px;\n            }\n        }\n    }\n}\n\n// Order Confirmation\n.order-confirmation {\n    @include margin-padding(null,80px 0);\n    @include respond-below(custom991) {\n        @include margin-padding(null,50px 0);\n    }\n    @include respond-below(custom767) {\n        @include margin-padding(null,40px 0);\n    }\n    .section-title {\n        max-width: 900px;\n        @include margin-padding(0 $__auto 20px, 0);\n        @include respond-below(custom767) {\n            display: block;\n        }\n        @extend %display-flex-center-between;\n        h5 {\n            color: $__gray;\n            @include respond-below(custom767) {\n                @include margin-padding(15px 0 0, null);\n            }\n            span {\n                font-weight: $__bold;\n                font-size: $__font__size__20;\n            }\n        }\n    }\n    .order-confirm-box {\n        .confirmation-title {\n            @extend %display-flex-center-between;\n            @include margin-padding(0 0 20px,0 0 20px);\n            border-bottom: 1px solid $__blue__light;\n            h4 {\n                color: $__gray__dark;\n                font-size: $__font__size__18;\n            }\n            a {\n                color: $__gray;\n                font-weight: $__semibold;\n                &:hover {\n                    color: $__primarycolor\n                }\n            }\n        }\n        .order-car {\n           @extend %display-flex-center;\n           margin-bottom: 20px;\n            img {\n                width: 90px;\n                border-radius: 10px;\n                margin-right: 10px;\n            }\n            h5 {\n                color: $__success__light;\n                font-size: $__font__size__18;\n                span {\n                   color: $__dangered;\n                   font-size: $__font__size__16;\n                   display: $__block; \n                   margin-top: 8px;\n                   font-weight: $__semibold;\n                }\n            }\n        }\n        .visa-card {\n            margin-bottom: 30px;\n            a {\n                display: $__block;\n                margin-bottom: 10px;\n            }\n            h6 {\n                color: $__sandstone;\n            }\n        }\n        .address-info {\n            @include respond-below(custom991) {\n                margin-bottom: 30px;\n            }\n            li {\n                color: $__sandstone;\n                margin-bottom: 10px;\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n    .place-order-btn {\n        text-align: $__right;\n        max-width: 900px;\n        margin: $__auto;\n        a {\n            @extend %inline-flex;\n            align-items: $__center;\n            @include margin-padding(null, 12px 20px);\n        }\n    }\n}\n// Modern Listing Details Styling\n.listing-details-modern {\n    background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%);\n    min-height: 100vh;\n\n    // Loading State\n    .loading-modern {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        min-height: 100vh;\n        gap: 20px;\n\n        .loading-spinner-modern {\n            position: relative;\n            width: 80px;\n            height: 80px;\n\n            .spinner-ring {\n                position: absolute;\n                border: 4px solid transparent;\n                border-top-color: #FFC107;\n                border-radius: 50%;\n                animation: spin 1.5s linear infinite;\n\n                &:nth-child(1) {\n                    width: 80px;\n                    height: 80px;\n                    animation-delay: 0s;\n                }\n\n                &:nth-child(2) {\n                    width: 60px;\n                    height: 60px;\n                    top: 10px;\n                    left: 10px;\n                    border-top-color: #FF9800;\n                    animation-delay: 0.3s;\n                }\n\n                &:nth-child(3) {\n                    width: 40px;\n                    height: 40px;\n                    top: 20px;\n                    left: 20px;\n                    border-top-color: #FFC107;\n                    animation-delay: 0.6s;\n                }\n            }\n        }\n\n        p {\n            color: rgba(255, 255, 255, 0.7);\n            font-size: 16px;\n            font-weight: 600;\n        }\n    }\n\n    // Not Found State\n    .not-found-modern {\n        text-align: center;\n        padding: 100px 20px;\n\n        i {\n            font-size: 80px;\n            color: #FFC107;\n            margin-bottom: 20px;\n        }\n\n        h2 {\n            color: white;\n            margin-bottom: 30px;\n        }\n    }\n\n    // Hero Section\n    .listing-hero-modern {\n        position: relative;\n        padding: 120px 0 60px;\n        background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n        overflow: hidden;\n\n        @media (max-width: 991px) {\n            padding: 100px 0 40px;\n        }\n\n        .hero-overlay-modern {\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: radial-gradient(circle at 50% 50%, rgba(255, 193, 7, 0.1) 0%, transparent 50%);\n            pointer-events: none;\n        }\n\n        .listing-hero-content {\n            position: relative;\n            z-index: 10;\n\n            .hero-badge-modern {\n                display: flex;\n                gap: 12px;\n                margin-bottom: 20px;\n\n                .year-badge {\n                    display: inline-flex;\n                    align-items: center;\n                    padding: 8px 20px;\n                    background: rgba(255, 193, 7, 0.1);\n                    border: 1px solid rgba(255, 193, 7, 0.3);\n                    border-radius: 50px;\n                    color: #FFC107;\n                    font-weight: 700;\n                    font-size: 14px;\n                }\n\n                .discount-badge {\n                    display: inline-flex;\n                    align-items: center;\n                    padding: 8px 20px;\n                    background: linear-gradient(135deg, #e63946, #d62828);\n                    border-radius: 50px;\n                    color: white;\n                    font-weight: 700;\n                    font-size: 14px;\n                    box-shadow: 0 4px 15px rgba(230, 57, 70, 0.3);\n                }\n            }\n\n            h1 {\n                font-size: 56px;\n                font-weight: 800;\n                color: white;\n                margin-bottom: 25px;\n                letter-spacing: -0.02em;\n                background: linear-gradient(135deg, #ffffff 0%, #FFC107 100%);\n                -webkit-background-clip: text;\n                -webkit-text-fill-color: transparent;\n                background-clip: text;\n\n                @media (max-width: 991px) {\n                    font-size: 40px;\n                }\n\n                @media (max-width: 767px) {\n                    font-size: 32px;\n                }\n            }\n\n            .hero-quick-specs {\n                display: flex;\n                gap: 30px;\n                flex-wrap: wrap;\n\n                @media (max-width: 767px) {\n                    gap: 20px;\n                }\n\n                span {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n                    color: rgba(255, 255, 255, 0.8);\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    i {\n                        color: #FFC107;\n                        font-size: 18px;\n                    }\n                }\n            }\n        }\n    }\n\n    // Content Section\n    .listing-content-modern {\n        background: #0a0a0a;\n        padding: 60px 0 80px;\n\n        @media (max-width: 991px) {\n            padding: 40px 0 60px;\n        }\n    }\n\n    // Image Gallery\n    .product-img-modern {\n        margin-bottom: 30px;\n        border-radius: 16px;\n        overflow: hidden;\n\n        .image-gallery {\n            background: rgba(255, 255, 255, 0.03);\n            border-radius: 16px;\n            padding: 15px;\n\n            .image-gallery-slide {\n                border-radius: 12px;\n                overflow: hidden;\n\n                img {\n                    border-radius: 12px;\n                }\n            }\n\n            .image-gallery-thumbnail {\n                border: 2px solid rgba(255, 255, 255, 0.1);\n                border-radius: 8px;\n                transition: all 0.3s ease;\n\n                &.active {\n                    border-color: #FFC107;\n                }\n\n                &:hover {\n                    border-color: rgba(255, 193, 7, 0.5);\n                }\n            }\n\n            .image-gallery-icon {\n                color: white;\n                filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.5));\n\n                &:hover {\n                    color: #FFC107;\n                }\n            }\n        }\n    }\n\n    // Specs Card\n    .specs-card-modern {\n        background: rgba(255, 255, 255, 0.03);\n        backdrop-filter: blur(10px);\n        border: 1px solid rgba(255, 255, 255, 0.1);\n        border-radius: 16px;\n        padding: 30px;\n        margin-bottom: 30px;\n\n        @media (max-width: 991px) {\n            padding: 20px;\n        }\n\n        .card-header-modern {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            margin-bottom: 25px;\n            padding-bottom: 15px;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n            i {\n                color: #FFC107;\n                font-size: 24px;\n            }\n\n            h4 {\n                color: white;\n                font-size: 22px;\n                font-weight: 700;\n                margin: 0;\n            }\n        }\n\n        .card-body-modern {\n            .specs-grid-modern {\n                .spec-item-modern {\n                    display: flex;\n                    align-items: center;\n                    gap: 15px;\n                    padding: 15px;\n                    background: rgba(255, 255, 255, 0.02);\n                    border-radius: 10px;\n                    margin-bottom: 15px;\n                    transition: all 0.3s ease;\n\n                    @media (max-width: 767px) {\n                        padding: 12px;\n                    }\n\n                    &:hover {\n                        background: rgba(255, 193, 7, 0.05);\n                        border: 1px solid rgba(255, 193, 7, 0.2);\n                        transform: translateX(5px);\n                    }\n\n                    .spec-icon-modern {\n                        width: 45px;\n                        height: 45px;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        background: rgba(255, 193, 7, 0.1);\n                        border-radius: 10px;\n                        flex-shrink: 0;\n\n                        i {\n                            color: #FFC107;\n                            font-size: 20px;\n                        }\n                    }\n\n                    .spec-info-modern {\n                        flex: 1;\n\n                        span {\n                            display: block;\n                            font-size: 12px;\n                            color: rgba(255, 255, 255, 0.5);\n                            margin-bottom: 3px;\n                            text-transform: uppercase;\n                            letter-spacing: 0.5px;\n                        }\n\n                        h6 {\n                            color: white;\n                            font-size: 16px;\n                            font-weight: 700;\n                            margin: 0;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    // Description Card\n    .description-card-modern {\n        background: rgba(255, 255, 255, 0.03);\n        backdrop-filter: blur(10px);\n        border: 1px solid rgba(255, 255, 255, 0.1);\n        border-radius: 16px;\n        padding: 30px;\n\n        @media (max-width: 991px) {\n            padding: 20px;\n        }\n\n        .card-header-modern {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            margin-bottom: 20px;\n            padding-bottom: 15px;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n            i {\n                color: #FFC107;\n                font-size: 24px;\n            }\n\n            h4 {\n                color: white;\n                font-size: 22px;\n                font-weight: 700;\n                margin: 0;\n            }\n        }\n\n        .card-body-modern {\n            p {\n                color: rgba(255, 255, 255, 0.8);\n                font-size: 15px;\n                line-height: 1.8;\n                margin: 0;\n            }\n        }\n    }\n\n    // Inquiry Card (Sidebar)\n    .sticky-sidebar-modern {\n        position: sticky;\n        top: 100px;\n\n        @media (max-width: 991px) {\n            position: static;\n            margin-top: 30px;\n        }\n    }\n\n    .inquiry-card-modern {\n        background: rgba(255, 255, 255, 0.03);\n        backdrop-filter: blur(10px);\n        border: 1px solid rgba(255, 255, 255, 0.1);\n        border-radius: 16px;\n        padding: 30px;\n\n        @media (max-width: 991px) {\n            padding: 25px;\n        }\n\n        .price-section-modern {\n            text-align: center;\n            padding: 25px;\n            background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 152, 0, 0.1));\n            border-radius: 12px;\n            margin-bottom: 25px;\n\n            .price-label {\n                font-size: 13px;\n                color: rgba(255, 255, 255, 0.6);\n                text-transform: uppercase;\n                letter-spacing: 1px;\n                margin-bottom: 10px;\n            }\n\n            .price-old {\n                font-size: 18px;\n                color: rgba(255, 255, 255, 0.5);\n                text-decoration: line-through;\n                margin-bottom: 5px;\n            }\n\n            .price-current {\n                font-size: 42px;\n                font-weight: 800;\n                color: white;\n                line-height: 1;\n                background: linear-gradient(135deg, #FFC107, #FF9800);\n                -webkit-background-clip: text;\n                -webkit-text-fill-color: transparent;\n                background-clip: text;\n\n                @media (max-width: 767px) {\n                    font-size: 36px;\n                }\n            }\n\n            .savings-badge {\n                display: inline-flex;\n                align-items: center;\n                gap: 6px;\n                margin-top: 12px;\n                padding: 8px 16px;\n                background: linear-gradient(135deg, #e63946, #d62828);\n                border-radius: 50px;\n                color: white;\n                font-size: 13px;\n                font-weight: 700;\n\n                i {\n                    font-size: 14px;\n                }\n            }\n        }\n\n        .divider-modern {\n            height: 1px;\n            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n            margin: 25px 0;\n        }\n\n        .form-header-modern {\n            text-align: center;\n            margin-bottom: 25px;\n\n            i {\n                font-size: 32px;\n                color: #FFC107;\n                margin-bottom: 10px;\n            }\n\n            h4 {\n                color: white;\n                font-size: 20px;\n                font-weight: 700;\n                margin-bottom: 8px;\n            }\n\n            p {\n                color: rgba(255, 255, 255, 0.6);\n                font-size: 13px;\n                margin: 0;\n            }\n        }\n\n        .inquiry-form-modern {\n            .form-group-modern {\n                margin-bottom: 20px;\n\n                label {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n                    color: rgba(255, 255, 255, 0.8);\n                    font-size: 14px;\n                    font-weight: 600;\n                    margin-bottom: 8px;\n\n                    i {\n                        color: #FFC107;\n                        font-size: 16px;\n                    }\n                }\n\n                .input-modern {\n                    width: 100%;\n                    padding: 12px 16px;\n                    background: rgba(255, 255, 255, 0.05);\n                    border: 1px solid rgba(255, 255, 255, 0.1);\n                    border-radius: 10px;\n                    color: white;\n                    font-size: 14px;\n                    transition: all 0.3s ease;\n\n                    &:focus {\n                        outline: none;\n                        border-color: rgba(255, 193, 7, 0.5);\n                        background: rgba(255, 255, 255, 0.08);\n                        box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);\n                    }\n\n                    &::placeholder {\n                        color: rgba(255, 255, 255, 0.4);\n                    }\n\n                    &.textarea-modern {\n                        resize: vertical;\n                        min-height: 100px;\n                    }\n                }\n            }\n\n            .btn-submit-modern {\n                width: 100%;\n                padding: 14px 20px;\n                background: linear-gradient(135deg, #FFC107, #FF9800);\n                border: none;\n                border-radius: 10px;\n                color: #1a1a1a;\n                font-size: 16px;\n                font-weight: 700;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 8px;\n                transition: all 0.3s ease;\n                cursor: pointer;\n\n                i {\n                    font-size: 18px;\n                }\n\n                &:hover:not(:disabled) {\n                    transform: translateY(-2px);\n                    box-shadow: 0 8px 25px rgba(255, 193, 7, 0.4);\n                }\n\n                &:disabled {\n                    opacity: 0.7;\n                    cursor: not-allowed;\n                }\n            }\n\n            .contact-alternatives-modern {\n                margin-top: 20px;\n                padding-top: 20px;\n                border-top: 1px solid rgba(255, 255, 255, 0.1);\n\n                .alternative-label {\n                    text-align: center;\n                    font-size: 12px;\n                    color: rgba(255, 255, 255, 0.5);\n                    margin-bottom: 12px;\n                }\n\n                .btn-call-modern {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    gap: 10px;\n                    padding: 12px 20px;\n                    background: rgba(40, 167, 69, 0.1);\n                    border: 1px solid rgba(40, 167, 69, 0.3);\n                    border-radius: 10px;\n                    color: #28a745;\n                    font-size: 15px;\n                    font-weight: 600;\n                    text-decoration: none;\n                    transition: all 0.3s ease;\n\n                    i {\n                        font-size: 18px;\n                    }\n\n                    &:hover {\n                        background: #28a745;\n                        color: white;\n                        border-color: #28a745;\n                        transform: translateY(-2px);\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Page Transition Animations\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes fadeInPage {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.main-wrapper {\n    animation: fadeInPage 0.5s ease-out;\n}\n\n        // Updated CTA Section\n        .cta-section-modern {\n            h4 {\n                color: white;\n                font-size: 20px;\n                font-weight: 700;\n                margin-bottom: 8px;\n                text-align: center;\n            }\n\n            p {\n                color: rgba(255, 255, 255, 0.6);\n                font-size: 14px;\n                text-align: center;\n                margin-bottom: 25px;\n            }\n\n            .btn-call-primary-modern {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 15px;\n                width: 100%;\n                padding: 20px 24px;\n                background: linear-gradient(135deg, #28a745, #20c997);\n                border: none;\n                border-radius: 12px;\n                text-decoration: none;\n                transition: all 0.3s ease;\n                box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);\n                margin-bottom: 20px;\n                position: relative;\n                overflow: hidden;\n\n                &::before {\n                    content: '';\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    width: 0;\n                    height: 0;\n                    border-radius: 50%;\n                    background: rgba(255, 255, 255, 0.2);\n                    transform: translate(-50%, -50%);\n                    transition: width 0.6s, height 0.6s;\n                }\n\n                &:hover {\n                    transform: translateY(-3px) scale(1.02);\n                    box-shadow: 0 12px 35px rgba(40, 167, 69, 0.5);\n\n                    &::before {\n                        width: 400px;\n                        height: 400px;\n                    }\n\n                    .btn-call-number {\n                        transform: scale(1.05);\n                    }\n                }\n\n                i {\n                    font-size: 28px;\n                    color: white;\n                    animation: phonePulse 2s ease-in-out infinite;\n                }\n\n                .btn-call-content {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: flex-start;\n                    gap: 2px;\n\n                    .btn-call-label {\n                        font-size: 13px;\n                        color: rgba(255, 255, 255, 0.9);\n                        text-transform: uppercase;\n                        letter-spacing: 1px;\n                        font-weight: 600;\n                    }\n\n                    .btn-call-number {\n                        font-size: 22px;\n                        color: white;\n                        font-weight: 800;\n                        transition: transform 0.3s ease;\n                    }\n                }\n            }\n\n            .or-divider-modern {\n                position: relative;\n                text-align: center;\n                margin: 20px 0;\n\n                &::before,\n                &::after {\n                    content: '';\n                    position: absolute;\n                    top: 50%;\n                    width: 40%;\n                    height: 1px;\n                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n                }\n\n                &::before {\n                    left: 0;\n                }\n\n                &::after {\n                    right: 0;\n                }\n\n                span {\n                    display: inline-block;\n                    padding: 0 15px;\n                    background: rgba(255, 255, 255, 0.03);\n                    color: rgba(255, 255, 255, 0.5);\n                    font-size: 12px;\n                    text-transform: uppercase;\n                    letter-spacing: 1px;\n                    border-radius: 50px;\n                }\n            }\n\n            .btn-form-toggle-modern {\n                width: 100%;\n                padding: 14px 20px;\n                background: rgba(255, 255, 255, 0.05);\n                border: 1px solid rgba(255, 255, 255, 0.15);\n                border-radius: 10px;\n                color: rgba(255, 255, 255, 0.9);\n                font-size: 15px;\n                font-weight: 600;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 10px;\n                transition: all 0.3s ease;\n                cursor: pointer;\n                margin-bottom: 20px;\n\n                i {\n                    font-size: 18px;\n                }\n\n                &:hover {\n                    background: rgba(255, 255, 255, 0.08);\n                    border-color: rgba(255, 193, 7, 0.3);\n                    color: #FFC107;\n                }\n            }\n\n            .inquiry-form-modern {\n                max-height: 0;\n                overflow: hidden;\n                opacity: 0;\n                transition: all 0.5s ease;\n\n                &.expanded {\n                    max-height: 1000px;\n                    opacity: 1;\n                    margin-top: 10px;\n                }\n            }\n        }\n\n@keyframes phonePulse {\n    0%, 100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.1);\n    }\n}\n\n        // Updated Price Section with VAT Breakdown\n        .price-section-modern {\n            padding: 25px;\n            background: linear-gradient(135deg, rgba(255, 193, 7, 0.08), rgba(255, 152, 0, 0.08));\n            border-radius: 12px;\n            margin-bottom: 25px;\n            border: 1px solid rgba(255, 193, 7, 0.2);\n        }\n\n        .price-breakdown-modern {\n            .price-row-discount,\n            .price-row-base,\n            .price-row-vat,\n            .price-row-total {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: 12px;\n\n                span:first-child {\n                    color: rgba(255, 255, 255, 0.7);\n                    font-size: 14px;\n                    font-weight: 600;\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n                }\n            }\n\n            .price-row-discount {\n                .price-old-inline {\n                    color: rgba(255, 255, 255, 0.5);\n                    font-size: 16px;\n                    text-decoration: line-through;\n                }\n            }\n\n            .price-row-base {\n                .price-base {\n                    color: white;\n                    font-size: 20px;\n                    font-weight: 700;\n                }\n            }\n\n            .price-row-vat {\n                .vat-regime-badge {\n                    display: inline-flex;\n                    align-items: center;\n                    gap: 3px;\n                    padding: 2px 8px;\n                    background: rgba(33, 150, 243, 0.2);\n                    border-radius: 10px;\n                    font-size: 11px;\n                    color: #2196F3;\n                    margin-left: 6px;\n                    cursor: help;\n\n                    i {\n                        font-size: 12px;\n                    }\n                }\n\n                .vat-amount {\n                    color: rgba(255, 255, 255, 0.9);\n                    font-size: 16px;\n                    font-weight: 600;\n                }\n            }\n\n            .price-row-total {\n                margin-bottom: 0 !important;\n\n                span:first-child {\n                    color: white;\n                    font-size: 16px;\n                    font-weight: 700;\n                    text-transform: uppercase;\n                    letter-spacing: 0.5px;\n                }\n\n                .price-total {\n                    font-size: 32px;\n                    font-weight: 800;\n                    background: linear-gradient(135deg, #FFC107, #FF9800);\n                    -webkit-background-clip: text;\n                    -webkit-text-fill-color: transparent;\n                    background-clip: text;\n\n                    @media (max-width: 767px) {\n                        font-size: 28px;\n                    }\n                }\n            }\n\n            .savings-badge-inline {\n                display: inline-flex;\n                align-items: center;\n                gap: 6px;\n                padding: 6px 12px;\n                background: linear-gradient(135deg, #e63946, #d62828);\n                border-radius: 50px;\n                color: white;\n                font-size: 12px;\n                font-weight: 700;\n                margin-bottom: 12px;\n                align-self: flex-start;\n\n                i {\n                    font-size: 13px;\n                }\n            }\n\n            .price-divider {\n                height: 1px;\n                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);\n                margin: 15px 0;\n            }\n\n            .price-divider-bold {\n                height: 2px;\n                background: linear-gradient(90deg, transparent, rgba(255, 193, 7, 0.3), transparent);\n                margin: 15px 0;\n            }\n\n            .vat-included-notice {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 8px;\n                margin-top: 15px;\n                padding: 10px 15px;\n                background: rgba(33, 150, 243, 0.15);\n                border: 1px solid rgba(33, 150, 243, 0.3);\n                border-radius: 8px;\n                color: #64B5F6;\n                font-size: 13px;\n                font-weight: 600;\n\n                i {\n                    font-size: 16px;\n                }\n            }\n\n            // Premium Price Row Styles\n            .price-row-base-premium {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: 16px;\n                padding: 16px;\n                background: rgba(255, 255, 255, 0.05);\n                border-radius: 12px;\n                border: 1px solid rgba(255, 255, 255, 0.1);\n\n                span:first-child {\n                    color: rgba(255, 255, 255, 0.9);\n                    font-size: 15px;\n                    font-weight: 600;\n                    text-transform: uppercase;\n                    letter-spacing: 0.5px;\n                }\n\n                .price-base-value {\n                    color: white;\n                    font-size: 24px;\n                    font-weight: 800;\n                }\n            }\n\n            .price-row-vat-premium {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: 16px;\n                padding: 16px;\n                background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05));\n                border-radius: 12px;\n                border: 1px solid rgba(76, 175, 80, 0.3);\n                box-shadow: 0 2px 8px rgba(76, 175, 80, 0.1);\n\n                .vat-label-container {\n                    display: flex;\n                    align-items: center;\n                    gap: 10px;\n\n                    span:first-child {\n                        color: #81C784;\n                        font-size: 15px;\n                        font-weight: 600;\n                        text-transform: uppercase;\n                        letter-spacing: 0.5px;\n                    }\n\n                    .vat-badge-deductible {\n                        display: inline-flex;\n                        align-items: center;\n                        justify-content: center;\n                        padding: 4px 10px;\n                        background: linear-gradient(135deg, #4CAF50, #66BB6A);\n                        border-radius: 10px;\n                        color: white;\n                        font-size: 12px;\n                        font-weight: 800;\n                        box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);\n                        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n                    }\n                }\n\n                .vat-amount-value {\n                    color: #4CAF50;\n                    font-size: 20px;\n                    font-weight: 700;\n                }\n            }\n\n            .price-row-total-premium {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                padding: 20px;\n                background: linear-gradient(135deg, rgba(255, 193, 7, 0.15), rgba(255, 152, 0, 0.1));\n                border-radius: 12px;\n                border: 2px solid rgba(255, 193, 7, 0.4);\n                box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);\n                margin-bottom: 0 !important;\n\n                span:first-child {\n                    color: white;\n                    font-size: 18px;\n                    font-weight: 700;\n                    text-transform: uppercase;\n                    letter-spacing: 1px;\n                }\n\n                .price-total {\n                    font-size: 36px;\n                    font-weight: 800;\n                    background: linear-gradient(135deg, #FFC107, #FF9800);\n                    -webkit-background-clip: text;\n                    -webkit-text-fill-color: transparent;\n                    background-clip: text;\n                    text-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);\n\n                    @media (max-width: 767px) {\n                        font-size: 30px;\n                    }\n                }\n            }\n        }\n","/*-----------------\n    24. Products\n-----------------------*/\n\n.accordion {\n    border-bottom: 1px solid $__light__gooses;\n    margin-bottom: 18px;\n         .filter-title {            \n             margin-bottom: 20px;\n                a {\n                    font-size: $__font__size__18;\n                    color: $__secondarycolor;\n                    display: $__inline__block;\n                    @include respond-below(custom991) {\n                        font-size: $__font__size__16;\n                    } \n                }\n        }\n        .view-all {\n            margin-bottom: 15px;\n            font-weight: $__medium;\n            font-size: $__font__size__12;\n            color: $__primarycolor;\n        }\n    }\n    .accordion-last {\n            border: 0;\n    }\n    .filter-range {\n        .irs--flat {\n            .irs-grid {\n                display: $__none;\n            }\n            .irs-min,.irs-max,.irs-grid-text {\n                visibility: hidden !important;\n            }\n            .irs-line {\n                background: $__white;\n            }\n            .irs-bar {\n                background: $__warningcolor;\n                height: 8px;\n            }\n            .irs-single {\n                background: $__warningcolor;\n                width: 50px;\n                text-align: $__center;\n                margin-left: 10px;\n                &:before {\n                    border-top-color: $__warningcolor;\n                }\n            }\n            .irs-handle {\n                &.state_hover {\n                    > i:first-child {\n                        background: $__warningcolor;\n                    }\n                }\n                &:hover {\n                    i {\n                        background: $__warningcolor;\n                    }\n                }\n                & >i {\n                    background: $__warningcolor;\n                    width: 15px;\n                    height: 15px;\n                    border-radius: 50%;\n                    &:first-child {\n                     \n                    }\n                }\n            }\n        }\n    }\n.product-search {    \n    @include margin-padding(0 0 20px, null);\n    border-bottom: 1px solid $__light__gooses;\n}\n.form-custom {\n    position: $__relative;\n     .form-control {\n        @include margin-padding(null, 10px);\n        @include margin-padding(0 0 20px, null);\n        font-weight: $__medium;\n        font-size: $__font__size__14;\n        color: $__gray__lightdark;\n        background: $__cylindrical;\n        border: 1px solid $__light__gooses;\n        &:focus {\n            background: $__white;\n            outline: none;\n        }\n        &::placeholder {\n            color: $__gray__lightdark;\n        }\n    }\n        span {\n            img {\n            @include position($__absolute,null,null,null,null);\n            right: 15px;\n            top: 50%;\n            transform: translate(-5%, -50%);\n            }\n        }\n}\n.open-filter {\n    .custom_check {\n        color: $__gray__dark;\n        i {\n            color: red;\n        }\n    }\n    i {\n        transition: 0.2s;\n    }\n}\n.accordion {    \n    .collapsed {\n        i {\n            color: $__gray__dark;\n            transition: 0.2s;\n            transform: rotate(-180deg);\n        }\n    }\n    .float-end {\n        color: $__gray__dark;\n        font-size: $__font__size__14;\n        margin-top: 3px;\n    }\n}\n.list-btn {\n    @include respond-below(custom768) {\n        display: $__none;\n    }\n\t.filter-list {\n\t\t@extend %display-flex-center;\n        @include respond-below(custom320) {\n            display: $__block !important;\n        }\n        .short-filter {\n            @extend %display-flex-center;\n            border: 1px solid $__dark__gray;\n            @include rounded(8px);\n            color: $__gray__dark;\n            font-size: $__font__size__14;\n            height: 39px;\n            padding: 10px;\n            background: $__white;\n            .sort {\n                background: transparent;\n                border: none;\n                outline: 0;\n                font-size: $__font__size__12;\n                font-weight: $__semibold;\n                color: $__grayish__blue;\n            }\n        }\n\t\tli {\n            @include margin-padding(null, 0 5px 0 0);\n            @include respond-below(custom320) {\n                @include margin-padding(0 0 10px, null);\n            }\n            a.active {\n                border: 1px solid $__primarycolor !important;\n                color: $__primarycolor !important;\n            }\n\t\t\t&:last-child {\n\t\t\t\t@include margin-padding(null, 0);               \n\t\t\t}\n            ul {\n                li {\n                    @include margin-padding(null, 0);\n                    @include margin-padding(0 0 10px, null);\n                    @extend %display-flex-center;\n                    .download-item {\n                        color: $__gray__dark;\n                        font-size: $__font__size__14;\n                        margin: auto;\n                        &:hover {\n                            color: $__primarycolor;\n                        }\n                    }                    \n                    &:last-child {\n                        margin-bottom: 0;\n                        padding-bottom: 0;              \n                    }\n                }\n            }\n\t\t}\n\t}\n\t.btn-filters {\n        border: 1px solid $__dark__gray;\n        @include rounded(8px);\n        color: $__gray__dark;\n        min-width: 39px;\n        height: 39px;\n        @extend %flex-align-center;\n        background: $__white;\n        @include transition(all 0.4s ease);\n        @include respond-below(custom320) {\n            max-width: 140px;\n        }\n            span {\n                margin-bottom: 0;\n                line-height: 0;\n                 font-size: $__font__size__18;\n            }\n\t\t&:hover {\n\t\t\tbox-shadow: 0 40px 0 0 $__primarycolor inset;\n            @include transition(all 0.4s ease);\n\t\t\tcolor: $__white;\n\t\t\ti {\n\t\t\t\tcolor: $__white;\n\t\t\t}\n\t\t}\n\t}\n    .dropdown-menu {\n        background: #FFFFFF;\n        border: 1px solid #E0E0E0;\n        box-shadow: 0px 16px 32px rgb(190 190 190 / 20%);\n        border-radius: 12px;\n        padding: 10px;\n        margin-top: 10px !important;\n        min-width: 100px;\n        .dropdown-item {\n            font-weight: 500;\n            font-size: 14px;\n            color: #878A99;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;            \n        }\n    }\n}\n.custom_check {\n    color: $__gray__lightdark;\n    display: $__inline__block;\n    position: $__relative;\n    font-size: 14px;\n    margin-bottom: 15px;\n    padding-left: 30px;\n    cursor: $__pointer;\n    font-weight: $__regular;\n    user-select: $__none;\n    input:checked ~ .checkmark {\n        background-color: $__secondarycolor;\n        border-color: $__secondarycolor;\n        &:after {\n            display: $__block;\n            top: 1px;\n            left: 5px;\n            font-size: 10px;\n        }\n    }\n    input {\n        position: $__absolute;\n        opacity: 0;\n        cursor: $__pointer;\n    }\n    .checkmark {\n        position: $__absolute;\n        top: 0;\n        left: 0;\n        height: 19px;\n        width: 19px;\n        border: 1px solid #C4C4C4;\n        background-color: $__white;\n        border-radius: 4px;\n        border: 1px solid $__blue__light;\n        background: $__cylindrical;\n        border-radius: 6px;\n        transition: all 0.3s ease-in-out;\n        &::after {\n            content: \"\\f00c\";\n            font-family: \"Font Awesome 5 Free\";\n            font-weight: 900;\n            position: $__absolute;\n            display: $__none;\n            left: 4px;\n            top: 2px;\n            color: $__white;\n            font-size: 9px;\n        }\n    }\n}\n.input-block{\n    .custom_check{\n        margin-bottom: 15px;\n    }\n}\n.car-listing {\n    .sidebar-form {\n        background: $__white;\n        @include margin-padding(null, 20px);\n        border-radius: 10px;\n        box-shadow: 0px 4px 24px $__primarylight;\n        @include respond-below(custom1199) {\n            margin-bottom: 24px;\n        }\n        .sidebar-heading {\n            h3 {\n                font-weight: $__medium;\n                font-size: $__font__size__18;\n                margin-bottom: 15px;\n                @include respond-below(custom991) {\n                    font-size: $__font__size__16;\n                } \n            }\n        }\n        .custom_check {\n            i {\n                color: $__warningcolor;\n            }\n        }\n        .reset-filter {\n            display: $__block;\n            text-align: $__center;\n            margin-top: 15px;\n            color: $__dangered;\n            &:hover {\n                color: $__primarycolor;\n            }\n        }\n    }\n    .blog-pagination {\n        margin-top: 25px;\n        @include respond-below(custom479) {\n            margin-top: 10px;\n        }\n    }\n    .pagination {\n        flex-wrap: wrap;\n        .previtem,.nextlink {\n            @include respond-below(custom479) {\n                margin-bottom: 10px;\n            }\n            a {\n                height: 38px;\n                @extend %flex-align-center;\n                border-radius: 10px;\n                padding: 0 20px;\n                color: $__gray;\n                &:focus {\n                    outline: 0;\n                    box-shadow: $__none;\n                }\n            }\n        }\n        li {\n            .page-group {\n                ul {\n                    @include respond-below(custom479) {\n                        flex-wrap: wrap;\n                    }\n                    li {\n                        @include respond-below(custom479) {\n                            margin-bottom: 10px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .filter-btn {\n        padding: 10px 15px;\n        span {\n            line-height: 1;\n        }\n        &:active {\n            background: $__text-warning__light;\n            border-color: $__primarycolor;\n        }\n    }\n}\n.sorting-div {\n    .count-search {\n        @include respond-below(custom991) {\n            margin-bottom: 20px;\n        }\n            \n    }\n    .product-filter-group {\n        @extend %display-flex-center;\n        @extend %jusflex-end;\n        @include respond-below(custom575) {\n            display: block;\n         }\n        @include respond-below(custom991) {\n           justify-content: flex-start;\n        }\n        .sortbyset {\n            @extend %display-flex-center;\n            @include respond-below(custom575) {\n                flex-wrap: wrap;\n             }\n            .sortbytitle {\n                margin-right: 10px;\n                @include respond-below(custom575) {\n                    @include margin-padding(0 0 10px, null);\n                 }\n            }\n            .sorting-select {\n                margin-right: 10px;\n                &.select-one {\n                    width: 90px;\n                    @include respond-below(custom575) {\n                       margin-bottom: 15px;\n                       width: 100%;\n                    }\n                }\n                &.select-two {\n                    width: 150px;\n                    @include respond-below(custom575) {\n                        margin-bottom: 15px;\n                        width: 100%;\n                    }\n                }\n                &.select-three {\n                    width: 300px;                     \n                    @include respond-below(custom767) {\n                        width: 300px;\n                    }                                    \n                    @include respond-below(custom575) {\n                        margin-bottom: 15px;\n                        width: 100%;\n                    }\n                }\n            }\n        }\n        .grid-listview {\n            ul {\n                @extend %display-flex-center;\n            }\n\n        }\n    }\n}.sortby-sec {\n    background: $__white;\n    @include margin-padding(null, 30px 0);\n    box-shadow: 0px 4px 24px rgba(225, 225, 225, 0.25);\n}\n.grid-listview {\n    ul {\n        li {\n            margin-right: 10px;\n            a {\n                width: 40px;\n                height: 40px;\n                @extend %flex-align-center;\n                background: $__light__gooses;\n                border-radius: 5px;\n                -webkit-transition: all 0.5s;\n                -moz-transition: all 0.5s;\n                -o-transition: all 0.5s;\n                transition: all 0.5s;\n                &.active {\n                    background: $__dark__blues;\n                    i {\n                        color: $__white;\n                    }\n                }\n                &:hover {\n                    background: $__dark__blues;\n                    -webkit-transition: all 0.5s;\n                    -moz-transition: all 0.5s;\n                    -o-transition: all 0.5s;\n                    transition: all 0.5s;\n                    i {\n                        color: $__white;\n                        -webkit-transition: all 0.5s;\n                        -moz-transition: all 0.5s;\n                        -o-transition: all 0.5s;\n                        transition: all 0.5s;\n                    }\n                }\n                i {\n                    color:$__sandstone;\n                    font-size: $__font__size__16;\n                }\n            }\n            &:last-child {\n                margin: 0;\n            }\n        }\n    }\n}\n.listview-car {\n    .card {\n        margin-bottom: 24px;        \n        @include margin-padding(null, 20px);\n        .blog-img {\n            margin-right: 15px;\n            flex-shrink: 0.5;\n            overflow: $__hidden;\n            border-radius: 10px;\n            @include respond-below(custom767) {\n                margin-right: 0;\n                margin-bottom: 15px;\n                width: 100%;\n            }\n            img {\n                border-radius: 10px;\n                -webkit-transition: all 0.5s ease;\n                -ms-transition: all 0.5s ease;\n                transition: all 0.5s ease;\n                @include respond-below(custom767) {\n                    width: 100%;\n                }\n            }\n            &:hover {\n                img {\n                    -webkit-transform: scale(1.15);\n                    -moz-transform: scale(1.15);\n                    transform: scale(1.15);\n                    -webkit-transition: all 0.5s ease;\n                    -ms-transition: all 0.5s ease;\n                    transition: all 0.5s ease;\n                }\n            }\n        }\n        .blog-widget {\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: $__center;\n            }\n        }\n        .card-body {\n            @include margin-padding(0,0);\n            .blog-list-head {\n                @extend %justify-content-between;\n                margin-bottom: 15px;\n                @include respond-below(custom767) {\n                    margin-bottom: 20px;\n                    flex-direction: column;                    \n                   align-items: inherit !important;\n                }\n                .blog-list-title {\n                    h3 {\n                        margin-bottom: 10px;                                                \n                        font-size: $__font__size__20; \n                        font-weight: $__semibold;   \n                        a {                    \n                            color: $__gray__dark;\n                            &:hover {\n                                color: #127384;\n                            }\n                            @include respond-below(custom991) {\n                                font-size: $__font__size__18;\n                            } \n                        }\n                    }\n                    h6 {\n                        font-size: $__font__size__15;\n                        color: $__sandstone;\n                        font-weight: $__regular;\n                            @include respond-below(custom767) {\n                                margin-bottom: 10px;\n                                font-size: $__font__size__15;\n                            }\n                    }\n                    h5 {\n                        margin-bottom: 3px;\n                        a {\n                            font-size: $__font__size__16;\n                            color: $__light__smokey-grays;\n                        }\n                        \n                    }\n                    .title-bottom {\n                       display: $__flex;\n                        @include respond-below(custom767) { \n                            margin-bottom: 10px;\n                        }\n                       img {\n                        margin-right: 10px;\n                        border-radius: 50%;\n                        width: 46px;\n                        height: 46px;\n                       }\n                        h6 {\n                            @extend %display-flex-center;\n                            i {\n                                line-height: 0;\n                            }\n                        }\n                    }\n                }\n                .blog-list-rate {\n                    h6 {\n                        font-weight: $__bold;\n                        font-size: $__font__size__24;\n                        @include respond-below(custom767) {\n                            font-size: $__font__size__22;\n                        }\n                        color: $__dangered;\n                        @extend %display-flex-center;\n                        @extend %justify-content-center;\n                            @include respond-below(custom767) {  \n                                justify-content: flex-start;\n                                -webkit-justify-content: start;\n                                -ms-flex-pack: start;\n                            }\n                        span {\n                            font-size: $__font__size__14;\n                            font-weight: $__normal;\n                            color: $__note__light;\n                            margin-left: 7px;\n                        }\n                    }\n                    .list-rating {\n                        margin-bottom: 8px;\n                        i {\n                            color: $__warningcolor;\n                            font-size: $__font__size__14;\n                        }\n                    }\n   \n                }\n                &.list-head-bottom {\n                    margin: 0;\n                    align-items: $__center;\n                }\n            }\n            \n            .listing-details-group {\n                @include margin-padding(0 0 15px,0 0 15px);\n                border-bottom: 1px solid $__light__gooses;\n                ul {\n                    @extend %display-flex-center-between;\n                    @include margin-padding(0,10px);\n                    background: $__light__vampire;\n                    border-radius: 5px;\n                    @include respond-below(custom1199) {  \n                        @include margin-padding(0, 10px 10px 0); \n                        display: flex;\n                        display: -webkit-flex;\n                        flex-wrap: wrap;\n                        -webkit-flex-wrap: wrap;\n                    }                    \n                    li {\n                        @extend %display-flex-center;\n                        @include respond-below(custom1199) {     \n                            -ms-flex: 33.33%;\n                            flex: 33.33%;\n                            max-width: 33.33%;\n                            display: flex;\n                            display: -webkit-flex;\n                            margin-bottom: 15px;\n                        }\n                        @include respond-below(custom767) {     \n                            -ms-flex: 50%;\n                            flex: 50%;\n                            max-width: 50%;\n                            display: flex;\n                            display: -webkit-flex;\n                        }\n                        span {\n                            line-height: 0;\n                            img {\n                                margin-right: 10px;\n                                line-height: 0;\n                                width: 16px;\n                                @extend %display-flex-center;\n                                @extend %justify-content-center;\n                            }\n                        }\n                    }\n                }\n            }\n            .listing-button {\n                .btn-order {\n                    background: $__goose-gray;\n                    color: $__white;\n                    -webkit-transition: all 0.5s;\n                    -moz-transition: all 0.5s;\n                    -o-transition: all 0.5s;\n                    transition: all 0.5s;\n                    @include respond-below(custom767) {\n                        width: 100%;\n                    }\n                    &:hover {\n                        background-color: $__dark__blues !important;\n                        color: $__white;\n                        border-radius: 5px;\n                        -webkit-transition: all 0.5s;\n                        -moz-transition: all 0.5s;\n                        -o-transition: all 0.5s;\n                        transition: all 0.5s;\n                    }\n                }\n            }\n        }\n    }\n}\n\n#checkBoxes1 {\n  height: 180px;\n  overflow-y: scroll;\n  -webkit-overflow-y: scroll;\n    -moz-overflow-y: scroll;\n    -ms-overflow-y: scroll;\n    -o-overflow-y: scroll;\n  @include margin-padding(0 0 15px, null);\n}\n#checkBoxes2 {\n    height: 180px;\n    overflow-y: scroll;\n    -webkit-overflow-y: scroll;\n    -moz-overflow-y: scroll;\n    -ms-overflow-y: scroll;\n    -o-overflow-y: scroll;\n    @include margin-padding(0 0 15px, null);\n}\n#checkBoxes3 {\n    height: 180px;\n    overflow-y: scroll;\n    -webkit-overflow-y: scroll;\n    -moz-overflow-y: scroll;\n    -ms-overflow-y: scroll;\n    -o-overflow-y: scroll;\n    @include margin-padding(0 0 15px, null);\n}\n#checkBoxes4 {\n    height: 180px;\n    overflow-y: scroll;\n    -webkit-overflow-y: scroll;\n    -moz-overflow-y: scroll;\n    -ms-overflow-y: scroll;\n    -o-overflow-y: scroll;\n    @include margin-padding(0 0 15px, null);\n}\n#checkBoxes5 {\n    height: 180px;\n    overflow-y: scroll;\n    -webkit-overflow-y: scroll;\n    -moz-overflow-y: scroll;\n    -ms-overflow-y: scroll;\n    -o-overflow-y: scroll;\n    @include margin-padding(0 0 15px, null);\n}\n#checkBoxes1::-webkit-scrollbar {\n  width: 6px\n}\n#checkBoxes2::-webkit-scrollbar {\n    width: 6px\n}\n#checkBoxes3::-webkit-scrollbar {\n    width: 6px\n}\n#checkBoxes4::-webkit-scrollbar {\n    width: 6px\n}\n#checkBoxes5::-webkit-scrollbar {\n    width: 6px\n}\n#checkBoxes1::-webkit-scrollbar-track {\n  background-color: #ddd;\n  border-radius: 2px;\n  -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes2::-webkit-scrollbar-track {\n    background-color: #ddd;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes3::-webkit-scrollbar-track {\n    background-color: #ddd;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes4::-webkit-scrollbar-track {\n    background-color: #ddd;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes5::-webkit-scrollbar-track {\n    background-color: #ddd;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes1::-webkit-scrollbar-thumb {\n    background-color: $__primarycolor;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes2::-webkit-scrollbar-thumb {\n    background-color: $__primarycolor;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes3::-webkit-scrollbar-thumb {\n    background-color: $__primarycolor;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes4::-webkit-scrollbar-thumb {\n    background-color: $__primarycolor;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n#checkBoxes5::-webkit-scrollbar-thumb {\n    background-color: $__primarycolor;\n    border-radius: 2px;\n    -webkit-background-color: $__primarycolor;\n    -moz-background-color: $__primarycolor;\n    -ms-background-color: $__primarycolor;\n    -o-background-color: $__primarycolor;\n}\n","$color_1: #201f1d;\n$color_2: #fff;\n$color_3: #787878;\n\n@import \"primereact/resources/themes/lara-light-indigo/theme.css\";\n@import \"react-time-picker/dist/TimePicker.css\";\n\n.stickybar {\n  top: 0;\n  position: sticky;\n}\n.p-calendar.p-component.p-inputwrapper {\n  .p-inputtext.p-component {\n    background: #fcfbfb;\n    border: 1px solid #f4f4f4;\n    box-shadow: none;\n    border-radius: 5px;\n    margin: 0;\n    font-size: 14px;\n    font-weight: 400;\n    color: $color_1;\n    padding-right: 0;\n    max-width: 150px;\n  }\n  input {\n    &:focus {\n      box-shadow: none;\n    }\n    &::placeholder {\n      font-size: 14px;\n    }\n  }\n}\n.search-box-banner {\n  .group-img {\n    i {\n      top: 17px;\n    }\n  }\n}\n.p-datepicker-calendar-container {\n  table.p-datepicker-calendar {\n    font-size: 14px;\n  }\n}\ndiv.p-datepicker {\n  table {\n    td.p-datepicker-today {\n      > span {\n        background: #ffa633;\n        color: $color_2;\n      }\n    }\n  }\n}\n.p-calendar.p-component {\n  input {\n    font-size: 14px;\n  }\n}\n.group-img {\n  div.ant-picker {\n    height: 45px;\n    padding: 0 10px 0 0;\n  }\n  .ant-picker {\n    .ant-picker-input {\n      input {\n        text-overflow: unset;\n        padding: 2px 13px 13px 36px;\n        &::placeholder {\n          color: $color_3;\n        }\n      }\n      top: 10px;\n    }\n  }\n}\n.ant-picker-input {\n  span.ant-picker-suffix {\n    display: none;\n  }\n}\n@import \"~@fortawesome/fontawesome-svg-core/styles.css\";\n\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n#range-slider .range-slider__thumb[data-lower] {\n  width: 0;\n}\n\n#range-slider .range-slider__range {\n  border-radius: 6px;\n}\n\n.rc-slider {\n  margin-bottom: 15px;\n}\n\n.rc-slider-track,\n.rc-slider-tracks {\n  position: absolute;\n  height: 4px;\n  background-color: #ff9307;\n  border-radius: 6px;\n}\n\n.rc-slider-handle {\n  position: absolute;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  background-color: #fff;\n  border: solid 2px #ff9307;\n  border-radius: 50%;\n  cursor: pointer;\n  cursor: grab;\n  opacity: 0.8;\n  touch-action: pan-x;\n}\n\n.rc-slider-handle {\n  border-color: #ff9307 !important;\n  box-shadow: 0 0 0 5px #ff9307 !important;\n}\n.filled {\n  color: #ff9307 !important;\n}\n\n.collapsed {\n  .chev-up {\n    color: #201f1d;\n    transition: 0.2s;\n    transform: rotate(-180deg);\n  }\n}\n\n.stickysidebar {\n  position: sticky;\n  top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
